// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope, FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
//   FaBehance, FaGithub, FaMedium, FaDribbble, FaStackOverflow,
//   FaArtstation, FaPinterest, FaPaintBrush, FaUsers, FaLightbulb,
//   FaChartLine, FaChevronUp, FaChevronDown, FaBrain, FaArrowDown, FaArrowUp
// } from "react-icons/fa";

// import logo from "./assets/logo/grafitti.svg";
// import comingDummy from "./assets/images/kommende_spil_dummy.png";
// import releasedDummy from "./assets/images/udgivet_spil_dummy.png";
// import Brian from "./assets/team/mig4.png";

// // --- APP DATA ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500;
// const DECAY_AMOUNT = 1;
// const QUOTE_CHANGE_INTERVAL = 5000;

// const heroQuotes = [
//   "Vi bygger spil til dig, der er træt af at dyste mod en algoritme.",
//   "Ansigt til ansigt. Lige her i virkeligheden.",
//   "Kom op af sofaen! Legen venter lige foran dig.",
//   "Vi bruger kun mobilen som værktøjet, der holder styr på legen.",
//   "Gør ethvert rum eller sted til jeres fælles arena.",
//   "Kløgtig: Fordi det er sjovere at spille med rigtige mennesker."
// ];

// const rawTeamMembers = [
//   {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Eneansvarlig, Spiludvikler & Professionelt Legebarn",
//     fullRole: "Den kløgtige hjerne bag alt det her lort",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg er her ikke for at **please stivstikkere i den corporate verden eller gemme mig i et jakkesæt for at tækkes investorer**. Jeg bygger spil, der rykker ved virkeligheden. Det handler om at bevare evnen til at se leg i alt og gøre verden **for alvor sjov**.", 
//     infoBoxId: "innovationDevelopment"
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush",
//     title: "Design uden pis",
//     info: "Vi gider ikke kedelige kloner. Vi bygger oplevelser fra bunden, der føles som noget helt nyt. **Originalitet er ikke et valg, det er et krav** 🎨",
//     colors: { border: "#ff69b4", background: "#e91e63" },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samvær uden akavethed",
//     info: "Sociale spil behøver ikke være akavede teambuilding-øvelser. Vi designer rammerne, så I bare kan fokusere på at **grine og have det fedt sammen** 💪",
//     colors: { border: "#8a2be2", background: "#673ab7" },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Teknik der bare spiller",
//     info: "Vi nørder de svære ting i baggrunden – real-time synkronisering og værktøjer der virker – så alt spiller, når du trykker start. **Vi har styr på lortet** 💡",
//     colors: { border: "#FF9B00", background: "#FF7D08" },
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vores Mission",
//     info: "Vi vil have folk ud, hvor det sker. Vi bygger de værktøjer, der gør det muligt at spille og dyste sammen, uanset hvordan I mødes. Det handler om at komme op af sofaen og ind i legen.",
//     colors: { border: "#00bcd4", background: "#0097a7" },
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Projekt: [KLASSIFICERET]",
//     description: "Vi are i gang med at fintune noget, der kommer til at ændre måden, I ser verden på. Ingen spoilers endnu, men vi tør godt love, at det bliver leg på et helt nyt niveau. Hold øje med siden – vi løfter snart sløret.",
//     image: releasedDummy,
//     status: "Under wraps – vi tester stadig",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Arena: Udendørs",
//     description: "Vores næste store skridt. Vi rykker legen ud under åben himmel og gør verden til spillepladen. Her bruger vi teknologien til at binde jer sammen i det fri, uanset om I dyster eller samarbejder.",
//     image: comingDummy,
//     status: "I laboratoriet",
//   }
// ];

// const teamMembersWithCategories = rawTeamMembers;

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref}
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         {/* Front Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <motion.img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg border-2 border-yellow-400/50"
//             animate={{ 
//               boxShadow: [
//                 "0 0 15px rgba(255, 215, 0, 0.2)", 
//                 "0 0 40px rgba(255, 215, 0, 0.5)", 
//                 "0 0 15px rgba(255, 215, 0, 0.2)"
//               ] 
//             }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         {/* Back Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <div className="italic text-gray-400 text-center text-sm">
//             <ReactMarkdown>
//               {`"${member.mantra}"`}
//             </ReactMarkdown>
//           </div>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
//   teamCardsRef,
//   scrollTo
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* VURDERET STORT LOGO SOM SITETS HOVEDBLIKFANG */}
//       <motion.div
//   className="flex flex-col items-center mb-6 w-full max-w-lg md:max-w-2xl px-4"
//   initial={{ opacity: 0, scale: 0.3 }}
//   animate={{ opacity: 1, scale: 1 }}
//   transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0 }}
// >
//   <img 
//     src={logo} 
//     alt="Kløgtig logo" 
//     className="w-full h-auto max-h-[35vh] object-contain" 
//     style={{
//       filter: "drop-shadow(0px 0px 20px rgba(255, 105, 180, 0.5)) drop-shadow(0px 0px 45px rgba(138, 43, 226, 0.3))"
//     }}
//   />
// </motion.div>

//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Virkeligheden er bare verdens bedste arena
//       </motion.h1>

//       <div className="w-full flex justify-center">
//         <div style={{ minHeight: "8rem" }} className="relative flex flex-col items-center">
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 text-center w-full px-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: "5rem" }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           <div className="mt-8 w-full max-w-md px-4">
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-4 px-8 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden transition-all"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white/20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               <motion.span className="relative z-10 flex items-center justify-center text-white whitespace-nowrap">
//                 {clicks < requiredClicks ? (
//                   <>
//                     <span>Pust Mit Ego Op!</span>
//                     <span className="text-xs ml-2 align-middle opacity-80">
//                       ({requiredClicks - clicks})
//                     </span>
//                   </>
//                 ) : (
//                   <span>Okay, nu er jeg klar – se her ↓</span>
//                 )}
//               </motion.span>
//             </motion.button>

//             <p className="mt-4 text-sm text-gray-400 italic">
//               Hvis du ikke engang orker at klikke <strong>{requiredClicks} gange</strong>, så er vores spil nok alligevel for vilde til dig
//             </p>

//             <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//           </div>

//           <motion.div
//             onClick={() => scrollTo(teamCardsRef)()}
//             animate={{ y: [0, -8, 0] }}
//             transition={{ duration: 1.2, repeat: Infinity }}
//             className="mt-8 text-2xl text-pink-300 cursor-pointer"
//           >
//             <FaArrowDown size={30} color="white"/>
//           </motion.div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo,
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);

//   const iconComponents = {
//     FaPaintBrush,
//     FaUsers,
//     FaLightbulb,
//     FaChartLine,
//     FaChevronDown,
//     FaChevronUp,
//     FaBrain,
//   };

//   const getIconComponent = (iconName) => iconComponents[iconName];

//   const handleInfoBoxClick = useCallback(
//     (box) => {
//       if (activeInfoBoxId === box.id) {
//         setActiveInfoBoxId(null);
//         setCurrentNavInfo(null);
//       } else {
//         setActiveInfoBoxId(box.id);
//         setCurrentNavInfo(box);
//       }
//     },
//     [activeInfoBoxId]
//   );

//   const handleDeflateClick = useCallback(() => {
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);

//   const isSingleMember = teamMembers.length === 1;
//   const teamSectionTitle = isSingleMember ? 'Manden Bag Værket' : 'Holdet af kloge hoveder';
//   const deflateButtonText = isSingleMember ? 'Punktér mit ego (og start forfra)' : 'Punktér os allesammen!';

//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen"
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >
//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
//       </div>

//       <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
//         {teamSectionTitle}
//       </h2>

//       <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
//         {infoBoxesData.map((box) => {
//           const Icon = getIconComponent(box.icon);
//           const isActive = activeInfoBoxId === box.id;
//           return (
//             <motion.button
//               key={box.id}
//               onClick={() => handleInfoBoxClick(box)}
//               className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
//                 ${isActive
//                   ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
//                   : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
//                 }
//               `}
//               style={{
//                 borderColor: isActive ? box.colors.border : undefined,
//                 backgroundColor: isActive ? box.colors.background : undefined,
//                 boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
//               }}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
//               {Icon && <Icon size={20} className="mr-2" />}
//               <span>{box.title}</span>
//             </motion.button>
//           );
//         })}
//       </div>

//       <AnimatePresence mode="wait">
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
//             style={{
//               boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`,
//             }}
//             initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
//             exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//           >
//             <h3 className="text-3xl font-bold mb-4 text-white">
//               {currentNavInfo.title}
//             </h3>
//             <div className="text-lg leading-relaxed text-gray-200 markdown-content">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <div
//         className={`grid gap-8 max-w-7xl w-full relative z-10 ${
//           teamMembers.length === 1
//             ? 'grid-cols-1 place-items-center'
//             : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
//         }`}
//       >
//         {teamMembers.map((m) => {
//           const isHighlighted = activeInfoBoxId === m.infoBoxId;
//           const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
//           const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               highlightColor={highlightColor}
//               ref={(el) => (cardRefs.current[m.id] = el)}
//             />
//           );
//         })}
//       </div>

//       <div className="mt-20 relative z-10">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
//           style={{
//             background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)",
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 2s ease-in-out infinite",
//           }}
//           whileHover={{
//             scale: 1.03,
//             boxShadow: "0 0 40px rgba(255,87,51,0.8)",
//             transition: { duration: 0.2 }
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="relative z-10">{deflateButtonText}</span>
//           <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// })

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       <section
//         ref={gamesSectionRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/40 text-white flex flex-col items-center"
//       >
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,255,150,0.5)] text-center tracking-tight">
//           Udgivne Spil
//         </h2>
        
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {developedGames.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-green-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               whileHover={{ y: -10, borderColor: "rgba(74, 222, 128, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-green-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-green-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.5)]">
//                 {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       <section
//         ref={gamesInDevRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/20 backdrop-blur-sm text-white flex flex-col items-center border-t border-white/10"
//       >
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,188,212,0.5)] text-center tracking-tight">
//           Vores Sociale Spil
//         </h2>
        
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-cyan-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               whileHover={{ y: -10, borderColor: "rgba(6, 182, 212, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-cyan-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-cyan-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(8,145,178,0.5)]">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.div
//           onClick={scrollTo(headerRef)}
//           animate={{ y: [0, -8, 0] }}
//           transition={{ duration: 1.2, repeat: Infinity }}
//           className="mt-8 text-2xl text-pink-300"
//         >
//           <FaArrowUp size={30} color="white"/>
//         </motion.div>
//       </section>
//     </>
//   );
// });

// // --- UPDATED Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
//         <div className="flex flex-col items-center md:items-start">
//           <div className="flex items-center space-x-2">
//             <img src={logo} alt="Kløgtig logo" className="w-48 h-48 object-contain" />
//           </div>
//           <div className="text-sm max-w-xs text-center md:text-left">
//             <ReactMarkdown>
//               {`Vi laver vores eget lort. Vi rykker spillet ud af skærmen og gør virkeligheden til den bedste arena, fordi det er her, det bliver **for alvor sjovt** at være sammen.`}
//             </ReactMarkdown>
//           </div>
//         </div>
//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <a href="mailto:hej@kloegtig.dk" className="flex items-center hover:text-purple-400">
//             <FaEnvelope className="mr-2 text-pink-400" /> hej@kloegtig.dk
//           </a>
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null);
//   const teamCardRefs = useRef({});
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);

//   const headerRef = useRef(null);
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null);
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % heroQuotes.length);
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval);
//   }, []);

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y },
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);

//   useEffect(() => {
//     const startDecayTimer = () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0;
//         });
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]);

//   useEffect(() => {
//     if (showConfetti) {
//       shootConfetti(0.5, 0.5);
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200);

//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false);
//     scrollTo(headerRef)();
//   }, [scrollTo, headerRef]);

//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-black">
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]}
//         teamCardsRef={teamCardsRef}
//         scrollTo={scrollTo}
//       />

//       <AnimatePresence>
//         {isContentUnlocked && (
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo}
//               cardRefs={teamCardRefs}
//               triggerConfettiAtRef={triggerConfettiAtRef}
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;





import React, { useState, useEffect, useRef, useCallback} from "react";
import { motion, AnimatePresence, useSpring } from "framer-motion";
import canvasConfetti from "canvas-confetti";
import ReactMarkdown from "react-markdown";
import {
  FaEnvelope, FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
  FaBehance, FaGithub, FaMedium, FaDribbble, FaStackOverflow,
  FaArtstation, FaPinterest, FaPaintBrush, FaUsers, FaLightbulb,
  FaChartLine, FaChevronUp, FaChevronDown, FaBrain, FaArrowDown, FaArrowUp
} from "react-icons/fa";

import logo from "./assets/logo/logo3.png";
import comingDummy from "./assets/images/kommende_spil_dummy.png"
import releasedDummy from "./assets/images/udgivet_spil_dummy.png"
import Brian from "./assets/team/mig3-headshot.png"

// --- APP DATA ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;
const QUOTE_CHANGE_INTERVAL = 5000;

const heroQuotes = [
  "Vi bygger spil til dig, der er træt af at dyste mod en algoritme.",
  "Ansigt til ansigt. Lige her i virkeligheden.",
  "Kom op af sofaen! Legen venter lige foran dig.",
  "Vi bruger kun mobilen som værktøjet, der holder styr på legen.",
  "Gør ethvert rum eller sted til jeres fælles arena.",
  "Kløgtig: Fordi det er sjovere at spille med rigtige mennesker."
];

const rawTeamMembers = [
  {
    id: 1,
    name: "Brian",
    photo: Brian,
    role: "Eneansvarlig, Spiludvikler & Professionelt Legebarn",
    fullRole: "Den kløgtige hjerne bag alt det her lort",
    contactInfo: {
      email: "brian@kloegtig.dk",
      phone: "+4593949459",
      social: "linkedin.com/in/brian-nørgaard-775130243",
    },
    mantra: "Jeg er her ikke for at **please stivstikkere i den corporate verden eller gemme mig i et jakkesæt for at tækkes investorer**. Jeg bygger spil, der rykker ved virkeligheden. Det handler om at bevare evnen til at se leg i alt og gøre verden **for alvor sjov**.", 
    infoBoxId: "innovationDevelopment"
  }
];

const infoBoxesData = [
  {
    id: "creativityDesign",
    icon: "FaPaintBrush",
    title: "Design uden pis",
    info: "Vi gider ikke kedelige kloner. Vi bygger oplevelser fra bunden, der føles som noget helt nyt. **Originalitet er ikke et valg, det er et krav** 🎨",
    colors: { border: "#ff69b4", background: "#e91e63" },
  },
  {
    id: "teamworkCommunity",
    icon: "FaUsers",
    title: "Samvær uden akavethed",
    info: "Sociale spil behøver ikke være akavede teambuilding-øvelser. Vi designer rammerne, så I bare kan fokusere på at **grine og have det fedt sammen** 💪",
    colors: { border: "#8a2be2", background: "#673ab7" },
  },
  {
    id: "innovationDevelopment",
    icon: "FaLightbulb",
    title: "Teknik der bare spiller",
    info: "Vi nørder de svære ting i baggrunden – real-time synkronisering og værktøjer der virker – så alt spiller, når du trykker start. **Vi har styr på lortet** 💡",
    colors: { border: "#FF9B00", background: "#FF7D08" },
  },
  {
    id: "visionProgress",
    icon: "FaChartLine",
    title: "Vores Mission",
    info: "Vi vil have folk ud, hvor det sker. Vi bygger de værktøjer, der gør det muligt at spille og dyste sammen, uanset hvordan I mødes. Det handler om at komme op af sofaen og ind i legen.",
    colors: { border: "#00bcd4", background: "#0097a7" },
  },
];

const developedGames = [
  {
    id: 1,
    title: "Projekt: [KLASSIFICERET]",
    description: "Vi er i gang med at fintune noget, der kommer til at ændre måden, I ser verden på. Ingen spoilers endnu, men vi tør godt love, at det bliver leg på et helt nyt niveau. Hold øje med siden – vi løfter snart sløret.",
    image: releasedDummy,
    status: "Under wraps – vi tester stadig",
  }
];

const gamesInDevelopment = [
  {
    id: 101,
    title: "Arena: Udendørs",
    description: "Vores næste store skridt. Vi rykker legen ud under åben himmel og gør verden til spillepladen. Her bruger vi teknologien til at binde jer sammen i det fri, uanset om I dyster eller samarbejder.",
    image: comingDummy,
    status: "I laboratoriet",
  }
];


const teamMembersWithCategories = rawTeamMembers;

// --- COMPONENT: TeamCard ---
const getSocialIcon = (socialUrl) => {
  if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
  if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
  if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
  if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
  if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
  if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
  if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
  if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
  if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
  if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
  if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
  return null;
};

const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 });

  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      ref={ref}
      className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
        dimmed ? "opacity-40" : ""
      } cursor-default`}
      style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        {/* Front Side */}
        <div
          className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(0deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          {/* GLORIE EFFEKT PÅ BILLEDE */}
          <motion.img
            src={member.photo}
            alt={member.name}
            className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg border-2 border-yellow-400/50"
            animate={{ 
              boxShadow: [
                "0 0 15px rgba(255, 215, 0, 0.2)", 
                "0 0 40px rgba(255, 215, 0, 0.5)", 
                "0 0 15px rgba(255, 215, 0, 0.2)"
              ] 
            }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        {/* Back Side */}
        <div
          className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(180deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">
            {member.name}'s Info
          </h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
              {member.contactInfo.email}
            </a>
          </p>
          {member.contactInfo.social && (
            <p className="text-sm text-gray-200 mb-3 flex items-center">
              {getSocialIcon(member.contactInfo.social)}
              <a
                href={`https://${member.contactInfo.social}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {member.contactInfo.social.split("/").pop()}
              </a>
            </p>
          )}
          <div className="italic text-gray-400 text-center text-sm">
            <ReactMarkdown>
              {`"${member.mantra}"`}
            </ReactMarkdown>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
});

// --- COMPONENT: HeroSection ---
const HeroSection = ({
  clicks,
  requiredClicks,
  handleMainButtonClick,
  isButtonClicked,
  currentQuote,
  teamCardsRef,
  scrollTo
}) => {
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <motion.header
      className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="flex flex-col items-center mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
      >
        <img src={logo} alt="Kløgtig logo" className="w-full h-auto max-h-[35vh] object-contain" />
      </motion.div>

      <motion.h1
        className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
      >
        Virkeligheden er bare verdens bedste arena
      </motion.h1>

      <div className="w-full flex justify-center">
        <div style={{ minHeight: "8rem" }} className="relative flex flex-col items-center">
          <AnimatePresence mode="wait">
            <motion.p
              key={currentQuote}
              className="mt-4 text-base md:text-xl font-medium text-gray-200 text-center w-full px-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              style={{ minHeight: "5rem" }}
            >
              {currentQuote}
            </motion.p>
          </AnimatePresence>

          <div className="mt-8 w-full max-w-md px-4"> {/* Containeren er nu bredere */}
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full py-4 px-8 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden transition-all"
              style={{
                background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
                backgroundSize: "200% 200%",
                animation: "buttonGradient 2s linear infinite",
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              disabled={clicks >= requiredClicks}
            >
              <motion.div
                className="absolute inset-0 bg-white/20"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
              <motion.span className="relative z-10 flex items-center justify-center text-white whitespace-nowrap">
                {clicks < requiredClicks ? (
                  <>
                    <span>Pust Mit Ego Op!</span>
                    <span className="text-xs ml-2 align-middle opacity-80">
                      ({requiredClicks - clicks})
                    </span>
                  </>
                ) : (
                  <span>Okay, nu er jeg klar – se her ↓</span>
                )}
              </motion.span>
            </motion.button>

            <p className="mt-4 text-sm text-gray-400 italic">
              Hvis du ikke engang orker at klikke <strong>{requiredClicks} gange</strong>, så er vores spil nok alligevel for vilde til dig
            </p>

            <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
              <motion.div
                className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
            </div>
          </div>

          <motion.div
        onClick={() => scrollTo(teamCardsRef)()} // Scroller nu til TeamSection
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 1.2, repeat: Infinity }}
        className="mt-8 text-2xl text-pink-300 cursor-pointer" // Tilføjet cursor-pointer
      >
        <FaArrowDown size={30} color="white"/>
      </motion.div>
        </div>
      </div>
    </motion.header>
  );
};

// --- COMPONENT: TeamSection ---
const TeamSection = React.memo(({
  teamMembers,
  infoBoxesData,
  teamCardsRef,
  resetEgo,
  cardRefs,
  triggerConfettiAtRef,
}) => {
  const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);

  const iconComponents = {
    FaPaintBrush,
    FaUsers,
    FaLightbulb,
    FaChartLine,
    FaChevronDown,
    FaChevronUp,
    FaBrain,
  };

  const getIconComponent = (iconName) => iconComponents[iconName];

  const handleInfoBoxClick = useCallback(
    (box) => {
      if (activeInfoBoxId === box.id) {
        setActiveInfoBoxId(null);
        setCurrentNavInfo(null);
      } else {
        setActiveInfoBoxId(box.id);
        setCurrentNavInfo(box);
      }
    },
    [activeInfoBoxId]
  );

  const handleDeflateClick = useCallback(() => {
    Object.values(cardRefs.current).forEach((ref) => {
      if (ref) {
        triggerConfettiAtRef(ref);
      }
    });
    resetEgo();
  }, [cardRefs, triggerConfettiAtRef, resetEgo]);

  const isSingleMember = teamMembers.length === 1;
const teamSectionTitle = isSingleMember ? 'Manden Bag Værket' : 'Holdet af kloge hoveder';
const deflateButtonText = isSingleMember ? 'Punktér mit ego (og start forfra)' : 'Punktér os allesammen!';

  return (
    <motion.section
      ref={teamCardsRef}
      className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >

      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
      </div>

      <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
        {teamSectionTitle}
      </h2>

 
      <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
        {infoBoxesData.map((box) => {
          const Icon = getIconComponent(box.icon);
          const isActive = activeInfoBoxId === box.id;

          return (
            <motion.button
              key={box.id}
              onClick={() => handleInfoBoxClick(box)}
              className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
                ${isActive
                  ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
                  : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
                }
              `}
              style={{
                borderColor: isActive ? box.colors.border : undefined,
                backgroundColor: isActive ? box.colors.background : undefined,
                boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
              {Icon && <Icon size={20} className="mr-2" />}
              <span>{box.title}</span>
            </motion.button>
          );
        })}
      </div>

  
      <AnimatePresence mode="wait">
        {currentNavInfo && (
          <motion.div
            key={currentNavInfo.id}
            className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
            style={{
              boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
            }}
            initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
            animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
            exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <h3 className="text-3xl font-bold mb-4 text-white">
              {currentNavInfo.title}
            </h3>
            <div className="text-lg leading-relaxed text-gray-200 markdown-content">
              <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

     
      <div
        className={`grid gap-8 max-w-7xl w-full relative z-10 ${
          teamMembers.length === 1
            ? 'grid-cols-1 place-items-center'
            : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
        }`}
      >
        {teamMembers.map((m) => {
          const isHighlighted = activeInfoBoxId === m.infoBoxId;
          const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
          const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

          return (
            <TeamCard
              key={m.id}
              member={m}
              isHighlighted={isHighlighted}
              dimmed={dimmed}
              highlightColor={highlightColor}
              ref={(el) => (cardRefs.current[m.id] = el)}
            />
          );
        })}
      </div>

   
      <div className="mt-20 relative z-10">
        <motion.button
          onClick={handleDeflateClick}
          className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
          style={{
            background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
            backgroundSize: "200% 200%",
            animation: "pulseGradient 2s ease-in-out infinite",
          }}
          whileHover={{
            scale: 1.03,
            boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="relative z-10">{deflateButtonText}</span>
          <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
        </motion.button>
      </div>
    </motion.section>
  );
})

// --- COMPONENT: GamesSection ---
const GamesSection = React.memo(({
  developedGames,
  gamesInDevelopment,
  gamesSectionRef,
  gamesInDevRef,
  headerRef,
  scrollTo,
}) => {
  return (
    <>
      {/* SEKTION FOR UDGIVNE SPIL */}
      <section
        ref={gamesSectionRef}
        className="relative z-10 w-full py-24 px-4 bg-black/40 text-white flex flex-col items-center"
      >
        {/* Overskrift: Gjort solid og hvid med kraftig shadow for maksimal tydelighed */}
        <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,255,150,0.5)] text-center tracking-tight">
          Udgivne Spil
        </h2>
        
        {/* Container: Bruger flex-wrap og justify-center for at sikre 100% centrering af 1 eller flere kort */}
        <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
          {developedGames.map((game) => (
            <motion.div
              key={game.id}
              className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-green-500/40 text-center flex flex-col w-full max-w-md"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, borderColor: "rgba(74, 222, 128, 0.8)" }}
            >
              <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
                <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
              </div>
              <h3 className="text-3xl font-bold mb-3 text-green-400">{game.title}</h3>
              <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
              <span className="inline-block bg-green-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.5)]">
                {game.status}
              </span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* SEKTION FOR KOMMENDE SPIL */}
      <section
        ref={gamesInDevRef}
        className="relative z-10 w-full py-24 px-4 bg-black/20 backdrop-blur-sm text-white flex flex-col items-center border-t border-white/10"
      >
        {/* Overskrift: Gjort solid hvid/cyan med shadow */}
        <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,188,212,0.5)] text-center tracking-tight">
          Vores Sociale Spil
        </h2>
        
        <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
          {gamesInDevelopment.map((game) => (
            <motion.div
              key={game.id}
              className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-cyan-500/40 text-center flex flex-col w-full max-w-md"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              whileHover={{ y: -10, borderColor: "rgba(6, 182, 212, 0.8)" }}
            >
              <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
                <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
              </div>
              <h3 className="text-3xl font-bold mb-3 text-cyan-400">{game.title}</h3>
              <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(8,145,178,0.5)]">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.div
            onClick={scrollTo(headerRef)}
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 1.2, repeat: Infinity }}
            className="mt-8 text-2xl text-pink-300"
          >
            <FaArrowUp size={30} color="white"/>
          </motion.div>
      
      </section>
    </>
  );
});

// --- UPDATED Footer ---
const Footer = React.memo(() => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex flex-col items-center md:items-start">
          <div className="flex items-center space-x-2">
            <img src={logo} alt="Kløgtig logo" className="w-48 h-48 object-contain" />

          </div>
          <div className="text-sm max-w-xs text-center md:text-left">
            <ReactMarkdown>
              {`Vi laver vores eget lort. Vi rykker spillet ud af skærmen og gør virkeligheden til den bedste arena, fordi det er her, det bliver **for alvor sjovt** at være sammen.`}
            </ReactMarkdown>
          </div>
        </div>
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <a href="mailto:hej@kloegtig.dk" className="flex items-center hover:text-purple-400">
            <FaEnvelope className="mr-2 text-pink-400" /> hej@kloegtig.dk
          </a>
        </div>
      </div>
    </footer>
  );
});

// --- MAIN APP COMPONENT ---
function App() {
  const [clicks, setClicks] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
  const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

  // Refs for scrolling
  const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
  const gamesInDevRef = useRef(null);

  const scrollTo = useCallback((ref) => () => {
    // If ref is headerRef (which points to the top of the page), scroll to top of window
    if (ref === headerRef) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Scroll to the top of the page on initial render
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Effect for changing quotes
  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setCurrentQuoteIndex((prevIndex) =>
        (prevIndex + 1) % heroQuotes.length
      );
    }, QUOTE_CHANGE_INTERVAL);

    return () => clearInterval(quoteInterval); // Cleanup on unmount
  }, []); // Empty dependency array means it runs once on mount

  const shootConfetti = useCallback((x, y) => {
    const common = {
      spread: 360,
      ticks: 100,
      gravity: 0.5,
      decay: 0.94,
      startVelocity: 30,
      origin: { x: x, y: y }, // Use provided x, y for origin
    };

    canvasConfetti({
      ...common,
      scalar: 1.2,
      shapes: ["circle", "square"],
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    });

    canvasConfetti({
      ...common,
      scalar: 0.75,
      shapes: ["star"],
      colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
    });
  }, []);

  const triggerConfettiAtRef = useCallback((ref) => {
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      shootConfetti(x / window.innerWidth, y / window.innerHeight);
    }
  }, [shootConfetti]);


  // Effect for managing click decay
  useEffect(() => {
    const startDecayTimer = () => {
      // Clear any existing decay timer to prevent multiple timers running
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }

      decayTimeoutRef.current = setTimeout(() => {
        setClicks((prevClicks) => {
          if (prevClicks > 0) {
            return Math.max(0, prevClicks - DECAY_AMOUNT);
          }
          return 0; // Don't go below zero
        });
        // Reschedule the decay if clicks are still above zero AND content is not unlocked
        if (clicks > 0 && clicks < REQUIRED_CLICKS) {
            startDecayTimer();
        }
      }, DECAY_INTERVAL);
    };

    // Only start decay if clicks are not 0 and content isn't unlocked
    if (clicks > 0 && clicks < REQUIRED_CLICKS) {
        startDecayTimer();
    } else {
        // If clicks are 0 or content is unlocked, ensure no decay timer is running
        if (decayTimeoutRef.current) {
            clearTimeout(decayTimeoutRef.current);
            decayTimeoutRef.current = null;
        }
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }
    };
  }, [clicks]); // Re-run when clicks or requiredClicks change

  // Confetti effect (for initial unlock)
  useEffect(() => {
    if (showConfetti) {
      // This burst is for the initial "Pust Vores Egoer Op!" completion
      shootConfetti(0.5, 0.5); // Center confetti
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, BURST_DURATION);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, shootConfetti]);

  // Unlock content effect
  useEffect(() => {
    if (clicks >= REQUIRED_CLICKS) {
      setShowConfetti(true);
      // Stop decay when content is unlocked
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
      }
      setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
    }
  }, [clicks, scrollTo, teamCardsRef]);

  // Function for the "Pust Vores Egoer Op!" button
  const handleMainButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

    // Clear any pending decay timeout when a click occurs
    if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
    }

    // Increment clicks only if less than REQUIRED_CLICKS
    setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
  };

  // New function specifically for resetting ego from "Punktèr Os!" button
  const resetEgo = useCallback(() => {
    setClicks(0);
    setShowConfetti(false); // Ensure confetti stops
    scrollTo(headerRef)(); // Scroll to top on reset
  }, [scrollTo, headerRef]);


  const isContentUnlocked = clicks >= REQUIRED_CLICKS;

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
      <div className="absolute inset-0 z-0 opacity-20" />

      <HeroSection
        clicks={clicks}
        requiredClicks={REQUIRED_CLICKS}
        handleMainButtonClick={handleMainButtonClick}
        isButtonClicked={isButtonClicked}
        currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
        teamCardsRef={teamCardsRef}
        scrollTo={scrollTo}
      />

      <AnimatePresence>
        {isContentUnlocked && ( // Only render these sections if content is unlocked
          <>
            <TeamSection
              teamMembers={teamMembersWithCategories}
              infoBoxesData={infoBoxesData}
              teamCardsRef={teamCardsRef}
              resetEgo={resetEgo} // Pass the new resetEgo function
              cardRefs={teamCardRefs} // Pass the ref object to TeamSection
              triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
            />
            <GamesSection
              developedGames={developedGames}
              gamesInDevelopment={gamesInDevelopment}
              gamesSectionRef={gamesSectionRef}
              gamesInDevRef={gamesInDevRef}
              headerRef={headerRef}
              scrollTo={scrollTo}
            />
          </>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}

export default App;





// import React, { useState, useEffect, useRef, useCallback} from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope, FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
//   FaBehance, FaGithub, FaMedium, FaDribbble, FaStackOverflow,
//   FaArtstation, FaPinterest, FaPaintBrush, FaUsers, FaLightbulb,
//   FaChartLine, FaChevronUp, FaChevronDown, FaBrain, FaArrowDown, FaArrowUp
// } from "react-icons/fa";

// import logo from "./assets/logo/grafitti.svg";
// import comingDummy from "./assets/images/kommende_spil_dummy.png"
// import releasedDummy from "./assets/images/udgivet_spil_dummy.png"
// import Brian from "./assets/team/mig3-headshot.png"

// // --- APP DATA ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500;
// const DECAY_AMOUNT = 1;
// const QUOTE_CHANGE_INTERVAL = 5000;

// const heroQuotes = [
//   "Vi bygger spil til dig, der er træt af at dyste mod en algoritme.",
//   "Ansigt til ansigt. Lige her i virkeligheden.",
//   "Kom op af sofaen! Legen venter lige foran dig.",
//   "Vi bruger kun mobilen som værktøjet, der holder styr på legen.",
//   "Gør ethvert rum eller sted til jeres fælles arena.",
//   "Kløgtig: Fordi det er sjovere at spille med rigtige mennesker."
// ];

// const rawTeamMembers = [
//   {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Eneansvarlig, Spiludvikler & Professionelt Legebarn",
//     fullRole: "Den kløgtige hjerne bag alt det her lort",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg er her ikke for at **please stivstikkere i den corporate verden eller gemme mig i et jakkesæt for at tækkes investorer**. Jeg bygger spil, der rykker ved virkeligheden. Det handler om at bevare evnen til at se leg i alt og gøre verden **for alvor sjov**.", 
//     infoBoxId: "innovationDevelopment"
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush",
//     title: "Design uden pis",
//     info: "Vi gider ikke kedelige kloner. Vi bygger oplevelser fra bunden, der føles som noget helt nyt. **Originalitet er ikke et valg, det er et krav** 🎨",
//     colors: { border: "#ff69b4", background: "#e91e63" },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samvær uden akavethed",
//     info: "Sociale spil behøver ikke være akavede teambuilding-øvelser. Vi designer rammerne, så I bare kan fokusere på at **grine og have det fedt sammen** 💪",
//     colors: { border: "#8a2be2", background: "#673ab7" },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Teknik der bare spiller",
//     info: "Vi nørder de svære ting i baggrunden – real-time synkronisering og værktøjer der virker – så alt spiller, når du trykker start. **Vi har styr på lortet** 💡",
//     colors: { border: "#FF9B00", background: "#FF7D08" },
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vores Mission",
//     info: "Vi vil have folk ud, hvor det sker. Vi bygger de værktøjer, der gør det muligt at spille og dyste sammen, uanset hvordan I mødes. Det handler om at komme op af sofaen og ind i legen.",
//     colors: { border: "#00bcd4", background: "#0097a7" },
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Projekt: [KLASSIFICERET]",
//     description: "Vi er i gang med at fintune noget, der kommer til at ændre måden, I ser verden på. Ingen spoilers endnu, men vi tør godt love, at det bliver leg på et helt nyt niveau. Hold øje med siden – vi løfter snart sløret.",
//     image: releasedDummy,
//     status: "Under wraps – vi tester stadig",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Arena: Udendørs",
//     description: "Vores næste store skridt. Vi rykker legen ud under åben himmel og gør verden til spillepladen. Her bruger vi teknologien til at binde jer sammen i det fri, uanset om I dyster eller samarbejder.",
//     image: comingDummy,
//     status: "I laboratoriet",
//   }
// ];


// const teamMembersWithCategories = rawTeamMembers;

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref}
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         {/* Front Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           {/* GLORIE EFFEKT PÅ BILLEDE */}
//           <motion.img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg border-2 border-yellow-400/50"
//             animate={{ 
//               boxShadow: [
//                 "0 0 15px rgba(255, 215, 0, 0.2)", 
//                 "0 0 40px rgba(255, 215, 0, 0.5)", 
//                 "0 0 15px rgba(255, 215, 0, 0.2)"
//               ] 
//             }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         {/* Back Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <div className="italic text-gray-400 text-center text-sm">
//             <ReactMarkdown>
//               {`"${member.mantra}"`}
//             </ReactMarkdown>
//           </div>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
//   teamCardsRef,
//   scrollTo
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">- for alvor sjov!</p>
//       </motion.div>

//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Virkeligheden er bare verdens bedste arena
//       </motion.h1>

//       <div className="w-full flex justify-center">
//         <div style={{ minHeight: "8rem" }} className="relative flex flex-col items-center">
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 text-center w-full px-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: "5rem" }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           <div className="mt-8 w-full max-w-md px-4"> {/* Containeren er nu bredere */}
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-4 px-8 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden transition-all"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white/20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               <motion.span className="relative z-10 flex items-center justify-center text-white whitespace-nowrap">
//                 {clicks < requiredClicks ? (
//                   <>
//                     <span>Pust Mit Ego Op!</span>
//                     <span className="text-xs ml-2 align-middle opacity-80">
//                       ({requiredClicks - clicks})
//                     </span>
//                   </>
//                 ) : (
//                   <span>Okay, nu er jeg klar – se her ↓</span>
//                 )}
//               </motion.span>
//             </motion.button>

//             <p className="mt-4 text-sm text-gray-400 italic">
//               Hvis du ikke engang orker at klikke <strong>{requiredClicks} gange</strong>, så er vores spil nok alligevel for vilde til dig
//             </p>

//             <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//           </div>

//           <motion.div
//         onClick={scrollTo(teamCardsRef)} // Scroller nu til TeamSection
//         animate={{ y: [0, -8, 0] }}
//         transition={{ duration: 1.2, repeat: Infinity }}
//         className="mt-8 text-2xl text-pink-300 cursor-pointer" // Tilføjet cursor-pointer
//       >
//         <FaArrowDown size={30} color="white"/>
//       </motion.div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo,
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);

//   const iconComponents = {
//     FaPaintBrush,
//     FaUsers,
//     FaLightbulb,
//     FaChartLine,
//     FaChevronDown,
//     FaChevronUp,
//     FaBrain,
//   };

//   const getIconComponent = (iconName) => iconComponents[iconName];

//   const handleInfoBoxClick = useCallback(
//     (box) => {
//       if (activeInfoBoxId === box.id) {
//         setActiveInfoBoxId(null);
//         setCurrentNavInfo(null);
//       } else {
//         setActiveInfoBoxId(box.id);
//         setCurrentNavInfo(box);
//       }
//     },
//     [activeInfoBoxId]
//   );

//   const handleDeflateClick = useCallback(() => {
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);

//   const isSingleMember = teamMembers.length === 1;
// const teamSectionTitle = isSingleMember ? 'Manden Bag Værket' : 'Holdet af kloge hoveder';
// const deflateButtonText = isSingleMember ? 'Punktér mit ego (og start forfra)' : 'Punktér os allesammen!';

//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >

//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
//       </div>

//       <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
//         {teamSectionTitle}
//       </h2>

 
//       <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
//         {infoBoxesData.map((box) => {
//           const Icon = getIconComponent(box.icon);
//           const isActive = activeInfoBoxId === box.id;

//           return (
//             <motion.button
//               key={box.id}
//               onClick={() => handleInfoBoxClick(box)}
//               className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
//                 ${isActive
//                   ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
//                   : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
//                 }
//               `}
//               style={{
//                 borderColor: isActive ? box.colors.border : undefined,
//                 backgroundColor: isActive ? box.colors.background : undefined,
//                 boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
//               }}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
//               {Icon && <Icon size={20} className="mr-2" />}
//               <span>{box.title}</span>
//             </motion.button>
//           );
//         })}
//       </div>

  
//       <AnimatePresence mode="wait">
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
//             style={{
//               boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
//             }}
//             initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
//             exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//           >
//             <h3 className="text-3xl font-bold mb-4 text-white">
//               {currentNavInfo.title}
//             </h3>
//             <div className="text-lg leading-relaxed text-gray-200 markdown-content">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

     
//       <div
//         className={`grid gap-8 max-w-7xl w-full relative z-10 ${
//           teamMembers.length === 1
//             ? 'grid-cols-1 place-items-center'
//             : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
//         }`}
//       >
//         {teamMembers.map((m) => {
//           const isHighlighted = activeInfoBoxId === m.infoBoxId;
//           const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
//           const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               highlightColor={highlightColor}
//               ref={(el) => (cardRefs.current[m.id] = el)}
//             />
//           );
//         })}
//       </div>

   
//       <div className="mt-20 relative z-10">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
//           style={{
//             background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 2s ease-in-out infinite",
//           }}
//           whileHover={{
//             scale: 1.03,
//             boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
//             transition: { duration: 0.2 }
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="relative z-10">{deflateButtonText}</span>
//           <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// })

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       {/* SEKTION FOR UDGIVNE SPIL */}
//       <section
//         ref={gamesSectionRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/40 text-white flex flex-col items-center"
//       >
//         {/* Overskrift: Gjort solid og hvid med kraftig shadow for maksimal tydelighed */}
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,255,150,0.5)] text-center tracking-tight">
//           Udgivne Spil
//         </h2>
        
//         {/* Container: Bruger flex-wrap og justify-center for at sikre 100% centrering af 1 eller flere kort */}
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {developedGames.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-green-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               whileHover={{ y: -10, borderColor: "rgba(74, 222, 128, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-green-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-green-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.5)]">
//                 {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* SEKTION FOR KOMMENDE SPIL */}
//       <section
//         ref={gamesInDevRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/20 backdrop-blur-sm text-white flex flex-col items-center border-t border-white/10"
//       >
//         {/* Overskrift: Gjort solid hvid/cyan med shadow */}
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,188,212,0.5)] text-center tracking-tight">
//           Vores Sociale Spil
//         </h2>
        
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-cyan-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               whileHover={{ y: -10, borderColor: "rgba(6, 182, 212, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-cyan-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-cyan-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(8,145,178,0.5)]">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.div
//             onClick={scrollTo(headerRef)}
//             animate={{ y: [0, -8, 0] }}
//             transition={{ duration: 1.2, repeat: Infinity }}
//             className="mt-8 text-2xl text-pink-300"
//           >
//             <FaArrowUp size={30} color="white"/>
//           </motion.div>
      
//       </section>
//     </>
//   );
// });

// // --- UPDATED Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
//         <div className="flex flex-col items-center md:items-start">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- for alvor sjov!</p>
//             </div>
//           </div>
//           <div className="text-sm max-w-xs text-center md:text-left">
//             <ReactMarkdown>
//               {`Vi laver vores eget lort. Vi rykker spillet ud af skærmen og gør virkeligheden til den bedste arena, fordi det er her, det bliver **for alvor sjovt** at være sammen.`}
//             </ReactMarkdown>
//           </div>
//         </div>
//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <a href="mailto:hej@kloegtig.dk" className="flex items-center hover:text-purple-400">
//             <FaEnvelope className="mr-2 text-pink-400" /> hej@kloegtig.dk
//           </a>
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   // Effect for changing quotes
//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) =>
//         (prevIndex + 1) % heroQuotes.length
//       );
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval); // Cleanup on unmount
//   }, []); // Empty dependency array means it runs once on mount

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
//         teamCardsRef={teamCardsRef}
//         scrollTo={scrollTo}
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;





// import React, { useState, useEffect, useRef, useCallback} from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope, FaLinkedin, FaTwitter, FaFacebook, FaInstagram,
//   FaBehance, FaGithub, FaMedium, FaDribbble, FaStackOverflow,
//   FaArtstation, FaPinterest, FaPaintBrush, FaUsers, FaLightbulb,
//   FaChartLine, FaChevronUp, FaChevronDown, FaBrain, FaArrowDown, FaArrowUp
// } from "react-icons/fa";

// import logo from "./assets/logo/fox.png";
// import comingDummy from "./assets/images/kommende_spil_dummy.png"
// import releasedDummy from "./assets/images/udgivet_spil_dummy.png"
// import Brian from "./assets/team/mig3-headshot.png"

// // --- APP DATA ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500;
// const DECAY_AMOUNT = 1;
// const QUOTE_CHANGE_INTERVAL = 5000;

// const heroQuotes = [
//   "Vi bygger spil til dig, der er træt af at dyste mod en algoritme.",
//   "Ansigt til ansigt. Lige her i virkeligheden.",
//   "Kom op af sofaen! Legen venter lige foran dig.",
//   "Vi bruger kun mobilen som værktøjet, der holder styr på legen.",
//   "Gør ethvert rum eller sted til jeres fælles arena.",
//   "Kløgtig: Fordi det er sjovere at spille med rigtige mennesker."
// ];

// const rawTeamMembers = [
//   {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Eneansvarlig, Spiludvikler & Professionelt Legebarn",
//     fullRole: "Den kløgtige hjerne bag alt det her lort",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg er her ikke for at **please stivstikkere i den corporate verden eller gemme mig i et jakkesæt for at tækkes investorer**. Jeg bygger spil, der rykker ved virkeligheden. Det handler om at bevare evnen til at se leg i alt og gøre verden **for alvor sjov**.", 
//     infoBoxId: "innovationDevelopment"
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush",
//     title: "Design uden pis",
//     info: "Vi gider ikke kedelige kloner. Vi bygger oplevelser fra bunden, der føles som noget helt nyt. **Originalitet er ikke et valg, det er et krav** 🎨",
//     colors: { border: "#ff69b4", background: "#e91e63" },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samvær uden akavethed",
//     info: "Sociale spil behøver ikke være akavede teambuilding-øvelser. Vi designer rammerne, så I bare kan fokusere på at **grine og have det fedt sammen** 💪",
//     colors: { border: "#8a2be2", background: "#673ab7" },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Teknik der bare spiller",
//     info: "Vi nørder de svære ting i baggrunden – real-time synkronisering og værktøjer der virker – så alt spiller, når du trykker start. **Vi har styr på lortet** 💡",
//     colors: { border: "#FF9B00", background: "#FF7D08" },
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vores Mission",
//     info: "Vi vil have folk ud, hvor det sker. Vi bygger de værktøjer, der gør det muligt at spille og dyste sammen, uanset hvordan I mødes. Det handler om at komme op af sofaen og ind i legen.",
//     colors: { border: "#00bcd4", background: "#0097a7" },
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Projekt: [KLASSIFICERET]",
//     description: "Vi er i gang med at fintune noget, der kommer til at ændre måden, I ser verden på. Ingen spoilers endnu, men vi tør godt love, at det bliver leg på et helt nyt niveau. Hold øje med siden – vi løfter snart sløret.",
//     image: releasedDummy,
//     status: "Under wraps – vi tester stadig",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Arena: Udendørs",
//     description: "Vores næste store skridt. Vi rykker legen ud under åben himmel og gør verden til spillepladen. Her bruger vi teknologien til at binde jer sammen i det fri, uanset om I dyster eller samarbejder.",
//     image: comingDummy,
//     status: "I laboratoriet",
//   }
// ];


// const teamMembersWithCategories = rawTeamMembers;

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref}
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         {/* Front Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           {/* GLORIE EFFEKT PÅ BILLEDE */}
//           <motion.img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg border-2 border-yellow-400/50"
//             animate={{ 
//               boxShadow: [
//                 "0 0 15px rgba(255, 215, 0, 0.2)", 
//                 "0 0 40px rgba(255, 215, 0, 0.5)", 
//                 "0 0 15px rgba(255, 215, 0, 0.2)"
//               ] 
//             }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         {/* Back Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <div className="italic text-gray-400 text-center text-sm">
//             <ReactMarkdown>
//               {`"${member.mantra}"`}
//             </ReactMarkdown>
//           </div>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
//   teamCardsRef,
//   scrollTo
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">- for alvor sjov!</p>
//       </motion.div>

//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Virkeligheden er bare verdens bedste arena
//       </motion.h1>

//       <div className="w-full flex justify-center">
//         <div style={{ minHeight: "8rem" }} className="relative flex flex-col items-center">
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 text-center w-full px-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: "5rem" }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           <div className="mt-8 w-full max-w-md px-4"> {/* Containeren er nu bredere */}
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-4 px-8 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden transition-all"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white/20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               <motion.span className="relative z-10 flex items-center justify-center text-white whitespace-nowrap">
//                 {clicks < requiredClicks ? (
//                   <>
//                     <span>Pust Mit Ego Op!</span>
//                     <span className="text-xs ml-2 align-middle opacity-80">
//                       ({requiredClicks - clicks})
//                     </span>
//                   </>
//                 ) : (
//                   <span>Okay, nu er jeg klar – se her ↓</span>
//                 )}
//               </motion.span>
//             </motion.button>

//             <p className="mt-4 text-sm text-gray-400 italic">
//               Hvis du ikke engang orker at klikke <strong>{requiredClicks} gange</strong>, så er vores spil nok alligevel for vilde til dig
//             </p>

//             <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//           </div>

//           <motion.div
//         onClick={scrollTo(teamCardsRef)} // Scroller nu til TeamSection
//         animate={{ y: [0, -8, 0] }}
//         transition={{ duration: 1.2, repeat: Infinity }}
//         className="mt-8 text-2xl text-pink-300 cursor-pointer" // Tilføjet cursor-pointer
//       >
//         <FaArrowDown size={30} color="white"/>
//       </motion.div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo,
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);

//   const iconComponents = {
//     FaPaintBrush,
//     FaUsers,
//     FaLightbulb,
//     FaChartLine,
//     FaChevronDown,
//     FaChevronUp,
//     FaBrain,
//   };

//   const getIconComponent = (iconName) => iconComponents[iconName];

//   const handleInfoBoxClick = useCallback(
//     (box) => {
//       if (activeInfoBoxId === box.id) {
//         setActiveInfoBoxId(null);
//         setCurrentNavInfo(null);
//       } else {
//         setActiveInfoBoxId(box.id);
//         setCurrentNavInfo(box);
//       }
//     },
//     [activeInfoBoxId]
//   );

//   const handleDeflateClick = useCallback(() => {
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);

//   const isSingleMember = teamMembers.length === 1;
// const teamSectionTitle = isSingleMember ? 'Manden Bag Værket' : 'Holdet af kloge hoveder';
// const deflateButtonText = isSingleMember ? 'Punktér mit ego (og start forfra)' : 'Punktér os allesammen!';

//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >

//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
//       </div>

//       <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
//         {teamSectionTitle}
//       </h2>

 
//       <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
//         {infoBoxesData.map((box) => {
//           const Icon = getIconComponent(box.icon);
//           const isActive = activeInfoBoxId === box.id;

//           return (
//             <motion.button
//               key={box.id}
//               onClick={() => handleInfoBoxClick(box)}
//               className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
//                 ${isActive
//                   ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
//                   : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
//                 }
//               `}
//               style={{
//                 borderColor: isActive ? box.colors.border : undefined,
//                 backgroundColor: isActive ? box.colors.background : undefined,
//                 boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
//               }}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
//               {Icon && <Icon size={20} className="mr-2" />}
//               <span>{box.title}</span>
//             </motion.button>
//           );
//         })}
//       </div>

  
//       <AnimatePresence mode="wait">
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
//             style={{
//               boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
//             }}
//             initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
//             exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//           >
//             <h3 className="text-3xl font-bold mb-4 text-white">
//               {currentNavInfo.title}
//             </h3>
//             <div className="text-lg leading-relaxed text-gray-200 markdown-content">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

     
//       <div
//         className={`grid gap-8 max-w-7xl w-full relative z-10 ${
//           teamMembers.length === 1
//             ? 'grid-cols-1 place-items-center'
//             : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
//         }`}
//       >
//         {teamMembers.map((m) => {
//           const isHighlighted = activeInfoBoxId === m.infoBoxId;
//           const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
//           const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               highlightColor={highlightColor}
//               ref={(el) => (cardRefs.current[m.id] = el)}
//             />
//           );
//         })}
//       </div>

   
//       <div className="mt-20 relative z-10">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
//           style={{
//             background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 2s ease-in-out infinite",
//           }}
//           whileHover={{
//             scale: 1.03,
//             boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
//             transition: { duration: 0.2 }
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="relative z-10">{deflateButtonText}</span>
//           <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// })

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       {/* SEKTION FOR UDGIVNE SPIL */}
//       <section
//         ref={gamesSectionRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/40 text-white flex flex-col items-center"
//       >
//         {/* Overskrift: Gjort solid og hvid med kraftig shadow for maksimal tydelighed */}
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,255,150,0.5)] text-center tracking-tight">
//           Udgivne Spil
//         </h2>
        
//         {/* Container: Bruger flex-wrap og justify-center for at sikre 100% centrering af 1 eller flere kort */}
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {developedGames.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-green-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               whileHover={{ y: -10, borderColor: "rgba(74, 222, 128, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-green-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-green-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.5)]">
//                 {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* SEKTION FOR KOMMENDE SPIL */}
//       <section
//         ref={gamesInDevRef}
//         className="relative z-10 w-full py-24 px-4 bg-black/20 backdrop-blur-sm text-white flex flex-col items-center border-t border-white/10"
//       >
//         {/* Overskrift: Gjort solid hvid/cyan med shadow */}
//         <h2 className="text-5xl md:text-6xl font-extrabold mb-16 text-white drop-shadow-[0_2px_10px_rgba(0,188,212,0.5)] text-center tracking-tight">
//           Vores Sociale Spil
//         </h2>
        
//         <div className="flex flex-wrap justify-center gap-10 max-w-6xl w-full">
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-gray-900/80 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-cyan-500/40 text-center flex flex-col w-full max-w-md"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               whileHover={{ y: -10, borderColor: "rgba(6, 182, 212, 0.8)" }}
//             >
//               <div className="relative overflow-hidden rounded-2xl mb-6 border border-white/10">
//                 <img src={game.image} alt={game.title} className="w-full h-56 object-cover" />
//               </div>
//               <h3 className="text-3xl font-bold mb-3 text-cyan-400">{game.title}</h3>
//               <p className="text-gray-200 text-base leading-relaxed mb-6 flex-grow">{game.description}</p>
//               <span className="inline-block bg-cyan-600 text-white font-bold py-2 px-8 rounded-full shadow-[0_0_15px_rgba(8,145,178,0.5)]">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.div
//             onClick={scrollTo(headerRef)}
//             animate={{ y: [0, -8, 0] }}
//             transition={{ duration: 1.2, repeat: Infinity }}
//             className="mt-8 text-2xl text-pink-300"
//           >
//             <FaArrowUp size={30} color="white"/>
//           </motion.div>
      
//       </section>
//     </>
//   );
// });

// // --- UPDATED Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
//         <div className="flex flex-col items-center md:items-start">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- for alvor sjov!</p>
//             </div>
//           </div>
//           <div className="text-sm max-w-xs text-center md:text-left">
//             <ReactMarkdown>
//               {`Vi laver vores eget lort. Vi rykker spillet ud af skærmen og gør virkeligheden til den bedste arena, fordi det er her, det bliver **for alvor sjovt** at være sammen.`}
//             </ReactMarkdown>
//           </div>
//         </div>
//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <a href="mailto:hej@kloegtig.dk" className="flex items-center hover:text-purple-400">
//             <FaEnvelope className="mr-2 text-pink-400" /> hej@kloegtig.dk
//           </a>
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   // Effect for changing quotes
//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) =>
//         (prevIndex + 1) % heroQuotes.length
//       );
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval); // Cleanup on unmount
//   }, []); // Empty dependency array means it runs once on mount

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
//         teamCardsRef={teamCardsRef}
//         scrollTo={scrollTo}
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;





// import React, { useState, useEffect, useRef, useCallback} from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope,
//   FaLinkedin,
//   FaTwitter,
//   FaFacebook,
//   FaInstagram,
//   FaBehance,
//   FaGithub,
//   FaMedium,
//   FaDribbble,
//   FaStackOverflow,
//   FaArtstation,
//   FaPinterest,
//   FaPaintBrush,
//   FaUsers,
//   FaLightbulb,
//   FaChartLine,
//   FaChevronUp,
//   FaChevronDown,
//   FaBrain,
//   FaArrowDown,
//   FaArrowUp
// } from "react-icons/fa";
// import logo from "./assets/logo/fox.png"; // Make sure your logo is here
// import comingDummy from "./assets/images/kommende spil dummy-2.png"
// import releasedDummy from "./assets/images/udgivet spil dummy.png"
// import Brian from "./assets/team/mig3-headshot.png"

// // --- APP DATA (moved from appData.js) ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500; // Time in ms before a click decays
// const DECAY_AMOUNT = 1; // How many clicks decay per interval
// const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

// const heroQuotes = [
//   "Vi bygger spil til dig, der er træt af at dyste mod en algoritme.",
//   "Ansigt til ansigt. Lige her i virkeligheden.",
//   "Kom op af sofaen! Legen venter lige foran dig.",
//   "Vi bruger kun mobilen som værktøjet, der holder styr på legen.",
//   "Gør ethvert rum eller sted til jeres fælles arena.",
//   "Kløgtig: Fordi det er sjovere at spille med rigtige mennesker."
// ];

// const rawTeamMembers = [
//   {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Eneansvarlig, Spiludvikler & Professionelt Legebarn",
//     fullRole: "Den kløgtige hjerne bag alt det her lort",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg er her ikke for at **please stivstikkere i den corporate verden eller gemme mig i et jakkesæt for at tækkes investorer**. Jeg bygger spil, der rykker ved virkeligheden. Det handler om at bevare evnen til at se leg i alt og gøre verden **for alvor sjov**.", 
//     infoBoxId: "innovationDevelopment"
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush",
//     title: "Design uden pis",
//     info: "Vi gider ikke kedelige kloner. Vi bygger oplevelser fra bunden, der føles som noget helt nyt. **Originalitet er ikke et valg, det er et krav** 🎨",
//     colors: { border: "#ff69b4", background: "#e91e63" },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samvær uden akavethed",
//     info: "Sociale spil behøver ikke være akavede teambuilding-øvelser. Vi designer rammerne, så I bare kan fokusere på at **grine og have det fedt sammen** 💪",
//     colors: { border: "#8a2be2", background: "#673ab7" },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Teknik der bare spiller",
//     info: "Vi nørder de svære ting i baggrunden – real-time synkronisering og værktøjer der virker – så alt spiller, når du trykker start. **Vi har styr på lortet** 💡",
//     colors: { border: "#FF9B00", background: "#FF7D08" },
//   },
//   {
//   id: "visionProgress",
//   icon: "FaChartLine",
//   title: "Vores Mission",
//   info: "Vi vil have folk ud, hvor det sker. Vi bygger de værktøjer, der gør det muligt at spille og dyste sammen, uanset hvordan I mødes. Det handler om at komme op af sofaen og ind i legen.",
//   colors: { border: "#00bcd4", background: "#0097a7" },
// },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "IRL Quiz Show (Beta)",
//     description: "Vores første udgivelse. Et intenst setup, hvor din mobil er din svarknap, men hvor legen og samværet foregår ansigt til ansigt. Kom op af stolen og vis hvem der er klogest, uanset hvor arenaen er.",
//     image: releasedDummy, // Du kan evt. bruge et specifikt billede her senere
//     status: "Ude nu – vi tester og retter til",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Arena: Udendørs",
//     description: "Vores næste store skridt. Vi rykker legen ud under åben himmel og gør verden til spillepladen. Her bruger vi teknologien til at binde jer sammen i det fri, uanset om I dyster eller samarbejder.",
//     image: comingDummy,
//     status: "I laboratoriet",
//   }
// ];


// const teamMembersWithCategories = rawTeamMembers;

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref}
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         {/* Front Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           {/* GLORIE EFFEKT PÅ BILLEDE */}
//           <motion.img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg border-2 border-yellow-400/50"
//             animate={{ 
//               boxShadow: [
//                 "0 0 15px rgba(255, 215, 0, 0.2)", 
//                 "0 0 40px rgba(255, 215, 0, 0.5)", 
//                 "0 0 15px rgba(255, 215, 0, 0.2)"
//               ] 
//             }}
//             transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         {/* Back Side */}
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <div className="italic text-gray-400 text-center text-sm">
//             <ReactMarkdown>
//               {`"${member.mantra}"`}
//             </ReactMarkdown>
//           </div>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* Logo + Titel */}
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img
//           src={logo}
//           alt="Kløgtig logo"
//           className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2"
//         />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">
//           kløgtig
//         </span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">
//           - for alvor sjov!
//         </p>
//       </motion.div>

//       {/* Overskrift */}
//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Virkeligheden Er Den Bedste Arena
//       </motion.h1>

//       {/* Citat */}
//       <div className="w-full flex justify-center">
//         <div style={{ minHeight: "8rem" }} className="relative flex flex-col items-center">
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 text-center w-full"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: "5rem" }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           {/* Knap + progress */}
//           <div className="mt-8 w-72 md:w-80">
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               transition={{ duration: 0.1 }}
//               aria-label="Pust Ego Op!"
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white/20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               <motion.span className="relative z-10 flex items-center justify-center text-white">
//   {clicks < requiredClicks ? (
//     <>
//       <span>Pust Mit Ego Op!</span>
//       <span className="text-xs ml-1 align-middle">
//         &nbsp;({requiredClicks - clicks} tilbage)
//       </span>
//     </>
//   ) : (
//     <span>Okay, nu er jeg klar – se her ↓</span>
//   )}
// </motion.span>
//             </motion.button>

//             {/* Microcopy */}
//             <p className="mt-2 text-sm text-gray-400 italic">
//   Hvis du ikke engang orker at klikke <strong>{requiredClicks} gange</strong>, så er vores spil nok alligevel for vilde til dig ↓
// </p>

//             {/* Progress-bar */}
//             <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//             <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
//               {clicks} / {requiredClicks} klik
//             </div>
//           </div>

//           {/* Pege-animation */}
//           <motion.div
//             animate={{ y: [0, -8, 0] }}
//             transition={{ duration: 1.2, repeat: Infinity }}
//             className="mt-4 text-2xl text-pink-300"
//           >
//             <FaArrowDown size={30} color="white"/>
//           </motion.div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo,
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);

//   const iconComponents = {
//     FaPaintBrush,
//     FaUsers,
//     FaLightbulb,
//     FaChartLine,
//     FaChevronDown,
//     FaChevronUp,
//     FaBrain,
//   };

//   const getIconComponent = (iconName) => iconComponents[iconName];

//   const handleInfoBoxClick = useCallback(
//     (box) => {
//       if (activeInfoBoxId === box.id) {
//         setActiveInfoBoxId(null);
//         setCurrentNavInfo(null);
//       } else {
//         setActiveInfoBoxId(box.id);
//         setCurrentNavInfo(box);
//       }
//     },
//     [activeInfoBoxId]
//   );

//   const handleDeflateClick = useCallback(() => {
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);

//   const isSingleMember = teamMembers.length === 1;
// const teamSectionTitle = isSingleMember ? 'Manden Bag Værket' : 'Holdet af kloge hoveder';
// const deflateButtonText = isSingleMember ? 'Punktér mit ego (og start forfra)' : 'Punktér os allesammen!';

//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >

//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
//       </div>

//       <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
//         {teamSectionTitle}
//       </h2>

 
//       <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
//         {infoBoxesData.map((box) => {
//           const Icon = getIconComponent(box.icon);
//           const isActive = activeInfoBoxId === box.id;

//           return (
//             <motion.button
//               key={box.id}
//               onClick={() => handleInfoBoxClick(box)}
//               className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
//                 ${isActive
//                   ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
//                   : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
//                 }
//               `}
//               style={{
//                 borderColor: isActive ? box.colors.border : undefined,
//                 backgroundColor: isActive ? box.colors.background : undefined,
//                 boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
//               }}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
//               {Icon && <Icon size={20} className="mr-2" />}
//               <span>{box.title}</span>
//             </motion.button>
//           );
//         })}
//       </div>

  
//       <AnimatePresence mode="wait">
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
//             style={{
//               boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
//             }}
//             initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
//             exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//           >
//             <h3 className="text-3xl font-bold mb-4 text-white">
//               {currentNavInfo.title}
//             </h3>
//             <div className="text-lg leading-relaxed text-gray-200 markdown-content">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

     
//       <div
//         className={`grid gap-8 max-w-7xl w-full relative z-10 ${
//           teamMembers.length === 1
//             ? 'grid-cols-1 place-items-center'
//             : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
//         }`}
//       >
//         {teamMembers.map((m) => {
//           const isHighlighted = activeInfoBoxId === m.infoBoxId;
//           const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
//           const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               highlightColor={highlightColor}
//               ref={(el) => (cardRefs.current[m.id] = el)}
//             />
//           );
//         })}
//       </div>

   
//       <div className="mt-20 relative z-10">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
//           style={{
//             background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 2s ease-in-out infinite",
//           }}
//           whileHover={{
//             scale: 1.03,
//             boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
//             transition: { duration: 0.2 }
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="relative z-10">{deflateButtonText}</span>
//           <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// })

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//     <section
//         ref={gamesSectionRef} // Brug den korrekte ref her
//         className="relative z-10 w-full py-20 px-4 bg-black/20 text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-400">
//           Udgivne Spil
//         </h2>
//         <div className="grid gap-8 max-w-4xl w-full grid-cols-1 md:grid-cols-2 justify-items-center">
//           {developedGames.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-green-700 text-center flex flex-col w-full"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//             >
//               <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4" />
//               <h3 className="text-2xl font-bold mb-2 text-green-300">{game.title}</h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
//               <span className="inline-block bg-green-600 text-white font-semibold py-1 px-4 rounded-full">
//                 {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//       </section>
//       <section
//         ref={gamesInDevRef}
//         id="games-in-development"
//         className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
//           Vores Sociale Spil
//         </h2>
//         <div
//           className={`grid gap-8 max-w-4xl w-full ${
//             gamesInDevelopment.length === 1
//               ? "grid-cols-1 max-w-sm"
//               : gamesInDevelopment.length === 2
//               ? "grid-cols-1 md:grid-cols-2 max-w-2xl"
//               : "grid-cols-1 md:grid-cols-2"
//           } ${gamesInDevelopment.length <= 2 ? "justify-items-center" : ""}`}
//         >
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center flex flex-col w-full"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               transition={{ duration: 0.6 }}
//             >
//               <img
//                 src={game.image}
//                 alt={game.title}
//                 className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
//               />
//               <h3 className="text-2xl font-bold mb-2 text-cyan-300">
//                 {game.title}
//               </h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">
//                 {game.description}
//               </p>
//               <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.div
//   animate={{ y: [0, -8, 0] }}
//   transition={{ duration: 1.2, repeat: Infinity, repeatType: "loop" }}
// >
//   <motion.button
//     onClick={scrollTo(headerRef)}
//     className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg"
//     initial={{ opacity: 0, y: 20 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     viewport={{ once: true, amount: 0.5 }}
//     transition={{ duration: 0.5 }}
//     whileHover={{ scale: 1.1, boxShadow: "0 0 20px rgba(128, 90, 213, 0.7)" }}
//     whileTap={{ scale: 0.95 }}
//     aria-label="Scroll back to top"
//   >
//     <FaArrowUp size={30} className="text-white" />
//   </motion.button>
// </motion.div>

//       </section>
//     </>
//   );
// });

// // --- COMPONENT: Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
//         <div className="flex flex-col items-center md:items-start text-center md:text-left">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- for alvor sjov!</p>
//             </div>
//           </div>
//           <div className="text-sm max-w-xs">
//             <ReactMarkdown>
//     Vi laver vores eget lort. Vi rykker spillet ud af skærmen og gør virkeligheden til den bedste arena, fordi det er her, det bliver **for alvor sjovt** at være sammen.
//   </ReactMarkdown>
//           </div>
//           <p className="text-sm mt-2">
//             &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
//             forbeholdt.
//           </p>
//         </div>

//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <ul className="space-y-2">
//             <li className="flex items-center justify-center md:justify-start">
//               <FaEnvelope className="mr-2 text-pink-400" />
//               <a href="mailto:hej@kloegtig.dk" className="hover:text-purple-400 transition-colors">
//                 hej@kloegtig.dk
//               </a>
//             </li>
    
//           </ul>
       
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   // Effect for changing quotes
//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) =>
//         (prevIndex + 1) % heroQuotes.length
//       );
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval); // Cleanup on unmount
//   }, []); // Empty dependency array means it runs once on mount

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;





// import React, { useState, useEffect, useRef, useCallback} from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope,
//   FaLinkedin,
//   FaTwitter,
//   FaFacebook,
//   FaInstagram,
//   FaBehance,
//   FaGithub,
//   FaMedium,
//   FaDribbble,
//   FaStackOverflow,
//   FaArtstation,
//   FaPinterest,
//   FaPaintBrush,
//   FaUsers,
//   FaLightbulb,
//   FaChartLine,
//   FaChevronUp,
//   FaChevronDown,
//   FaBrain
// } from "react-icons/fa";
// import logo from "./assets/logo/fox.png"; // Make sure your logo is here
// import comingDummy from "./assets/images/kommende spil dummy-2.png"
// import releasedDummy from "./assets/images/udgivet spil dummy.png"
// import Brian from "./assets/team/mig3-headshot.png"

// // --- APP DATA (moved from appData.js) ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500; // Time in ms before a click decays
// const DECAY_AMOUNT = 1; // How many clicks decay per interval
// const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

// const heroQuotes = [
//   "Hos Kløgtig skaber vi uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
//   "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
//   "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
//   "Vi bringer mennesker sammen, én latterfyldt spiloplevelse ad gangen",
//   "Vores mission? Uendelig sjov, for alle!",
//   "Vi skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt."
// ];

// const rawTeamMembers = [
//     {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Grundlægger, Spilskaber & Idémager",
//     fullRole: "Kløgtigs kreative kraft og legeleder",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg finder glæden i at skubbe grænserne for leg, så vi kan skabe uventede fællesskaber gennem konstant innovation",
//     infoBoxId: "innovationDevelopment"
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush", // Use string for icon name, pass to component to render
//     title: "Kreativitet & Design",
//     info: "Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst 🎮",
//     colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samarbejde & Fællesskab",
//     info: "Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere 💪",
//     colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Innovation & Udvikling",
//     info: "Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer** 💡",
//     colors: { border: "#FF9B00", background: "#FF7D08" }, // Sunny Yellow
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vision & Fremdrift",
//     info: "Vi har et **klart formål og en tydelig retning** for vores spil og forretning 🧭 ",
//     colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Ingen sociale spil udgivet endnu!",
//     description: "Vi er travlt optaget med at skabe fremtidens klassikere inden for social gaming. Følg med!",
//     image: releasedDummy,
//     //link: "#",
//     status: "I beta",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Spændende socialt spilprojekt i støbeskeen!",
//     description: "Vi har et helt nyt socialt spilprojekt under udvikling, som for alvor er sat over ilden i laboratoriet. Forbered jer på en innovativ måde at forbinde og more jer på. Projektet er allerede i beta, så glæd jer til at opleve det snart!",
//     image: comingDummy,
//     status: "I Beta",
//   },
//   {
//     id: 102,
//     title: "Nye interaktive sociale eventyr undervejs!",
//     description: "Vi brygger på noget helt særligt i vores laboratorier. Hold øje med nye sociale oplevelser, der snart afsløres!",
//     image: comingDummy,
//     status: "Hemmeligt Projekt",
//   },
// ];


// const teamMembersWithCategories = rawTeamMembers;

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref} // Attach the ref here
//       // *** CHANGE HERE: Use a max-width instead of w-full ***
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       // You can adjust max-w-sm to max-w-md, max-w-lg, etc., depending on your desired card size.
//       // w-full is kept to ensure it still expands to fill the space up to the max-width.
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         <div
//           className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg"
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         <div
//           className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <p className="italic text-gray-400 text-center text-sm">
//             "{member.mantra}"
//           </p>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);
//   const QUOTE_SECTION_HEIGHT = '8rem'; 

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
     
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
//       </motion.div>
      

//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Vi Skaber Sociale Spil, Der Forbinder!
//       </motion.h1>

 
//       <div className="w-full flex justify-center"> 
//         <div 
//           className="relative flex flex-col items-center"
//           style={{ minHeight: QUOTE_SECTION_HEIGHT, width: '600px' }} // Fixed width here
//         >
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 flex items-center justify-center text-center w-full"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: '5rem' }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           <div className="absolute left-1/2 -translate-x-1/2 w-72 md:w-80"
//                style={{ top: QUOTE_SECTION_HEIGHT, marginTop: '2rem' }}>
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               transition={{ duration: 0.1 }}
//               aria-label="Pust Vores Egoer Op!"
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white/20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               {rawTeamMembers.length > 1 ? (<span className="relative z-10 text-white">Pust Vores Egoer Op!</span>) : (<span className="relative z-10 text-white">Pust Mit Ego Op!</span>)}
              
//             </motion.button>
//             <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//             <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
//               {clicks} / {requiredClicks} klik
//             </div>
//           </div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo,
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);

//   const iconComponents = {
//     FaPaintBrush,
//     FaUsers,
//     FaLightbulb,
//     FaChartLine,
//     FaChevronDown,
//     FaChevronUp,
//     FaBrain,
//   };

//   const getIconComponent = (iconName) => iconComponents[iconName];

//   const handleInfoBoxClick = useCallback(
//     (box) => {
//       if (activeInfoBoxId === box.id) {
//         setActiveInfoBoxId(null);
//         setCurrentNavInfo(null);
//       } else {
//         setActiveInfoBoxId(box.id);
//         setCurrentNavInfo(box);
//       }
//     },
//     [activeInfoBoxId]
//   );

//   const handleDeflateClick = useCallback(() => {
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);

//   const isSingleMember = teamMembers.length === 1;
//   const teamSectionTitle = isSingleMember ? 'Mød Mig!' : 'Mød Vores Team!';
//   const deflateButtonText = isSingleMember ? 'Punktér Mig!' : 'Punktér Os!';

//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >

//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
//         <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
//       </div>

//       <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
//         {teamSectionTitle}
//       </h2>

 
//       <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
//         {infoBoxesData.map((box) => {
//           const Icon = getIconComponent(box.icon);
//           const isActive = activeInfoBoxId === box.id;

//           return (
//             <motion.button
//               key={box.id}
//               onClick={() => handleInfoBoxClick(box)}
//               className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
//                 ${isActive
//                   ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
//                   : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
//                 }
//               `}
//               style={{
//                 borderColor: isActive ? box.colors.border : undefined,
//                 backgroundColor: isActive ? box.colors.background : undefined,
//                 boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
//               }}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
//               {Icon && <Icon size={20} className="mr-2" />}
//               <span>{box.title}</span>
//             </motion.button>
//           );
//         })}
//       </div>

  
//       <AnimatePresence mode="wait">
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
//             style={{
//               boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
//             }}
//             initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
//             exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
//             transition={{ duration: 0.4, ease: "easeOut" }}
//           >
//             <h3 className="text-3xl font-bold mb-4 text-white">
//               {currentNavInfo.title}
//             </h3>
//             <div className="text-lg leading-relaxed text-gray-200 markdown-content">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

     
//       <div
//         className={`grid gap-8 max-w-7xl w-full relative z-10 ${
//           teamMembers.length === 1
//             ? 'grid-cols-1 place-items-center'
//             : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
//         }`}
//       >
//         {teamMembers.map((m) => {
//           const isHighlighted = activeInfoBoxId === m.infoBoxId;
//           const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
//           const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               highlightColor={highlightColor}
//               ref={(el) => (cardRefs.current[m.id] = el)}
//             />
//           );
//         })}
//       </div>

   
//       <div className="mt-20 relative z-10">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
//           style={{
//             background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 2s ease-in-out infinite",
//           }}
//           whileHover={{
//             scale: 1.03,
//             boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
//             transition: { duration: 0.2 }
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="relative z-10">{deflateButtonText}</span>
//           <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// })

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       <section
//         ref={gamesInDevRef}
//         id="games-in-development"
//         className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
//           Vores Sociale Spil
//         </h2>
//         <div
//           className={`grid gap-8 max-w-4xl w-full ${
//             gamesInDevelopment.length === 1
//               ? "grid-cols-1 max-w-sm"
//               : gamesInDevelopment.length === 2
//               ? "grid-cols-1 md:grid-cols-2 max-w-2xl"
//               : "grid-cols-1 md:grid-cols-2"
//           } ${gamesInDevelopment.length <= 2 ? "justify-items-center" : ""}`}
//         >
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center flex flex-col w-full"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               transition={{ duration: 0.6 }}
//             >
//               <img
//                 src={game.image}
//                 alt={game.title}
//                 className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
//               />
//               <h3 className="text-2xl font-bold mb-2 text-cyan-300">
//                 {game.title}
//               </h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">
//                 {game.description}
//               </p>
//               <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.button
//           onClick={scrollTo(headerRef)}
//           className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ duration: 0.5 }}
//           aria-label="Scroll back to top"
//         >
//           <FaChevronUp size={30} />
//         </motion.button>
//       </section>
//     </>
//   );
// });

// // --- COMPONENT: Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
//         <div className="flex flex-col items-center md:items-start text-center md:text-left">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
//             </div>
//           </div>
//           <div className="text-sm max-w-xs">
//             <ReactMarkdown>
//               Skaber uforglemmelige **sociale spiloplevelser**, der forbinder spillere
//               både lokalt og globalt.
//             </ReactMarkdown>
//           </div>
//           <p className="text-sm mt-2">
//             &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
//             forbeholdt.
//           </p>
//         </div>

//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <ul className="space-y-2">
//             <li className="flex items-center justify-center md:justify-start">
//               <FaEnvelope className="mr-2 text-pink-400" />
//               <a href="mailto:hej@kloegtig.dk" className="hover:text-purple-400 transition-colors">
//                 hej@kloegtig.dk
//               </a>
//             </li>
//             {/* <li className="flex items-center justify-center md:justify-start">
//              <FaPhone className="mr-2 text-pink-400" />
//             <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
//               +45 12 34 56 78
//             </a>
//              </li>  */}
//           </ul>
//            {/* <div className="flex justify-center md:justify-start space-x-4 mt-6">
//              <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//                <FaFacebook size={24} />
//              </a>
//              <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//                <FaTwitter size={24} />
//              </a>
//              <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//                <FaInstagram size={24} />
//              </a>
//              <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//                <FaLinkedin size={24} />
//              </a>
//            </div>  */}
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   // Effect for changing quotes
//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) =>
//         (prevIndex + 1) % heroQuotes.length
//       );
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval); // Cleanup on unmount
//   }, []); // Empty dependency array means it runs once on mount

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;





/* import React, { useState, useEffect, useRef, useCallback} from "react";
import { motion, AnimatePresence, useSpring } from "framer-motion";
import canvasConfetti from "canvas-confetti";
import ReactMarkdown from "react-markdown";
import {
  FaEnvelope,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaBehance,
  FaGithub,
  FaMedium,
  FaDribbble,
  FaStackOverflow,
  FaArtstation,
  FaPinterest,
  FaPaintBrush,
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaChevronUp,
  FaChevronDown,
  FaBrain
} from "react-icons/fa";
import logo from "./assets/logo/fox.png"; // Make sure your logo is here
import comingDummy from "./assets/images/kommende spil dummy-2.png"
import releasedDummy from "./assets/images/udgivet spil dummy.png"
import Brian from "./assets/team/mig3-headshot.png"

// --- APP DATA (moved from appData.js) ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500; // Time in ms before a click decays
const DECAY_AMOUNT = 1; // How many clicks decay per interval
const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

const heroQuotes = [
  "Hos Kløgtig skaber vi uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
  "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
  "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
  "Vi bringer mennesker sammen, én latterfyldt spiloplevelse ad gangen",
  "Vores mission? Uendelig sjov, for alle!",
  "Vi skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt."
];

const rawTeamMembers = [
    {
    id: 1,
    name: "Brian",
    photo: Brian,
    role: "Grundlægger, Spilskaber & Idémager",
    fullRole: "Kløgtigs kreative kraft og legeleder",
    contactInfo: {
      email: "brian@kloegtig.dk",
      phone: "+4593949459",
      social: "linkedin.com/in/brian-nørgaard-775130243",
    },
    mantra: "Jeg finder glæden i at skubbe grænserne for leg, så vi kan skabe uventede fællesskaber gennem konstant innovation",
    infoBoxId: "innovationDevelopment"
  }
];

const infoBoxesData = [
  {
    id: "creativityDesign",
    icon: "FaPaintBrush", // Use string for icon name, pass to component to render
    title: "Kreativitet & Design",
    info: "Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst 🎮",
    colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
  },
  {
    id: "teamworkCommunity",
    icon: "FaUsers",
    title: "Samarbejde & Fællesskab",
    info: "Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere 💪",
    colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
  },
  {
    id: "innovationDevelopment",
    icon: "FaLightbulb",
    title: "Innovation & Udvikling",
    info: "Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer** 💡",
    colors: { border: "#FF9B00", background: "#FF7D08" }, // Sunny Yellow
  },
  {
    id: "visionProgress",
    icon: "FaChartLine",
    title: "Vision & Fremdrift",
    info: "Vi har et **klart formål og en tydelig retning** for vores spil og forretning 🧭 ",
    colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
  },
];

const developedGames = [
  {
    id: 1,
    title: "Ingen sociale spil udgivet endnu!",
    description: "Vi er travlt optaget med at skabe fremtidens klassikere inden for social gaming. Følg med!",
    image: releasedDummy,
    //link: "#",
    status: "I beta",
  }
];

const gamesInDevelopment = [
  {
    id: 101,
    title: "Spændende socialt spilprojekt i støbeskeen!",
    description: "Vi har et helt nyt socialt spilprojekt under udvikling, som for alvor er sat over ilden i laboratoriet. Forbered jer på en innovativ måde at forbinde og more jer på. Projektet er allerede i beta, så glæd jer til at opleve det snart!",
    image: comingDummy,
    status: "I Beta",
  },
  {
    id: 102,
    title: "Nye interaktive sociale eventyr undervejs!",
    description: "Vi brygger på noget helt særligt i vores laboratorier. Hold øje med nye sociale oplevelser, der snart afsløres!",
    image: comingDummy,
    status: "Hemmeligt Projekt",
  },
];


const teamMembersWithCategories = rawTeamMembers;

// --- COMPONENT: TeamCard ---
const getSocialIcon = (socialUrl) => {
  if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
  if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
  if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
  if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
  if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
  if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
  if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
  if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
  if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
  if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
  if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
  return null;
};

const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 });

  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      ref={ref} // Attach the ref here
      // *** CHANGE HERE: Use a max-width instead of w-full ***
      className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
        dimmed ? "opacity-40" : ""
      } cursor-default`}
      // You can adjust max-w-sm to max-w-md, max-w-lg, etc., depending on your desired card size.
      // w-full is kept to ensure it still expands to fill the space up to the max-width.
      style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        <div
          className="absolute inset-0 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(0deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <img
            src={member.photo}
            alt={member.name}
            className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg"
          />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(180deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">
            {member.name}'s Info
          </h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
              {member.contactInfo.email}
            </a>
          </p>
          {member.contactInfo.social && (
            <p className="text-sm text-gray-200 mb-3 flex items-center">
              {getSocialIcon(member.contactInfo.social)}
              <a
                href={`https://${member.contactInfo.social}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {member.contactInfo.social.split("/").pop()}
              </a>
            </p>
          )}
          <p className="italic text-gray-400 text-center text-sm">
            "{member.mantra}"
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
});

// --- COMPONENT: HeroSection ---
const HeroSection = ({
  clicks,
  requiredClicks,
  handleMainButtonClick,
  isButtonClicked,
  currentQuote,
}) => {
  const progressPct = Math.round((clicks / requiredClicks) * 100);
  const QUOTE_SECTION_HEIGHT = '8rem'; 

  return (
    <motion.header
      className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
     
      <motion.div
        className="flex flex-col items-center mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
      >
        <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
        <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
        <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
      </motion.div>
      

      <motion.h1
        className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
      >
        Vi Skaber Sociale Spil, Der Forbinder!
      </motion.h1>

 
      <div className="w-full flex justify-center"> 
        <div 
          className="relative flex flex-col items-center"
          style={{ minHeight: QUOTE_SECTION_HEIGHT, width: '600px' }} // Fixed width here
        >
          <AnimatePresence mode="wait">
            <motion.p
              key={currentQuote}
              className="mt-4 text-base md:text-xl font-medium text-gray-200 flex items-center justify-center text-center w-full"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              style={{ minHeight: '5rem' }}
            >
              {currentQuote}
            </motion.p>
          </AnimatePresence>

          <div className="absolute left-1/2 -translate-x-1/2 w-72 md:w-80"
               style={{ top: QUOTE_SECTION_HEIGHT, marginTop: '2rem' }}>
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
                backgroundSize: "200% 200%",
                animation: "buttonGradient 2s linear infinite",
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label="Pust Vores Egoer Op!"
              disabled={clicks >= requiredClicks}
            >
              <motion.div
                className="absolute inset-0 bg-white/20"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
              {rawTeamMembers.length > 1 ? (<span className="relative z-10 text-white">Pust Vores Egoer Op!</span>) : (<span className="relative z-10 text-white">Pust Mit Ego Op!</span>)}
              
            </motion.button>
            <div className="mt-4 w-full bg-gray-200 h-2 rounded overflow-hidden">
              <motion.div
                className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
              {clicks} / {requiredClicks} klik
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

// --- COMPONENT: TeamSection ---
const TeamSection = React.memo(({
  teamMembers,
  infoBoxesData,
  teamCardsRef,
  resetEgo,
  cardRefs,
  triggerConfettiAtRef,
}) => {
  const [activeInfoBoxId, setActiveInfoBoxId] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);

  const iconComponents = {
    FaPaintBrush,
    FaUsers,
    FaLightbulb,
    FaChartLine,
    FaChevronDown,
    FaChevronUp,
    FaBrain,
  };

  const getIconComponent = (iconName) => iconComponents[iconName];

  const handleInfoBoxClick = useCallback(
    (box) => {
      if (activeInfoBoxId === box.id) {
        setActiveInfoBoxId(null);
        setCurrentNavInfo(null);
      } else {
        setActiveInfoBoxId(box.id);
        setCurrentNavInfo(box);
      }
    },
    [activeInfoBoxId]
  );

  const handleDeflateClick = useCallback(() => {
    Object.values(cardRefs.current).forEach((ref) => {
      if (ref) {
        triggerConfettiAtRef(ref);
      }
    });
    resetEgo();
  }, [cardRefs, triggerConfettiAtRef, resetEgo]);

  const isSingleMember = teamMembers.length === 1;
  const teamSectionTitle = isSingleMember ? 'Mød Mig!' : 'Mød Vores Team!';
  const deflateButtonText = isSingleMember ? 'Punktér Mig!' : 'Punktér Os!';

  return (
    <motion.section
      ref={teamCardsRef}
      className="relative z-10 w-full py-24 px-4 flex flex-col justify-center items-center bg-gradient-to-br from-gray-950 to-gray-800 text-white overflow-hidden min-h-screen" // Deeper, more sophisticated background
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >

      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-teal-500 rounded-full mix-blend-soft-light filter blur-3xl animate-blob-slow animation-delay-4000"></div>
      </div>

      <h2 className="text-5xl md:text-7xl font-extrabold mb-8 pb-4 text-center relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 drop-shadow-lg leading-tight">
        {teamSectionTitle}
      </h2>

 
      <div className="flex flex-wrap justify-center items-center mb-16 gap-3 md:gap-5 max-w-5xl relative z-10">
        {infoBoxesData.map((box) => {
          const Icon = getIconComponent(box.icon);
          const isActive = activeInfoBoxId === box.id;

          return (
            <motion.button
              key={box.id}
              onClick={() => handleInfoBoxClick(box)}
              className={`flex items-center px-6 py-2 rounded-full font-medium text-sm md:text-base transition-all duration-300 ease-in-out cursor-pointer relative overflow-hidden group
                ${isActive
                  ? `bg-opacity-20 text-white shadow-lg border border-opacity-60`
                  : 'bg-gray-700 bg-opacity-40 text-gray-300 border border-transparent hover:bg-opacity-60'
                }
              `}
              style={{
                borderColor: isActive ? box.colors.border : undefined,
                backgroundColor: isActive ? box.colors.background : undefined,
                boxShadow: isActive ? `0 0 25px ${box.colors.border}80` : 'none',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-5 transition-opacity duration-200"></span> 
              {Icon && <Icon size={20} className="mr-2" />}
              <span>{box.title}</span>
            </motion.button>
          );
        })}
      </div>

  
      <AnimatePresence mode="wait">
        {currentNavInfo && (
          <motion.div
            key={currentNavInfo.id}
            className="mb-20 p-8 rounded-3xl max-w-4xl w-full text-center relative z-10 backdrop-blur-md bg-gray-800 bg-opacity-70 border border-gray-700"
            style={{
              boxShadow: `0 15px 40px rgba(0, 0, 0, 0.5), 0 0 0 2px ${currentNavInfo.colors.border}40 inset`, // Outer shadow + inner colored border
            }}
            initial={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
            animate={{ opacity: 1, height: "auto", scaleY: 1, transformOrigin: 'top' }}
            exit={{ opacity: 0, height: 0, scaleY: 0.8, transformOrigin: 'top' }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <h3 className="text-3xl font-bold mb-4 text-white">
              {currentNavInfo.title}
            </h3>
            <div className="text-lg leading-relaxed text-gray-200 markdown-content">
              <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

     
      <div
        className={`grid gap-8 max-w-7xl w-full relative z-10 ${
          teamMembers.length === 1
            ? 'grid-cols-1 place-items-center'
            : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
        }`}
      >
        {teamMembers.map((m) => {
          const isHighlighted = activeInfoBoxId === m.infoBoxId;
          const dimmed = activeInfoBoxId && activeInfoBoxId !== m.infoBoxId;
          const highlightColor = infoBoxesData.find(box => box.id === m.infoBoxId)?.colors.border;

          return (
            <TeamCard
              key={m.id}
              member={m}
              isHighlighted={isHighlighted}
              dimmed={dimmed}
              highlightColor={highlightColor}
              ref={(el) => (cardRefs.current[m.id] = el)}
            />
          );
        })}
      </div>

   
      <div className="mt-20 relative z-10">
        <motion.button
          onClick={handleDeflateClick}
          className="px-12 py-4 rounded-full font-bold text-xl uppercase shadow-xl tracking-wide text-white relative overflow-hidden group transform active:scale-98 transition-transform duration-100"
          style={{
            background: "linear-gradient(45deg, #FF5733, #FFC300, #DAF7A6)", // Warm, energetic gradient
            backgroundSize: "200% 200%",
            animation: "pulseGradient 2s ease-in-out infinite",
          }}
          whileHover={{
            scale: 1.03,
            boxShadow: "0 0 40px rgba(255,87,51,0.8)", // More pronounced glow
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="relative z-10">{deflateButtonText}</span>
          <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
        </motion.button>
      </div>
    </motion.section>
  );
})

// --- COMPONENT: GamesSection ---
const GamesSection = React.memo(({
  developedGames,
  gamesInDevelopment,
  gamesSectionRef,
  gamesInDevRef,
  headerRef,
  scrollTo,
}) => {
  return (
    <>
      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Vores Sociale Spil
        </h2>
        <div
          className={`grid gap-8 max-w-4xl w-full ${
            gamesInDevelopment.length === 1
              ? "grid-cols-1 max-w-sm"
              : gamesInDevelopment.length === 2
              ? "grid-cols-1 md:grid-cols-2 max-w-2xl"
              : "grid-cols-1 md:grid-cols-2"
          } ${gamesInDevelopment.length <= 2 ? "justify-items-center" : ""}`}
        >
          {gamesInDevelopment.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center flex flex-col w-full"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(headerRef)}
          className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll back to top"
        >
          <FaChevronUp size={30} />
        </motion.button>
      </section>
    </>
  );
});

// --- COMPONENT: Footer ---
const Footer = React.memo(() => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <div className="text-sm max-w-xs">
            <ReactMarkdown>
              Skaber uforglemmelige **sociale spiloplevelser**, der forbinder spillere
              både lokalt og globalt.
            </ReactMarkdown>
          </div>
          <p className="text-sm mt-2">
            &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
            forbeholdt.
          </p>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center justify-center md:justify-start">
              <FaEnvelope className="mr-2 text-pink-400" />
              <a href="mailto:hej@kloegtig.dk" className="hover:text-purple-400 transition-colors">
                hej@kloegtig.dk
              </a>
            </li>
            //  <li className="flex items-center justify-center md:justify-start">
            //   <FaPhone className="mr-2 text-pink-400" />
            //   <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
            //     +45 12 34 56 78
            //   </a>
            // </li> 
          </ul>
          // <div className="flex justify-center md:justify-start space-x-4 mt-6">
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaFacebook size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaTwitter size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaInstagram size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaLinkedin size={24} />
          //   </a>
          // </div> 
        </div>
      </div>
    </footer>
  );
});

// --- MAIN APP COMPONENT ---
function App() {
  const [clicks, setClicks] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
  const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

  // Refs for scrolling
  const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
  const gamesInDevRef = useRef(null);

  const scrollTo = useCallback((ref) => () => {
    // If ref is headerRef (which points to the top of the page), scroll to top of window
    if (ref === headerRef) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Scroll to the top of the page on initial render
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Effect for changing quotes
  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setCurrentQuoteIndex((prevIndex) =>
        (prevIndex + 1) % heroQuotes.length
      );
    }, QUOTE_CHANGE_INTERVAL);

    return () => clearInterval(quoteInterval); // Cleanup on unmount
  }, []); // Empty dependency array means it runs once on mount

  const shootConfetti = useCallback((x, y) => {
    const common = {
      spread: 360,
      ticks: 100,
      gravity: 0.5,
      decay: 0.94,
      startVelocity: 30,
      origin: { x: x, y: y }, // Use provided x, y for origin
    };

    canvasConfetti({
      ...common,
      scalar: 1.2,
      shapes: ["circle", "square"],
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    });

    canvasConfetti({
      ...common,
      scalar: 0.75,
      shapes: ["star"],
      colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
    });
  }, []);

  const triggerConfettiAtRef = useCallback((ref) => {
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      shootConfetti(x / window.innerWidth, y / window.innerHeight);
    }
  }, [shootConfetti]);


  // Effect for managing click decay
  useEffect(() => {
    const startDecayTimer = () => {
      // Clear any existing decay timer to prevent multiple timers running
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }

      decayTimeoutRef.current = setTimeout(() => {
        setClicks((prevClicks) => {
          if (prevClicks > 0) {
            return Math.max(0, prevClicks - DECAY_AMOUNT);
          }
          return 0; // Don't go below zero
        });
        // Reschedule the decay if clicks are still above zero AND content is not unlocked
        if (clicks > 0 && clicks < REQUIRED_CLICKS) {
            startDecayTimer();
        }
      }, DECAY_INTERVAL);
    };

    // Only start decay if clicks are not 0 and content isn't unlocked
    if (clicks > 0 && clicks < REQUIRED_CLICKS) {
        startDecayTimer();
    } else {
        // If clicks are 0 or content is unlocked, ensure no decay timer is running
        if (decayTimeoutRef.current) {
            clearTimeout(decayTimeoutRef.current);
            decayTimeoutRef.current = null;
        }
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }
    };
  }, [clicks]); // Re-run when clicks or requiredClicks change

  // Confetti effect (for initial unlock)
  useEffect(() => {
    if (showConfetti) {
      // This burst is for the initial "Pust Vores Egoer Op!" completion
      shootConfetti(0.5, 0.5); // Center confetti
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, BURST_DURATION);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, shootConfetti]);

  // Unlock content effect
  useEffect(() => {
    if (clicks >= REQUIRED_CLICKS) {
      setShowConfetti(true);
      // Stop decay when content is unlocked
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
      }
      setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
    }
  }, [clicks, scrollTo, teamCardsRef]);

  // Function for the "Pust Vores Egoer Op!" button
  const handleMainButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

    // Clear any pending decay timeout when a click occurs
    if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
    }

    // Increment clicks only if less than REQUIRED_CLICKS
    setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
  };

  // New function specifically for resetting ego from "Punktèr Os!" button
  const resetEgo = useCallback(() => {
    setClicks(0);
    setShowConfetti(false); // Ensure confetti stops
    scrollTo(headerRef)(); // Scroll to top on reset
  }, [scrollTo, headerRef]);


  const isContentUnlocked = clicks >= REQUIRED_CLICKS;

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
      <div className="absolute inset-0 z-0 opacity-20" />

      <HeroSection
        clicks={clicks}
        requiredClicks={REQUIRED_CLICKS}
        handleMainButtonClick={handleMainButtonClick}
        isButtonClicked={isButtonClicked}
        currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
      />

      <AnimatePresence>
        {isContentUnlocked && ( // Only render these sections if content is unlocked
          <>
            <TeamSection
              teamMembers={teamMembersWithCategories}
              infoBoxesData={infoBoxesData}
              teamCardsRef={teamCardsRef}
              resetEgo={resetEgo} // Pass the new resetEgo function
              cardRefs={teamCardRefs} // Pass the ref object to TeamSection
              triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
            />
            <GamesSection
              developedGames={developedGames}
              gamesInDevelopment={gamesInDevelopment}
              gamesSectionRef={gamesSectionRef}
              gamesInDevRef={gamesInDevRef}
              headerRef={headerRef}
              scrollTo={scrollTo}
            />
          </>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}

export default App; */





// import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope,
//   FaLinkedin,
//   FaTwitter,
//   FaFacebook,
//   FaInstagram,
//   FaBehance,
//   FaGithub,
//   FaMedium,
//   FaDribbble,
//   FaStackOverflow,
//   FaArtstation,
//   FaPinterest,
//   FaPaintBrush,
//   FaUsers,
//   FaLightbulb,
//   FaChartLine,
//   FaChevronUp,
// } from "react-icons/fa";
// import logo from "./assets/logo/fox.png"; // Make sure your logo is here
// import comingDummy from "./assets/images/kommende spil dummy-2.png"
// import releasedDummy from "./assets/images/udgivet spil dummy.png"
// import Brian from "./assets/team/mig3-headshot.png"

// // --- APP DATA (moved from appData.js) ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500; // Time in ms before a click decays
// const DECAY_AMOUNT = 1; // How many clicks decay per interval
// const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

// const heroQuotes = [
//   "Hos Kløgtig skaber vi uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
//   "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
//   "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
//   "Vi bringer mennesker sammen, én latterfyldt spiloplevelse ad gangen",
//   "Vores mission? Uendelig sjov, for alle!",
//   "Vi skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt."
// ];

// const rawTeamMembers = [
//     {
//     id: 1,
//     name: "Brian",
//     photo: Brian,
//     role: "Grundlægger, Spilskaber & Idémager",
//     fullRole: "Kløgtigs kreative kraft og legeleder",
//     contactInfo: {
//       email: "brian@kloegtig.dk",
//       phone: "+4593949459",
//       social: "linkedin.com/in/brian-nørgaard-775130243",
//     },
//     mantra: "Jeg finder glæden i at skubbe grænserne for leg, så vi kan skabe uventede fællesskaber gennem konstant innovation",
//   }
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush", // Use string for icon name, pass to component to render
//     title: "Kreativitet & Design",
//     info: "Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst 🎮",
//     category: "creativityDesign",
//     colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
//     scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1, CVO: 0 },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samarbejde & Fællesskab",
//     info: "Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere 💪",
//     category: "teamworkCommunity",
//     colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
//     scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6, CVO: 0 },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Innovation & Udvikling",
//     info: "Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer** 💡",
//     category: "innovationDevelopment",
//     colors: { border: "#FF9B00", background: "#FF7D08" }, // Sunny Yellow
//     scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6, CVO: 1 },
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vision & Fremdrift",
//     info: "Vi har et **klart formål og en tydelig retning** for vores spil og forretning 🧭 ",
//     category: "visionProgress",
//     colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
//     scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5, CVO: 0 },
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Ingen sociale spil udgivet endnu!",
//     description: "Vi er travlt optaget med at skabe fremtidens klassikere inden for social gaming. Følg med!",
//     image: releasedDummy,
//     //link: "#",
//     status: "I beta",
//   }
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Spændende Socialt Projekt Bulderkoger!",
//     description: "Et nyt socialt spil projekt er sat over den helt store ild i laboratoriet. Glæd jer til at forbinde og have det sjovt!",
//     image: comingDummy,
//     status: "I Beta",
//   },
//   {
//     id: 102,
//     title: "Interaktive Sociale Eventyr Brygger!",
//     description: "Spændende projekter brygger, over sagte ild, i vores laboratorier. Glæd jer til nye sociale oplevelser!",
//     image: comingDummy,
//     status: "Hemmeligt Projekt",
//   },
// ];


// const calculateMemberCategories = (members, infoBoxes) => {
//   return members.map((member) => {
//     let bestScore = -Infinity;
//     let bestCategory = infoBoxes[0].category; // Default to the first category
//     for (const box of infoBoxes) {
//       const score = box.scoreMapping[member.role] || 0; // Use member.role directly
//       if (score > bestScore) {
//         bestScore = score;
//         bestCategory = box.category;
//       }
//     }
//     return { ...member, category: bestCategory };
//   });
// };

// const teamMembersWithCategories = calculateMemberCategories(rawTeamMembers, infoBoxesData);

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref} // Attach the ref here
//       // *** CHANGE HERE: Use a max-width instead of w-full ***
//       className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         dimmed ? "opacity-40" : ""
//       } cursor-default`}
//       // You can adjust max-w-sm to max-w-md, max-w-lg, etc., depending on your desired card size.
//       // w-full is kept to ensure it still expands to fill the space up to the max-width.
//       style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         <div
//           className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg"
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         <div
//           className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <p className="italic text-gray-400 text-center text-sm">
//             "{member.mantra}"
//           </p>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
//   currentQuote,
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);
//   const QUOTE_SECTION_HEIGHT = '8rem'; 

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* THIS IS THE LOGO AND CATCHPHRASE BLOCK - MOVED BACK TO TOP LEVEL */}
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
//       </motion.div>
      
//       {/* THIS IS THE H1 BLOCK - MOVED BACK TO TOP LEVEL */}
//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Vi Skaber Sociale Spil, Der Forbinder!
//       </motion.h1>

//       {/* This is the new wrapper for the quote/button block */}
//       {/* We keep this separate as its fixed width and absolute positioning parent */}
//       <div className="w-full flex justify-center"> 
//         <div 
//           className="relative flex flex-col items-center"
//           style={{ minHeight: QUOTE_SECTION_HEIGHT, width: '600px' }} // Fixed width here
//         >
//           <AnimatePresence mode="wait">
//             <motion.p
//               key={currentQuote}
//               className="mt-4 text-base md:text-xl font-medium text-gray-200 flex items-center justify-center text-center w-full"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//               style={{ minHeight: '5rem' }}
//             >
//               {currentQuote}
//             </motion.p>
//           </AnimatePresence>

//           <div className="absolute left-1/2 -translate-x-1/2 w-72 md:w-80"
//                style={{ top: QUOTE_SECTION_HEIGHT, marginTop: '2rem' }}>
//             <motion.button
//               onClick={handleMainButtonClick}
//               className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
//               style={{
//                 background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//                 backgroundSize: "200% 200%",
//                 animation: "buttonGradient 2s linear infinite",
//               }}
//               whileTap={{ scale: 0.95 }}
//               animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//               transition={{ duration: 0.1 }}
//               aria-label="Pust Vores Egoer Op!"
//               disabled={clicks >= requiredClicks}
//             >
//               <motion.div
//                 className="absolute inset-0 bg-white bg-opacity-20"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//               {rawTeamMembers.length > 1 ? (<span className="relative z-10 text-white">Pust Vores Egoer Op!</span>) : (<span className="relative z-10 text-white">Pust Mit Ego Op!</span>)}
              
//             </motion.button>
//             <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
//               <motion.div
//                 className="h-full bg-green-400"
//                 animate={{ width: `${progressPct}%` }}
//                 transition={{ type: "tween", duration: 0.2 }}
//               />
//             </div>
//             <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
//               {clicks} / {requiredClicks} klik
//             </div>
//           </div>
//         </div>
//       </div>
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const iconComponents = {
//   FaPaintBrush: FaPaintBrush,
//   FaUsers: FaUsers,
//   FaLightbulb: FaLightbulb,
//   FaChartLine: FaChartLine,
// };

// const TeamSection = React.memo(({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo, // New prop for resetting ego
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);
//   const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
//   const [highlightColor, setHighlightColor] = useState("ring-yellow-400");

//   const categoryMemberMap = useMemo(() => {
//     const map = {};
//     teamMembers.forEach((m) => {
//       if (!map[m.category]) map[m.category] = [];
//       map[m.category].push(m.id);
//     });
//     return map;
//   }, [teamMembers]);

//   const handleInfoBoxClick = useCallback(
//     (item) => {
//       if (selectedCategory === item.category) {
//         setSelectedCategory(null);
//         setCurrentNavInfo(null);  
//         setHighlightColor(item.colors.border)
//         setHighlightedMemberIds([]);
//       } else {
//         setSelectedCategory(item.category);
//         setCurrentNavInfo(item);
//         setHighlightColor(item.colors.border)
//         setHighlightedMemberIds(categoryMemberMap[item.category] || []);
//       }
//     },
//     [selectedCategory, categoryMemberMap]
//   );

//   const handleDeflateClick = useCallback(() => {
//     // Trigger confetti from each card's position
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     // Call the resetEgo function passed from App.js
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);


//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-20 px-4 flex flex-col justify-center items-center"
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >
//       {rawTeamMembers.length > 1 ? (<h2 className="text-4xl md:text-5xl leading-snug font-extrabold mb-8 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
//         Mød Vores Team!
//       </h2>) : (<h2 className="text-4xl md:text-5xl leading-snug font-extrabold mb-8 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
//         Mød Mig!
//       </h2>)}

//       <div className="flex flex-wrap justify-center align-center mb-12 gap-4 md:gap-6">
//         {infoBoxesData.map((item) => {
//           const isActive = selectedCategory === item.category;
//           const IconComponent = iconComponents[item.icon];

//           return (
//             <motion.div
//               key={item.id}
//               onClick={() => handleInfoBoxClick(item)}
//               className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer text-white"
//               style={{
//                 border: `2px solid ${item.colors.border}`,
//                 backgroundColor: item.colors.background,
//                 boxShadow: isActive ? `0 0 15px ${item.colors.border}` : "none",
//               }}
//               whileHover={{ scale: 1.05 }}
//             >
//               {IconComponent && <IconComponent size={40} />}
//               <span className="mt-2 text-center font-semibold">
//                 {item.title}
//               </span>
//             </motion.div>
//           );
//         })}
//       </div>

//       <AnimatePresence>
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center text-white"
//             style={{
//               border: `2px solid ${currentNavInfo.colors.border}`,
//               backgroundColor: currentNavInfo.colors.background,
//             }}
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: "auto" }}
//             exit={{ opacity: 0, height: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
//             <div className="text-base text-lg text-white-900">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <div
//   className={`grid gap-6 max-w-7xl w-full ${
//     teamMembers.length === 1
//       ? "grid-cols-1 place-items-center" // Center if only one card
//       : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" // Original grid for multiple cards
//   }`}
// >
//   {teamMembers.map((m) => {
//     const isHighlighted = highlightedMemberIds.includes(m.id);
//     const dimmed = selectedCategory && !isHighlighted;
//     return (
//       <TeamCard
//         key={m.id}
//         member={m}
//         isHighlighted={isHighlighted}
//         dimmed={dimmed}
//         highlightColor={highlightColor}
//         ref={(el) => (cardRefs.current[m.id] = el)} // Assign ref to each card
//       />
//     );
//   })}
// </div>

//       <div className="mt-12">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-8 py-3 rounded-full font-bold uppercase shadow-lg"
//           style={{
//             background: "linear-gradient(90deg,#db2777,#ec4899,#f0abfc)",
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 1.5s ease-in-out infinite",
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//         {rawTeamMembers.length > 1 ? (<span className="text-white">Punktèr Os!</span>):(<span className="text-white">Punktèr Mig!</span>)}
          
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// });

// // --- COMPONENT: GamesSection ---
// const GamesSection = React.memo(({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       <section
//         ref={gamesInDevRef}
//         id="games-in-development"
//         className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
//           Vores Sociale Spil
//         </h2>
//         <div
//           className={`grid gap-8 max-w-4xl w-full ${
//             gamesInDevelopment.length === 1
//               ? "grid-cols-1 max-w-sm"
//               : gamesInDevelopment.length === 2
//               ? "grid-cols-1 md:grid-cols-2 max-w-2xl"
//               : "grid-cols-1 md:grid-cols-2"
//           } ${gamesInDevelopment.length <= 2 ? "justify-items-center" : ""}`}
//         >
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center flex flex-col w-full"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               transition={{ duration: 0.6 }}
//             >
//               <img
//                 src={game.image}
//                 alt={game.title}
//                 className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
//               />
//               <h3 className="text-2xl font-bold mb-2 text-cyan-300">
//                 {game.title}
//               </h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">
//                 {game.description}
//               </p>
//               <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.button
//           onClick={scrollTo(headerRef)}
//           className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ duration: 0.5 }}
//           aria-label="Scroll back to top"
//         >
//           <FaChevronUp size={30} />
//         </motion.button>
//       </section>
//     </>
//   );
// });

// // --- COMPONENT: Footer ---
// const Footer = React.memo(() => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
//         <div className="flex flex-col items-center md:items-start text-center md:text-left">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
//             </div>
//           </div>
//           <div className="text-sm max-w-xs"> {/* Use a div to contain ReactMarkdown */}
//             <ReactMarkdown>
//               Skaber uforglemmelige **sociale spiloplevelser**, der forbinder spillere
//               både lokalt og globalt.
//             </ReactMarkdown>
//           </div>
//           <p className="text-sm mt-2">
//             &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
//             forbeholdt.
//           </p>
//         </div>

//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <ul className="space-y-2">
//             <li className="flex items-center justify-center md:justify-start">
//               <FaEnvelope className="mr-2 text-pink-400" />
//               <a href="mailto:hej@kloegtig.dk" className="hover:text-purple-400 transition-colors">
//                 hej@kloegtig.dk
//               </a>
//             </li>
//             {/* <li className="flex items-center justify-center md:justify-start">
//               <FaPhone className="mr-2 text-pink-400" />
//               <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
//                 +45 12 34 56 78
//               </a>
//             </li> */}
//           </ul>
//           {/* <div className="flex justify-center md:justify-start space-x-4 mt-6">
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaFacebook size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaTwitter size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaInstagram size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaLinkedin size={24} />
//             </a>
//           </div> */}
//         </div>
//       </div>
//     </footer>
//   );
// });

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
//   const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   // Effect for changing quotes
//   useEffect(() => {
//     const quoteInterval = setInterval(() => {
//       setCurrentQuoteIndex((prevIndex) =>
//         (prevIndex + 1) % heroQuotes.length
//       );
//     }, QUOTE_CHANGE_INTERVAL);

//     return () => clearInterval(quoteInterval); // Cleanup on unmount
//   }, []); // Empty dependency array means it runs once on mount

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;




/* import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { motion, AnimatePresence, useSpring } from "framer-motion";
import canvasConfetti from "canvas-confetti";
import ReactMarkdown from "react-markdown";
import {
  FaEnvelope,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaBehance,
  FaGithub,
  FaMedium,
  FaDribbble,
  FaStackOverflow,
  FaArtstation,
  FaPinterest,
  FaPaintBrush,
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaChevronUp,
} from "react-icons/fa";
import logo from "./assets/logo/fox.png"; // Make sure your logo is here
import comingDummy from "./assets/images/kommende spil dummy-2.png"
import releasedDummy from "./assets/images/udgivet spil dummy.png"
import Brian from "./assets/team/mig3-headshot.png"

// --- APP DATA (moved from appData.js) ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500; // Time in ms before a click decays
const DECAY_AMOUNT = 1; // How many clicks decay per interval
const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

const heroQuotes = [
  "Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
  "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
  "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
  "Bring mennesker sammen, én latterfyldt spiloplevelse ad gangen.",
  "Vores mission? Uendelig sjov, for alle!",
  "Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt"
];

const rawTeamMembers = [
   {
    id: 1,
    name: "Brian",
    photo: Brian,
    role: "CVO",
    fullRole: "(Chief Visionary Officer & Architect of Playful Realities)",
    contactInfo: {
      email: "brian@kloegtig.dk",
      phone: "+4593949459",
      social: "linkedin.com/in/brian-nørgaard-775130243",
    },
    mantra: "Vi forvandler drømme til levende oplevelser.",
  }
];

const infoBoxesData = [
  {
    id: "creativityDesign",
    icon: "FaPaintBrush", // Use string for icon name, pass to component to render
    title: "Kreativitet & Design",
    info: "Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst 🎮",
    category: "creativityDesign",
    colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1, CVO: 0 },
  },
  {
    id: "teamworkCommunity",
    icon: "FaUsers",
    title: "Samarbejde & Fællesskab",
    info: "Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere 💪",
    category: "teamworkCommunity",
    colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6, CVO: 0 },
  },
  {
    id: "innovationDevelopment",
    icon: "FaLightbulb",
    title: "Innovation & Udvikling",
    info: "Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer** 💡",
    category: "innovationDevelopment",
    colors: { border: "#FF9B00", background: "#FF7D08" }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6, CVO: 1 },
  },
  {
    id: "visionProgress",
    icon: "FaChartLine",
    title: "Vision & Fremdrift",
    info: "Vi har et **klart formål og en tydelig retning** for vores spil og forretning 🧭 ",
    category: "visionProgress",
    colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5, CVO: 0 },
  },
];

const developedGames = [
  {
    id: 1,
    title: "Ingen spil udgivet endnu!",
  description: "Vi er travlt optaget med at skabe fremtidens klassikere. Følg med!",
  image: releasedDummy,
  //link: "#",
  status: "I beta",
  }
];

const gamesInDevelopment = [
  {
    id: 101,
  title: "Spændende Projekt bulderkoger!",
  description: "Projektet er sat over den helt store ild, i laboratoriet. Glæd jer!",
  image: comingDummy,
  status: "I Beta",
  },
  {
    id: 102,
  title: "Interaktive Eventyr Brygger!",
  description: "Spændende projekter brygger, over sagte ild, i vores laboratorier. Glæd jer!",
  image: comingDummy,
  status: "Hemmeligt Projekt",
  },
];


const calculateMemberCategories = (members, infoBoxes) => {
  return members.map((member) => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const teamMembersWithCategories = calculateMemberCategories(rawTeamMembers, infoBoxesData);

// --- COMPONENT: TeamCard ---
const getSocialIcon = (socialUrl) => {
  if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
  if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
  if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
  if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
  if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
  if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
  if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
  if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
  if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
  if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
  if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
  return null;
};

const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 });

  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      ref={ref} // Attach the ref here
      // *** CHANGE HERE: Use a max-width instead of w-full ***
      className={`relative max-w-sm w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
        dimmed ? "opacity-40" : ""
      } cursor-default`}
      // You can adjust max-w-sm to max-w-md, max-w-lg, etc., depending on your desired card size.
      // w-full is kept to ensure it still expands to fill the space up to the max-width.
      style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        <div
          className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(0deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <img
            src={member.photo}
            alt={member.name}
            className="w-24 h-24 rounded-full mx-auto mb-3 object-contain shadow-lg"
          />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(180deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">
            {member.name}'s Info
          </h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
              {member.contactInfo.email}
            </a>
          </p>
          {member.contactInfo.social && (
            <p className="text-sm text-gray-200 mb-3 flex items-center">
              {getSocialIcon(member.contactInfo.social)}
              <a
                href={`https://${member.contactInfo.social}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {member.contactInfo.social.split("/").pop()}
              </a>
            </p>
          )}
          <p className="italic text-gray-400 text-center text-sm">
            "{member.mantra}"
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
});

// --- COMPONENT: HeroSection ---
const HeroSection = ({
  clicks,
  requiredClicks,
  handleMainButtonClick,
  isButtonClicked,
  currentQuote,
}) => {
  const progressPct = Math.round((clicks / requiredClicks) * 100);
  const QUOTE_SECTION_HEIGHT = '8rem'; 

  return (
    <motion.header
      className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="flex flex-col items-center mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
      >
        <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
        <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
        <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
      </motion.div>
      

      <motion.h1
        className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
      >
        Spil. Hyg. Fejr!
      </motion.h1>

      <div className="w-full flex justify-center"> 
        <div 
          className="relative flex flex-col items-center"
          style={{ minHeight: QUOTE_SECTION_HEIGHT, width: '600px' }} // Fixed width here
        >
          <AnimatePresence mode="wait">
            <motion.p
              key={currentQuote}
              className="mt-4 text-base md:text-xl font-medium text-gray-200 flex items-center justify-center text-center w-full"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              style={{ minHeight: '5rem' }}
            >
              {currentQuote}
            </motion.p>
          </AnimatePresence>

          <div className="absolute left-1/2 -translate-x-1/2 w-72 md:w-80"
               style={{ top: QUOTE_SECTION_HEIGHT, marginTop: '2rem' }}>
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
                backgroundSize: "200% 200%",
                animation: "buttonGradient 2s linear infinite",
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label="Pust Vores Egoer Op!"
              disabled={clicks >= requiredClicks}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
              {rawTeamMembers.length > 1 ? (<span className="relative z-10 text-white">Pust Vores Egoer Op!</span>) : (<span className="relative z-10 text-white">Pust Mit Ego Op!</span>)}
              
            </motion.button>
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }}
                transition={{ type: "tween", duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
              {clicks} / {requiredClicks} klik
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

// --- COMPONENT: TeamSection ---
const iconComponents = {
  FaPaintBrush: FaPaintBrush,
  FaUsers: FaUsers,
  FaLightbulb: FaLightbulb,
  FaChartLine: FaChartLine,
};

const TeamSection = React.memo(({
  teamMembers,
  infoBoxesData,
  teamCardsRef,
  resetEgo, // New prop for resetting ego
  cardRefs,
  triggerConfettiAtRef,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [highlightColor, setHighlightColor] = useState("ring-yellow-400");

  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach((m) => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  const handleInfoBoxClick = useCallback(
    (item) => {
      if (selectedCategory === item.category) {
        setSelectedCategory(null);
        setCurrentNavInfo(null);  
        setHighlightColor(item.colors.border)
        setHighlightedMemberIds([]);
      } else {
        setSelectedCategory(item.category);
        setCurrentNavInfo(item);
        setHighlightColor(item.colors.border)
        setHighlightedMemberIds(categoryMemberMap[item.category] || []);
      }
    },
    [selectedCategory, categoryMemberMap]
  );

  const handleDeflateClick = useCallback(() => {
    // Trigger confetti from each card's position
    Object.values(cardRefs.current).forEach((ref) => {
      if (ref) {
        triggerConfettiAtRef(ref);
      }
    });
    // Call the resetEgo function passed from App.js
    resetEgo();
  }, [cardRefs, triggerConfettiAtRef, resetEgo]);


  return (
    <motion.section
      ref={teamCardsRef}
      className="relative z-10 w-full py-20 px-4 flex flex-col justify-center items-center"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >
      {rawTeamMembers.length > 1 ? (<h2 className="text-4xl md:text-5xl leading-snug font-extrabold mb-8 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
        Mød Vores Team!
      </h2>) : (<h2 className="text-4xl md:text-5xl leading-snug font-extrabold mb-8 pb-4 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
        Mød Mig!
      </h2>)}

      <div className="flex flex-wrap justify-center align-center mb-12 gap-4 md:gap-6">
        {infoBoxesData.map((item) => {
          const isActive = selectedCategory === item.category;
          const IconComponent = iconComponents[item.icon];

          return (
            <motion.div
              key={item.id}
              onClick={() => handleInfoBoxClick(item)}
              className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer text-white"
              style={{
                border: `2px solid ${item.colors.border}`,
                backgroundColor: item.colors.background,
                boxShadow: isActive ? `0 0 15px ${item.colors.border}` : "none",
              }}
              whileHover={{ scale: 1.05 }}
            >
              {IconComponent && <IconComponent size={40} />}
              <span className="mt-2 text-center font-semibold">
                {item.title}
              </span>
            </motion.div>
          );
        })}
      </div>

      <AnimatePresence>
        {currentNavInfo && (
          <motion.div
            key={currentNavInfo.id}
            className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center text-white"
            style={{
              border: `2px solid ${currentNavInfo.colors.border}`,
              backgroundColor: currentNavInfo.colors.background,
            }}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
            <div className="text-base text-lg text-white-900">
              <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div
  className={`grid gap-6 max-w-7xl w-full ${
    teamMembers.length === 1
      ? "grid-cols-1 place-items-center" // Center if only one card
      : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" // Original grid for multiple cards
  }`}
>
  {teamMembers.map((m) => {
    const isHighlighted = highlightedMemberIds.includes(m.id);
    const dimmed = selectedCategory && !isHighlighted;
    return (
      <TeamCard
        key={m.id}
        member={m}
        isHighlighted={isHighlighted}
        dimmed={dimmed}
        highlightColor={highlightColor}
        ref={(el) => (cardRefs.current[m.id] = el)} // Assign ref to each card
      />
    );
  })}
</div>

      <div className="mt-12">
        <motion.button
          onClick={handleDeflateClick}
          className="px-8 py-3 rounded-full font-bold uppercase shadow-lg"
          style={{
            background: "linear-gradient(90deg,#db2777,#ec4899,#f0abfc)",
            backgroundSize: "200% 200%",
            animation: "pulseGradient 1.5s ease-in-out infinite",
          }}
          whileTap={{ scale: 0.95 }}
        >
        {rawTeamMembers.length > 1 ? (<span className="text-white">Punktèr Os!</span>):(<span className="text-white">Punktèr Mig!</span>)}
          
        </motion.button>
      </div>
    </motion.section>
  );
});

// --- COMPONENT: GamesSection ---
const GamesSection = React.memo(({
  developedGames,
  gamesInDevelopment,
  gamesSectionRef,
  gamesInDevRef,
  headerRef,
  scrollTo,
}) => {
  return (
    <>
      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div
          className={`grid gap-8 max-w-4xl w-full ${
            gamesInDevelopment.length === 1
              ? "grid-cols-1 max-w-sm"
              : gamesInDevelopment.length === 2
              ? "grid-cols-1 md:grid-cols-2 max-w-2xl"
              : "grid-cols-1 md:grid-cols-2"
          } ${gamesInDevelopment.length <= 2 ? "justify-items-center" : ""}`}
        >
          {gamesInDevelopment.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center flex flex-col w-full"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(headerRef)}
          className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll back to top"
        >
          <FaChevronUp size={30} />
        </motion.button>
      </section>
    </>
  );
});

// --- COMPONENT: Footer ---
const Footer = React.memo(() => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere
            både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">
            &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
            forbeholdt.
          </p>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center justify-center md:justify-start">
              <FaEnvelope className="mr-2 text-pink-400" />
              <a href="mailto:hej@kloegtig.dk" className="hover:text-purple-400 transition-colors">
                hej@kloegtig.dk
              </a>
            </li>
            // <li className="flex items-center justify-center md:justify-start">
            //   <FaPhone className="mr-2 text-pink-400" />
            //   <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
            //     +45 12 34 56 78
            //   </a>
            // </li>
          </ul>
          //  <div className="flex justify-center md:justify-start space-x-4 mt-6">
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaFacebook size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaTwitter size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaInstagram size={24} />
          //   </a>
          //   <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
          //     <FaLinkedin size={24} />
          //   </a>
          // </div>
        </div>
      </div>
    </footer>
  );
});

// --- MAIN APP COMPONENT ---
function App() {
  const [clicks, setClicks] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
  const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

  // Refs for scrolling
  const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
  const gamesInDevRef = useRef(null);

  const scrollTo = useCallback((ref) => () => {
    // If ref is headerRef (which points to the top of the page), scroll to top of window
    if (ref === headerRef) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Scroll to the top of the page on initial render
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Effect for changing quotes
  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setCurrentQuoteIndex((prevIndex) =>
        (prevIndex + 1) % heroQuotes.length
      );
    }, QUOTE_CHANGE_INTERVAL);

    return () => clearInterval(quoteInterval); // Cleanup on unmount
  }, []); // Empty dependency array means it runs once on mount

  const shootConfetti = useCallback((x, y) => {
    const common = {
      spread: 360,
      ticks: 100,
      gravity: 0.5,
      decay: 0.94,
      startVelocity: 30,
      origin: { x: x, y: y }, // Use provided x, y for origin
    };

    canvasConfetti({
      ...common,
      scalar: 1.2,
      shapes: ["circle", "square"],
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    });

    canvasConfetti({
      ...common,
      scalar: 0.75,
      shapes: ["star"],
      colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
    });
  }, []);

  const triggerConfettiAtRef = useCallback((ref) => {
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      shootConfetti(x / window.innerWidth, y / window.innerHeight);
    }
  }, [shootConfetti]);


  // Effect for managing click decay
  useEffect(() => {
    const startDecayTimer = () => {
      // Clear any existing decay timer to prevent multiple timers running
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }

      decayTimeoutRef.current = setTimeout(() => {
        setClicks((prevClicks) => {
          if (prevClicks > 0) {
            return Math.max(0, prevClicks - DECAY_AMOUNT);
          }
          return 0; // Don't go below zero
        });
        // Reschedule the decay if clicks are still above zero AND content is not unlocked
        if (clicks > 0 && clicks < REQUIRED_CLICKS) {
            startDecayTimer();
        }
      }, DECAY_INTERVAL);
    };

    // Only start decay if clicks are not 0 and content isn't unlocked
    if (clicks > 0 && clicks < REQUIRED_CLICKS) {
        startDecayTimer();
    } else {
        // If clicks are 0 or content is unlocked, ensure no decay timer is running
        if (decayTimeoutRef.current) {
            clearTimeout(decayTimeoutRef.current);
            decayTimeoutRef.current = null;
        }
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }
    };
  }, [clicks]); // Re-run when clicks or requiredClicks change

  // Confetti effect (for initial unlock)
  useEffect(() => {
    if (showConfetti) {
      // This burst is for the initial "Pust Vores Egoer Op!" completion
      shootConfetti(0.5, 0.5); // Center confetti
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, BURST_DURATION);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, shootConfetti]);

  // Unlock content effect
  useEffect(() => {
    if (clicks >= REQUIRED_CLICKS) {
      setShowConfetti(true);
      // Stop decay when content is unlocked
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
      }
      setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
    }
  }, [clicks, scrollTo, teamCardsRef]);

  // Function for the "Pust Vores Egoer Op!" button
  const handleMainButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

    // Clear any pending decay timeout when a click occurs
    if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
    }

    // Increment clicks only if less than REQUIRED_CLICKS
    setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
  };

  // New function specifically for resetting ego from "Punktèr Os!" button
  const resetEgo = useCallback(() => {
    setClicks(0);
    setShowConfetti(false); // Ensure confetti stops
    scrollTo(headerRef)(); // Scroll to top on reset
  }, [scrollTo, headerRef]);


  const isContentUnlocked = clicks >= REQUIRED_CLICKS;

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
      <div className="absolute inset-0 z-0 opacity-20" />

      <HeroSection
        clicks={clicks}
        requiredClicks={REQUIRED_CLICKS}
        handleMainButtonClick={handleMainButtonClick}
        isButtonClicked={isButtonClicked}
        currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
      />

      <AnimatePresence>
        {isContentUnlocked && ( // Only render these sections if content is unlocked
          <>
            <TeamSection
              teamMembers={teamMembersWithCategories}
              infoBoxesData={infoBoxesData}
              teamCardsRef={teamCardsRef}
              resetEgo={resetEgo} // Pass the new resetEgo function
              cardRefs={teamCardRefs} // Pass the ref object to TeamSection
              triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
            />
            <GamesSection
              developedGames={developedGames}
              gamesInDevelopment={gamesInDevelopment}
              gamesSectionRef={gamesSectionRef}
              gamesInDevRef={gamesInDevRef}
              headerRef={headerRef}
              scrollTo={scrollTo}
            />
          </>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}

export default App; */





/* import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { motion, AnimatePresence, useSpring } from "framer-motion";
import canvasConfetti from "canvas-confetti";
import ReactMarkdown from "react-markdown";
import {
  FaEnvelope,
  FaPhone,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaBehance,
  FaGithub,
  FaMedium,
  FaDribbble,
  FaStackOverflow,
  FaArtstation,
  FaPinterest,
  FaPaintBrush,
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import logo from "./assets/logo/fox.png"; // Make sure your logo is here

// --- APP DATA (moved from appData.js) ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500; // Time in ms before a click decays
const DECAY_AMOUNT = 1; // How many clicks decay per interval
const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

const heroQuotes = [
  "Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
  "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
  "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
  "Bring mennesker sammen, én latterfyldt spiloplevelse ad gangen.",
  "Vores mission? Uendelig sjov, for alle!"
];


const rawTeamMembers = [
  {
    id: 1,
    name: "Alice",
    photo: "https://i.pravatar.cc/150?img=1",
    role: "GALL",
    fullRole: "(Grand Architect of Ludicrous Levels)",
    contactInfo: {
      email: "alice.gall@kloegtig.dk",
      phone: "+1-555-0101",
      social: "linkedin.com/in/alice_gall",
    },
    mantra: "Building worlds, one pixel at a time.",
  },
  {
    id: 2,
    name: "Bob",
    photo: "https://i.pravatar.cc/150?img=2",
    role: "CAA",
    fullRole: "(Chief Algorithm Alchemist)",
    contactInfo: {
      email: "bob.caa@kloegtig.dk",
      phone: "+1-555-0102",
      social: "twitter.com/bob_caa",
    },
    mantra: "The code always knows.",
  },
  {
    id: 3,
    name: "Charlie",
    photo: "https://i.pravatar.cc/150?img=3",
    role: "PDPX",
    fullRole: "(Primary Dream Weaver of Player Experiences)",
    contactInfo: {
      email: "charlie.pdpx@kloegtig.dk",
      phone: "+1-555-0103",
      social: "instagram.com/charlie_pdpx",
    },
    mantra: "Crafting unforgettable moments.",
  },
  {
    id: 4,
    name: "Diana",
    photo: "https://i.pravatar.cc/150?img=4",
    role: "CSS",
    fullRole: "(Community Sparkle Spreader)",
    contactInfo: {
      email: "diana.css@kloegtig.dk",
      phone: "+1-555-0104",
      social: "facebook.com/diana_css",
    },
    mantra: "Connecting hearts, one smile at a time.",
  },
  {
    id: 5,
    name: "Eve",
    photo: "https://i.pravatar.cc/150?img=5",
    role: "KUXS",
    fullRole: "(Kinetic User Experience Sorceress)",
    contactInfo: {
      email: "eve.kuxs@kloegtig.dk",
      phone: "+1-555-0105",
      social: "behance.net/eve_kuxs",
    },
    mantra: "Intuitive design is magic.",
  },
  {
    id: 6,
    name: "Frank",
    photo: "https://i.pravatar.cc/150?img=6",
    role: "KSL",
    fullRole: "(Keeper of Supreme Logic)",
    contactInfo: {
      email: "frank.ksl@kloegtig.dk",
      phone: "+1-555-0106",
      social: "github.com/frank_ksl",
    },
    mantra: "Logic is the foundation of greatness.",
  },
  {
    id: 7,
    name: "Grace",
    photo: "https://i.pravatar.cc/150?img=7",
    role: "LSS",
    fullRole: "(Live Service Storyteller)",
    contactInfo: {
      email: "grace.lss@kloegtig.dk",
      phone: "+1-555-0107",
      social: "medium.com/@grace_lss",
    },
    mantra: "Every update tells a new tale.",
  },
  {
    id: 8,
    name: "Heidi",
    photo: "https://i.pravatar.cc/150?img=8",
    role: "UID",
    fullRole: "(Unreal Interface Dreamer)",
    contactInfo: {
      email: "heidi.uid@kloegtig.dk",
      phone: "+1-555-0108",
      social: "dribbble.com/heidi_uid",
    },
    mantra: "Designing the future, one interface at a time.",
  },
  {
    id: 9,
    name: "Ivan",
    photo: "https://i.pravatar.cc/150?img=9",
    role: "BII",
    fullRole: "(Backend Illusionist & Inventor)",
    contactInfo: {
      email: "ivan.bii@kloegtig.dk",
      phone: "+1-555-0109",
      social: "stackoverflow.com/users/ivan_bii",
    },
    mantra: "Behind every great front-end is a magical back-end.",
  },
  {
    id: 10,
    name: "Judy",
    photo: "https://i.pravatar.cc/150?img=10",
    role: "NWBW",
    fullRole: "(Narrative & World-Building Wizard)",
    contactInfo: {
      email: "judy.nwbw@kloegtig.dk",
      phone: "+1-555-0110",
      social: "artstation.com/judy_nwbw",
    },
    mantra: "Worlds within words, stories without end.",
  },
  {
    id: 11,
    name: "Kevin",
    photo: "https://i.pravatar.cc/150?img=11",
    role: "BUD",
    fullRole: "(Business Unit Dragon)",
    contactInfo: {
      email: "kevin.bud@kloegtig.dk",
      phone: "+1-555-0111",
      social: "linkedin.com/in/kevin_bud",
    },
    mantra: "Igniting growth, one strategy at a time.",
  },
  {
    id: 12,
    name: "Liam",
    photo: "https://i.pravatar.cc/150?img=12",
    role: "PME",
    fullRole: "(Potion Master of Experience)",
    contactInfo: {
      email: "liam.pme@kloegtig.dk",
      phone: "+1-555-0112",
      social: "pinterest.com/liam_pme",
    },
    mantra: "Brewing experiences that delight.",
  },
];

const infoBoxesData = [
  {
    id: "creativityDesign",
    icon: "FaPaintBrush", // Use string for icon name, pass to component to render
    title: "Kreativitet & Design",
    info: "Vi brænder for at skabe 🎨 **originale og engagerende spiloplevelser** 🎮 gennem innovativt design og fængslende kunst.",
    category: "creativityDesign",
    colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
  },
  {
    id: "teamworkCommunity",
    icon: "FaUsers",
    title: "Samarbejde & Fællesskab",
    info: "Vores succes bygger på 💪 **stærkt samarbejde og et inkluderende fællesskab** 🤝, både internt og med vores spillere.",
    category: "teamworkCommunity",
    colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
  },
  {
    id: "innovationDevelopment",
    icon: "FaLightbulb",
    title: "Innovation & Udvikling",
    info: "Vi driver kontinuerlig innovation ved at udforske 🚀 **nye teknologier og banebrydende idéer** 💡.",
    category: "innovationDevelopment",
    colors: { border: "#ffd700", background: "#ffc107" }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: "visionProgress",
    icon: "FaChartLine",
    title: "Vision & Fremdrift",
    info: "Vi har et🎯 **klart formål og en tydelig retning** 🧭 for vores spil og forretning.",
    category: "visionProgress",
    colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

const developedGames = [
  {
    id: 1,
    title: "Starfall Tactics",
    description:
      "An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of 'Indie Game of the Year' 2023.",
    image: "https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image",
    link: "#",
  },
  {
    id: 2,
    title: "Whispering Woods",
    description:
      "A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.",
    image: "https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image",
    link: "#",
  },
  {
    id: 3,
    title: "Neon Drift Racers",
    description:
      "High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.",
    image: "https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image",
    link: "#",
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: "Project Aurora",
    description:
      "An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.",
    image: "https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image",
    status: "Alpha Testing",
  },
  {
    id: 102,
    title: "Mythic Mayhem",
    description:
      "A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.",
    image: "https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image",
    status: "Concept & Prototyping",
  },
];

const calculateMemberCategories = (members, infoBoxes) => {
  return members.map((member) => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const teamMembersWithCategories = calculateMemberCategories(rawTeamMembers, infoBoxesData);

// --- COMPONENT: TeamCard ---
const getSocialIcon = (socialUrl) => {
  if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
  if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
  if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
  if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
  if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
  if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
  if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
  if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
  if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
  if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
  if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
  return null;
};

const TeamCard = React.forwardRef(({ member, isHighlighted, highlightColor, dimmed }, ref) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 });

  console.log("HIGH COLOR: ", highlightColor)
  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      ref={ref} // Attach the ref here
       className={`relative w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
   dimmed ? "opacity-40" : ""
 } cursor-default`}
      style={{ perspective: 1000, border: isHighlighted ? `4px solid ${highlightColor}` : undefined, }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        <div
          className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(0deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <img
            src={member.photo}
            alt={member.name}
            className="w-24 h-24 rounded-full mx-auto mb-3 object-cover shadow-lg"
          />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(180deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">
            {member.name}'s Info
          </h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
              {member.contactInfo.email}
            </a>
          </p>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaPhone className="mr-2 text-green-300" />
            <span>{member.contactInfo.phone}</span>
          </p>
          {member.contactInfo.social && (
            <p className="text-sm text-gray-200 mb-3 flex items-center">
              {getSocialIcon(member.contactInfo.social)}
              <a
                href={`https://${member.contactInfo.social}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {member.contactInfo.social.split("/").pop()}
              </a>
            </p>
          )}
          <p className="italic text-gray-400 text-center text-sm">
            "{member.mantra}"
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
});

// --- COMPONENT: HeroSection ---
const HeroSection = ({
  clicks,
  requiredClicks,
  handleMainButtonClick,
  isButtonClicked,
  currentQuote, // New prop for the current quote
}) => {
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <motion.header
      className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      
      <motion.div
        className="flex flex-col items-center mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
      >
        <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
        <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
        <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
      </motion.div>
      

      <motion.h1
        className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
      >
        Spil. Hyg. Fejr!
      </motion.h1>
      <AnimatePresence mode="wait">
        <motion.p
          key={currentQuote} // Key change forces re-render and animation
          className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl min-h-[4rem] flex items-center justify-center" // Added min-h and flex properties
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
        >
          {currentQuote}
        </motion.p>
      </AnimatePresence>

      <div className="mt-8 w-full max-w-sm md:max-w-md">
        <motion.button
          onClick={handleMainButtonClick}
          className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
          style={{
            background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
            backgroundSize: "200% 200%",
            animation: "buttonGradient 2s linear infinite",
          }}
          whileTap={{ scale: 0.95 }}
          animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
          transition={{ duration: 0.1 }}
          aria-label="Pust Vores Egoer Op!"
          disabled={clicks >= requiredClicks} // Disable button if clicks reach requiredClicks
        >
          <motion.div
            className="absolute inset-0 bg-white bg-opacity-20"
            animate={{ width: `${progressPct}%` }}
            transition={{ type: "tween", duration: 0.2 }}
          />
          <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
        </motion.button>
        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
          <motion.div
            className="h-full bg-green-400"
            animate={{ width: `${progressPct}%` }}
            transition={{ type: "tween", duration: 0.2 }}
          />
        </div>
        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
          {clicks} / {requiredClicks} klik
        </div>
      </div>
      
    </motion.header>
  );
};

// --- COMPONENT: TeamSection ---
const iconComponents = {
  FaPaintBrush: FaPaintBrush,
  FaUsers: FaUsers,
  FaLightbulb: FaLightbulb,
  FaChartLine: FaChartLine,
};

const TeamSection = React.memo(({
  teamMembers,
  infoBoxesData,
  teamCardsRef,
  resetEgo, // New prop for resetting ego
  cardRefs,
  triggerConfettiAtRef,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [highlightColor, setHighlightColor] = useState("ring-yellow-400");

  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach((m) => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  const handleInfoBoxClick = useCallback(
    (item) => {
      if (selectedCategory === item.category) {
        setSelectedCategory(null);
        setCurrentNavInfo(null);  
        setHighlightColor(item.colors.border)
        setHighlightedMemberIds([]);
      } else {
        setSelectedCategory(item.category);
        setCurrentNavInfo(item);
        setHighlightColor(item.colors.border)
        setHighlightedMemberIds(categoryMemberMap[item.category] || []);
      }
    },
    [selectedCategory, categoryMemberMap]
  );

  const handleDeflateClick = useCallback(() => {
    // Trigger confetti from each card's position
    Object.values(cardRefs.current).forEach((ref) => {
      if (ref) {
        triggerConfettiAtRef(ref);
      }
    });
    // Call the resetEgo function passed from App.js
    resetEgo();
  }, [cardRefs, triggerConfettiAtRef, resetEgo]);


  return (
    <motion.section
      ref={teamCardsRef}
      className="relative z-10 w-full py-20 px-4 flex flex-col items-center"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
        Mød Vores Team!
      </h2>

      <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
        {infoBoxesData.map((item) => {
          const isActive = selectedCategory === item.category;
          const IconComponent = iconComponents[item.icon];

          return (
            <motion.div
              key={item.id}
              onClick={() => handleInfoBoxClick(item)}
              className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer text-white"
              style={{
                border: `2px solid ${item.colors.border}`,
                backgroundColor: item.colors.background,
                boxShadow: isActive ? `0 0 15px ${item.colors.border}` : "none",
              }}
              whileHover={{ scale: 1.05 }}
            >
              {IconComponent && <IconComponent size={40} />}
              <span className="mt-2 text-center font-semibold">
                {item.title}
              </span>
            </motion.div>
          );
        })}
      </div>

      <AnimatePresence>
        {currentNavInfo && (
          <motion.div
            key={currentNavInfo.id}
            className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center text-white"
            style={{
              border: `2px solid ${currentNavInfo.colors.border}`,
              backgroundColor: currentNavInfo.colors.background,
            }}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
            <div className="text-base text-lg text-white-900">
              <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
        {teamMembers.map((m) => {
          const isHighlighted = highlightedMemberIds.includes(m.id);
          const dimmed = selectedCategory && !isHighlighted;
          return (
            <TeamCard
              key={m.id}
              member={m}
              isHighlighted={isHighlighted}
              dimmed={dimmed}
              highlightColor={highlightColor}
              ref={(el) => (cardRefs.current[m.id] = el)} // Assign ref to each card
            />
          );
        })}
      </div>

      <div className="mt-12">
        <motion.button
          onClick={handleDeflateClick}
          className="px-8 py-3 rounded-full font-bold uppercase shadow-lg"
          style={{
            background: "linear-gradient(90deg,#db2777,#ec4899,#f0abfc)",
            backgroundSize: "200% 200%",
            animation: "pulseGradient 1.5s ease-in-out infinite",
          }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="text-white">Punktèr Os!</span>
        </motion.button>
      </div>
    </motion.section>
  );
});

// --- COMPONENT: GamesSection ---
const GamesSection = React.memo(({
  developedGames,
  gamesInDevelopment,
  gamesSectionRef,
  gamesInDevRef,
  headerRef,
  scrollTo,
}) => {
  return (
    <>
      <section
        id="games"
        ref={gamesSectionRef}
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <a
                href={game.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors"
              >
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(gamesInDevRef)}
          className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll to games in development"
        >
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(headerRef)}
          className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll back to top"
        >
          <FaChevronUp size={30} />
        </motion.button>
      </section>
    </>
  );
});

// --- COMPONENT: Footer ---
const Footer = React.memo(() => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere
            både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">
            &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
            forbeholdt.
          </p>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">
                Om Os
              </a>
            </li>
            <li>
              <a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">
                Vores Spil
              </a>
            </li>
            <li>
              <a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">
                Mød Teamet
              </a>
            </li>
            <li>
              <a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">
                Kontakt
              </a>
            </li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center justify-center md:justify-start">
              <FaEnvelope className="mr-2 text-pink-400" />
              <a href="mailto:info@kloegtig.dk" className="hover:text-purple-400 transition-colors">
                info@kloegtig.dk
              </a>
            </li>
            <li className="flex items-center justify-center md:justify-start">
              <FaPhone className="mr-2 text-pink-400" />
              <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
                +45 12 34 56 78
              </a>
            </li>
          </ul>
          <div className="flex justify-center md:justify-start space-x-4 mt-6">
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
});

// --- MAIN APP COMPONENT ---
function App() {
  const [clicks, setClicks] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
  const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

  // Refs for scrolling
  const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
  const gamesInDevRef = useRef(null);

  const scrollTo = useCallback((ref) => () => {
    // If ref is headerRef (which points to the top of the page), scroll to top of window
    if (ref === headerRef) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Scroll to the top of the page on initial render
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Effect for changing quotes
  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setCurrentQuoteIndex((prevIndex) =>
        (prevIndex + 1) % heroQuotes.length
      );
    }, QUOTE_CHANGE_INTERVAL);

    return () => clearInterval(quoteInterval); // Cleanup on unmount
  }, []); // Empty dependency array means it runs once on mount

  const shootConfetti = useCallback((x, y) => {
    const common = {
      spread: 360,
      ticks: 100,
      gravity: 0.5,
      decay: 0.94,
      startVelocity: 30,
      origin: { x: x, y: y }, // Use provided x, y for origin
    };

    canvasConfetti({
      ...common,
      scalar: 1.2,
      shapes: ["circle", "square"],
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    });

    canvasConfetti({
      ...common,
      scalar: 0.75,
      shapes: ["star"],
      colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
    });
  }, []);

  const triggerConfettiAtRef = useCallback((ref) => {
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      shootConfetti(x / window.innerWidth, y / window.innerHeight);
    }
  }, [shootConfetti]);


  // Effect for managing click decay
  useEffect(() => {
    const startDecayTimer = () => {
      // Clear any existing decay timer to prevent multiple timers running
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }

      decayTimeoutRef.current = setTimeout(() => {
        setClicks((prevClicks) => {
          if (prevClicks > 0) {
            return Math.max(0, prevClicks - DECAY_AMOUNT);
          }
          return 0; // Don't go below zero
        });
        // Reschedule the decay if clicks are still above zero AND content is not unlocked
        if (clicks > 0 && clicks < REQUIRED_CLICKS) {
            startDecayTimer();
        }
      }, DECAY_INTERVAL);
    };

    // Only start decay if clicks are not 0 and content isn't unlocked
    if (clicks > 0 && clicks < REQUIRED_CLICKS) {
        startDecayTimer();
    } else {
        // If clicks are 0 or content is unlocked, ensure no decay timer is running
        if (decayTimeoutRef.current) {
            clearTimeout(decayTimeoutRef.current);
            decayTimeoutRef.current = null;
        }
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }
    };
  }, [clicks, REQUIRED_CLICKS]); // Re-run when clicks or requiredClicks change

  // Confetti effect (for initial unlock)
  useEffect(() => {
    if (showConfetti) {
      // This burst is for the initial "Pust Vores Egoer Op!" completion
      shootConfetti(0.5, 0.5); // Center confetti
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, BURST_DURATION);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, shootConfetti]);

  // Unlock content effect
  useEffect(() => {
    if (clicks >= REQUIRED_CLICKS) {
      setShowConfetti(true);
      // Stop decay when content is unlocked
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
      }
      setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
    }
  }, [clicks, scrollTo, teamCardsRef]);

  // Function for the "Pust Vores Egoer Op!" button
  const handleMainButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

    // Clear any pending decay timeout when a click occurs
    if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
    }

    // Increment clicks only if less than REQUIRED_CLICKS
    setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
  };

  // New function specifically for resetting ego from "Punktèr Os!" button
  const resetEgo = useCallback(() => {
    setClicks(0);
    setShowConfetti(false); // Ensure confetti stops
    scrollTo(headerRef)(); // Scroll to top on reset
  }, [scrollTo, headerRef]);


  const isContentUnlocked = clicks >= REQUIRED_CLICKS;

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
      <div className="absolute inset-0 z-0 opacity-20" />

      <HeroSection
        clicks={clicks}
        requiredClicks={REQUIRED_CLICKS}
        handleMainButtonClick={handleMainButtonClick}
        isButtonClicked={isButtonClicked}
        currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
      />

      <AnimatePresence>
        {isContentUnlocked && ( // Only render these sections if content is unlocked
          <>
            <TeamSection
              teamMembers={teamMembersWithCategories}
              infoBoxesData={infoBoxesData}
              teamCardsRef={teamCardsRef}
              resetEgo={resetEgo} // Pass the new resetEgo function
              cardRefs={teamCardRefs} // Pass the ref object to TeamSection
              triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
            />
            <GamesSection
              developedGames={developedGames}
              gamesInDevelopment={gamesInDevelopment}
              gamesSectionRef={gamesSectionRef}
              gamesInDevRef={gamesInDevRef}
              headerRef={headerRef}
              scrollTo={scrollTo}
            />
          </>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}

export default App; */





/* import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { motion, AnimatePresence, useSpring } from "framer-motion";
import canvasConfetti from "canvas-confetti";
import ReactMarkdown from "react-markdown";
import {
  FaEnvelope,
  FaPhone,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaBehance,
  FaGithub,
  FaMedium,
  FaDribbble,
  FaStackOverflow,
  FaArtstation,
  FaPinterest,
  FaPaintBrush,
  FaUsers,
  FaLightbulb,
  FaChartLine,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import logo from "./assets/logo/fox.png"; // Make sure your logo is here

// --- APP DATA (moved from appData.js) ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500; // Time in ms before a click decays
const DECAY_AMOUNT = 1; // How many clicks decay per interval
const QUOTE_CHANGE_INTERVAL = 5000; // 5 seconds for quote change

const heroQuotes = [
  "Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.",
  "Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!",
  "Leg er ikke en luksus, det er en nødvendighed. Og vi leverer den!",
  "Bring mennesker sammen, én latterfyldt spiloplevelse ad gangen.",
  "Vores mission? Uendelig sjov, for alle!"
];


const rawTeamMembers = [
  {
    id: 1,
    name: "Alice",
    photo: "https://i.pravatar.cc/150?img=1",
    role: "GALL",
    fullRole: "(Grand Architect of Ludicrous Levels)",
    contactInfo: {
      email: "alice.gall@kloegtig.dk",
      phone: "+1-555-0101",
      social: "linkedin.com/in/alice_gall",
    },
    mantra: "Building worlds, one pixel at a time.",
  },
  {
    id: 2,
    name: "Bob",
    photo: "https://i.pravatar.cc/150?img=2",
    role: "CAA",
    fullRole: "(Chief Algorithm Alchemist)",
    contactInfo: {
      email: "bob.caa@kloegtig.dk",
      phone: "+1-555-0102",
      social: "twitter.com/bob_caa",
    },
    mantra: "The code always knows.",
  },
  {
    id: 3,
    name: "Charlie",
    photo: "https://i.pravatar.cc/150?img=3",
    role: "PDPX",
    fullRole: "(Primary Dream Weaver of Player Experiences)",
    contactInfo: {
      email: "charlie.pdpx@kloegtig.dk",
      phone: "+1-555-0103",
      social: "instagram.com/charlie_pdpx",
    },
    mantra: "Crafting unforgettable moments.",
  },
  {
    id: 4,
    name: "Diana",
    photo: "https://i.pravatar.cc/150?img=4",
    role: "CSS",
    fullRole: "(Community Sparkle Spreader)",
    contactInfo: {
      email: "diana.css@kloegtig.dk",
      phone: "+1-555-0104",
      social: "facebook.com/diana_css",
    },
    mantra: "Connecting hearts, one smile at a time.",
  },
  {
    id: 5,
    name: "Eve",
    photo: "https://i.pravatar.cc/150?img=5",
    role: "KUXS",
    fullRole: "(Kinetic User Experience Sorceress)",
    contactInfo: {
      email: "eve.kuxs@kloegtig.dk",
      phone: "+1-555-0105",
      social: "behance.net/eve_kuxs",
    },
    mantra: "Intuitive design is magic.",
  },
  {
    id: 6,
    name: "Frank",
    photo: "https://i.pravatar.cc/150?img=6",
    role: "KSL",
    fullRole: "(Keeper of Supreme Logic)",
    contactInfo: {
      email: "frank.ksl@kloegtig.dk",
      phone: "+1-555-0106",
      social: "github.com/frank_ksl",
    },
    mantra: "Logic is the foundation of greatness.",
  },
  {
    id: 7,
    name: "Grace",
    photo: "https://i.pravatar.cc/150?img=7",
    role: "LSS",
    fullRole: "(Live Service Storyteller)",
    contactInfo: {
      email: "grace.lss@kloegtig.dk",
      phone: "+1-555-0107",
      social: "medium.com/@grace_lss",
    },
    mantra: "Every update tells a new tale.",
  },
  {
    id: 8,
    name: "Heidi",
    photo: "https://i.pravatar.cc/150?img=8",
    role: "UID",
    fullRole: "(Unreal Interface Dreamer)",
    contactInfo: {
      email: "heidi.uid@kloegtig.dk",
      phone: "+1-555-0108",
      social: "dribbble.com/heidi_uid",
    },
    mantra: "Designing the future, one interface at a time.",
  },
  {
    id: 9,
    name: "Ivan",
    photo: "https://i.pravatar.cc/150?img=9",
    role: "BII",
    fullRole: "(Backend Illusionist & Inventor)",
    contactInfo: {
      email: "ivan.bii@kloegtig.dk",
      phone: "+1-555-0109",
      social: "stackoverflow.com/users/ivan_bii",
    },
    mantra: "Behind every great front-end is a magical back-end.",
  },
  {
    id: 10,
    name: "Judy",
    photo: "https://i.pravatar.cc/150?img=10",
    role: "NWBW",
    fullRole: "(Narrative & World-Building Wizard)",
    contactInfo: {
      email: "judy.nwbw@kloegtig.dk",
      phone: "+1-555-0110",
      social: "artstation.com/judy_nwbw",
    },
    mantra: "Worlds within words, stories without end.",
  },
  {
    id: 11,
    name: "Kevin",
    photo: "https://i.pravatar.cc/150?img=11",
    role: "BUD",
    fullRole: "(Business Unit Dragon)",
    contactInfo: {
      email: "kevin.bud@kloegtig.dk",
      phone: "+1-555-0111",
      social: "linkedin.com/in/kevin_bud",
    },
    mantra: "Igniting growth, one strategy at a time.",
  },
  {
    id: 12,
    name: "Liam",
    photo: "https://i.pravatar.cc/150?img=12",
    role: "PME",
    fullRole: "(Potion Master of Experience)",
    contactInfo: {
      email: "liam.pme@kloegtig.dk",
      phone: "+1-555-0112",
      social: "pinterest.com/liam_pme",
    },
    mantra: "Brewing experiences that delight.",
  },
];

const infoBoxesData = [
  {
    id: "creativityDesign",
    icon: "FaPaintBrush", // Use string for icon name, pass to component to render
    title: "Kreativitet & Design",
    info: "Vi brænder for at skabe 🎨 **originale og engagerende spiloplevelser** 🎮 gennem innovativt design og fængslende kunst.",
    category: "creativityDesign",
    colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
  },
  {
    id: "teamworkCommunity",
    icon: "FaUsers",
    title: "Samarbejde & Fællesskab",
    info: "Vores succes bygger på 💪 **stærkt samarbejde og et inkluderende fællesskab** 🤝, både internt og med vores spillere.",
    category: "teamworkCommunity",
    colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
  },
  {
    id: "innovationDevelopment",
    icon: "FaLightbulb",
    title: "Innovation & Udvikling",
    info: "Vi driver kontinuerlig innovation ved at udforske 🚀 **nye teknologier og banebrydende idéer** 💡.",
    category: "innovationDevelopment",
    colors: { border: "#ffd700", background: "#ffc107" }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: "visionProgress",
    icon: "FaChartLine",
    title: "Vision & Fremdrift",
    info: "Vi har et🎯 **klart formål og en tydelig retning** 🧭 for vores spil og forretning.",
    category: "visionProgress",
    colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

const developedGames = [
  {
    id: 1,
    title: "Starfall Tactics",
    description:
      "An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of 'Indie Game of the Year' 2023.",
    image: "https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image",
    link: "#",
  },
  {
    id: 2,
    title: "Whispering Woods",
    description:
      "A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.",
    image: "https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image",
    link: "#",
  },
  {
    id: 3,
    title: "Neon Drift Racers",
    description:
      "High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.",
    image: "https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image",
    link: "#",
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: "Project Aurora",
    description:
      "An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.",
    image: "https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image",
    status: "Alpha Testing",
  },
  {
    id: 102,
    title: "Mythic Mayhem",
    description:
      "A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.",
    image: "https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image",
    status: "Concept & Prototyping",
  },
];

const calculateMemberCategories = (members, infoBoxes) => {
  return members.map((member) => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const teamMembersWithCategories = calculateMemberCategories(rawTeamMembers, infoBoxesData);

// --- COMPONENT: TeamCard ---
const getSocialIcon = (socialUrl) => {
  if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
  if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
  if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
  if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
  if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
  if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
  if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
  if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
  if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
  if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
  if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
  return null;
};

const TeamCard = React.forwardRef(({ member, isHighlighted, dimmed }, ref) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 });

  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      ref={ref} // Attach the ref here
      className={`relative w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
        isHighlighted ? "ring-4 ring-yellow-400 scale-105" : ""
      } ${dimmed ? "opacity-40" : ""} cursor-default`}
      style={{ perspective: 1000 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        <div
          className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(0deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <img
            src={member.photo}
            alt={member.name}
            className="w-24 h-24 rounded-full mx-auto mb-3 object-cover shadow-lg"
          />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
          style={{
            transform: "rotateY(180deg) translateZ(0)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">
            {member.name}'s Info
          </h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
              {member.contactInfo.email}
            </a>
          </p>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaPhone className="mr-2 text-green-300" />
            <span>{member.contactInfo.phone}</span>
          </p>
          {member.contactInfo.social && (
            <p className="text-sm text-gray-200 mb-3 flex items-center">
              {getSocialIcon(member.contactInfo.social)}
              <a
                href={`https://${member.contactInfo.social}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {member.contactInfo.social.split("/").pop()}
              </a>
            </p>
          )}
          <p className="italic text-gray-400 text-center text-sm">
            "{member.mantra}"
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
});

// --- COMPONENT: HeroSection ---
const HeroSection = ({
  clicks,
  requiredClicks,
  handleMainButtonClick,
  isButtonClicked,
  currentQuote, // New prop for the current quote
}) => {
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <motion.header
      className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      
      <motion.div
        className="flex flex-col items-center mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
      >
        <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
        <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
        <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
      </motion.div>
      

      <motion.h1
        className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
      >
        Spil. Hyg. Fejr!
      </motion.h1>
      <AnimatePresence mode="wait">
        <motion.p
          key={currentQuote} // Key change forces re-render and animation
          className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl min-h-[4rem] flex items-center justify-center" // Added min-h and flex properties
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
        >
          {currentQuote}
        </motion.p>
      </AnimatePresence>

      <div className="mt-8 w-full max-w-sm md:max-w-md">
        <motion.button
          onClick={handleMainButtonClick}
          className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
          style={{
            background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
            backgroundSize: "200% 200%",
            animation: "buttonGradient 2s linear infinite",
          }}
          whileTap={{ scale: 0.95 }}
          animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
          transition={{ duration: 0.1 }}
          aria-label="Pust Vores Egoer Op!"
          disabled={clicks >= requiredClicks} // Disable button if clicks reach requiredClicks
        >
          <motion.div
            className="absolute inset-0 bg-white bg-opacity-20"
            animate={{ width: `${progressPct}%` }}
            transition={{ type: "tween", duration: 0.2 }}
          />
          <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
        </motion.button>
        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
          <motion.div
            className="h-full bg-green-400"
            animate={{ width: `${progressPct}%` }}
            transition={{ type: "tween", duration: 0.2 }}
          />
        </div>
        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
          {clicks} / {requiredClicks} klik
        </div>
      </div>
      
    </motion.header>
  );
};

// --- COMPONENT: TeamSection ---
const iconComponents = {
  FaPaintBrush: FaPaintBrush,
  FaUsers: FaUsers,
  FaLightbulb: FaLightbulb,
  FaChartLine: FaChartLine,
};

const TeamSection = React.memo(({
  teamMembers,
  infoBoxesData,
  teamCardsRef,
  resetEgo, // New prop for resetting ego
  cardRefs,
  triggerConfettiAtRef,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);

  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach((m) => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  const handleInfoBoxClick = useCallback(
    (item) => {
      if (selectedCategory === item.category) {
        setSelectedCategory(null);
        setCurrentNavInfo(null);
        setHighlightedMemberIds([]);
      } else {
        setSelectedCategory(item.category);
        setCurrentNavInfo(item);
        setHighlightedMemberIds(categoryMemberMap[item.category] || []);
      }
    },
    [selectedCategory, categoryMemberMap]
  );

  const handleDeflateClick = useCallback(() => {
    // Trigger confetti from each card's position
    Object.values(cardRefs.current).forEach((ref) => {
      if (ref) {
        triggerConfettiAtRef(ref);
      }
    });
    // Call the resetEgo function passed from App.js
    resetEgo();
  }, [cardRefs, triggerConfettiAtRef, resetEgo]);


  return (
    <motion.section
      ref={teamCardsRef}
      className="relative z-10 w-full py-20 px-4 flex flex-col items-center"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
        Mød Vores Team!
      </h2>

      <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
        {infoBoxesData.map((item) => {
          const isActive = selectedCategory === item.category;
          const IconComponent = iconComponents[item.icon];

          return (
            <motion.div
              key={item.id}
              onClick={() => handleInfoBoxClick(item)}
              className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer"
              style={{
                border: `2px solid ${item.colors.border}`,
                backgroundColor: item.colors.background,
                boxShadow: isActive ? `0 0 15px ${item.colors.border}` : "none",
              }}
              whileHover={{ scale: 1.05 }}
            >
              {IconComponent && <IconComponent size={40} />}
              <span className="mt-2 text-center font-semibold">
                {item.title}
              </span>
            </motion.div>
          );
        })}
      </div>

      <AnimatePresence>
        {currentNavInfo && (
          <motion.div
            key={currentNavInfo.id}
            className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center"
            style={{
              border: `2px solid ${currentNavInfo.colors.border}`,
              backgroundColor: currentNavInfo.colors.background,
            }}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
            <div className="text-base text-lg text-white-900">
              <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
        {teamMembers.map((m) => {
          const isHighlighted = highlightedMemberIds.includes(m.id);
          const dimmed = selectedCategory && !isHighlighted;
          return (
            <TeamCard
              key={m.id}
              member={m}
              isHighlighted={isHighlighted}
              dimmed={dimmed}
              ref={(el) => (cardRefs.current[m.id] = el)} // Assign ref to each card
            />
          );
        })}
      </div>

      <div className="mt-12">
        <motion.button
          onClick={handleDeflateClick}
          className="px-8 py-3 rounded-full font-bold uppercase shadow-lg"
          style={{
            background: "linear-gradient(90deg,#db2777,#ec4899,#f0abfc)",
            backgroundSize: "200% 200%",
            animation: "pulseGradient 1.5s ease-in-out infinite",
          }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="text-white">Punktèr Os!</span>
        </motion.button>
      </div>
    </motion.section>
  );
});

// --- COMPONENT: GamesSection ---
const GamesSection = React.memo(({
  developedGames,
  gamesInDevelopment,
  gamesSectionRef,
  gamesInDevRef,
  headerRef,
  scrollTo,
}) => {
  return (
    <>
      <section
        id="games"
        ref={gamesSectionRef}
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <a
                href={game.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors"
              >
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(gamesInDevRef)}
          className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll to games in development"
        >
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map((game) => (
            <motion.div
              key={game.id}
              className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={game.image}
                alt={game.title}
                className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
              />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">
                {game.title}
              </h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">
                {game.description}
              </p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button
          onClick={scrollTo(headerRef)}
          className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          aria-label="Scroll back to top"
        >
          <FaChevronUp size={30} />
        </motion.button>
      </section>
    </>
  );
});

// --- COMPONENT: Footer ---
const Footer = React.memo(() => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere
            både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">
            &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
            forbeholdt.
          </p>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">
                Om Os
              </a>
            </li>
            <li>
              <a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">
                Vores Spil
              </a>
            </li>
            <li>
              <a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">
                Mød Teamet
              </a>
            </li>
            <li>
              <a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">
                Kontakt
              </a>
            </li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center justify-center md:justify-start">
              <FaEnvelope className="mr-2 text-pink-400" />
              <a href="mailto:info@kloegtig.dk" className="hover:text-purple-400 transition-colors">
                info@kloegtig.dk
              </a>
            </li>
            <li className="flex items-center justify-center md:justify-start">
              <FaPhone className="mr-2 text-pink-400" />
              <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
                +45 12 34 56 78
              </a>
            </li>
          </ul>
          <div className="flex justify-center md:justify-start space-x-4 mt-6">
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
});

// --- MAIN APP COMPONENT ---
function App() {
  const [clicks, setClicks] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
  const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0); // State for current quote

  // Refs for scrolling
  const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
  const gamesInDevRef = useRef(null);

  const scrollTo = useCallback((ref) => () => {
    // If ref is headerRef (which points to the top of the page), scroll to top of window
    if (ref === headerRef) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Scroll to the top of the page on initial render
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Effect for changing quotes
  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setCurrentQuoteIndex((prevIndex) =>
        (prevIndex + 1) % heroQuotes.length
      );
    }, QUOTE_CHANGE_INTERVAL);

    return () => clearInterval(quoteInterval); // Cleanup on unmount
  }, []); // Empty dependency array means it runs once on mount

  const shootConfetti = useCallback((x, y) => {
    const common = {
      spread: 360,
      ticks: 100,
      gravity: 0.5,
      decay: 0.94,
      startVelocity: 30,
      origin: { x: x, y: y }, // Use provided x, y for origin
    };

    canvasConfetti({
      ...common,
      scalar: 1.2,
      shapes: ["circle", "square"],
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    });

    canvasConfetti({
      ...common,
      scalar: 0.75,
      shapes: ["star"],
      colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
    });
  }, []);

  const triggerConfettiAtRef = useCallback((ref) => {
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      shootConfetti(x / window.innerWidth, y / window.innerHeight);
    }
  }, [shootConfetti]);


  // Effect for managing click decay
  useEffect(() => {
    const startDecayTimer = () => {
      // Clear any existing decay timer to prevent multiple timers running
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }

      decayTimeoutRef.current = setTimeout(() => {
        setClicks((prevClicks) => {
          if (prevClicks > 0) {
            return Math.max(0, prevClicks - DECAY_AMOUNT);
          }
          return 0; // Don't go below zero
        });
        // Reschedule the decay if clicks are still above zero AND content is not unlocked
        if (clicks > 0 && clicks < REQUIRED_CLICKS) {
            startDecayTimer();
        }
      }, DECAY_INTERVAL);
    };

    // Only start decay if clicks are not 0 and content isn't unlocked
    if (clicks > 0 && clicks < REQUIRED_CLICKS) {
        startDecayTimer();
    } else {
        // If clicks are 0 or content is unlocked, ensure no decay timer is running
        if (decayTimeoutRef.current) {
            clearTimeout(decayTimeoutRef.current);
            decayTimeoutRef.current = null;
        }
    }

    // Cleanup on unmount or when dependencies change
    return () => {
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
      }
    };
  }, [clicks, REQUIRED_CLICKS]); // Re-run when clicks or requiredClicks change

  // Confetti effect (for initial unlock)
  useEffect(() => {
    if (showConfetti) {
      // This burst is for the initial "Pust Vores Egoer Op!" completion
      shootConfetti(0.5, 0.5); // Center confetti
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, BURST_DURATION);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, shootConfetti]);

  // Unlock content effect
  useEffect(() => {
    if (clicks >= REQUIRED_CLICKS) {
      setShowConfetti(true);
      // Stop decay when content is unlocked
      if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
      }
      setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
    }
  }, [clicks, scrollTo, teamCardsRef]);

  // Function for the "Pust Vores Egoer Op!" button
  const handleMainButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

    // Clear any pending decay timeout when a click occurs
    if (decayTimeoutRef.current) {
        clearTimeout(decayTimeoutRef.current);
        decayTimeoutRef.current = null;
    }

    // Increment clicks only if less than REQUIRED_CLICKS
    setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
  };

  // New function specifically for resetting ego from "Punktèr Os!" button
  const resetEgo = useCallback(() => {
    setClicks(0);
    setShowConfetti(false); // Ensure confetti stops
    scrollTo(headerRef)(); // Scroll to top on reset
  }, [scrollTo, headerRef]);


  const isContentUnlocked = clicks >= REQUIRED_CLICKS;

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
      
      <div className="absolute inset-0 z-0 opacity-20" />

      <HeroSection
        clicks={clicks}
        requiredClicks={REQUIRED_CLICKS}
        handleMainButtonClick={handleMainButtonClick}
        isButtonClicked={isButtonClicked}
        currentQuote={heroQuotes[currentQuoteIndex]} // Pass the current quote
      />

      <AnimatePresence>
        {isContentUnlocked && ( // Only render these sections if content is unlocked
          <>
            <TeamSection
              teamMembers={teamMembersWithCategories}
              infoBoxesData={infoBoxesData}
              teamCardsRef={teamCardsRef}
              resetEgo={resetEgo} // Pass the new resetEgo function
              cardRefs={teamCardRefs} // Pass the ref object to TeamSection
              triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
            />
            <GamesSection
              developedGames={developedGames}
              gamesInDevelopment={gamesInDevelopment}
              gamesSectionRef={gamesSectionRef}
              gamesInDevRef={gamesInDevRef}
              headerRef={headerRef}
              scrollTo={scrollTo}
            />
          </>
        )}
      </AnimatePresence>

      <Footer />
    </div>
  );
}

export default App; */





// // src/App.js
// import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
// import { motion, AnimatePresence, useSpring } from "framer-motion";
// import canvasConfetti from "canvas-confetti";
// import ReactMarkdown from "react-markdown";
// import {
//   FaEnvelope,
//   FaPhone,
//   FaLinkedin,
//   FaTwitter,
//   FaFacebook,
//   FaInstagram,
//   FaBehance,
//   FaGithub,
//   FaMedium,
//   FaDribbble,
//   FaStackOverflow,
//   FaArtstation,
//   FaPinterest,
//   FaPaintBrush,
//   FaUsers,
//   FaLightbulb,
//   FaChartLine,
//   FaChevronDown,
//   FaChevronUp,
// } from "react-icons/fa";
// import logo from "./assets/logo/fox.png"; // Make sure your logo is here

// // --- APP DATA (moved from appData.js) ---
// const REQUIRED_CLICKS = 10;
// const BURST_DURATION = 600;
// const DECAY_INTERVAL = 500; // Time in ms before a click decays
// const DECAY_AMOUNT = 1; // How many clicks decay per interval

// const rawTeamMembers = [
//   {
//     id: 1,
//     name: "Alice",
//     photo: "https://i.pravatar.cc/150?img=1",
//     role: "GALL",
//     fullRole: "(Grand Architect of Ludicrous Levels)",
//     contactInfo: {
//       email: "alice.gall@kloegtig.dk",
//       phone: "+1-555-0101",
//       social: "linkedin.com/in/alice_gall",
//     },
//     mantra: "Building worlds, one pixel at a time.",
//   },
//   {
//     id: 2,
//     name: "Bob",
//     photo: "https://i.pravatar.cc/150?img=2",
//     role: "CAA",
//     fullRole: "(Chief Algorithm Alchemist)",
//     contactInfo: {
//       email: "bob.caa@kloegtig.dk",
//       phone: "+1-555-0102",
//       social: "twitter.com/bob_caa",
//     },
//     mantra: "The code always knows.",
//   },
//   {
//     id: 3,
//     name: "Charlie",
//     photo: "https://i.pravatar.cc/150?img=3",
//     role: "PDPX",
//     fullRole: "(Primary Dream Weaver of Player Experiences)",
//     contactInfo: {
//       email: "charlie.pdpx@kloegtig.dk",
//       phone: "+1-555-0103",
//       social: "instagram.com/charlie_pdpx",
//     },
//     mantra: "Crafting unforgettable moments.",
//   },
//   {
//     id: 4,
//     name: "Diana",
//     photo: "https://i.pravatar.cc/150?img=4",
//     role: "CSS",
//     fullRole: "(Community Sparkle Spreader)",
//     contactInfo: {
//       email: "diana.css@kloegtig.dk",
//       phone: "+1-555-0104",
//       social: "facebook.com/diana_css",
//     },
//     mantra: "Connecting hearts, one smile at a time.",
//   },
//   {
//     id: 5,
//     name: "Eve",
//     photo: "https://i.pravatar.cc/150?img=5",
//     role: "KUXS",
//     fullRole: "(Kinetic User Experience Sorceress)",
//     contactInfo: {
//       email: "eve.kuxs@kloegtig.dk",
//       phone: "+1-555-0105",
//       social: "behance.net/eve_kuxs",
//     },
//     mantra: "Intuitive design is magic.",
//   },
//   {
//     id: 6,
//     name: "Frank",
//     photo: "https://i.pravatar.cc/150?img=6",
//     role: "KSL",
//     fullRole: "(Keeper of Supreme Logic)",
//     contactInfo: {
//       email: "frank.ksl@kloegtig.dk",
//       phone: "+1-555-0106",
//       social: "github.com/frank_ksl",
//     },
//     mantra: "Logic is the foundation of greatness.",
//   },
//   {
//     id: 7,
//     name: "Grace",
//     photo: "https://i.pravatar.cc/150?img=7",
//     role: "LSS",
//     fullRole: "(Live Service Storyteller)",
//     contactInfo: {
//       email: "grace.lss@kloegtig.dk",
//       phone: "+1-555-0107",
//       social: "medium.com/@grace_lss",
//     },
//     mantra: "Every update tells a new tale.",
//   },
//   {
//     id: 8,
//     name: "Heidi",
//     photo: "https://i.pravatar.cc/150?img=8",
//     role: "UID",
//     fullRole: "(Unreal Interface Dreamer)",
//     contactInfo: {
//       email: "heidi.uid@kloegtig.dk",
//       phone: "+1-555-0108",
//       social: "dribbble.com/heidi_uid",
//     },
//     mantra: "Designing the future, one interface at a time.",
//   },
//   {
//     id: 9,
//     name: "Ivan",
//     photo: "https://i.pravatar.cc/150?img=9",
//     role: "BII",
//     fullRole: "(Backend Illusionist & Inventor)",
//     contactInfo: {
//       email: "ivan.bii@kloegtig.dk",
//       phone: "+1-555-0109",
//       social: "stackoverflow.com/users/ivan_bii",
//     },
//     mantra: "Behind every great front-end is a magical back-end.",
//   },
//   {
//     id: 10,
//     name: "Judy",
//     photo: "https://i.pravatar.cc/150?img=10",
//     role: "NWBW",
//     fullRole: "(Narrative & World-Building Wizard)",
//     contactInfo: {
//       email: "judy.nwbw@kloegtig.dk",
//       phone: "+1-555-0110",
//       social: "artstation.com/judy_nwbw",
//     },
//     mantra: "Worlds within words, stories without end.",
//   },
//   {
//     id: 11,
//     name: "Kevin",
//     photo: "https://i.pravatar.cc/150?img=11",
//     role: "BUD",
//     fullRole: "(Business Unit Dragon)",
//     contactInfo: {
//       email: "kevin.bud@kloegtig.dk",
//       phone: "+1-555-0111",
//       social: "linkedin.com/in/kevin_bud",
//     },
//     mantra: "Igniting growth, one strategy at a time.",
//   },
//   {
//     id: 12,
//     name: "Liam",
//     photo: "https://i.pravatar.cc/150?img=12",
//     role: "PME",
//     fullRole: "(Potion Master of Experience)",
//     contactInfo: {
//       email: "liam.pme@kloegtig.dk",
//       phone: "+1-555-0112",
//       social: "pinterest.com/liam_pme",
//     },
//     mantra: "Brewing experiences that delight.",
//   },
// ];

// const infoBoxesData = [
//   {
//     id: "creativityDesign",
//     icon: "FaPaintBrush", // Use string for icon name, pass to component to render
//     title: "Kreativitet & Design",
//     info: "Vi brænder for at skabe 🎨 **originale og engagerende spiloplevelser** 🎮 gennem innovativt design og fængslende kunst.",
//     category: "creativityDesign",
//     colors: { border: "#ff69b4", background: "#e91e63" }, // Playful Pink
//     scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
//   },
//   {
//     id: "teamworkCommunity",
//     icon: "FaUsers",
//     title: "Samarbejde & Fællesskab",
//     info: "Vores succes bygger på 💪 **stærkt samarbejde og et inkluderende fællesskab** 🤝, både internt og med vores spillere.",
//     category: "teamworkCommunity",
//     colors: { border: "#8a2be2", background: "#673ab7" }, // Amethyst Purple
//     scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
//   },
//   {
//     id: "innovationDevelopment",
//     icon: "FaLightbulb",
//     title: "Innovation & Udvikling",
//     info: "Vi driver kontinuerlig innovation ved at udforske 🚀 **nye teknologier og banebrydende idéer** 💡.",
//     category: "innovationDevelopment",
//     colors: { border: "#ffd700", background: "#ffc107" }, // Sunny Yellow
//     scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
//   },
//   {
//     id: "visionProgress",
//     icon: "FaChartLine",
//     title: "Vision & Fremdrift",
//     info: "Vi har et🎯 **klart formål og en tydelig retning** 🧭 for vores spil og forretning.",
//     category: "visionProgress",
//     colors: { border: "#00bcd4", background: "#0097a7" }, // Turquoise
//     scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
//   },
// ];

// const developedGames = [
//   {
//     id: 1,
//     title: "Starfall Tactics",
//     description:
//       "An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of 'Indie Game of the Year' 2023.",
//     image: "https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image",
//     link: "#",
//   },
//   {
//     id: 2,
//     title: "Whispering Woods",
//     description:
//       "A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.",
//     image: "https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image",
//     link: "#",
//   },
//   {
//     id: 3,
//     title: "Neon Drift Racers",
//     description:
//       "High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.",
//     image: "https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image",
//     link: "#",
//   },
// ];

// const gamesInDevelopment = [
//   {
//     id: 101,
//     title: "Project Aurora",
//     description:
//       "An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.",
//     image: "https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image",
//     status: "Alpha Testing",
//   },
//   {
//     id: 102,
//     title: "Mythic Mayhem",
//     description:
//       "A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.",
//     image: "https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image",
//     status: "Concept & Prototyping",
//   },
// ];

// const calculateMemberCategories = (members, infoBoxes) => {
//   return members.map((member) => {
//     let bestScore = -Infinity;
//     let bestCategory = infoBoxes[0].category; // Default to the first category
//     for (const box of infoBoxes) {
//       const score = box.scoreMapping[member.role] || 0; // Use member.role directly
//       if (score > bestScore) {
//         bestScore = score;
//         bestCategory = box.category;
//       }
//     }
//     return { ...member, category: bestCategory };
//   });
// };

// const teamMembersWithCategories = calculateMemberCategories(rawTeamMembers, infoBoxesData);

// // --- COMPONENT: TeamCard ---
// const getSocialIcon = (socialUrl) => {
//   if (socialUrl.includes("linkedin.com")) return <FaLinkedin className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("twitter.com")) return <FaTwitter className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("facebook.com")) return <FaFacebook className="mr-2 text-blue-400" />;
//   if (socialUrl.includes("instagram.com")) return <FaInstagram className="mr-2 text-pink-400" />;
//   if (socialUrl.includes("behance.net")) return <FaBehance className="mr-2 text-blue-500" />;
//   if (socialUrl.includes("github.com")) return <FaGithub className="mr-2 text-gray-400" />;
//   if (socialUrl.includes("medium.com")) return <FaMedium className="mr-2 text-green-400" />;
//   if (socialUrl.includes("dribbble.com")) return <FaDribbble className="mr-2 text-pink-500" />;
//   if (socialUrl.includes("stackoverflow.com")) return <FaStackOverflow className="mr-2 text-orange-400" />;
//   if (socialUrl.includes("artstation.com")) return <FaArtstation className="mr-2 text-blue-600" />;
//   if (socialUrl.includes("pinterest.com")) return <FaPinterest className="mr-2 text-red-500" />;
//   return null;
// };

// const TeamCard = React.forwardRef(({ member, isHighlighted, dimmed }, ref) => {
//   const [isFlipped, setIsFlipped] = useState(false);
//   const rotation = useSpring(0, { stiffness: 300, damping: 25 });

//   useEffect(() => {
//     rotation.set(isFlipped ? 180 : 0);
//   }, [isFlipped, rotation]);

//   const handleMouseEnter = () => setIsFlipped(true);
//   const handleMouseLeave = () => setIsFlipped(false);

//   return (
//     <motion.div
//       ref={ref} // Attach the ref here
//       className={`relative w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${
//         isHighlighted ? "ring-4 ring-yellow-400 scale-105" : ""
//       } ${dimmed ? "opacity-40" : ""} cursor-default`}
//       style={{ perspective: 1000 }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       initial={{ opacity: 0, scale: 0.8 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.8 }}
//       whileHover={{ scale: 1.05 }}
//     >
//       <motion.div
//         className="relative w-full h-full"
//         style={{
//           rotateY: rotation,
//           transformStyle: "preserve-3d",
//           willChange: "transform",
//         }}
//       >
//         <div
//           className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(0deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <img
//             src={member.photo}
//             alt={member.name}
//             className="w-24 h-24 rounded-full mx-auto mb-3 object-cover shadow-lg"
//           />
//           <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
//           <p className="italic text-gray-300 text-base">{member.role}</p>
//           <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
//         </div>

//         <div
//           className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center"
//           style={{
//             transform: "rotateY(180deg) translateZ(0)",
//             backdropFilter: "blur(5px)",
//             WebkitBackdropFilter: "blur(5px)",
//           }}
//         >
//           <h4 className="font-bold text-yellow-300 text-lg mb-2">
//             {member.name}'s Info
//           </h4>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaEnvelope className="mr-2 text-blue-300" />
//             <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">
//               {member.contactInfo.email}
//             </a>
//           </p>
//           <p className="text-sm text-gray-200 mb-1 flex items-center">
//             <FaPhone className="mr-2 text-green-300" />
//             <span>{member.contactInfo.phone}</span>
//           </p>
//           {member.contactInfo.social && (
//             <p className="text-sm text-gray-200 mb-3 flex items-center">
//               {getSocialIcon(member.contactInfo.social)}
//               <a
//                 href={`https://${member.contactInfo.social}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="hover:underline"
//               >
//                 {member.contactInfo.social.split("/").pop()}
//               </a>
//             </p>
//           )}
//           <p className="italic text-gray-400 text-center text-sm">
//             "{member.mantra}"
//           </p>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// });

// // --- COMPONENT: HeroSection ---
// const HeroSection = ({
//   clicks,
//   requiredClicks,
//   handleMainButtonClick,
//   isButtonClicked,
// }) => {
//   const progressPct = Math.round((clicks / requiredClicks) * 100);

//   return (
//     <motion.header
//       className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
//       initial={{ opacity: 1 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* --- Logo and Catchphrase at the very top --- */}
//       <motion.div
//         className="flex flex-col items-center mb-8"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0 }}
//       >
//         <img src={logo} alt="Kløgtig logo" className="w-24 h-24 md:w-32 md:h-32 object-contain mb-2" />
//         <span className="text-4xl md:text-5xl font-extrabold text-white">kløgtig</span>
//         <p className="italic text-lg md:text-xl text-pink-300 mt-1">- seriøs sjov!</p>
//       </motion.div>
//       {/* --- End Logo and Catchphrase --- */}

//       <motion.h1
//         className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
//         initial={{ scale: 0.8, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         transition={{ type: "spring", stiffness: 120, damping: 20, delay: 0.2 }}
//       >
//         Spil. Hyg. Fejr!
//       </motion.h1>
//       <p className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl">
//         Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige
//         oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
//       </p>
//       <div className="mt-8 w-full max-w-sm md:max-w-md">
//         <motion.button
//           onClick={handleMainButtonClick}
//           className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
//           style={{
//             background: "linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)",
//             backgroundSize: "200% 200%",
//             animation: "buttonGradient 2s linear infinite",
//           }}
//           whileTap={{ scale: 0.95 }}
//           animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
//           transition={{ duration: 0.1 }}
//           aria-label="Pust Vores Egoer Op!"
//           disabled={clicks >= requiredClicks} // Disable button if clicks reach requiredClicks
//         >
//           <motion.div
//             className="absolute inset-0 bg-white bg-opacity-20"
//             animate={{ width: `${progressPct}%` }}
//             transition={{ type: "tween", duration: 0.2 }}
//           />
//           <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
//         </motion.button>
//         <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
//           <motion.div
//             className="h-full bg-green-400"
//             animate={{ width: `${progressPct}%` }}
//             transition={{ type: "tween", duration: 0.2 }}
//           />
//         </div>
//         <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">
//           {clicks} / {requiredClicks} klik
//         </div>
//       </div>
//       {/* Removed the first scroll down button */}
//     </motion.header>
//   );
// };

// // --- COMPONENT: TeamSection ---
// const iconComponents = {
//   FaPaintBrush: FaPaintBrush,
//   FaUsers: FaUsers,
//   FaLightbulb: FaLightbulb,
//   FaChartLine: FaChartLine,
// };

// const TeamSection = ({
//   teamMembers,
//   infoBoxesData,
//   teamCardsRef,
//   resetEgo, // New prop for resetting ego
//   cardRefs,
//   triggerConfettiAtRef,
// }) => {
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [currentNavInfo, setCurrentNavInfo] = useState(null);
//   const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);

//   const categoryMemberMap = useMemo(() => {
//     const map = {};
//     teamMembers.forEach((m) => {
//       if (!map[m.category]) map[m.category] = [];
//       map[m.category].push(m.id);
//     });
//     return map;
//   }, [teamMembers]);

//   const handleInfoBoxClick = useCallback(
//     (item) => {
//       if (selectedCategory === item.category) {
//         setSelectedCategory(null);
//         setCurrentNavInfo(null);
//         setHighlightedMemberIds([]);
//       } else {
//         setSelectedCategory(item.category);
//         setCurrentNavInfo(item);
//         setHighlightedMemberIds(categoryMemberMap[item.category] || []);
//       }
//     },
//     [selectedCategory, categoryMemberMap]
//   );

//   const handleDeflateClick = useCallback(() => {
//     // Trigger confetti from each card's position
//     Object.values(cardRefs.current).forEach((ref) => {
//       if (ref) {
//         triggerConfettiAtRef(ref);
//       }
//     });
//     // Call the resetEgo function passed from App.js
//     resetEgo();
//   }, [cardRefs, triggerConfettiAtRef, resetEgo]);


//   return (
//     <motion.section
//       ref={teamCardsRef}
//       className="relative z-10 w-full py-20 px-4 flex flex-col items-center"
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -50 }}
//       transition={{ duration: 0.8 }}
//     >
//       <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
//         Mød Vores Team!
//       </h2>

//       <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
//         {infoBoxesData.map((item) => {
//           const isActive = selectedCategory === item.category;
//           const IconComponent = iconComponents[item.icon];

//           return (
//             <motion.div
//               key={item.id}
//               onClick={() => handleInfoBoxClick(item)}
//               className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer"
//               style={{
//                 border: `2px solid ${item.colors.border}`,
//                 backgroundColor: item.colors.background,
//                 boxShadow: isActive ? `0 0 15px ${item.colors.border}` : "none",
//               }}
//               whileHover={{ scale: 1.05 }}
//             >
//               {IconComponent && <IconComponent size={40} />}
//               <span className="mt-2 text-center font-semibold">
//                 {item.title}
//               </span>
//             </motion.div>
//           );
//         })}
//       </div>

//       <AnimatePresence>
//         {currentNavInfo && (
//           <motion.div
//             key={currentNavInfo.id}
//             className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center"
//             style={{
//               border: `2px solid ${currentNavInfo.colors.border}`,
//               backgroundColor: currentNavInfo.colors.background,
//             }}
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: "auto" }}
//             exit={{ opacity: 0, height: 0 }}
//             transition={{ duration: 0.3 }}
//           >
//             <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
//             <div className="text-base text-lg text-white-900">
//               <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
//         {teamMembers.map((m) => {
//           const isHighlighted = highlightedMemberIds.includes(m.id);
//           const dimmed = selectedCategory && !isHighlighted;
//           return (
//             <TeamCard
//               key={m.id}
//               member={m}
//               isHighlighted={isHighlighted}
//               dimmed={dimmed}
//               ref={(el) => (cardRefs.current[m.id] = el)} // Assign ref to each card
//             />
//           );
//         })}
//       </div>

//       <div className="mt-12">
//         <motion.button
//           onClick={handleDeflateClick}
//           className="px-8 py-3 rounded-full font-bold uppercase shadow-lg"
//           style={{
//             background: "linear-gradient(90deg,#db2777,#ec4899,#f0abfc)",
//             backgroundSize: "200% 200%",
//             animation: "pulseGradient 1.5s ease-in-out infinite",
//           }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <span className="text-white">Punktèr Os!</span>
//         </motion.button>
//       </div>
//     </motion.section>
//   );
// };

// // --- COMPONENT: GamesSection ---
// const GamesSection = ({
//   developedGames,
//   gamesInDevelopment,
//   gamesSectionRef,
//   gamesInDevRef,
//   headerRef,
//   scrollTo,
// }) => {
//   return (
//     <>
//       <section
//         id="games"
//         ref={gamesSectionRef}
//         className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
//           Vores Spil
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
//           {developedGames.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               transition={{ duration: 0.6 }}
//             >
//               <img
//                 src={game.image}
//                 alt={game.title}
//                 className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
//               />
//               <h3 className="text-2xl font-bold mb-2 text-pink-300">
//                 {game.title}
//               </h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">
//                 {game.description}
//               </p>
//               <a
//                 href={game.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors"
//               >
//                 Læs Mere
//               </a>
//             </motion.div>
//           ))}
//         </div>
//         <motion.button
//           onClick={scrollTo(gamesInDevRef)}
//           className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ duration: 0.5 }}
//           aria-label="Scroll to games in development"
//         >
//           <FaChevronDown size={30} />
//         </motion.button>
//       </section>

//       <section
//         ref={gamesInDevRef}
//         id="games-in-development"
//         className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
//       >
//         <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
//           Spil Under Udvikling
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
//           {gamesInDevelopment.map((game) => (
//             <motion.div
//               key={game.id}
//               className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true, amount: 0.3 }}
//               transition={{ duration: 0.6 }}
//             >
//               <img
//                 src={game.image}
//                 alt={game.title}
//                 className="w-full h-48 object-cover rounded-lg mb-4 shadow-md"
//               />
//               <h3 className="text-2xl font-bold mb-2 text-cyan-300">
//                 {game.title}
//               </h3>
//               <p className="text-gray-300 text-sm mb-4 flex-grow">
//                 {game.description}
//               </p>
//               <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
//                 Status: {game.status}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//         <motion.button
//           onClick={scrollTo(headerRef)}
//           className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.5 }}
//           transition={{ duration: 0.5 }}
//           aria-label="Scroll back to top"
//         >
//           <FaChevronUp size={30} />
//         </motion.button>
//       </section>
//     </>
//   );
// };

// // --- COMPONENT: Footer ---
// const Footer = () => {
//   return (
//     <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
//         <div className="flex flex-col items-center md:items-start text-center md:text-left">
//           <div className="flex items-center space-x-2 mb-4">
//             <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
//             <div>
//               <span className="text-2xl font-bold text-white">kløgtig</span>
//               <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
//             </div>
//           </div>
//           <p className="text-sm max-w-xs">
//             Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere
//             både lokalt og globalt.
//           </p>
//           <p className="text-sm mt-2">
//             &copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder
//             forbeholdt.
//           </p>
//         </div>

//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
//           <ul className="space-y-2">
//             <li>
//               <a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">
//                 Om Os
//               </a>
//             </li>
//             <li>
//               <a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">
//                 Vores Spil
//               </a>
//             </li>
//             <li>
//               <a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">
//                 Mød Teamet
//               </a>
//             </li>
//             <li>
//               <a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">
//                 Kontakt
//               </a>
//             </li>
//           </ul>
//         </div>

//         <div className="text-center md:text-left">
//           <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
//           <ul className="space-y-2">
//             <li className="flex items-center justify-center md:justify-start">
//               <FaEnvelope className="mr-2 text-pink-400" />
//               <a href="mailto:info@kloegtig.dk" className="hover:text-purple-400 transition-colors">
//                 info@kloegtig.dk
//               </a>
//             </li>
//             <li className="flex items-center justify-center md:justify-start">
//               <FaPhone className="mr-2 text-pink-400" />
//               <a href="tel:+4512345678" className="hover:text-purple-400 transition-colors">
//                 +45 12 34 56 78
//               </a>
//             </li>
//           </ul>
//           <div className="flex justify-center md:justify-start space-x-4 mt-6">
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaFacebook size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaTwitter size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaInstagram size={24} />
//             </a>
//             <a href="#" className="text-gray-300 hover:text-pink-400 transition-colors">
//               <FaLinkedin size={24} />
//             </a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// // --- MAIN APP COMPONENT ---
// function App() {
//   const [clicks, setClicks] = useState(0);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [isButtonClicked, setIsButtonClicked] = useState(false);
//   const decayTimeoutRef = useRef(null); // Use a single ref for the timeout
//   const teamCardRefs = useRef({}); // New ref to store individual team card DOM nodes

//   // Refs for scrolling
//   const headerRef = useRef(null); // This points to the very top of the page (HeroSection)
//   const teamCardsRef = useRef(null);
//   const gamesSectionRef = useRef(null); // This ref is for the GamesSection itself
//   const gamesInDevRef = useRef(null);

//   const scrollTo = useCallback((ref) => () => {
//     // If ref is headerRef (which points to the top of the page), scroll to top of window
//     if (ref === headerRef) {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } else {
//       ref.current?.scrollIntoView({ behavior: "smooth" });
//     }
//   }, []);

//   // Scroll to the top of the page on initial render
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   }, []);

//   const shootConfetti = useCallback((x, y) => {
//     const common = {
//       spread: 360,
//       ticks: 100,
//       gravity: 0.5,
//       decay: 0.94,
//       startVelocity: 30,
//       origin: { x: x, y: y }, // Use provided x, y for origin
//     };

//     canvasConfetti({
//       ...common,
//       scalar: 1.2,
//       shapes: ["circle", "square"],
//       colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
//     });

//     canvasConfetti({
//       ...common,
//       scalar: 0.75,
//       shapes: ["star"],
//       colors: ["#FFD700", "#FF69B4", "#8A2BE2"],
//     });
//   }, []);

//   const triggerConfettiAtRef = useCallback((ref) => {
//     if (ref) {
//       const rect = ref.getBoundingClientRect();
//       const x = rect.left + rect.width / 2;
//       const y = rect.top + rect.height / 2;
//       shootConfetti(x / window.innerWidth, y / window.innerHeight);
//     }
//   }, [shootConfetti]);


//   // Effect for managing click decay
//   useEffect(() => {
//     const startDecayTimer = () => {
//       // Clear any existing decay timer to prevent multiple timers running
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }

//       decayTimeoutRef.current = setTimeout(() => {
//         setClicks((prevClicks) => {
//           if (prevClicks > 0) {
//             return Math.max(0, prevClicks - DECAY_AMOUNT);
//           }
//           return 0; // Don't go below zero
//         });
//         // Reschedule the decay if clicks are still above zero AND content is not unlocked
//         if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//             startDecayTimer();
//         }
//       }, DECAY_INTERVAL);
//     };

//     // Only start decay if clicks are not 0 and content isn't unlocked
//     if (clicks > 0 && clicks < REQUIRED_CLICKS) {
//         startDecayTimer();
//     } else {
//         // If clicks are 0 or content is unlocked, ensure no decay timer is running
//         if (decayTimeoutRef.current) {
//             clearTimeout(decayTimeoutRef.current);
//             decayTimeoutRef.current = null;
//         }
//     }

//     // Cleanup on unmount or when dependencies change
//     return () => {
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//       }
//     };
//   }, [clicks, REQUIRED_CLICKS]); // Re-run when clicks or requiredClicks change

//   // Confetti effect (for initial unlock)
//   useEffect(() => {
//     if (showConfetti) {
//       // This burst is for the initial "Pust Vores Egoer Op!" completion
//       shootConfetti(0.5, 0.5); // Center confetti
//       const timer = setTimeout(() => {
//         setShowConfetti(false);
//       }, BURST_DURATION);
//       return () => clearTimeout(timer);
//     }
//   }, [showConfetti, shootConfetti]);

//   // Unlock content effect
//   useEffect(() => {
//     if (clicks >= REQUIRED_CLICKS) {
//       setShowConfetti(true);
//       // Stop decay when content is unlocked
//       if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//       }
//       setTimeout(() => scrollTo(teamCardsRef)(), BURST_DURATION + 500);
//     }
//   }, [clicks, scrollTo, teamCardsRef]);

//   // Function for the "Pust Vores Egoer Op!" button
//   const handleMainButtonClick = () => {
//     setIsButtonClicked(true);
//     setTimeout(() => setIsButtonClicked(false), 200); // Reset button click animation

//     // Clear any pending decay timeout when a click occurs
//     if (decayTimeoutRef.current) {
//         clearTimeout(decayTimeoutRef.current);
//         decayTimeoutRef.current = null;
//     }

//     // Increment clicks only if less than REQUIRED_CLICKS
//     setClicks((prev) => (prev < REQUIRED_CLICKS ? prev + 1 : prev));
//   };

//   // New function specifically for resetting ego from "Punktèr Os!" button
//   const resetEgo = useCallback(() => {
//     setClicks(0);
//     setShowConfetti(false); // Ensure confetti stops
//     // Optionally, restart decay if needed, but typically on reset, it's back to 0
//     // and decay will naturally start if clicks become > 0 again.
//     scrollTo(headerRef)(); // Scroll to top on reset
//   }, [scrollTo, headerRef]);


//   const isContentUnlocked = clicks >= REQUIRED_CLICKS;

//   return (
//     <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900 to-black animate-[gradient_40s_ease-in-out_infinite_alternate]">
//       {/* Background elements, if any */}
//       <div className="absolute inset-0 z-0 opacity-20" />

//       <HeroSection
//         clicks={clicks}
//         requiredClicks={REQUIRED_CLICKS}
//         handleMainButtonClick={handleMainButtonClick}
//         isButtonClicked={isButtonClicked}
//         // gamesSectionRef is no longer passed as a target for the HeroSection's scroll button
//         // The HeroSection itself effectively serves as the "headerRef" for scrolling to the very top.
//       />

//       <AnimatePresence>
//         {isContentUnlocked && ( // Only render these sections if content is unlocked
//           <>
//             <TeamSection
//               teamMembers={teamMembersWithCategories}
//               infoBoxesData={infoBoxesData}
//               teamCardsRef={teamCardsRef}
//               resetEgo={resetEgo} // Pass the new resetEgo function
//               cardRefs={teamCardRefs} // Pass the ref object to TeamSection
//               triggerConfettiAtRef={triggerConfettiAtRef} // Pass the confetti trigger
//             />
//             <GamesSection
//               developedGames={developedGames}
//               gamesInDevelopment={gamesInDevelopment}
//               gamesSectionRef={gamesSectionRef}
//               gamesInDevRef={gamesInDevRef}
//               headerRef={headerRef}
//               scrollTo={scrollTo}
//             />
//           </>
//         )}
//       </AnimatePresence>

//       <Footer />
//     </div>
//   );
// }

// export default App;






/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence, useSpring } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';
import ReactMarkdown from 'react-markdown';

const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

const rawTeamMembers = [
  {
    "id": 1,
    "name": "Alice",
    "photo": "https://i.pravatar.cc/150?img=1",
    "role": "GALL",
    "fullRole": "(Grand Architect of Ludicrous Levels)",
    "contactInfo": {
      "email": "alice.gall@kloegtig.dk",
      "phone": "+1-555-0101",
      "social": "linkedin.com/in/alice_gall"
    },
    "mantra": "Building worlds, one pixel at a time."
  },
  {
    "id": 2,
    "name": "Bob",
    "photo": "https://i.pravatar.cc/150?img=2",
    "role": "CAA",
    "fullRole": "(Chief Algorithm Alchemist)",
    "contactInfo": {
      "email": "bob.caa@kloegtig.dk",
      "phone": "+1-555-0102",
      "social": "twitter.com/bob_caa"
    },
    "mantra": "The code always knows."
  },
  {
    "id": 3,
    "name": "Charlie",
    "photo": "https://i.pravatar.cc/150?img=3",
    "role": "PDPX",
    "fullRole": "(Primary Dream Weaver of Player Experiences)",
    "contactInfo": {
      "email": "charlie.pdpx@kloegtig.dk",
      "phone": "+1-555-0103",
      "social": "instagram.com/charlie_pdpx"
    },
    "mantra": "Crafting unforgettable moments."
  },
  {
    "id": 4,
    "name": "Diana",
    "photo": "https://i.pravatar.cc/150?img=4",
    "role": "CSS",
    "fullRole": "(Community Sparkle Spreader)",
    "contactInfo": {
      "email": "diana.css@kloegtig.dk",
      "phone": "+1-555-0104",
      "social": "facebook.com/diana_css"
    },
    "mantra": "Connecting hearts, one smile at a time."
  },
  {
    "id": 5,
    "name": "Eve",
    "photo": "https://i.pravatar.cc/150?img=5",
    "role": "KUXS",
    "fullRole": "(Kinetic User Experience Sorceress)",
    "contactInfo": {
      "email": "eve.kuxs@kloegtig.dk",
      "phone": "+1-555-0105",
      "social": "behance.net/eve_kuxs"
    },
    "mantra": "Intuitive design is magic."
  },
  {
    "id": 6,
    "name": "Frank",
    "photo": "https://i.pravatar.cc/150?img=6",
    "role": "KSL",
    "fullRole": "(Keeper of Supreme Logic)",
    "contactInfo": {
      "email": "frank.ksl@kloegtig.dk",
      "phone": "+1-555-0106",
      "social": "github.com/frank_ksl"
    },
    "mantra": "Logic is the foundation of greatness."
  },
  {
    "id": 7,
    "name": "Grace",
    "photo": "https://i.pravatar.cc/150?img=7",
    "role": "LSS",
    "fullRole": "(Live Service Storyteller)",
    "contactInfo": {
      "email": "grace.lss@kloegtig.dk",
      "phone": "+1-555-0107",
      "social": "medium.com/@grace_lss"
    },
    "mantra": "Every update tells a new tale."
  },
  {
    "id": 8,
    "name": "Heidi",
    "photo": "https://i.pravatar.cc/150?img=8",
    "role": "UID",
    "fullRole": "(Unreal Interface Dreamer)",
    "contactInfo": {
      "email": "heidi.uid@kloegtig.dk",
      "phone": "+1-555-0108",
      "social": "dribbble.com/heidi_uid"
    },
    "mantra": "Designing the future, one interface at a time."
  },
  {
    "id": 9,
    "name": "Ivan",
    "photo": "https://i.pravatar.cc/150?img=9",
    "role": "BII",
    "fullRole": "(Backend Illusionist & Inventor)",
    "contactInfo": {
      "email": "ivan.bii@kloegtig.dk",
      "phone": "+1-555-0109",
      "social": "stackoverflow.com/users/ivan_bii"
    },
    "mantra": "Behind every great front-end is a magical back-end."
  },
  {
    "id": 10,
    "name": "Judy",
    "photo": "https://i.pravatar.cc/150?img=10",
    "role": "NWBW",
    "fullRole": "(Narrative & World-Building Wizard)",
    "contactInfo": {
      "email": "judy.nwbw@kloegtig.dk",
      "phone": "+1-555-0110",
      "social": "artstation.com/judy_nwbw"
    },
    "mantra": "Worlds within words, stories without end."
  },
  {
    "id": 11,
    "name": "Kevin",
    "photo": "https://i.pravatar.cc/150?img=11",
    "role": "BUD",
    "fullRole": "(Business Unit Dragon)",
    "contactInfo": {
      "email": "kevin.bud@kloegtig.dk",
      "phone": "+1-555-0111",
      "social": "linkedin.com/in/kevin_bud"
    },
    "mantra": "Igniting growth, one strategy at a time."
  },
  {
    "id": 12,
    "name": "Liam",
    "photo": "https://i.pravatar.cc/150?img=12",
    "role": "PME",
    "fullRole": "(Potion Master of Experience)",
    "contactInfo": {
      "email": "liam.pme@kloegtig.dk",
      "phone": "+1-555-0112",
      "social": "pinterest.com/liam_pme"
    },
    "mantra": "Brewing experiences that delight."
  }
];

const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe 🎨 **originale og engagerende spiloplevelser** 🎮 gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#ff69b4', background: '#e91e63' }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på 💪 **stærkt samarbejde og et inkluderende fællesskab** 🤝, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#8a2be2', background: '#673ab7' }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske 🚀 **nye teknologier og banebrydende idéer** 💡.',
    category: 'innovationDevelopment',
    colors: { border: '#ffd700', background: '#ffc107' }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et 🎯 **klart formål og en tydelig retning** 🧭 for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#00bcd4', background: '#0097a7' }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image', // Updated placeholder color
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image', // Updated placeholder color
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image', // Updated placeholder color
    status: 'Concept & Prototyping',
  },
];

const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const TeamCard = ({ member, isHighlighted, dimmed }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 }); // Spring physics for smooth rotation

  // Set rotation based on isFlipped state
  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      className={`relative w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''} cursor-default`}
      style={{ perspective: 1000 }} // For 3D effect on the parent
      onMouseEnter={handleMouseEnter} // Hover to flip
      onMouseLeave={handleMouseLeave} // Hover out to flip back
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >
 
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: 'preserve-3d',
          willChange: 'transform' // Hint to browser for transform changes
        }}
      >
        <div
          className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center" // Semi-transparent black background
          style={{
            transform: 'rotateY(0deg) translateZ(0)', // Force hardware acceleration
            backdropFilter: 'blur(5px)', // Reintroduce backdrop blur
            WebkitBackdropFilter: 'blur(5px)' // For Safari support
          }}
        >
          <img src={member.photo} alt={member.name} className="w-24 h-24 rounded-full mx-auto mb-3 object-cover" />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>

        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center" // Slightly lighter semi-transparent black background
          style={{
            transform: 'rotateY(180deg) translateZ(0)', // Force hardware acceleration
            backdropFilter: 'blur(5px)', // Reintroduce backdrop blur
            WebkitBackdropFilter: 'blur(5px)' // For Safari support
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">{member.name}'s Info</h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">{member.contactInfo.email}</a>
          </p>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaPhone className="mr-2 text-green-300" />
            <span>{member.contactInfo.phone}</span>
          </p>
          <p className="text-sm text-gray-200 mb-3 flex items-center">
            <FaLinkedin className="mr-2 text-purple-300" />
            <a href={`https://${member.contactInfo.social}`} target="_blank" rel="noopener noreferrer" className="hover:underline">{member.contactInfo.social.split('/').pop()}</a>
          </p>
          <p className="italic text-gray-400 text-center text-sm">"{member.mantra}"</p>
        </div>
      </motion.div>
    </motion.div>
  );
};

const Footer = () => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder forbeholdt.</p>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li><a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">Om Os</a></li>
            <li><a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">Vores Spil</a></li>
            <li><a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">Mød Teamet</a></li>
            <li><a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">Kontakt</a></li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center md:justify-start justify-center">
              <FaEnvelope className="mr-2" />
              <a href="mailto:info@kloegtig.com" className="hover:text-purple-400 transition-colors">info@kloegtig.com</a>
            </li>
            <li className="flex items-center md:justify-start justify-center">

              <span className="mr-2">📞</span>
              <span>+45 1234 5678</span>
            </li>
            <li className="text-sm">
              Kløgtig Games ApS<br />
              Spillegade 1, 1234 Spilby<br />
              Danmark
            </li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Følg Os</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-blue-600 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="https://twitter.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-blue-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-pink-500 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com/company/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-blue-700 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 250, // More confetti!
        spread: 360,
        startVelocity: 70,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#FF69B4', '#8A2BE2', '#FFD700', '#00BCD4', '#FF4500'], // Playful colors
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setCurrentNavInfo(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-500 via-pink-500 to-yellow-300 animate-[gradient_40s_ease-in-out_infinite_alternate] z-0">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-md sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
              <p className="text-sm text-gray-200">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header
            ref={headerRef}
            className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>


            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section
            ref={teamCardsRef}
            className="relative z-10 w-full py-20 px-4 flex flex-col items-center" // No background or blur on this section
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 15px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <div className="text-base text-lg text-white-900">
                    <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <TeamCard key={m.id} member={m} isHighlighted={isHighlighted} dimmed={dimmed} />
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#db2777,#ec4899,#f0abfc)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section
        ref={gamesSectionRef}
        id="games"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <Footer />

      <style jsx>{`
        body {
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }

        @keyframes gradient {
          0% { background-position: 0% 0%; }
          25% { background-position: 100% 0%; }
          50% { background-position: 100% 100%; }
          75% { background-position: 0% 100%; }
          100% { background-position: 0% 0%; }
        }
        .animate-\\[gradient_40s_ease-in-out_infinite_alternate\\] {
          animation: gradient 40s ease-in-out infinite alternate;
          background-size: 400% 400%;
        }

        .preserve-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence, useSpring } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';
import ReactMarkdown from 'react-markdown';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  {
    id: 1,
    name: 'Alice',
    photo: 'https://i.pravatar.cc/150?img=1',
    role: 'GALL', // Grand Architect of Ludicrous Levels
    fullRole: '(Grand Architect of Ludicrous Levels)',
    contactInfo: {
      email: 'alice@example.com',
      phone: '+1-555-0101',
      social: 'linkedin.com/in/alice_gall'
    },
    mantra: 'Building worlds, one pixel at a time.'
  },
  {
    id: 2,
    name: 'Bob',
    photo: 'https://i.pravatar.cc/150?img=2',
    role: 'CAA', // Chief Algorithm Alchemist
    fullRole: '(Chief Algorithm Alchemist)',
    contactInfo: {
      email: 'bob@example.com',
      phone: '+1-555-0102',
      social: 'twitter.com/bob_caa'
    },
    mantra: 'The code always knows.'
  },
  {
    id: 3,
    name: 'Charlie',
    photo: 'https://i.pravatar.cc/150?img=3',
    role: 'PDPX', // Primary Dream Weaver of Player Experiences
    fullRole: '(Primary Dream Weaver of Player Experiences)',
    contactInfo: {
      email: 'charlie@example.com',
      phone: '+1-555-0103',
      social: 'instagram.com/charlie_pdpx'
    },
    mantra: 'Crafting unforgettable moments.'
  },
  {
    id: 4,
    name: 'Diana',
    photo: 'https://i.pravatar.cc/150?img=4',
    role: 'CSS', // Community Sparkle Spreader
    fullRole: '(Community Sparkle Spreader)',
    contactInfo: {
      email: 'diana@example.com',
      phone: '+1-555-0104',
      social: 'facebook.com/diana_css'
    },
    mantra: 'Connecting hearts, one smile at a time.'
  },
  {
    id: 5,
    name: 'Eve',
    photo: 'https://i.pravatar.cc/150?img=5',
    role: 'KUXS', // Kinetic User Experience Sorceress
    fullRole: '(Kinetic User Experience Sorceress)',
    contactInfo: {
      email: 'eve@example.com',
      phone: '+1-555-0105',
      social: 'behance.net/eve_kuxs'
    },
    mantra: 'Intuitive design is magic.'
  },
  {
    id: 6,
    name: 'Frank',
    photo: 'https://i.pravatar.cc/150?img=6',
    role: 'KSL', // Keeper of Supreme Logic
    fullRole: '(Keeper of Supreme Logic)',
    contactInfo: {
      email: 'frank@example.com',
      phone: '+1-555-0106',
      social: 'github.com/frank_ksl'
    },
    mantra: 'Logic is the foundation of greatness.'
  },
  {
    id: 7,
    name: 'Grace',
    photo: 'https://i.pravatar.cc/150?img=7',
    role: 'LSS', // Live Service Storyteller
    fullRole: '(Live Service Storyteller)',
    contactInfo: {
      email: 'grace@example.com',
      phone: '+1-555-0107',
      social: 'medium.com/@grace_lss'
    },
    mantra: 'Every update tells a new tale.'
  },
  {
    id: 8,
    name: 'Heidi',
    photo: 'https://i.pravatar.cc/150?img=8',
    role: 'UID', // Unreal Interface Dreamer
    fullRole: '(Unreal Interface Dreamer)',
    contactInfo: {
      email: 'heidi@example.com',
      phone: '+1-555-0108',
      social: 'dribbble.com/heidi_uid'
    },
    mantra: 'Designing the future, one interface at a time.'
  },
  {
    id: 9,
    name: 'Ivan',
    photo: 'https://i.pravatar.cc/150?img=9',
    role: 'BII', // Backend Illusionist & Inventor
    fullRole: '(Backend Illusionist & Inventor)',
    contactInfo: {
      email: 'ivan@example.com',
      phone: '+1-555-0109',
      social: 'stackoverflow.com/users/ivan_bii'
    },
    mantra: 'Behind every great front-end is a magical back-end.'
  },
  {
    id: 10,
    name: 'Judy',
    photo: 'https://i.pravatar.cc/150?img=10',
    role: 'NWBW', // Narrative & World-Building Wizard
    fullRole: '(Narrative & World-Building Wizard)',
    contactInfo: {
      email: 'judy@example.com',
      phone: '+1-555-0110',
      social: 'artstation.com/judy_nwbw'
    },
    mantra: 'Worlds within words, stories without end.'
  },
  {
    id: 11,
    name: 'Kevin',
    photo: 'https://i.pravatar.cc/150?img=11',
    role: 'BUD', // Business Unit Dragon
    fullRole: '(Business Unit Dragon)',
    contactInfo: {
      email: 'kevin@example.com',
      phone: '+1-555-0111',
      social: 'linkedin.com/in/kevin_bud'
    },
    mantra: 'Igniting growth, one strategy at a time.'
  },
  {
    id: 12,
    name: 'Liam',
    photo: 'https://i.pravatar.cc/150?img=12',
    role: 'PME', // Potion Master of Experience
    fullRole: '(Potion Master of Experience)',
    contactInfo: {
      email: 'liam@example.com',
      phone: '+1-555-0112',
      social: 'pinterest.com/liam_pme'
    },
    mantra: 'Brewing experiences that delight.'
  },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe 🎨 **originale og engagerende spiloplevelser** 🎮 gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#ff69b4', background: '#e91e63' }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på 💪 **stærkt samarbejde og et inkluderende fællesskab** 🤝, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#8a2be2', background: '#673ab7' }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske 🚀 **nye teknologier og banebrydende idéer** 💡.',
    category: 'innovationDevelopment',
    colors: { border: '#ffd700', background: '#ffc107' }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et 🎯 **klart formål og en tydelig retning** 🧭 for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#00bcd4', background: '#0097a7' }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image', // Updated placeholder color
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image', // Updated placeholder color
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image', // Updated placeholder color
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

// --- New TeamCard Component ---
const TeamCard = ({ member, isHighlighted, dimmed }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const rotation = useSpring(0, { stiffness: 300, damping: 25 }); // Spring physics for smooth rotation

  // Set rotation based on isFlipped state
  useEffect(() => {
    rotation.set(isFlipped ? 180 : 0);
  }, [isFlipped, rotation]);

  const handleMouseEnter = () => setIsFlipped(true);
  const handleMouseLeave = () => setIsFlipped(false);

  return (
    <motion.div
      className={`relative w-full h-64 rounded-xl text-center preserve-3d transition-opacity duration-300 ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''} cursor-default`}
      style={{ perspective: 1000 }} // For 3D effect on the parent
      onMouseEnter={handleMouseEnter} // Hover to flip
      onMouseLeave={handleMouseLeave} // Hover out to flip back
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.05 }}
    >

      <motion.div
        className="relative w-full h-full"
        style={{
          rotateY: rotation,
          transformStyle: 'preserve-3d',
          willChange: 'transform' // Hint to browser for transform changes
        }}
      >
     
        <div
          className="absolute inset-0 bg-black/50 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center" // Semi-transparent black background
          style={{
            transform: 'rotateY(0deg) translateZ(0)', // Force hardware acceleration
            backdropFilter: 'blur(5px)', // Reintroduce backdrop blur
            WebkitBackdropFilter: 'blur(5px)' // For Safari support
          }}
        >
          <img src={member.photo} alt={member.name} className="w-24 h-24 rounded-full mx-auto mb-3 object-cover" />
          <h4 className="font-bold text-pink-300 text-lg">{member.name}</h4>
          <p className="italic text-gray-300 text-base">{member.role}</p>
          <p className="text-xs text-gray-400 mt-1">{member.fullRole}</p>
        </div>


        <div
          className="absolute inset-0 bg-black/40 rounded-xl p-4 backface-hidden flex flex-col items-center justify-center" // Slightly lighter semi-transparent black background
          style={{
            transform: 'rotateY(180deg) translateZ(0)', // Force hardware acceleration
            backdropFilter: 'blur(5px)', // Reintroduce backdrop blur
            WebkitBackdropFilter: 'blur(5px)' // For Safari support
          }}
        >
          <h4 className="font-bold text-yellow-300 text-lg mb-2">{member.name}'s Info</h4>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaEnvelope className="mr-2 text-blue-300" />
            <a href={`mailto:${member.contactInfo.email}`} className="hover:underline">{member.contactInfo.email}</a>
          </p>
          <p className="text-sm text-gray-200 mb-1 flex items-center">
            <FaPhone className="mr-2 text-green-300" />
            <span>{member.contactInfo.phone}</span>
          </p>
          <p className="text-sm text-gray-200 mb-3 flex items-center">
            <FaLinkedin className="mr-2 text-purple-300" />
            <a href={`https://${member.contactInfo.social}`} target="_blank" rel="noopener noreferrer" className="hover:underline">{member.contactInfo.social.split('/').pop()}</a>
          </p>
          <p className="italic text-gray-400 text-center text-sm">"{member.mantra}"</p>
        </div>
      </motion.div>
    </motion.div>
  );
};

const Footer = () => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

     
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder forbeholdt.</p>
        </div>


        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li><a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">Om Os</a></li>
            <li><a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">Vores Spil</a></li>
            <li><a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">Mød Teamet</a></li>
            <li><a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">Kontakt</a></li>
          </ul>
        </div>

     
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center md:justify-start justify-center">
              <FaEnvelope className="mr-2" />
              <a href="mailto:info@kloegtig.com" className="hover:text-purple-400 transition-colors">info@kloegtig.com</a>
            </li>
            <li className="flex items-center md:justify-start justify-center">

              <span className="mr-2">📞</span>
              <span>+45 1234 5678</span>
            </li>
            <li className="text-sm">
              Kløgtig Games ApS<br />
              Spillegade 1, 1234 Spilby<br />
              Danmark
            </li>
          </ul>
        </div>


      
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Følg Os</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-blue-600 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="https://twitter.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-blue-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-pink-500 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com/company/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-blue-700 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 250, // More confetti!
        spread: 360,
        startVelocity: 70,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#FF69B4', '#8A2BE2', '#FFD700', '#00BCD4', '#FF4500'], // Playful colors
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    // Apply the gradient to the outermost div and ensure it covers the entire page
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-500 via-pink-500 to-yellow-300 animate-[gradient_40s_ease-in-out_infinite_alternate] z-0">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-md sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
              <p className="text-sm text-gray-200">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header
            ref={headerRef}
            className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>


            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section
            ref={teamCardsRef}
            className="relative z-10 w-full py-20 px-4 flex flex-col items-center" // No background or blur on this section
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 15px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <div className="text-base text-lg text-white-900">
                    <ReactMarkdown>{currentNavInfo.info}</ReactMarkdown>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <TeamCard key={m.id} member={m} isHighlighted={isHighlighted} dimmed={dimmed} />
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#db2777,#ec4899,#f0abfc)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section
        ref={gamesSectionRef}
        id="games"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section
        ref={gamesInDevRef}
        id="games-in-development"
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center"
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <Footer />

      <style jsx>{`
        
        body {
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }

        
        @keyframes gradient {
          0% { background-position: 0% 0%; }
          25% { background-position: 100% 0%; }
          50% { background-position: 100% 100%; }
          75% { background-position: 0% 100%; }
          100% { background-position: 0% 0%; }
        }
        .animate-\\[gradient_40s_ease-in-out_infinite_alternate\\] {
          animation: gradient 40s ease-in-out infinite alternate;
          background-size: 400% 400%;
        }

    
        .preserve-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden; 
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  {
    id: 1,
    name: 'Alice',
    photo: 'https://i.pravatar.cc/150?img=1',
    role: 'GALL', // Grand Architect of Ludicrous Levels
    fullRole: '(Grand Architect of Ludicrous Levels)',
    contactInfo: {
      email: 'alice@example.com',
      phone: '+1-555-0101',
      social: 'linkedin.com/in/alice_gall'
    },
    mantra: 'Building worlds, one pixel at a time.'
  },
  {
    id: 2,
    name: 'Bob',
    photo: 'https://i.pravatar.cc/150?img=2',
    role: 'CAA', // Chief Algorithm Alchemist
    fullRole: '(Chief Algorithm Alchemist)',
    contactInfo: {
      email: 'bob@example.com',
      phone: '+1-555-0102',
      social: 'twitter.com/bob_caa'
    },
    mantra: 'The code always knows.'
  },
  {
    id: 3,
    name: 'Charlie',
    photo: 'https://i.pravatar.cc/150?img=3',
    role: 'PDPX', // Primary Dream Weaver of Player Experiences
    fullRole: '(Primary Dream Weaver of Player Experiences)',
    contactInfo: {
      email: 'charlie@example.com',
      phone: '+1-555-0103',
      social: 'instagram.com/charlie_pdpx'
    },
    mantra: 'Crafting unforgettable moments.'
  },
  {
    id: 4,
    name: 'Diana',
    photo: 'https://i.pravatar.cc/150?img=4',
    role: 'CSS', // Community Sparkle Spreader
    fullRole: '(Community Sparkle Spreader)',
    contactInfo: {
      email: 'diana@example.com',
      phone: '+1-555-0104',
      social: 'facebook.com/diana_css'
    },
    mantra: 'Connecting hearts, one smile at a time.'
  },
  {
    id: 5,
    name: 'Eve',
    photo: 'https://i.pravatar.cc/150?img=5',
    role: 'KUXS', // Kinetic User Experience Sorceress
    fullRole: '(Kinetic User Experience Sorceress)',
    contactInfo: {
      email: 'eve@example.com',
      phone: '+1-555-0105',
      social: 'behance.net/eve_kuxs'
    },
    mantra: 'Intuitive design is magic.'
  },
  {
    id: 6,
    name: 'Frank',
    photo: 'https://i.pravatar.cc/150?img=6',
    role: 'KSL', // Keeper of Supreme Logic
    fullRole: '(Keeper of Supreme Logic)',
    contactInfo: {
      email: 'frank@example.com',
      phone: '+1-555-0106',
      social: 'github.com/frank_ksl'
    },
    mantra: 'Logic is the foundation of greatness.'
  },
  {
    id: 7,
    name: 'Grace',
    photo: 'https://i.pravatar.cc/150?img=7',
    role: 'LSS', // Live Service Storyteller
    fullRole: '(Live Service Storyteller)',
    contactInfo: {
      email: 'grace@example.com',
      phone: '+1-555-0107',
      social: 'medium.com/@grace_lss'
    },
    mantra: 'Every update tells a new tale.'
  },
  {
    id: 8,
    name: 'Heidi',
    photo: 'https://i.pravatar.cc/150?img=8',
    role: 'UID', // Unreal Interface Dreamer
    fullRole: '(Unreal Interface Dreamer)',
    contactInfo: {
      email: 'heidi@example.com',
      phone: '+1-555-0108',
      social: 'dribbble.com/heidi_uid'
    },
    mantra: 'Designing the future, one interface at a time.'
  },
  {
    id: 9,
    name: 'Ivan',
    photo: 'https://i.pravatar.cc/150?img=9',
    role: 'BII', // Backend Illusionist & Inventor
    fullRole: '(Backend Illusionist & Inventor)',
    contactInfo: {
      email: 'ivan@example.com',
      phone: '+1-555-0109',
      social: 'stackoverflow.com/users/ivan_bii'
    },
    mantra: 'Behind every great front-end is a magical back-end.'
  },
  {
    id: 10,
    name: 'Judy',
    photo: 'https://i.pravatar.cc/150?img=10',
    role: 'NWBW', // Narrative & World-Building Wizard
    fullRole: '(Narrative & World-Building Wizard)',
    contactInfo: {
      email: 'judy@example.com',
      phone: '+1-555-0110',
      social: 'artstation.com/judy_nwbw'
    },
    mantra: 'Worlds within words, stories without end.'
  },
  {
    id: 11,
    name: 'Kevin',
    photo: 'https://i.pravatar.cc/150?img=11',
    role: 'BUD', // Business Unit Dragon
    fullRole: '(Business Unit Dragon)',
    contactInfo: {
      email: 'kevin@example.com',
      phone: '+1-555-0111',
      social: 'linkedin.com/in/kevin_bud'
    },
    mantra: 'Igniting growth, one strategy at a time.'
  },
  {
    id: 12,
    name: 'Liam',
    photo: 'https://i.pravatar.cc/150?img=12',
    role: 'PME', // Potion Master of Experience
    fullRole: '(Potion Master of Experience)',
    contactInfo: {
      email: 'liam@example.com',
      phone: '+1-555-0112',
      social: 'pinterest.com/liam_pme'
    },
    mantra: 'Brewing experiences that delight.'
  },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#ff69b4', background: '#e91e63' }, // Playful Pink
    scoreMapping: { GALL: 1, PDPX: 0.7, KUXS: 0.8, UID: 0.9, NWBW: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#8a2be2', background: '#673ab7' }, // Amethyst Purple
    scoreMapping: { PDPX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, PME: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#ffd700', background: '#ffc107' }, // Sunny Yellow
    scoreMapping: { CAA: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#00bcd4', background: '#0097a7' }, // Turquoise
    scoreMapping: { BUD: 1, CAA: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/6a0e71/ffffff?text=Game+1+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/3e6b8a/ffffff?text=Game+2+Image', // Updated placeholder color
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/9a244e/ffffff?text=Game+3+Image', // Updated placeholder color
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/7f3e91/ffffff?text=Dev+Game+1+Image', // Updated placeholder color
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/5e8bba/ffffff?text=Dev+Game+2+Image', // Updated placeholder color
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category; // Default to the first category
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0; // Use member.role directly
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const Footer = () => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-md text-gray-300 py-10 px-4 mt-auto relative z-20"> 
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

        
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere både lokalt og globalt.
          </p>
          <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder forbeholdt.</p>
        </div>


        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li><a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">Om Os</a></li>
            <li><a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">Vores Spil</a></li>
            <li><a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">Mød Teamet</a></li>
            <li><a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">Kontakt</a></li>
          </ul>
        </div>

        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center md:justify-start justify-center">
              <FaEnvelope className="mr-2" />
              <a href="mailto:info@kloegtig.com" className="hover:text-purple-400 transition-colors">info@kloegtig.com</a>
            </li>
            <li className="flex items-center md:justify-start justify-center">

              <span className="mr-2">📞</span>
              <span>+45 1234 5678</span>
            </li>
            <li className="text-sm">
              Kløgtig Games ApS<br />
              Spillegade 1, 1234 Spilby<br />
              Danmark
            </li>
          </ul>
        </div>


        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Følg Os</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-blue-600 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="https://twitter.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-blue-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-pink-500 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com/company/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-blue-700 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 250, // More confetti!
        spread: 360,
        startVelocity: 70,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#FF69B4', '#8A2BE2', '#FFD700', '#00BCD4', '#FF4500'], // Playful colors
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    // Apply the gradient to the outermost div and ensure it covers the entire page
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-500 via-pink-500 to-yellow-300 animate-[gradient_20s_ease-in-out_infinite_alternate] z-0"> 

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-md sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
              <p className="text-sm text-gray-200">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header
            ref={headerRef}
            className="relative z-10 flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-200 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF69B4,#FFD700,#00BCD4)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>


            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section
            ref={teamCardsRef}
            className="relative z-10 w-full py-20 px-4 flex flex-col items-center bg-black/10 backdrop-blur-md" // Changed background and blur
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 15px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#db2777,#ec4899,#f0abfc)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section
        ref={gamesSectionRef}
        id="games" // Added ID for navigation
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center" // Adjusted background and blur
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-pink-600 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section
        ref={gamesInDevRef}
        id="games-in-development" // Added ID for navigation
        className="relative z-10 w-full py-20 px-4 bg-black/10 backdrop-blur-md text-white flex flex-col items-center" // Adjusted background and blur
      >
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-md rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-500 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <Footer />

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
          100% { background-position: 0% 0%; } 
        }
        .animate-\\[gradient_20s_ease-in-out_infinite_alternate\\] {
          animation: gradient 20s ease-in-out infinite alternate; 
          background-size: 400% 400%;
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  {
    id: 1,
    name: 'Alice',
    photo: 'https://i.pravatar.cc/150?img=1',
    role: 'GALL', // Grand Architect of Ludicrous Levels
    fullRole: '(Grand Architect of Ludicrous Levels)',
    contactInfo: {
      email: 'alice@example.com',
      phone: '+1-555-0101',
      social: 'linkedin.com/in/alice_gall'
    },
    mantra: 'Building worlds, one pixel at a time.'
  },
  {
    id: 2,
    name: 'Bob',
    photo: 'https://i.pravatar.cc/150?img=2',
    role: 'CAA', // Chief Algorithm Alchemist
    fullRole: '(Chief Algorithm Alchemist)',
    contactInfo: {
      email: 'bob@example.com',
      phone: '+1-555-0102',
      social: 'twitter.com/bob_caa'
    },
    mantra: 'The code always knows.'
  },
  {
    id: 3,
    name: 'Charlie',
    photo: 'https://i.pravatar.cc/150?img=3',
    role: 'PDPX', // Primary Dream Weaver of Player Experiences
    fullRole: '(Primary Dream Weaver of Player Experiences)',
    contactInfo: {
      email: 'charlie@example.com',
      phone: '+1-555-0103',
      social: 'instagram.com/charlie_pdpx'
    },
    mantra: 'Crafting unforgettable moments.'
  },
  {
    id: 4,
    name: 'Diana',
    photo: 'https://i.pravatar.cc/150?img=4',
    role: 'CSS', // Community Sparkle Spreader
    fullRole: '(Community Sparkle Spreader)',
    contactInfo: {
      email: 'diana@example.com',
      phone: '+1-555-0104',
      social: 'facebook.com/diana_css'
    },
    mantra: 'Connecting hearts, one smile at a time.'
  },
  {
    id: 5,
    name: 'Eve',
    photo: 'https://i.pravatar.cc/150?img=5',
    role: 'KUXS', // Kinetic User Experience Sorceress
    fullRole: '(Kinetic User Experience Sorceress)',
    contactInfo: {
      email: 'eve@example.com',
      phone: '+1-555-0105',
      social: 'behance.net/eve_kuxs'
    },
    mantra: 'Intuitive design is magic.'
  },
  {
    id: 6,
    name: 'Frank',
    photo: 'https://i.pravatar.cc/150?img=6',
    role: 'KSL', // Keeper of Supreme Logic
    fullRole: '(Keeper of Supreme Logic)',
    contactInfo: {
      email: 'frank@example.com',
      phone: '+1-555-0106',
      social: 'github.com/frank_ksl'
    },
    mantra: 'Logic is the foundation of greatness.'
  },
  {
    id: 7,
    name: 'Grace',
    photo: 'https://i.pravatar.cc/150?img=7',
    role: 'LSS', // Live Service Storyteller
    fullRole: '(Live Service Storyteller)',
    contactInfo: {
      email: 'grace@example.com',
      phone: '+1-555-0107',
      social: 'medium.com/@grace_lss'
    },
    mantra: 'Every update tells a new tale.'
  },
  {
    id: 8,
    name: 'Heidi',
    photo: 'https://i.pravatar.cc/150?img=8',
    role: 'UID', // Unreal Interface Dreamer
    fullRole: '(Unreal Interface Dreamer)',
    contactInfo: {
      email: 'heidi@example.com',
      phone: '+1-555-0108',
      social: 'dribbble.com/heidi_uid'
    },
    mantra: 'Designing the future, one interface at a time.'
  },
  {
    id: 9,
    name: 'Ivan',
    photo: 'https://i.pravatar.cc/150?img=9',
    role: 'BII', // Backend Illusionist & Inventor
    fullRole: '(Backend Illusionist & Inventor)',
    contactInfo: {
      email: 'ivan@example.com',
      phone: '+1-555-0109',
      social: 'stackoverflow.com/users/ivan_bii'
    },
    mantra: 'Behind every great front-end is a magical back-end.'
  },
  {
    id: 10,
    name: 'Judy',
    photo: 'https://i.pravatar.cc/150?img=10',
    role: 'NWBW', // Narrative & World-Building Wizard
    fullRole: '(Narrative & World-Building Wizard)',
    contactInfo: {
      email: 'judy@example.com',
      phone: '+1-555-0110',
      social: 'artstation.com/judy_nwbw'
    },
    mantra: 'Worlds within words, stories without end.'
  },
  {
    id: 11,
    name: 'Kevin',
    photo: 'https://i.pravatar.cc/150?img=11',
    role: 'BUD', // Business Unit Dragon
    fullRole: '(Business Unit Dragon)',
    contactInfo: {
      email: 'kevin@example.com',
      phone: '+1-555-0111',
      social: 'linkedin.com/in/kevin_bud'
    },
    mantra: 'Igniting growth, one strategy at a time.'
  },
  {
    id: 12,
    name: 'Liam',
    photo: 'https://i.pravatar.cc/150?img=12',
    role: 'PME', // Potion Master of Experience
    fullRole: '(Potion Master of Experience)',
    contactInfo: {
      email: 'liam@example.com',
      phone: '+1-555-0112',
      social: 'pinterest.com/liam_pme'
    },
    mantra: 'Brewing experiences that delight.'
  },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const Footer = () => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-sm text-gray-300 py-10 px-4 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

     
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere lokalt og globalt.
          </p>
          <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder forbeholdt.</p>
        </div>


        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li><a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">Om Os</a></li>
            <li><a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">Vores Spil</a></li>
            <li><a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">Mød Teamet</a></li>
            <li><a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">Kontakt</a></li>
          </ul>
        </div>

        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center md:justify-start justify-center">
              <FaEnvelope className="mr-2" />
              <a href="mailto:info@kloegtig.com" className="hover:text-purple-400 transition-colors">info@kloegtig.com</a>
            </li>
            <li className="flex items-center md:justify-start justify-center">
              
              <span className="mr-2">📞</span>
              <span>+45 1234 5678</span>
            </li>
            <li className="text-sm">
              Kløgtig Games ApS<br />
              Spillegade 1, 1234 Spilby<br />
              Danmark
            </li>
          </ul>
        </div>

        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Følg Os</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-blue-600 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="https://twitter.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-blue-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-pink-500 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com/company/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-blue-700 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-pink-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">

            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
              <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
            </motion.div>

          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header ref={headerRef} className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>

            
            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-pink-900 to-indigo-900" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.8 }}>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-pink-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-pink-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <Footer /> 

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  {
    id: 1,
    name: 'Alice',
    photo: 'https://i.pravatar.cc/150?img=1',
    role: 'GALL', // Grand Architect of Ludicrous Levels
    fullRole: '(Grand Architect of Ludicrous Levels)',
    contactInfo: {
      email: 'alice@example.com',
      phone: '+1-555-0101',
      social: 'linkedin.com/in/alice_gall'
    },
    mantra: 'Building worlds, one pixel at a time.'
  },
  {
    id: 2,
    name: 'Bob',
    photo: 'https://i.pravatar.cc/150?img=2',
    role: 'CAA', // Chief Algorithm Alchemist
    fullRole: '(Chief Algorithm Alchemist)',
    contactInfo: {
      email: 'bob@example.com',
      phone: '+1-555-0102',
      social: 'twitter.com/bob_caa'
    },
    mantra: 'The code always knows.'
  },
  {
    id: 3,
    name: 'Charlie',
    photo: 'https://i.pravatar.cc/150?img=3',
    role: 'PDPX', // Primary Dream Weaver of Player Experiences
    fullRole: '(Primary Dream Weaver of Player Experiences)',
    contactInfo: {
      email: 'charlie@example.com',
      phone: '+1-555-0103',
      social: 'instagram.com/charlie_pdpx'
    },
    mantra: 'Crafting unforgettable moments.'
  },
  {
    id: 4,
    name: 'Diana',
    photo: 'https://i.pravatar.cc/150?img=4',
    role: 'CSS', // Community Sparkle Spreader
    fullRole: '(Community Sparkle Spreader)',
    contactInfo: {
      email: 'diana@example.com',
      phone: '+1-555-0104',
      social: 'facebook.com/diana_css'
    },
    mantra: 'Connecting hearts, one smile at a time.'
  },
  {
    id: 5,
    name: 'Eve',
    photo: 'https://i.pravatar.cc/150?img=5',
    role: 'KUXS', // Kinetic User Experience Sorceress
    fullRole: '(Kinetic User Experience Sorceress)',
    contactInfo: {
      email: 'eve@example.com',
      phone: '+1-555-0105',
      social: 'behance.net/eve_kuxs'
    },
    mantra: 'Intuitive design is magic.'
  },
  {
    id: 6,
    name: 'Frank',
    photo: 'https://i.pravatar.cc/150?img=6',
    role: 'KSL', // Keeper of Supreme Logic
    fullRole: '(Keeper of Supreme Logic)',
    contactInfo: {
      email: 'frank@example.com',
      phone: '+1-555-0106',
      social: 'github.com/frank_ksl'
    },
    mantra: 'Logic is the foundation of greatness.'
  },
  {
    id: 7,
    name: 'Grace',
    photo: 'https://i.pravatar.cc/150?img=7',
    role: 'LSS', // Live Service Storyteller
    fullRole: '(Live Service Storyteller)',
    contactInfo: {
      email: 'grace@example.com',
      phone: '+1-555-0107',
      social: 'medium.com/@grace_lss'
    },
    mantra: 'Every update tells a new tale.'
  },
  {
    id: 8,
    name: 'Heidi',
    photo: 'https://i.pravatar.cc/150?img=8',
    role: 'UID', // Unreal Interface Dreamer
    fullRole: '(Unreal Interface Dreamer)',
    contactInfo: {
      email: 'heidi@example.com',
      phone: '+1-555-0108',
      social: 'dribbble.com/heidi_uid'
    },
    mantra: 'Designing the future, one interface at a time.'
  },
  {
    id: 9,
    name: 'Ivan',
    photo: 'https://i.pravatar.cc/150?img=9',
    role: 'BII', // Backend Illusionist & Inventor
    fullRole: '(Backend Illusionist & Inventor)',
    contactInfo: {
      email: 'ivan@example.com',
      phone: '+1-555-0109',
      social: 'stackoverflow.com/users/ivan_bii'
    },
    mantra: 'Behind every great front-end is a magical back-end.'
  },
  {
    id: 10,
    name: 'Judy',
    photo: 'https://i.pravatar.cc/150?img=10',
    role: 'NWBW', // Narrative & World-Building Wizard
    fullRole: '(Narrative & World-Building Wizard)',
    contactInfo: {
      email: 'judy@example.com',
      phone: '+1-555-0110',
      social: 'artstation.com/judy_nwbw'
    },
    mantra: 'Worlds within words, stories without end.'
  },
  {
    id: 11,
    name: 'Kevin',
    photo: 'https://i.pravatar.cc/150?img=11',
    role: 'BUD', // Business Unit Dragon
    fullRole: '(Business Unit Dragon)',
    contactInfo: {
      email: 'kevin@example.com',
      phone: '+1-555-0111',
      social: 'linkedin.com/in/kevin_bud'
    },
    mantra: 'Igniting growth, one strategy at a time.'
  },
  {
    id: 12,
    name: 'Liam',
    photo: 'https://i.pravatar.cc/150?img=12',
    role: 'PME', // Potion Master of Experience
    fullRole: '(Potion Master of Experience)',
    contactInfo: {
      email: 'liam@example.com',
      phone: '+1-555-0112',
      social: 'pinterest.com/liam_pme'
    },
    mantra: 'Brewing experiences that delight.'
  },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

const Footer = () => {
  return (
    <footer className="w-full bg-black/40 backdrop-blur-sm text-gray-300 py-10 px-4 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

     
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="flex items-center space-x-2 mb-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 object-contain" />
            <div>
              <span className="text-2xl font-bold text-white">kløgtig</span>
              <p className="italic text-pink-300 text-sm">- seriøs sjov!</p>
            </div>
          </div>
          <p className="text-sm max-w-xs">
            Skaber uforglemmelige sociale spiloplevelser, der forbinder spillere lokalt og globalt.
          </p>
          <p className="text-sm mt-2">&copy; {new Date().getFullYear()} Kløgtig. Alle rettigheder forbeholdt.</p>
        </div>


        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Hurtige Links</h3>
          <ul className="space-y-2">
            <li><a href="#about" className="text-gray-300 hover:text-purple-400 transition-colors">Om Os</a></li>
            <li><a href="#games" className="text-gray-300 hover:text-purple-400 transition-colors">Vores Spil</a></li>
            <li><a href="#team" className="text-gray-300 hover:text-purple-400 transition-colors">Mød Teamet</a></li>
            <li><a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors">Kontakt</a></li>
          </ul>
        </div>

        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Kontakt Os</h3>
          <ul className="space-y-2">
            <li className="flex items-center md:justify-start justify-center">
              <FaEnvelope className="mr-2" />
              <a href="mailto:info@kloegtig.com" className="hover:text-purple-400 transition-colors">info@kloegtig.com</a>
            </li>
            <li className="flex items-center md:justify-start justify-center">
              
              <span className="mr-2">📞</span>
              <span>+45 1234 5678</span>
            </li>
            <li className="text-sm">
              Kløgtig Games ApS<br />
              Spillegade 1, 1234 Spilby<br />
              Danmark
            </li>
          </ul>
        </div>

        
        <div className="text-center md:text-left">
          <h3 className="text-lg font-bold text-white mb-4">Følg Os</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="https://facebook.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-blue-600 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="https://twitter.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-blue-400 transition-colors">
              <FaTwitter size={24} />
            </a>
            <a href="https://instagram.com/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-pink-500 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://linkedin.com/company/kloegtig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-blue-700 transition-colors">
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">

            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
              <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
            </motion.div>

          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header ref={headerRef} className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>

            
            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.8 }}>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <Footer /> 

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  {
    id: 1,
    name: 'Alice',
    photo: 'https://i.pravatar.cc/150?img=1',
    role: 'GALL', // Grand Architect of Ludicrous Levels
    fullRole: '(Grand Architect of Ludicrous Levels)',
    contactInfo: {
      email: 'alice@example.com',
      phone: '+1-555-0101',
      social: 'linkedin.com/in/alice_gall'
    },
    mantra: 'Building worlds, one pixel at a time.'
  },
  {
    id: 2,
    name: 'Bob',
    photo: 'https://i.pravatar.cc/150?img=2',
    role: 'CAA', // Chief Algorithm Alchemist
    fullRole: '(Chief Algorithm Alchemist)',
    contactInfo: {
      email: 'bob@example.com',
      phone: '+1-555-0102',
      social: 'twitter.com/bob_caa'
    },
    mantra: 'The code always knows.'
  },
  {
    id: 3,
    name: 'Charlie',
    photo: 'https://i.pravatar.cc/150?img=3',
    role: 'PDPX', // Primary Dream Weaver of Player Experiences
    fullRole: '(Primary Dream Weaver of Player Experiences)',
    contactInfo: {
      email: 'charlie@example.com',
      phone: '+1-555-0103',
      social: 'instagram.com/charlie_pdpx'
    },
    mantra: 'Crafting unforgettable moments.'
  },
  {
    id: 4,
    name: 'Diana',
    photo: 'https://i.pravatar.cc/150?img=4',
    role: 'CSS', // Community Sparkle Spreader
    fullRole: '(Community Sparkle Spreader)',
    contactInfo: {
      email: 'diana@example.com',
      phone: '+1-555-0104',
      social: 'facebook.com/diana_css'
    },
    mantra: 'Connecting hearts, one smile at a time.'
  },
  {
    id: 5,
    name: 'Eve',
    photo: 'https://i.pravatar.cc/150?img=5',
    role: 'KUXS', // Kinetic User Experience Sorceress
    fullRole: '(Kinetic User Experience Sorceress)',
    contactInfo: {
      email: 'eve@example.com',
      phone: '+1-555-0105',
      social: 'behance.net/eve_kuxs'
    },
    mantra: 'Intuitive design is magic.'
  },
  {
    id: 6,
    name: 'Frank',
    photo: 'https://i.pravatar.cc/150?img=6',
    role: 'KSL', // Keeper of Supreme Logic
    fullRole: '(Keeper of Supreme Logic)',
    contactInfo: {
      email: 'frank@example.com',
      phone: '+1-555-0106',
      social: 'github.com/frank_ksl'
    },
    mantra: 'Logic is the foundation of greatness.'
  },
  {
    id: 7,
    name: 'Grace',
    photo: 'https://i.pravatar.cc/150?img=7',
    role: 'LSS', // Live Service Storyteller
    fullRole: '(Live Service Storyteller)',
    contactInfo: {
      email: 'grace@example.com',
      phone: '+1-555-0107',
      social: 'medium.com/@grace_lss'
    },
    mantra: 'Every update tells a new tale.'
  },
  {
    id: 8,
    name: 'Heidi',
    photo: 'https://i.pravatar.cc/150?img=8',
    role: 'UID', // Unreal Interface Dreamer
    fullRole: '(Unreal Interface Dreamer)',
    contactInfo: {
      email: 'heidi@example.com',
      phone: '+1-555-0108',
      social: 'dribbble.com/heidi_uid'
    },
    mantra: 'Designing the future, one interface at a time.'
  },
  {
    id: 9,
    name: 'Ivan',
    photo: 'https://i.pravatar.cc/150?img=9',
    role: 'BII', // Backend Illusionist & Inventor
    fullRole: '(Backend Illusionist & Inventor)',
    contactInfo: {
      email: 'ivan@example.com',
      phone: '+1-555-0109',
      social: 'stackoverflow.com/users/ivan_bii'
    },
    mantra: 'Behind every great front-end is a magical back-end.'
  },
  {
    id: 10,
    name: 'Judy',
    photo: 'https://i.pravatar.cc/150?img=10',
    role: 'NWBW', // Narrative & World-Building Wizard
    fullRole: '(Narrative & World-Building Wizard)',
    contactInfo: {
      email: 'judy@example.com',
      phone: '+1-555-0110',
      social: 'artstation.com/judy_nwbw'
    },
    mantra: 'Worlds within words, stories without end.'
  },
  {
    id: 11,
    name: 'Kevin',
    photo: 'https://i.pravatar.cc/150?img=11',
    role: 'BUD', // Business Unit Dragon
    fullRole: '(Business Unit Dragon)',
    contactInfo: {
      email: 'kevin@example.com',
      phone: '+1-555-0111',
      social: 'linkedin.com/in/kevin_bud'
    },
    mantra: 'Igniting growth, one strategy at a time.'
  },
  {
    id: 12,
    name: 'Liam',
    photo: 'https://i.pravatar.cc/150?img=12',
    role: 'PME', // Potion Master of Experience
    fullRole: '(Potion Master of Experience)',
    contactInfo: {
      email: 'liam@example.com',
      phone: '+1-555-0112',
      social: 'pinterest.com/liam_pme'
    },
    mantra: 'Brewing experiences that delight.'
  },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    // Initial scroll to top is good practice to ensure consistent starting view
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // When deflating, we want to scroll back to the top where the header will reappear.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // NO SCROLL HERE - the team section appears in place of the header
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null, scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            
              <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
              </motion.div>
            
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header ref={headerRef} className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold md:pb-4 leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Pust Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Pust Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>
            
        
            <motion.button onClick={scrollTo(gamesSectionRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games section">
              <FaChevronDown size={30} />
            </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.8 }}>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punktèr Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)' },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)' },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)' },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)' },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)' },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)' },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)' },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)' },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)' },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // Scroll to the top of the team section after deflation
        teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // Scroll to the team section when inflated
        setTimeout(() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null (for scroll to top), scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            {!isInflated ? (
              <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
              </motion.div>
            ) : (
              <motion.ul key="inflated-nav-links" className="flex space-x-6 text-lg font-semibold" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <li><button onClick={scrollTo(teamCardsRef)} className="hover:text-purple-300">Vores Team</button></li>
                <li><button onClick={scrollTo(gamesSectionRef)} className="hover:text-purple-300">Vores Spil</button></li>
                <li><button onClick={scrollTo(gamesInDevRef)} className="hover:text-purple-300">Under Udvikling</button></li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header ref={headerRef} className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Blæs Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Blæs Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>
          
            <motion.button onClick={scrollTo(currentNavInfo !== "undefined" || gamesSectionRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.8 }}>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punkter Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)' },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)' },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)' },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)' },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)' },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)' },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)' },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)' },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)' },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const headerRef = useRef(null); // Ref for the top header section
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        // Scroll to the top of the team section after deflation
        teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        // Scroll to the team section when inflated
        setTimeout(() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If ref is null (for scroll to top), scroll to the top of the window
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            {!isInflated ? (
              <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
              </motion.div>
            ) : (
              <motion.ul key="inflated-nav-links" className="flex space-x-6 text-lg font-semibold" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <li><button onClick={scrollTo(teamCardsRef)} className="hover:text-purple-300">Vores Team</button></li>
                <li><button onClick={scrollTo(gamesSectionRef)} className="hover:text-purple-300">Vores Spil</button></li>
                <li><button onClick={scrollTo(gamesInDevRef)} className="hover:text-purple-300">Under Udvikling</button></li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

      <AnimatePresence>
        {!isInflated && (
          <motion.header ref={headerRef} className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}} transition={{ duration: 0.1 }} aria-label="Blæs Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Blæs Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>
          
            <motion.button onClick={scrollTo(currentNavInfo !== "undefined" || gamesSectionRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isInflated && !isBursting && (
          <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.8 }}>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
              Mød Vores Team!
            </h2>

            <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
              {infoBoxesData.map(item => {
                const isActive = selectedCategory === item.category;
                return (
                  <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale: 1.05 }}>
                    {item.icon}
                    <span className="mt-2 text-center font-semibold">{item.title}</span>
                  </motion.div>
                );
              })}
            </div>

            <AnimatePresence>
              {currentNavInfo && (
                <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                  <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                  <p className="text-base text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
              {teamMembers.map(m => {
                const isHighlighted = highlightedMemberIds.includes(m.id);
                const dimmed = selectedCategory && !isHighlighted;
                return (
                  <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} whileHover={{ scale: 1.05 }}>
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                    <h4 className="font-bold text-pink-300">{m.name}</h4>
                    <p className="italic text-gray-300">{m.role}</p>
                    <p className="text-xs text-gray-400">{m.fullRole}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-12">
              <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale: 0.95 }}>
                <span className="text-white">Punkter Os!</span>
              </motion.button>
            </div>
          </motion.section>
        )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(headerRef)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.5 }} transition={{ duration: 0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  { id: 1, name: 'Alice',  photo: 'https://i.pravatar.cc/150?img=1',  role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)' },
  { id: 2, name: 'Bob',    photo: 'https://i.pravatar.cc/150?img=2',  role: 'CGI', fullRole: '(Chief Algorithm Alchemist)' },
  { id: 3, name: 'Charlie',photo: 'https://i.pravatar.cc/150?img=3',  role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)' },
  { id: 4, name: 'Diana',  photo: 'https://i.pravatar.cc/150?img=4',  role: 'CSS', fullRole: '(Community Sparkle Spreader)' },
  { id: 5, name: 'Eve',    photo: 'https://i.pravatar.cc/150?img=5',  role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)' },
  { id: 6, name: 'Frank',  photo: 'https://i.pravatar.cc/150?img=6',  role: 'KSL', fullRole: '(Keeper of Supreme Logic)' },
  { id: 7, name: 'Grace',  photo: 'https://i.pravatar.cc/150?img=7',  role: 'LSS', fullRole: '(Live Service Storyteller)' },
  { id: 8, name: 'Heidi',  photo: 'https://i.pravatar.cc/150?img=8',  role: 'UID', fullRole: '(Unreal Interface Dreamer)' },
  { id: 9, name: 'Ivan',   photo: 'https://i.pravatar.cc/150?img=9',  role: 'BII', fullRole: '(Backend Illusionist & Inventor)' },
  { id: 10,name: 'Judy',   photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)' },
  { id: 11,name: 'Kevin',  photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)' },
  { id: 12,name: 'Liam',   photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)' },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        setTimeout(() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => ref.current?.scrollIntoView({ behavior: 'smooth' });

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">
     
      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            {!isInflated ? (
              <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
              </motion.div>
            ) : (
              <motion.ul key="inflated-nav-links" className="flex space-x-6 text-lg font-semibold" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <li><button onClick={scrollTo(teamCardsRef)} className="hover:text-purple-300">Vores Team</button></li>
                <li><button onClick={scrollTo(gamesSectionRef)} className="hover:text-purple-300">Vores Spil</button></li>
                <li><button onClick={scrollTo(gamesInDevRef)} className="hover:text-purple-300">Under Udvikling</button></li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

    
      <AnimatePresence>
        {!isInflated && (
          <motion.header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1,1.02,1] } : {}} transition={{ duration: 0.1 }} aria-label="Blæs Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Blæs Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>
          </motion.header>
        )}
      </AnimatePresence>

     
      <AnimatePresence>
      {isInflated && !isBursting && (
        <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity:0, y:50 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, y:-50 }} transition={{ duration:0.8 }}>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
            Mød Vores Team!
          </h2>

      
          <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
            {infoBoxesData.map(item => {
              const isActive = selectedCategory === item.category;
              return (
                <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale:1.05 }}>
                  {item.icon}
                  <span className="mt-2 text-center font-semibold">{item.title}</span>
                </motion.div>
              );
            })}
          </div>

        
          <AnimatePresence>
            {currentNavInfo && (
              <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.3 }}>
                <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                <p className="text-base text-gray-200">{currentNavInfo.info}</p>
              </motion.div>
            )}
          </AnimatePresence>

        
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
            {teamMembers.map(m => {
              const isHighlighted = highlightedMemberIds.includes(m.id);
              const dimmed = selectedCategory && !isHighlighted;
              return (
                <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity:0, scale:0.8 }} animate={{ opacity:1, scale:1 }} exit={{ opacity:0, scale:0.8 }} whileHover={{ scale:1.05 }}>
                  <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                  <h4 className="font-bold text-pink-300">{m.name}</h4>
                  <p className="italic text-gray-300">{m.role}</p>
                  <p className="text-xs text-gray-400">{m.fullRole}</p>
                </motion.div>
              );
            })}
          </div>

        
          <div className="mt-12">
            <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale:0.95 }}>
              <span className="text-white">Punkter Os!</span>
            </motion.button>
          </div>
        </motion.section>
      )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity:0, y:50 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.3 }} transition={{ duration:0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.5 }} transition={{ duration:0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity:0, y:50 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.3 }} transition={{ duration:0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(null)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.5 }} transition={{ duration:0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
const rawTeamMembers = [
  { id: 1, name: 'Alice',  photo: 'https://i.pravatar.cc/150?img=1',  role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)' },
  { id: 2, name: 'Bob',    photo: 'https://i.pravatar.cc/150?img=2',  role: 'CGI', fullRole: '(Chief Algorithm Alchemist)' },
  { id: 3, name: 'Charlie',photo: 'https://i.pravatar.cc/150?img=3',  role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)' },
  { id: 4, name: 'Diana',  photo: 'https://i.pravatar.cc/150?img=4',  role: 'CSS', fullRole: '(Community Sparkle Spreader)' },
  { id: 5, name: 'Eve',    photo: 'https://i.pravatar.cc/150?img=5',  role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)' },
  { id: 6, name: 'Frank',  photo: 'https://i.pravatar.cc/150?img=6',  role: 'KSL', fullRole: '(Keeper of Supreme Logic)' },
  { id: 7, name: 'Grace',  photo: 'https://i.pravatar.cc/150?img=7',  role: 'LSS', fullRole: '(Live Service Storyteller)' },
  { id: 8, name: 'Heidi',  photo: 'https://i.pravatar.cc/150?img=8',  role: 'UID', fullRole: '(Unreal Interface Dreamer)' },
  { id: 9, name: 'Ivan',   photo: 'https://i.pravatar.cc/150?img=9',  role: 'BII', fullRole: '(Backend Illusionist & Inventor)' },
  { id: 10,name: 'Judy',   photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)' },
  { id: 11,name: 'Kevin',  photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)' },
  { id: 12,name: 'Liam',   photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)' },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst.',
    category: 'creativityDesign',
    colors: { border: '#7c3aed', background: '#4c1d95' },
    scoreMapping: { GAL: 1, PDX: 0.7, KUX: 0.8, UID: 0.9, NWB: 1 },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere.',
    category: 'teamworkCommunity',
    colors: { border: '#9333ea', background: '#5b21b6' },
    scoreMapping: { PDX: 0.8, CSS: 1, LSS: 0.9, BUD: 0.7, POX: 0.6 },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**.',
    category: 'innovationDevelopment',
    colors: { border: '#facc15', background: '#713f12' },
    scoreMapping: { CGI: 1, KSL: 0.9, BII: 0.8, UID: 0.6 },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning.',
    category: 'visionProgress',
    colors: { border: '#22d3ee', background: '#0e7490' },
    scoreMapping: { BUD: 1, CGI: 0.7, KSL: 0.6, LSS: 0.5 },
  },
];

// --- Placeholder Game Data ---
const developedGames = [
  {
    id: 1,
    title: 'Starfall Tactics',
    description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
    image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
    link: '#',
  },
  {
    id: 2,
    title: 'Whispering Woods',
    description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
    image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
    link: '#',
  },
  {
    id: 3,
    title: 'Neon Drift Racers',
    description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
    image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
    link: '#',
  },
];

const gamesInDevelopment = [
  {
    id: 101,
    title: 'Project Aurora',
    description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
    image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
    status: 'Alpha Testing',
  },
  {
    id: 102,
    title: 'Mythic Mayhem',
    description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
    image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
    status: 'Concept & Prototyping',
  },
];

// --- Utility: assign exactly one category per member ---
const calculateMemberCategories = (members, infoBoxes) => {
  return members.map(member => {
    let bestScore = -Infinity;
    let bestCategory = infoBoxes[0].category;
    for (const box of infoBoxes) {
      const score = box.scoreMapping[member.role] || 0;
      if (score > bestScore) {
        bestScore = score;
        bestCategory = box.category;
      }
    }
    return { ...member, category: bestCategory };
  });
};

export default function App() {
  // State
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
  const [teamMembers, setTeamMembers] = useState([]);

  // Refs
  const teamCardsRef = useRef(null);
  const gamesSectionRef = useRef(null);
  const gamesInDevRef = useRef(null);

  // On mount: compute categories
  useEffect(() => {
    setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  // Build category→IDs map
  const categoryMemberMap = useMemo(() => {
    const map = {};
    teamMembers.forEach(m => {
      if (!map[m.category]) map[m.category] = [];
      map[m.category].push(m.id);
    });
    return map;
  }, [teamMembers]);

  // Idle decay
  useEffect(() => {
    if (clicks > 0 && !isInflated) {
      const id = setInterval(() => {
        if (Date.now() - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(c => Math.max(0, c - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
      return () => clearInterval(id);
    }
  }, [clicks, isInflated, lastClickTimestamp]);

  // Main inflate/deflate button
  const handleMainButtonClick = useCallback(() => {
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150);
    setLastClickTimestamp(Date.now());

    if (isInflated) {
      setIsBursting(true);
      confetti({
        particleCount: 200,
        spread: 360,
        startVelocity: 60,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
      });
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0);
        setSelectedCategory(null);
        setHighlightedMemberIds([]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, BURST_DURATION);
      return;
    }

    setClicks(c => {
      const next = Math.min(REQUIRED_CLICKS, c + 1);
      if (next >= REQUIRED_CLICKS) {
        setIsInflated(true);
        setTimeout(() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
      }
      return next;
    });
  }, [isInflated]);

  // Info box click
  const handleInfoBoxClick = useCallback(item => {
    if (selectedCategory === item.category) {
      setSelectedCategory(null);
      setCurrentNavInfo(null);
      setHighlightedMemberIds([]);
    } else {
      setSelectedCategory(item.category);
      setCurrentNavInfo(item);
      setHighlightedMemberIds(categoryMemberMap[item.category] || []);
    }
  }, [selectedCategory, categoryMemberMap]);

  // Scroll helpers
  const scrollTo = ref => () => ref.current?.scrollIntoView({ behavior: 'smooth' });

  const progressPct = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">
     
      <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
        <div className="flex items-center space-x-2 md:space-x-4">
          <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
          <div className="flex flex-col items-end">
            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
          </div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
          <AnimatePresence mode="wait">
            {!isInflated ? (
              <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
              </motion.div>
            ) : (
              <motion.ul key="inflated-nav-links" className="flex space-x-6 text-lg font-semibold" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                <li><button onClick={scrollTo(teamCardsRef)} className="hover:text-purple-300">Vores Team</button></li>
                <li><button onClick={scrollTo(gamesSectionRef)} className="hover:text-purple-300">Vores Spil</button></li>
                <li><button onClick={scrollTo(gamesInDevRef)} className="hover:text-purple-300">Under Udvikling</button></li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
        <div className="w-16 md:w-24" />
      </nav>

    
      <AnimatePresence>
        {!isInflated && (
          <motion.header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -50 }} transition={{ duration: 0.5 }}>
            <motion.h1 className="text-4xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}>
              Spil. Hyg. Fejr!
            </motion.h1>
            <p className="mt-4 text-base md:text-xl font-medium text-gray-300 max-w-2xl">
              Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
            </p>
            <div className="mt-8 w-full max-w-sm md:max-w-md">
              <motion.button onClick={handleMainButtonClick} className="w-full py-3 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden" style={{ background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite' }} whileTap={{ scale: 0.95 }} animate={isButtonClicked ? { scale: [1,1.02,1] } : {}} transition={{ duration: 0.1 }} aria-label="Blæs Vores Egoer Op!">
                <motion.div className="absolute inset-0 bg-white bg-opacity-20" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
                <span className="relative z-10 text-white">Blæs Vores Egoer Op!</span>
              </motion.button>
              <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                <motion.div className="h-full bg-green-400" animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              </div>
              <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
            </div>
          </motion.header>
        )}
      </AnimatePresence>

     
      <AnimatePresence>
      {isInflated && !isBursting && (
        <motion.section ref={teamCardsRef} className="w-full py-20 px-4 flex flex-col items-center bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" initial={{ opacity:0, y:50 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, y:-50 }} transition={{ duration:0.8 }}>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
            Mød Vores Team!
          </h2>

      
          <div className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6">
            {infoBoxesData.map(item => {
              const isActive = selectedCategory === item.category;
              return (
                <motion.div key={item.id} onClick={() => handleInfoBoxClick(item)} className="w-32 h-32 md:w-36 md:h-36 rounded-xl p-3 flex flex-col items-center justify-center cursor-pointer" style={{ border: `2px solid ${item.colors.border}`, backgroundColor: item.colors.background, boxShadow: isActive ? `0 0 10px ${item.colors.border}` : 'none' }} whileHover={{ scale:1.05 }}>
                  {item.icon}
                  <span className="mt-2 text-center font-semibold">{item.title}</span>
                </motion.div>
              );
            })}
          </div>

        
          <AnimatePresence>
            {currentNavInfo && (
              <motion.div key={currentNavInfo.id} className="mb-12 p-6 rounded-lg max-w-3xl w-full text-center" style={{ border: `2px solid ${currentNavInfo.colors.border}`, backgroundColor: currentNavInfo.colors.background }} initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} exit={{ opacity:0, height:0 }} transition={{ duration:0.3 }}>
                <p className="text-xl font-semibold mb-2">{currentNavInfo.title}</p>
                <p className="text-base text-gray-200">{currentNavInfo.info}</p>
              </motion.div>
            )}
          </AnimatePresence>

        
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
            {teamMembers.map(m => {
              const isHighlighted = highlightedMemberIds.includes(m.id);
              const dimmed = selectedCategory && !isHighlighted;
              return (
                <motion.div key={m.id} className={`p-4 rounded-xl text-center ${isHighlighted ? 'ring-4 ring-yellow-400 scale-105' : ''} ${dimmed ? 'opacity-40' : ''}`} style={{ background: 'rgba(0,0,0,0.5)' }} initial={{ opacity:0, scale:0.8 }} animate={{ opacity:1, scale:1 }} exit={{ opacity:0, scale:0.8 }} whileHover={{ scale:1.05 }}>
                  <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full mx-auto mb-3" />
                  <h4 className="font-bold text-pink-300">{m.name}</h4>
                  <p className="italic text-gray-300">{m.role}</p>
                  <p className="text-xs text-gray-400">{m.fullRole}</p>
                </motion.div>
              );
            })}
          </div>

        
          <div className="mt-12">
            <motion.button onClick={handleMainButtonClick} className="px-8 py-3 rounded-full font-bold uppercase shadow-lg" style={{ background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)', backgroundSize: '200% 200%', animation: 'pulseGradient 1.5s ease-in-out infinite' }} whileTap={{ scale:0.95 }}>
              <span className="text-white">Punkter Os!</span>
            </motion.button>
          </div>
        </motion.section>
      )}
      </AnimatePresence>

      <section ref={gamesSectionRef} className="w-full py-20 px-4 bg-gradient-to-br from-indigo-900 to-blue-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
          Vores Spil
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {developedGames.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 text-center flex flex-col" initial={{ opacity:0, y:50 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.3 }} transition={{ duration:0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <a href={game.link} target="_blank" rel="noopener noreferrer" className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors">
                Læs Mere
              </a>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(gamesInDevRef)} className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors" initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.5 }} transition={{ duration:0.5 }} aria-label="Scroll to games in development">
          <FaChevronDown size={30} />
        </motion.button>
      </section>

      <section ref={gamesInDevRef} className="w-full py-20 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
          Spil Under Udvikling
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
          {gamesInDevelopment.map(game => (
            <motion.div key={game.id} className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 text-center" initial={{ opacity:0, y:50 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.3 }} transition={{ duration:0.6 }}>
              <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
              <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
              <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
              <span className="inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full">
                Status: {game.status}
              </span>
            </motion.div>
          ))}
        </div>
        <motion.button onClick={scrollTo(null)} className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors" initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true, amount:0.5 }} transition={{ duration:0.5 }} aria-label="Scroll back to top">
          <FaChevronUp size={30} />
        </motion.button>
      </section>

      <style jsx>{`
        @keyframes buttonGradient {
          0% { background-position:0% 50%; }
          50% { background-position:100% 50%; }
          100% { background-position:0% 50%; }
        }
        @keyframes pulseGradient {
          0% { background-position:0% 50%; transform:scale(1); }
          50% { background-position:100% 50%; transform:scale(1.01); }
          100% { background-position:0% 50%; transform:scale(1); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */






/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Raw Team Member Data ---
// The 'categories' property is intentionally omitted here as it will be calculated dynamically.
const rawTeamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 } },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 } },
    { id: 3, name: 'Charlie', 'photo': 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 } },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 } },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 } },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 } },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 } },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 } },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 } },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 } },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 } },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 } },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
        scoreMapping: { CRE: 1, CHR: 0.5 }, // Creativity is primary, Charm contributes
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
        scoreMapping: { CHR: 1, GRT: 0.5 }, // Charm is primary, Grit contributes to team effort
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
        scoreMapping: { LOG: 1, CRE: 0.7 }, // Logic is primary, Creativity contributes to new ideas
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
        scoreMapping: { GRT: 1, LOG: 0.6 }, // Grit for seeing things through, Logic for strategic thinking
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Utility Function to Calculate Member Categories based on Scores ---
// This function determines the category (or categories) where a member has their
// absolutely highest calculated score.
const calculateMemberCategories = (members, infoBoxes) => {
    return members.map(member => {
        let highestCalculatedScore = -Infinity; // Initialize with negative infinity to correctly find highest
        let bestFitCategories = [];

        const memberCategoryScores = infoBoxes.map(infoBox => {
            let currentCategoryScore = 0;
            for (const stat in infoBox.scoreMapping) {
                if (member.scores && member.scores[stat]) {
                    currentCategoryScore += member.scores[stat] * infoBox.scoreMapping[stat];
                }
            }
            return { category: infoBox.category, score: currentCategoryScore };
        });

        for (const catScore of memberCategoryScores) {
            if (catScore.score > highestCalculatedScore) {
                highestCalculatedScore = catScore.score;
                bestFitCategories = [catScore.category]; // Start a new list if a new highest is found
            } else if (catScore.score === highestCalculatedScore) {
                // Add to list if tied. Even if 0 or negative, if it's the highest, it's their best fit.
                bestFitCategories.push(catScore.category);
            }
        }

        // Fallback: Ensure every member is associated with at least one category.
        // This handles cases where all calculated scores might be 0 or negative,
        // assigning them to the highest (least negative/zero) one.
        if (bestFitCategories.length === 0 && memberCategoryScores.length > 0) {
             let maxScore = -Infinity;
             let defaultCategory = null;
             for (const catScore of memberCategoryScores) {
                 if (catScore.score > maxScore) {
                     maxScore = catScore.score;
                     defaultCategory = catScore.category;
                 }
             }
             if (defaultCategory) {
                 bestFitCategories.push(defaultCategory);
             }
         } else if (bestFitCategories.length === 0 && infoBoxes.length > 0) {
             // If no scores or mapping result in any assignment,
             // just assign to the first infobox's category as a last resort.
             bestFitCategories.push(infoBoxes[0].category);
         }


        return { ...member, categories: bestFitCategories };
    });
};


// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
    const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);
    const [teamMembers, setTeamMembers] = useState([]); // State to hold calculated team members
    const [activeScoreMapping, setActiveScoreMapping] = useState({}); // State to hold the score mapping of the selected infobox

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);
    const teamCardsRef = useRef(null);

    // --- Calculate team member categories on mount ---
    useEffect(() => {
        setTeamMembers(calculateMemberCategories(rawTeamMembers, infoBoxesData));
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            confetti({
                particleCount: 200,
                spread: 360,
                startVelocity: 60,
                origin: { x: 0.5, y: 0.5 },
                colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
            });

            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setSelectedCategory(null);
                setHighlightedMemberIds([]);
                setActiveScoreMapping({}); // Clear active score mapping on deflate
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top when deflated
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
                setTimeout(() => {
                    teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
            return nextClicks;
        });
    }, [isInflated]);

    const handleInfoBoxClick = useCallback((item) => {
        let newSelectedCategory = null;
        let newCurrentNavInfo = null;
        let newHighlightedMemberIds = [];
        let newActiveScoreMapping = {};

        if (selectedCategory === item.category) {
            // Deselect the current category if clicked again
            newSelectedCategory = null;
            newCurrentNavInfo = null;
            newActiveScoreMapping = {};
            newHighlightedMemberIds = []; // Clear highlighted members
        } else {
            // Select a new category
            newSelectedCategory = item.category;
            newCurrentNavInfo = {
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            };
            newActiveScoreMapping = item.scoreMapping; // Store the score mapping for highlighting individual stats

            // Highlight members whose 'categories' array includes the selected 'item.category'.
            // This ensures only members who are a "best fit" (highest or tied highest score)
            // for the selected category get the card highlight.
            newHighlightedMemberIds = teamMembers
                .filter(member => member.categories && member.categories.includes(item.category))
                .map(member => member.id);
        }
        setSelectedCategory(newSelectedCategory);
        setCurrentNavInfo(newCurrentNavInfo);
        setHighlightedMemberIds(newHighlightedMemberIds);
        setActiveScoreMapping(newActiveScoreMapping); // Update the active score mapping
    }, [selectedCategory, teamMembers]); // Dependency on teamMembers is important here

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

           
            <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
               
                <div className="flex items-center space-x-2 md:space-x-4">
                    <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                    <div className="flex flex-col items-end">
                        <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                        <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                    </div>
                </div>

                
                <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                    <AnimatePresence mode="wait">
                        {!isInflated ? (
                            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }} className="p-2">
                                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                            </motion.div>
                        ) : (
                            <motion.div key="inflated-nav-links" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                                <ul className="flex space-x-6 text-lg font-semibold">
                                    <li><button onClick={() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' })} className="text-white hover:text-purple-300 transition-colors">Vores Team</button></li>
                                    <li><button onClick={scrollToGames} className="text-white hover:text-purple-300 transition-colors">Vores Spil</button></li>
                                    <li><button onClick={scrollToGamesInDevelopment} className="text-white hover:text-purple-300 transition-colors">Under Udvikling</button></li>
                                </ul>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                <div className="w-16 md:w-24" /> 
            </nav>

           
            <AnimatePresence>
                {!isInflated && (
                    <motion.header
                        className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center relative"
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                    >
                        <motion.h1
                            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                        >
                            Spil. Hyg. Fejr!
                        </motion.h1>

                        <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                        </p>

                        <div className="mt-8 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                    backgroundSize: '200% 200%',
                                    animation: 'buttonGradient 2s linear infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Blæs Vores Egoer Op!"
                            >
                                <motion.div
                                    className="absolute inset-0 bg-white bg-opacity-20"
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                                <span className="relative z-10">Blæs Vores Egoer Op!</span>
                            </motion.button>

                            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                                <motion.div
                                    className={`h-full bg-green-400`}
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                            </div>
                            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                        </div>
                    </motion.header>
                )}
            </AnimatePresence>

           
            <AnimatePresence>
                {isInflated && !isBursting && (
                    <motion.section
                        ref={teamCardsRef}
                        className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white flex flex-col items-center min-h-screen"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
                            Mød Vores Heltemodige Team!
                        </h2>

                        
                        <section className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6 px-2 max-w-4xl w-full text-xl font-semibold">
                            {infoBoxesData.map((item) => (
                                <motion.div
                                    key={item.id}
                                    className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                    style={{
                                        borderColor: item.colors.border,
                                        backgroundColor: item.colors.background,
                                        boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                    }}
                                    onClick={() => handleInfoBoxClick(item)}
                                >
                                    <span className="text-white mb-2">{item.icon}</span>
                                    <span className="font-bold text-base leading-tight">{item.title}</span>
                                </motion.div>
                            ))}
                        </section>

                        
                        <AnimatePresence mode="wait">
                            {currentNavInfo && (
                                <motion.div
                                    key={currentNavInfo.id + "-expanded"}
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="mt-8 mb-12 p-6 rounded-lg max-w-3xl w-full text-center"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '2px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <p className="text-xl font-semibold mb-2" dangerouslySetInnerHTML={{ __html: currentNavInfo.title }}></p>
                                    <p className="text-base text-gray-200" dangerouslySetInnerHTML={{ __html: currentNavInfo.info }}></p>
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
                            {teamMembers.map(member => { // Using the 'teamMembers' state here
                                const isHighlighted = highlightedMemberIds.includes(member.id);
                                // A member is 'dimmed' if a category is selected, and this member is NOT highlighted.
                                const dimIfUnselected = selectedCategory && !isHighlighted;

                                return (
                                    <motion.div
                                        key={member.id}
                                        className={`relative bg-black/50 backdrop-blur-sm rounded-xl p-4 shadow-xl border border-gray-700 flex flex-col items-center text-center transition-all duration-300 ease-in-out
                                            ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400 scale-105' : ''}
                                            ${dimIfUnselected ? 'opacity-40' : ''}
                                        `}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.8 }}
                                        transition={{ duration: 0.3 }}
                                        whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(255,255,255,0.3)' }}
                                    >
                                        <img src={member.photo} alt={member.name} className="w-24 h-24 object-cover rounded-full mb-3 border-2 border-purple-500 shadow-md" />
                                        <h3 className="text-xl font-bold text-pink-300">{member.name}</h3>
                                        <p className="text-sm italic text-gray-300 leading-tight">
                                            {member.role}
                                            <br />
                                            <span className="text-xs text-gray-400">{member.fullRole}</span>
                                        </p>
                                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-3 text-xs w-full max-w-[150px]">
                                            {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                                <div
                                                    key={stat}
                                                    className={`flex justify-between items-center rounded px-1.5 py-0.5
                                                        ${isHighlighted && activeScoreMapping[stat] ? 'bg-purple-800 bg-opacity-90' : 'bg-gray-800 bg-opacity-70'}
                                                    `}
                                                >
                                                    <span className={`font-semibold ${isHighlighted && activeScoreMapping[stat] ? 'text-yellow-300' : 'text-purple-300'}`}>{stat}:</span>
                                                    <span className={`font-bold ${isHighlighted && activeScoreMapping[stat] ? 'text-white text-base' : 'text-white'}`}>{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                        
                        <div className="mt-12 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)',
                                    backgroundSize: '200% 200%',
                                    animation: 'pulseGradient 1.5s ease-in-out infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Punkter Vores Egoer"
                            >
                                <span className="relative z-10">Punkter Os!</span>
                            </motion.button>
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

           
            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
                @keyframes buttonGradient {
                  0%{background-position:0% 50%}
                  50%{background-position:100% 50%}
                  100%{background-position:0% 50%}
                }
                @keyframes pulseGradient {
                  0%{background-position:0% 50%; transform: scale(1);}
                  50%{background-position:100% 50%; transform: scale(1.01);}
                  100%{background-position:0% 50%; transform: scale(1);}
                }
                @keyframes gradient {
                  0% { background-position: 0% 50%; }
                  25% { background-position: 50% 100%; }
                  50% { background-position: 100% 50%; }
                  75% { background-position: 50% 0%; }
                  100% { background-position: 0% 50%; }
                }
            `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;
const TOP_N_HIGHLIGHT = 3; // Number of top members to highlight

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 }, categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 }, categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 }, categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 }, categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 }, categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
        scoreMapping: { CRE: 1, CHR: 0.5 }, // Creativity is primary, Charm contributes
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
        scoreMapping: { CHR: 1, GRT: 0.5 }, // Charm is primary, Grit contributes to team effort
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
        scoreMapping: { LOG: 1, CRE: 0.7 }, // Logic is primary, Creativity contributes to new ideas
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
        scoreMapping: { GRT: 1, LOG: 0.6 }, // Grit for seeing things through, Logic for strategic thinking
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
    const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);
    const teamCardsRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            confetti({
                particleCount: 200,
                spread: 360,
                startVelocity: 60,
                origin: { x: 0.5, y: 0.5 },
                colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
            });

            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setSelectedCategory(null);
                setHighlightedMemberIds([]);
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top when deflated
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
                setTimeout(() => {
                    teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
            return nextClicks;
        });
    }, [isInflated]);

    const handleInfoBoxClick = useCallback((item) => {
        let newSelectedCategory = null;
        let newCurrentNavInfo = null;
        let newHighlightedMemberIds = [];

        if (selectedCategory === item.category) {
            newSelectedCategory = null;
            newCurrentNavInfo = null;
        } else {
            newSelectedCategory = item.category;
            newCurrentNavInfo = {
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            };

            const currentScoreMapping = infoBoxesData.find(box => box.id === item.id)?.scoreMapping;

            if (currentScoreMapping) {
                const membersWithCalculatedScores = teamMembers.map(member => {
                    let totalScore = 0;
                    for (const stat in currentScoreMapping) {
                        if (member.scores && member.scores[stat]) {
                            totalScore += member.scores[stat] * currentScoreMapping[stat];
                        }
                    }
                    return { ...member, calculatedScore: totalScore };
                });

                membersWithCalculatedScores.sort((a, b) => b.calculatedScore - a.calculatedScore);

                newHighlightedMemberIds = membersWithCalculatedScores
                    .slice(0, TOP_N_HIGHLIGHT)
                    .map(member => member.id);
            }
        }
        setSelectedCategory(newSelectedCategory);
        setCurrentNavInfo(newCurrentNavInfo);
        setHighlightedMemberIds(newHighlightedMemberIds);
    }, [selectedCategory, infoBoxesData]);

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            
            <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                
                <div className="flex items-center space-x-2 md:space-x-4">
                    <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                    <div className="flex flex-col items-end">
                        <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                        <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                    </div>
                </div>

                
                <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                    <AnimatePresence mode="wait">
                        {!isInflated ? (
                            <motion.div key="default-nav-info" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }} className="p-2">
                                <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                            </motion.div>
                        ) : (
                            <motion.div key="inflated-nav-links" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                                <ul className="flex space-x-6 text-lg font-semibold">
                                    <li><button onClick={() => teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' })} className="text-white hover:text-purple-300 transition-colors">Vores Team</button></li>
                                    <li><button onClick={scrollToGames} className="text-white hover:text-purple-300 transition-colors">Vores Spil</button></li>
                                    <li><button onClick={scrollToGamesInDevelopment} className="text-white hover:text-purple-300 transition-colors">Under Udvikling</button></li>
                                </ul>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                <div className="w-16 md:w-24" /> 
            </nav>

            
            <AnimatePresence>
                {!isInflated && (
                    <motion.header
                        className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto min-h-screen justify-center relative"
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                    >
                        <motion.h1
                            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                        >
                            Spil. Hyg. Fejr!
                        </motion.h1>

                        <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                        </p>

                        <div className="mt-8 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                    backgroundSize: '200% 200%',
                                    animation: 'buttonGradient 2s linear infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Blæs Vores Egoer Op!"
                            >
                                <motion.div
                                    className="absolute inset-0 bg-white bg-opacity-20"
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                                <span className="relative z-10">Blæs Vores Egoer Op!</span>
                            </motion.button>

                            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                                <motion.div
                                    className={`h-full bg-green-400`}
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                            </div>
                            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                        </div>
                    </motion.header>
                )}
            </AnimatePresence>

           
            <AnimatePresence>
                {isInflated && !isBursting && (
                    <motion.section
                        ref={teamCardsRef}
                        className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white flex flex-col items-center min-h-screen"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
                            Mød Vores Heltemodige Team!
                        </h2>

                        
                        <section className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6 px-2 max-w-4xl w-full text-xl font-semibold">
                            {infoBoxesData.map((item) => (
                                <motion.div
                                    key={item.id}
                                    className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                    style={{
                                        borderColor: item.colors.border,
                                        backgroundColor: item.colors.background,
                                        boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                    }}
                                    onClick={() => handleInfoBoxClick(item)}
                                >
                                    <span className="text-white mb-2">{item.icon}</span>
                                    <span className="font-bold text-base leading-tight">{item.title}</span>
                                </motion.div>
                            ))}
                        </section>

                       
                        <AnimatePresence mode="wait">
                            {currentNavInfo && (
                                <motion.div
                                    key={currentNavInfo.id + "-expanded"}
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="mt-8 mb-12 p-6 rounded-lg max-w-3xl w-full text-center"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '2px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <p className="text-xl font-semibold mb-2" dangerouslySetInnerHTML={{ __html: currentNavInfo.title }}></p>
                                    <p className="text-base text-gray-200" dangerouslySetInnerHTML={{ __html: currentNavInfo.info }}></p>
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
                            {teamMembers.map(member => {
                                const isHighlighted = highlightedMemberIds.includes(member.id);
                                const dimIfUnselected = selectedCategory && !isHighlighted;

                                return (
                                    <motion.div
                                        key={member.id}
                                        className={`relative bg-black/50 backdrop-blur-sm rounded-xl p-4 shadow-xl border border-gray-700 flex flex-col items-center text-center transition-all duration-300 ease-in-out
                                            ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400 scale-105' : ''}
                                            ${dimIfUnselected ? 'opacity-40' : ''}
                                        `}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.8 }}
                                        transition={{ duration: 0.3 }}
                                        whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(255,255,255,0.3)' }}
                                    >
                                        <img src={member.photo} alt={member.name} className="w-24 h-24 object-cover rounded-full mb-3 border-2 border-purple-500 shadow-md" />
                                        <h3 className="text-xl font-bold text-pink-300">{member.name}</h3>
                                        <p className="text-sm italic text-gray-300 leading-tight">
                                            {member.role}
                                            <br />
                                            <span className="text-xs text-gray-400">{member.fullRole}</span>
                                        </p>
                                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-3 text-xs w-full max-w-[150px]">
                                            {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                                <div key={stat} className="flex justify-between items-center bg-gray-800 bg-opacity-70 rounded px-1.5 py-0.5">
                                                    <span className="font-semibold text-purple-300">{stat}:</span>
                                                    <span className="font-bold text-white">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                        
                        <div className="mt-12 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)',
                                    backgroundSize: '200% 200%',
                                    animation: 'pulseGradient 1.5s ease-in-out infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Punkter Vores Egoer"
                            >
                                <span className="relative z-10">Punkter Os!</span>
                            </motion.button>
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

           
            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            
            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
                @keyframes buttonGradient {
                  0%{background-position:0% 50%}
                  50%{background-position:100% 50%}
                  100%{background-position:0% 50%}
                }
                @keyframes pulseGradient {
                  0%{background-position:0% 50%; transform: scale(1);}
                  50%{background-position:100% 50%; transform: scale(1.01);}
                  100%{background-position:0% 50%; transform: scale(1);}
                }
                @keyframes gradient {
                  0% { background-position: 0% 50%; }
                  25% { background-position: 50% 100%; }
                  50% { background-position: 100% 50%; }
                  75% { background-position: 50% 0%; }
                  100% { background-position: 0% 50%; }
                }
            `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;
const TOP_N_HIGHLIGHT = 3; // Number of top members to highlight

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 }, categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 }, categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 }, categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 }, categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 }, categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
        scoreMapping: { CRE: 1, CHR: 0.5 }, // Creativity is primary, Charm contributes
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
        scoreMapping: { CHR: 1, GRT: 0.5 }, // Charm is primary, Grit contributes to team effort
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
        scoreMapping: { LOG: 1, CRE: 0.7 }, // Logic is primary, Creativity contributes to new ideas
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
        scoreMapping: { GRT: 1, LOG: 0.6 }, // Grit for seeing things through, Logic for strategic thinking
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());
    const [highlightedMemberIds, setHighlightedMemberIds] = useState([]);

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);
    const teamCardsRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            confetti({
                particleCount: 200,
                spread: 360,
                startVelocity: 60,
                origin: { x: 0.5, y: 0.5 },
                colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
            });

            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setSelectedCategory(null);
                setHighlightedMemberIds([]);
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
                setTimeout(() => {
                    teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
            return nextClicks;
        });
    }, [isInflated]);

    const handleInfoBoxClick = useCallback((item) => {
        let newSelectedCategory = null;
        let newCurrentNavInfo = null;
        let newHighlightedMemberIds = [];

        if (selectedCategory === item.category) {
            newSelectedCategory = null;
            newCurrentNavInfo = null;
        } else {
            newSelectedCategory = item.category;
            newCurrentNavInfo = {
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            };

            const currentScoreMapping = infoBoxesData.find(box => box.id === item.id)?.scoreMapping;

            if (currentScoreMapping) {
                const membersWithCalculatedScores = teamMembers.map(member => {
                    let totalScore = 0;
                    for (const stat in currentScoreMapping) {
                        if (member.scores && member.scores[stat]) {
                            totalScore += member.scores[stat] * currentScoreMapping[stat];
                        }
                    }
                    return { ...member, calculatedScore: totalScore };
                });

                membersWithCalculatedScores.sort((a, b) => b.calculatedScore - a.calculatedScore);

                newHighlightedMemberIds = membersWithCalculatedScores
                    .slice(0, TOP_N_HIGHLIGHT)
                    .map(member => member.id);
            }
        }
        setSelectedCategory(newSelectedCategory);
        setCurrentNavInfo(newCurrentNavInfo);
        setHighlightedMemberIds(newHighlightedMemberIds);
    }, [selectedCategory, infoBoxesData]);

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                   
                    {!isInflated && (
                        <>
                            <div className="mt-8 w-full max-w-sm md:max-w-md">
                                <motion.button
                                    onClick={handleMainButtonClick}
                                    className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                    style={{
                                        background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                        backgroundSize: '200% 200%',
                                        animation: 'buttonGradient 2s linear infinite',
                                    }}
                                    whileTap={{ scale: 0.95 }}
                                    animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                    transition={{ duration: 0.1 }}
                                    aria-label="Blæs Vores Egoer Op!"
                                >
                                    <motion.div
                                        className="absolute inset-0 bg-white bg-opacity-20"
                                        animate={{ width: `${progressPercentage}%` }}
                                        transition={{ type: 'tween', duration: 0.2 }}
                                    />
                                    <span className="relative z-10">Blæs Vores Egoer Op!</span>
                                </motion.button>

                                <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                                    <motion.div
                                        className={`h-full bg-green-400`}
                                        animate={{ width: `${progressPercentage}%` }}
                                        transition={{ type: 'tween', duration: 0.2 }}
                                    />
                                </div>
                                <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                            </div>
                           
                            <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                                {infoBoxesData.map((item) => (
                                    <motion.div
                                        key={item.id}
                                        className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                        style={{
                                            borderColor: item.colors.border,
                                            backgroundColor: item.colors.background,
                                            boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                        }}
                                        onClick={() => handleInfoBoxClick(item)}
                                    >
                                        <span className="text-white mb-2">{item.icon}</span>
                                        <span className="font-bold text-base leading-tight">{item.title}</span>
                                    </motion.div>
                                ))}
                            </section>
                        </>
                    )}
                </header>

               
                {!isInflated && (
                    <motion.button
                        className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                        onClick={scrollToGames}
                        initial={{ y: 0 }}
                        animate={{ y: [0, -10, 0] }}
                        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                        aria-label="Scroll down to games section"
                    >
                        <FaChevronDown size={30} className="text-white" />
                    </motion.button>
                )}
            </div>

            
            <AnimatePresence>
                {isInflated && !isBursting && (
                    <motion.section
                        ref={teamCardsRef}
                        className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white flex flex-col items-center min-h-screen"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
                            Mød Vores Heltemodige Team!
                        </h2>

                       
                        <section className="flex flex-wrap justify-center mb-12 gap-4 md:gap-6 px-2 max-w-4xl w-full text-xl font-semibold">
                            {infoBoxesData.map((item) => (
                                <motion.div
                                    key={item.id}
                                    className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                    style={{
                                        borderColor: item.colors.border,
                                        backgroundColor: item.colors.background,
                                        boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                    }}
                                    onClick={() => handleInfoBoxClick(item)}
                                >
                                    <span className="text-white mb-2">{item.icon}</span>
                                    <span className="font-bold text-base leading-tight">{item.title}</span>
                                </motion.div>
                            ))}
                        </section>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
                            {teamMembers.map(member => {
                                const isHighlighted = highlightedMemberIds.includes(member.id);
                                const dimIfUnselected = selectedCategory && !isHighlighted;

                                return (
                                    <motion.div
                                        key={member.id}
                                        className={`relative bg-black/50 backdrop-blur-sm rounded-xl p-4 shadow-xl border border-gray-700 flex flex-col items-center text-center transition-all duration-300 ease-in-out
                                            ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400 scale-105' : ''}
                                            ${dimIfUnselected ? 'opacity-40' : ''}
                                        `}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.8 }}
                                        transition={{ duration: 0.3 }}
                                        whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(255,255,255,0.3)' }}
                                    >
                                        <img src={member.photo} alt={member.name} className="w-24 h-24 object-cover rounded-full mb-3 border-2 border-purple-500 shadow-md" />
                                        <h3 className="text-xl font-bold text-pink-300">{member.name}</h3>
                                        <p className="text-sm italic text-gray-300 leading-tight">
                                            {member.role}
                                            <br />
                                            <span className="text-xs text-gray-400">{member.fullRole}</span>
                                        </p>
                                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-3 text-xs w-full max-w-[150px]">
                                            {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                                <div key={stat} className="flex justify-between items-center bg-gray-800 bg-opacity-70 rounded px-1.5 py-0.5">
                                                    <span className="font-semibold text-purple-300">{stat}:</span>
                                                    <span className="font-bold text-white">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                        
                        <div className="mt-12 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)',
                                    backgroundSize: '200% 200%',
                                    animation: 'pulseGradient 1.5s ease-in-out infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Punkter Vores Egoer"
                            >
                                <span className="relative z-10">Punkter Os!</span>
                            </motion.button>
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 }, categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 }, categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 }, categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 }, categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 }, categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);
    const teamCardsRef = useRef(null); // New ref for the team cards section

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            // Confetti from a central point for burst effect on the button click area
            confetti({
                particleCount: 200,
                spread: 360,
                startVelocity: 60,
                origin: { x: 0.5, y: 0.5 },
                colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
            });

            // After burst, reset state
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
                // Scroll to team cards section once inflated
                setTimeout(() => {
                    teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
            return nextClicks;
        });
    }, [isInflated]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]);

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    
                    {!isInflated && (
                        <div className="mt-8 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                    backgroundSize: '200% 200%',
                                    animation: 'buttonGradient 2s linear infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Blæs Vores Egoer Op!"
                            >
                                <motion.div
                                    className="absolute inset-0 bg-white bg-opacity-20"
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                                <span className="relative z-10">Blæs Vores Egoer Op!</span>
                            </motion.button>

                            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                                <motion.div
                                    className={`h-full bg-green-400`}
                                    animate={{ width: `${progressPercentage}%` }}
                                    transition={{ type: 'tween', duration: 0.2 }}
                                />
                            </div>
                            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                        </div>
                    )}

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

        
            <AnimatePresence>
                {isInflated && !isBursting && (
                    <motion.section
                        ref={teamCardsRef}
                        className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white flex flex-col items-center min-h-screen"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
                            Mød Vores Heltemodige Team!
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
                            {teamMembers.map(member => {
                                const isHighlighted = selectedCategory && member.categories.includes(selectedCategory);

                                return (
                                    <motion.div
                                        key={member.id}
                                        className={`relative bg-black/50 backdrop-blur-sm rounded-xl p-4 shadow-xl border border-gray-700 flex flex-col items-center text-center transition-all duration-300 ease-in-out ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400 scale-105' : ''}`}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.8 }}
                                        transition={{ duration: 0.3 }}
                                        whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(255,255,255,0.3)' }}
                                    >
                                        <img src={member.photo} alt={member.name} className="w-24 h-24 object-cover rounded-full mb-3 border-2 border-purple-500 shadow-md" />
                                        <h3 className="text-xl font-bold text-pink-300">{member.name}</h3>
                                        <p className="text-sm italic text-gray-300 leading-tight">
                                            {member.role}
                                            <br />
                                            <span className="text-xs text-gray-400">{member.fullRole}</span>
                                        </p>
                                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-3 text-xs w-full max-w-[150px]">
                                            {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                                <div key={stat} className="flex justify-between items-center bg-gray-800 bg-opacity-70 rounded px-1.5 py-0.5">
                                                    <span className="font-semibold text-purple-300">{stat}:</span>
                                                    <span className="font-bold text-white">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                  
                        <div className="mt-12 w-full max-w-sm md:max-w-md">
                            <motion.button
                                onClick={handleMainButtonClick}
                                className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                                style={{
                                    background: 'linear-gradient(90deg,#831843,#db2777,#ec4899)',
                                    backgroundSize: '200% 200%',
                                    animation: 'pulseGradient 1.5s ease-in-out infinite',
                                }}
                                whileTap={{ scale: 0.95 }}
                                animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                                transition={{ duration: 0.1 }}
                                aria-label="Punkter Vores Egoer"
                            >
                                <span className="relative z-10">Punkter Os!</span>
                            </motion.button>
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144; // This will become more of a base for card size
const PHOTO_BUFFER = 20; // Less relevant for grid, but can be spacing
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 }, categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 }, categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 }, categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 }, categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 }, categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);
    const teamCardsRef = useRef(null); // New ref for the team cards section

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            // Confetti from a central point for burst effect on the button click area
            confetti({
                particleCount: 200,
                spread: 360,
                startVelocity: 60,
                origin: { x: 0.5, y: 0.5 },
                colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
            });

            // After burst, reset state
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                // No need to regenerate positions, as they are now grid-based
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
                // Scroll to team cards section once inflated
                setTimeout(() => {
                    teamCardsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
            return nextClicks;
        });
    }, [isInflated]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]);

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

           

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

           
            <AnimatePresence>
                {isInflated && !isBursting && (
                    <motion.section
                        ref={teamCardsRef}
                        className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white flex flex-col items-center min-h-screen"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-lime-400 drop-shadow-lg">
                            Mød Vores Heltemodige Team!
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
                            {teamMembers.map(member => {
                                const isHighlighted = selectedCategory && member.categories.includes(selectedCategory);

                                return (
                                    <motion.div
                                        key={member.id}
                                        className={`relative bg-black/50 backdrop-blur-sm rounded-xl p-4 shadow-xl border border-gray-700 flex flex-col items-center text-center transition-all duration-300 ease-in-out ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400 scale-105' : ''}`}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.8 }}
                                        transition={{ duration: 0.3 }}
                                        whileHover={{ scale: 1.05, boxShadow: '0 0 20px rgba(255,255,255,0.3)' }}
                                    >
                                        <img src={member.photo} alt={member.name} className="w-24 h-24 object-cover rounded-full mb-3 border-2 border-purple-500 shadow-md" />
                                        <h3 className="text-xl font-bold text-pink-300">{member.name}</h3>
                                        <p className="text-sm italic text-gray-300 leading-tight">
                                            {member.role}
                                            <br />
                                            <span className="text-xs text-gray-400">{member.fullRole}</span>
                                        </p>
                                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-3 text-xs w-full max-w-[150px]">
                                            {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                                <div key={stat} className="flex justify-between items-center bg-gray-800 bg-opacity-70 rounded px-1.5 py-0.5">
                                                    <span className="font-semibold text-purple-300">{stat}:</span>
                                                    <span className="font-bold text-white">{value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', scores: { CRE: 18, LOG: 12, CHR: 15, GRT: 14 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', scores: { CRE: 14, LOG: 19, CHR: 10, GRT: 17 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', scores: { CRE: 16, LOG: 13, CHR: 18, GRT: 16 }, categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', scores: { CRE: 15, LOG: 10, CHR: 19, GRT: 13 }, categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', scores: { CRE: 17, LOG: 11, CHR: 16, GRT: 12 }, categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', scores: { CRE: 12, LOG: 18, CHR: 13, GRT: 19 }, categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', scores: { CRE: 16, LOG: 15, CHR: 17, GRT: 15 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', scores: { CRE: 19, LOG: 14, CHR: 15, GRT: 11 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', scores: { CRE: 13, LOG: 20, CHR: 9, GRT: 18 }, categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', scores: { CRE: 20, LOG: 10, CHR: 17, GRT: 13 }, categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', scores: { CRE: 14, LOG: 15, CHR: 19, GRT: 16 }, categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', scores: { CRE: 17, LOG: 13, CHR: 18, GRT: 14 }, categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center text-white text-sm">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm leading-tight">
                                        {member.role}
                                        <br />
                                        <span className="text-xs text-gray-400">{member.fullRole}</span>
                                    </p>
                                    <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-2 text-xs w-full max-w-[120px]">
                                        {member.scores && Object.entries(member.scores).map(([stat, value]) => (
                                            <div key={stat} className="flex justify-between items-center bg-gray-800 bg-opacity-70 rounded px-1 py-0.5">
                                                <span className="font-semibold text-purple-300">{stat}:</span>
                                                <span className="font-bold text-white">{value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Levels)', mantra: 'Innovation gennem leg – sjov er den bedste strategi.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Algorithm Alchemist)', mantra: 'Kode, kaffe og kreative løsninger.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Primary Dream Weaver of Player Experiences)', mantra: 'Fokuser på spilleren, så følger succesen.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Community Sparkle Spreader)', mantra: 'Sammen er vi stærkere, sjovere og mere engagerede.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Kinetic User Experience Sorceress)', mantra: 'Skønhed i detaljen, glæde i oplevelsen.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Keeper of Supreme Logic)', mantra: 'Fejl er muligheder for perfektion.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Service Storyteller)', mantra: 'Datadrevet glæde for spilleren.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Unreal Interface Dreamer)', mantra: 'Intuitivt design, magisk oplevelse.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Illusionist & Inventor)', mantra: 'Robuste systemer, sømløse verdener.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrative & World-Building Wizard)', mantra: 'Fortæl en god historie, og verden vil følge.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Business Unit Dragon)', mantra: 'Vækst og værdi, med et smil!', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Potion Master of Experience)', mantra: 'Glad spiller, glad udvikler.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    
                                    <p className="italic text-sm leading-tight">
                                        {member.role}
                                        <br />
                                        <span className="text-xs text-gray-400">{member.fullRole}</span>
                                    </p>
                                    <p className="mt-2 text-xs text-gray-300">"{member.mantra}"</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                ></motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Grand Architect of Ludicrous Fun)', mantra: 'Innovation gennem leg – sjov er den bedste strategi.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Chief Goblin Inventor)', mantra: 'Kode, kaffe og kreative løsninger.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Pixel Dust Extraordinaire)', mantra: 'Fokuser på spilleren, så følger succesen.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Celestial Sparkle Strategist)', mantra: 'Sammen er vi stærkere, sjovere og mere engagerede.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Keeper of Unhinged Xylophones)', mantra: 'Skønhed i detaljen, glæde i oplevelsen.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Kingly Sparkle Lieutenant)', mantra: 'Fejl er muligheder for perfektion.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Loremaster of Secret Squirrels)', mantra: 'Datadrevet glæde for spilleren.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Ultimate Idea Distributor)', mantra: 'Intuitivt design, magisk oplevelse.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Bigfoot Infrastructure Inspector)', mantra: 'Robuste systemer, sømløse verdener.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Noodle-Wielding Bard)', mantra: 'Fortæl en god historie, og verden vil følge.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Bubblegum Underlord of Development)', mantra: 'Vækst og værdi, med et smil!', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Professional Optimist of Xylophones)', mantra: 'Glad spiller, glad udvikler.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    
                                    <p className="italic text-sm leading-tight">
                                        {member.role}
                                        <br />
                                        <span className="text-xs text-gray-400">{member.fullRole}</span>
                                    </p>
                                    <p className="mt-2 text-xs text-gray-300">"{member.mantra}"</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'GAL', fullRole: '(Gameplay Arkitekt)', mantra: 'Innovation gennem leg – sjov er den bedste strategi.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'CGI', fullRole: '(Core Gameplay Ingeniør)', mantra: 'Kode, kaffe og kreative løsninger.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'PDX', fullRole: '(Produktdirektør)', mantra: 'Fokuser på spilleren, så følger succesen.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'CSS', fullRole: '(Fællesskabsstrateg)', mantra: 'Sammen er vi stærkere, sjovere og mere engagerede.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'KUX', fullRole: '(Koncept- & UX-kunstner)', mantra: 'Skønhed i detaljen, glæde i oplevelsen.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'KSL', fullRole: '(Kvalitetssikringsleder)', mantra: 'Fejl er muligheder for perfektion.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LSS', fullRole: '(Live Services Specialist)', mantra: 'Datadrevet glæde for spilleren.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UID', fullRole: '(Brugerflade Designer)', mantra: 'Intuitivt design, magisk oplevelse.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'BII', fullRole: '(Backend Infrastruktur Ingeniør)', mantra: 'Robuste systemer, sømløse verdener.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'NWB', fullRole: '(Narrativ & World Builder)', mantra: 'Fortæl en god historie, og verden vil følge.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'BUD', fullRole: '(Forretningsudvikler)', mantra: 'Vækst og værdi, med et smil!', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'POX', fullRole: '(Spilleroplevelseschef)', mantra: 'Glad spiller, glad udvikler.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                   
                                    <p className="italic text-sm leading-tight">
                                        {member.role}
                                        <br />
                                        <span className="text-xs text-gray-400">{member.fullRole}</span>
                                    </p>
                                    <p className="mt-2 text-xs text-gray-300">Mantra: "{member.mantra}"</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', mantra: 'Innovation gennem leg – sjov er den bedste strategi.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', mantra: 'Kode, kaffe og kreative løsninger.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', mantra: 'Fokuser på spilleren, så følger succesen.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', mantra: 'Sammen er vi stærkere, sjovere og mere engagerede.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', mantra: 'Skønhed i detaljen, glæde i oplevelsen.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', mantra: 'Fejl er muligheder for perfektion.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', mantra: 'Datadrevet glæde for spilleren.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', mantra: 'Intuitivt design, magisk oplevelse.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', mantra: 'Robuste systemer, sømløse verdener.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', mantra: 'Fortæl en god historie, og verden vil følge.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', mantra: 'Vækst og værdi, med et smil!', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', mantra: 'Glad spiller, glad udvikler.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">"{member.mantra}"</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10;
const PHOTO_SIZE = 144;
const PHOTO_BUFFER = 20;
const RESIZE_DEBOUNCE_TIME = 200;
const BURST_DURATION = 600;
const DECAY_INTERVAL = 500;
const DECAY_AMOUNT = 1;

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />,
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image',
        link: '#',
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image',
        link: '#',
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image',
        link: '#',
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image',
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image',
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed from hoveredCategory
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null);
    const gamesInDevelopmentRef = useRef(null);

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);

    const handleMainButtonClick = useCallback(() => {
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150);

        setLastClickTimestamp(Date.now());

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'],
                })
            );
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0);
                setPositions(memoizedGeneratePositions());
            }, BURST_DURATION);
            return;
        }

        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const handleInfoBoxClick = useCallback((item) => {
        if (selectedCategory === item.category) {
            // If the same box is clicked, deselect it
            setSelectedCategory(null);
            setCurrentNavInfo(null);
        } else {
            // Select a new box
            setSelectedCategory(item.category);
            setCurrentNavInfo({
                id: item.id,
                title: item.title,
                info: item.info,
                borderColor: item.colors.border,
                bgColor: item.colors.background,
            });
        }
    }, [selectedCategory]); // Depend on selectedCategory to re-create if it changes

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;

    // Use selectedCategory instead of hoveredCategory for highlighting photos
    const currentHighlightedCategory = selectedCategory;

    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Use currentHighlightedCategory for photo highlighting
                    const isHighlighted = currentHighlightedCategory && member.categories.includes(currentHighlightedCategory);
                    const photoOpacity = isHighlighted || !currentHighlightedCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>

                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>

                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>

                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    // Use selectedCategory for box shadow
                                    boxShadow: selectedCategory === item.category ? `0 0 15px ${item.colors.border}, 0 0 5px 2px ${item.colors.border}` : 'none',
                                }}
                                onClick={() => handleInfoBoxClick(item)} // Changed to onClick
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>

            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Added FaChevronDown and FaChevronUp
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // Du kan justere dette for en længere spiloplevelse, f.eks. 20 eller 30
const PHOTO_SIZE = 144; // Fast størrelse på billedet i pixels
const PHOTO_BUFFER = 20; // Minimum plads i pixels mellem billeder
const RESIZE_DEBOUNCE_TIME = 200; // millisekunder for at undgå overflødige resize events
const BURST_DURATION = 600; // millisekunder for konfetti-animation og billed-nulstilling
const DECAY_INTERVAL = 500; // millisekunder: hvor ofte klik falder (øget fra 300ms)
const DECAY_AMOUNT = 1; // hvor mange klik mistes pr. forfaldsinterval

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />, // Brugt lightbulb for innovation/udvikling
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image', // Placeholder image
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image', // Placeholder image
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null); // Ref for the "Our Games" section
    const gamesInDevelopmentRef = useRef(null); // New ref for "Games in Development" section

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    // --- New: Scroll to top on component mount ---
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' }); // 'auto' for instant scroll, 'smooth' for animated
    }, []); // Empty dependency array ensures this runs only once on mount


    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                // Decay only if enough time has passed since the last click
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);


    const handleMainButtonClick = useCallback(() => {
        // Trigger button animation
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

        setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
                })
            );
            // Immediately hide photos for a smoother transition to burst
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0); // Reset clicks only after burst
                setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
            }, BURST_DURATION);
            return;
        }

        // Clicks simply increment from current value
        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;
    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToGamesInDevelopment = () => {
        gamesInDevelopmentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Sikrer at en foto fremhæves hvis den matcher en af dens kategorier med den hovered category
                    const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
                    const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>


            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>


                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>


                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>


                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                                }}
                                onMouseEnter={() => {
                                    setHoveredCategory(item.category);
                                    setCurrentNavInfo({
                                        id: item.id,
                                        title: item.title,
                                        info: item.info,
                                        borderColor: item.colors.border,
                                        bgColor: item.colors.background,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setHoveredCategory(null);
                                    setCurrentNavInfo(null);
                                }}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                

                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            
            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>

                
                <motion.button
                    className="mt-12 p-4 bg-blue-700 rounded-full shadow-lg hover:bg-blue-600 transition-colors"
                    onClick={scrollToGamesInDevelopment}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll to games in development"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </section>

            
            <section ref={gamesInDevelopmentRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>

                
                <motion.button
                    className="mt-12 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToTop}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.5 }}
                    aria-label="Scroll back to top"
                >
                    <FaChevronUp size={30} className="text-white" />
                </motion.button>
            </section>


            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown } from 'react-icons/fa'; // Added FaChevronDown
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // Du kan justere dette for en længere spiloplevelse, f.eks. 20 eller 30
const PHOTO_SIZE = 144; // Fast størrelse på billedet i pixels
const PHOTO_BUFFER = 20; // Minimum plads i pixels mellem billeder
const RESIZE_DEBOUNCE_TIME = 200; // millisekunder for at undgå overflødige resize events
const BURST_DURATION = 600; // millisekunder for konfetti-animation og billed-nulstilling
const DECAY_INTERVAL = 500; // millisekunder: hvor ofte klik falder (øget fra 300ms)
const DECAY_AMOUNT = 1; // hvor mange klik mistes pr. forfaldsinterval

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />, // Brugt lightbulb for innovation/udvikling
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image', // Placeholder image
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image', // Placeholder image
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null); // Ref for the "Our Games" section

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                // Decay only if enough time has passed since the last click
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);


    const handleMainButtonClick = useCallback(() => {
        // Trigger button animation
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

        setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
                })
            );
            // Immediately hide photos for a smoother transition to burst
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0); // Reset clicks only after burst
                setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
            }, BURST_DURATION);
            return;
        }

        // Clicks simply increment from current value
        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;
    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Sikrer at en foto fremhæves hvis den matcher en af dens kategorier med den hovered category
                    const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
                    const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>


            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>


                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>


                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>


                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                                }}
                                onMouseEnter={() => {
                                    setHoveredCategory(item.category);
                                    setCurrentNavInfo({
                                        id: item.id,
                                        title: item.title,
                                        info: item.info,
                                        borderColor: item.colors.border,
                                        bgColor: item.colors.background,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setHoveredCategory(null);
                                    setCurrentNavInfo(null);
                                }}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                
                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            
            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>
            </section>

            
            <section className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>
            </section>


            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown } from 'react-icons/fa'; // Added FaChevronDown
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // Du kan justere dette for en længere spiloplevelse, f.eks. 20 eller 30
const PHOTO_SIZE = 144; // Fast størrelse på billedet i pixels
const PHOTO_BUFFER = 20; // Minimum plads i pixels mellem billeder
const RESIZE_DEBOUNCE_TIME = 200; // millisekunder for at undgå overflødige resize events
const BURST_DURATION = 600; // millisekunder for konfetti-animation og billed-nulstilling
const DECAY_INTERVAL = 500; // millisekunder: hvor ofte klik falder (øget fra 300ms)
const DECAY_AMOUNT = 1; // hvor mange klik mistes pr. forfaldsinterval

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />, // Brugt lightbulb for innovation/udvikling
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image', // Placeholder image
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image', // Placeholder image
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null); // Ref for the "Our Games" section

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                // Decay only if enough time has passed since the last click
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);


    const handleMainButtonClick = useCallback(() => {
        // Trigger button animation
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

        setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
                })
            );
            // Immediately hide photos for a smoother transition to burst
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0); // Reset clicks only after burst
                setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
            }, BURST_DURATION);
            return;
        }

        // Clicks simply increment from current value
        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;
    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Sikrer at en foto fremhæves hvis den matcher en af dens kategorier med den hovered category
                    const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
                    const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>


            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>


                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>


                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>


                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                                }}
                                onMouseEnter={() => {
                                    setHoveredCategory(item.category);
                                    setCurrentNavInfo({
                                        id: item.id,
                                        title: item.title,
                                        info: item.info,
                                        borderColor: item.colors.border,
                                        bgColor: item.colors.background,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setHoveredCategory(null);
                                    setCurrentNavInfo(null);
                                }}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                
                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            
            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>
            </section>

            
            <section className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>
            </section>


            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine, FaChevronDown } from 'react-icons/fa'; // Added FaChevronDown
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // Du kan justere dette for en længere spiloplevelse, f.eks. 20 eller 30
const PHOTO_SIZE = 144; // Fast størrelse på billedet i pixels
const PHOTO_BUFFER = 20; // Minimum plads i pixels mellem billeder
const RESIZE_DEBOUNCE_TIME = 200; // millisekunder for at undgå overflødige resize events
const BURST_DURATION = 600; // millisekunder for konfetti-animation og billed-nulstilling
const DECAY_INTERVAL = 500; // millisekunder: hvor ofte klik falder (øget fra 300ms)
const DECAY_AMOUNT = 1; // hvor mange klik mistes pr. forfaldsinterval

// --- Team Member Data ---
const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
    { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
    { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
    { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
    { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
    { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
    { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
    {
        id: 'creativityDesign',
        icon: <FaPaintBrush size={40} />,
        title: 'Kreativitet & Design',
        info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
        category: 'creativityDesign',
        colors: {
            border: '#7c3aed', // purple-700
            background: '#4c1d95', // purple-900
        },
    },
    {
        id: 'teamworkCommunity',
        icon: <FaUsers size={40} />,
        title: 'Samarbejde & Fællesskab',
        info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
        category: 'teamworkCommunity',
        colors: {
            border: '#9333ea', // fuchsia-700
            background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
        },
    },
    {
        id: 'innovationDevelopment',
        icon: <FaLightbulb size={40} />, // Brugt lightbulb for innovation/udvikling
        title: 'Innovation & Udvikling',
        info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
        category: 'innovationDevelopment',
        colors: {
            border: '#facc15', // yellow-400
            background: '#713f12', // amber-900
        },
    },
    {
        id: 'visionProgress',
        icon: <FaChartLine size={40} />,
        title: 'Vision & Fremdrift',
        info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
        category: 'visionProgress',
        colors: {
            border: '#22d3ee', // cyan-400
            background: '#0e7490', // cyan-700
        },
    },
];

// --- Placeholder Game Data ---
const developedGames = [
    {
        id: 1,
        title: 'Starfall Tactics',
        description: 'An exhilarating real-time strategy game set in a distant galaxy, combining deep tactical combat with extensive fleet customization. Winner of "Indie Game of the Year" 2023.',
        image: 'https://via.placeholder.com/300x200/4a0e71/ffffff?text=Game+1+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 2,
        title: 'Whispering Woods',
        description: 'A cozy life simulation game where players build their dream farm, interact with charming forest creatures, and uncover ancient mysteries. Loved by players for its relaxing gameplay.',
        image: 'https://via.placeholder.com/300x200/1e3b8a/ffffff?text=Game+2+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
    {
        id: 3,
        title: 'Neon Drift Racers',
        description: 'High-octane arcade racing with stunning neon visuals and a pumping synthwave soundtrack. Master the art of drifting and dominate the leaderboards.',
        image: 'https://via.placeholder.com/300x200/7a042e/ffffff?text=Game+3+Image', // Placeholder image
        link: '#', // Replace with actual game link
    },
];

const gamesInDevelopment = [
    {
        id: 101,
        title: 'Project Aurora',
        description: 'An ambitious open-world RPG focusing on player choice and emergent storytelling. Currently in early alpha with a strong emphasis on community feedback.',
        image: 'https://via.placeholder.com/300x200/4f0e71/ffffff?text=Dev+Game+1+Image', // Placeholder image
        status: 'Alpha Testing',
    },
    {
        id: 102,
        title: 'Mythic Mayhem',
        description: 'A fast-paced, competitive arena brawler featuring mythical creatures and unique abilities. Expect intense 3v3 and 5v5 battles.',
        image: 'https://via.placeholder.com/300x200/1e3b5a/ffffff?text=Dev+Game+2+Image', // Placeholder image
        status: 'Concept & Prototyping',
    },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
    const positions = [];
    const w = window.innerWidth;
    const h = window.innerHeight;
    const effectivePhotoDim = photoSize + buffer;
    const MAX_PLACEMENT_TRIES = 500;

    for (const member of team) {
        let newX, newY;
        let foundPosition = false;
        let tries = 0;

        while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
            newX = Math.random() * (w - photoSize);
            newY = Math.random() * (h - photoSize);

            // Check for overlap with the central UI exclusion zone
            const overlapsExclusion =
                newX < exclusionZone.x + exclusionZone.width &&
                newX + photoSize > exclusionZone.x &&
                newY < exclusionZone.y + exclusionZone.height &&
                newY + photoSize > exclusionZone.y;

            if (overlapsExclusion) {
                tries++;
                continue;
            }

            // Check for overlap with existing photos
            let overlapsExistingPhotos = false;
            for (const p of positions) {
                const pLeftPx = parseFloat(p.left) / 100 * w;
                const pTopPx = parseFloat(p.top) / 100 * h;

                if (
                    newX < pLeftPx + effectivePhotoDim &&
                    newX + effectivePhotoDim > pLeftPx &&
                    newY < pTopPx + effectivePhotoDim &&
                    newY + effectivePhotoDim > pTopPx
                ) {
                    overlapsExistingPhotos = true;
                    break;
                }
            }

            if (!overlapsExistingPhotos) {
                foundPosition = true;
                positions.push({
                    id: member.id,
                    top: `${(newY / h) * 100}%`,
                    left: `${(newX / w) * 100}%`,
                });
            }
            tries++;
        }

        if (!foundPosition) {
            console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
            positions.push({
                id: member.id,
                top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
                left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
            });
        }
    }
    return positions;
};

// --- Main App Component ---
export default function App() {
    const [clicks, setClicks] = useState(0);
    const [isInflated, setIsInflated] = useState(false);
    const [isBursting, setIsBursting] = useState(false);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [currentNavInfo, setCurrentNavInfo] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

    const gamesSectionRef = useRef(null); // Ref for the "Our Games" section

    const centralUIExclusion = useMemo(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        return {
            x: w * 0.25,
            y: h * 0.15,
            width: w * 0.50,
            height: h * 0.70,
        };
    }, []);

    const memoizedGeneratePositions = useCallback(
        () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
        [centralUIExclusion]
    );

    const [positions, setPositions] = useState(memoizedGeneratePositions);

    const resizeTimerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(resizeTimerRef.current);
            resizeTimerRef.current = setTimeout(() => {
                setPositions(memoizedGeneratePositions());
            }, RESIZE_DEBOUNCE_TIME);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimerRef.current);
        };
    }, [memoizedGeneratePositions]);

    // Effect for progress decay when idle
    useEffect(() => {
        let decayInterval;
        if (clicks > 0 && !isInflated) {
            decayInterval = setInterval(() => {
                const now = Date.now();
                // Decay only if enough time has passed since the last click
                if (now - lastClickTimestamp > DECAY_INTERVAL) {
                    setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
                }
            }, DECAY_INTERVAL);
        }
        return () => clearInterval(decayInterval);
    }, [clicks, isInflated, lastClickTimestamp]);


    const handleMainButtonClick = useCallback(() => {
        // Trigger button animation
        setIsButtonClicked(true);
        setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

        setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

        if (isInflated) {
            setIsBursting(true);
            positions.forEach(pos =>
                confetti({
                    particleCount: 60,
                    spread: 120,
                    origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
                    colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
                })
            );
            // Immediately hide photos for a smoother transition to burst
            setPositions([]);
            setTimeout(() => {
                setIsBursting(false);
                setIsInflated(false);
                setClicks(0); // Reset clicks only after burst
                setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
            }, BURST_DURATION);
            return;
        }

        // Clicks simply increment from current value
        setClicks(prev => {
            const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
            if (nextClicks >= REQUIRED_CLICKS) {
                setIsInflated(true);
            }
            return nextClicks;
        });
    }, [isInflated, positions, memoizedGeneratePositions]);

    const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
    const showPhotos = clicks > 0 || isInflated;
    const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

    const scrollToGames = () => {
        gamesSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="relative min-h-screen font-sans text-white overflow-x-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

            <AnimatePresence>
                {!isBursting && showPhotos && positions.map(pos => {
                    const member = teamMembers.find(t => t.id === pos.id);
                    if (!member) return null;

                    // Sikrer at en foto fremhæves hvis den matcher en af dens kategorier med den hovered category
                    const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
                    const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

                    const currentPhotoScale = isHighlighted
                        ? 1.1
                        : (isInflated
                            ? 1
                            : photoScaleFactor);

                    const photoVariants = {
                        initial: { scale: 0.3, opacity: 0 },
                        animate: {
                            scale: currentPhotoScale,
                            opacity: photoOpacity,
                            transition: {
                                type: 'spring',
                                stiffness: 120,
                                damping: 20,
                                ...(isInflated && !isBursting && {
                                    scale: { duration: 0.3, ease: 'easeOut' }
                                })
                            }
                        },
                        exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
                    };

                    return (
                        <motion.div
                            key={member.id}
                            variants={photoVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
                            style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
                        >
                            <div className="relative group w-full h-full">
                                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />

                                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                                    <p className="font-bold text-lg">{member.name}</p>
                                    <p className="italic text-sm">{member.role}</p>
                                    <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </AnimatePresence>


            <div className="relative z-30 flex flex-col items-center min-h-screen">

                <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
                    <div className="flex items-center space-x-2 md:space-x-4">
                        <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
                        <div className="flex flex-col items-end">
                            <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
                            <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
                        </div>
                    </div>


                    <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
                        <AnimatePresence mode="wait">
                            {currentNavInfo ? (
                                <motion.div
                                    key={currentNavInfo.id}
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2 rounded-lg"
                                    style={{
                                        borderColor: currentNavInfo.borderColor,
                                        backgroundColor: currentNavInfo.bgColor,
                                        borderWidth: '1px'
                                    }}
                                >
                                    <p className="text-base font-semibold">{currentNavInfo.title}</p>
                                    <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="default-nav-info"
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.2 }}
                                    className="p-2"
                                >
                                    <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <div className="w-16 md:w-24" />
                </nav>


                <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
                    <motion.h1
                        className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
                    >
                        Spil. Hyg. Fejr!
                    </motion.h1>

                    <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
                        Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
                    </p>


                    <div className="mt-8 w-full max-w-sm md:max-w-md">
                        <motion.button
                            onClick={handleMainButtonClick}
                            className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
                            style={{
                                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                                backgroundSize: '200% 200%',
                                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
                            }}
                            whileTap={{ scale: 0.95 }}
                            animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
                            transition={{ duration: 0.1 }}
                            aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
                        >
                            <motion.div
                                className="absolute inset-0 bg-white bg-opacity-20"
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                            <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
                        </motion.button>

                        <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
                            <motion.div
                                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                                animate={{ width: `${progressPercentage}%` }}
                                transition={{ type: 'tween', duration: 0.2 }}
                            />
                        </div>
                        <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
                    </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
                        {infoBoxesData.map((item) => (
                            <motion.div
                                key={item.id}
                                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                                style={{
                                    borderColor: item.colors.border,
                                    backgroundColor: item.colors.background,
                                    boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                                }}
                                onMouseEnter={() => {
                                    setHoveredCategory(item.category);
                                    setCurrentNavInfo({
                                        id: item.id,
                                        title: item.title,
                                        info: item.info,
                                        borderColor: item.colors.border,
                                        bgColor: item.colors.background,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setHoveredCategory(null);
                                    setCurrentNavInfo(null);
                                }}
                            >
                                <span className="text-white mb-2">{item.icon}</span>
                                <span className="font-bold text-base leading-tight">{item.title}</span>
                            </motion.div>
                        ))}
                    </section>
                </header>

                
                <motion.button
                    className="absolute bottom-8 md:bottom-12 z-50 p-4 bg-purple-700 rounded-full shadow-lg hover:bg-purple-600 transition-colors"
                    onClick={scrollToGames}
                    initial={{ y: 0 }}
                    animate={{ y: [0, -10, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                    aria-label="Scroll down to games section"
                >
                    <FaChevronDown size={30} className="text-white" />
                </motion.button>
            </div>

            
            <section ref={gamesSectionRef} className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-indigo-900 to-blue-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg">
                    Vores Spil
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
                    {developedGames.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-purple-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-pink-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <a href={game.link} target="_blank" rel="noopener noreferrer"
                                className="mt-auto inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300">
                                Læs Mere
                            </a>
                        </motion.div>
                    ))}
                </div>
            </section>

            
            <section className="w-full py-20 px-4 md:px-8 bg-gradient-to-br from-blue-900 to-purple-900 text-white min-h-screen flex flex-col items-center justify-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-400 drop-shadow-lg">
                    Spil Under Udvikling
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
                    {gamesInDevelopment.map(game => (
                        <motion.div
                            key={game.id}
                            className="bg-black/40 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-cyan-700 flex flex-col items-center text-center"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.6 }}
                        >
                            <img src={game.image} alt={game.title} className="w-full h-48 object-cover rounded-lg mb-4 shadow-md" />
                            <h3 className="text-2xl font-bold mb-2 text-cyan-300">{game.title}</h3>
                            <p className="text-gray-300 text-sm mb-4 flex-grow">{game.description}</p>
                            <span className="mt-auto inline-block bg-cyan-600 text-white font-semibold py-1 px-4 rounded-full text-sm">
                                Status: {game.status}
                            </span>
                        </motion.div>
                    ))}
                </div>
            </section>


            <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaChartLine } from 'react-icons/fa'; // FaCode fjernet, da "Udvikling" nu er under "Innovation & Udvikling"
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // Du kan justere dette for en længere spiloplevelse, f.eks. 20 eller 30
const PHOTO_SIZE = 144; // Fast størrelse på billedet i pixels
const PHOTO_BUFFER = 20; // Minimum plads i pixels mellem billeder
const RESIZE_DEBOUNCE_TIME = 200; // millisekunder for at undgå overflødige resize events
const BURST_DURATION = 600; // millisekunder for konfetti-animation og billed-nulstilling
const DECAY_INTERVAL = 500; // millisekunder: hvor ofte klik falder (øget fra 300ms)
const DECAY_AMOUNT = 1; // hvor mange klik mistes pr. forfaldsinterval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Gameplay Arkitekt', bio: 'Formulerer engagerende spilkoncepter og intuitive mekanikker, der forbinder spillere.', categories: ['creativityDesign', 'innovationDevelopment'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Core Gameplay Ingeniør', bio: 'Gør spilvisioner til virkelighed med robust og optimeret kode, der sikrer flydende oplevelser.', categories: ['innovationDevelopment', 'visionProgress'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktdirektør', bio: 'Styrer spillets overordnede retning og køreplan med fokus på spillerbehov og strategisk vækst.', categories: ['teamworkCommunity', 'visionProgress'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsstrateg', bio: 'Opbygger og plejer stærke spillerfællesskaber gennem aktiv dialog og engagement.', categories: ['teamworkCommunity', 'creativityDesign'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Koncept- & UX-kunstner', bio: 'Visualiserer nye spilverdener og karakterer, mens hun sikrer intuitive brugeroplevelser.', categories: ['creativityDesign', 'innovationDevelopment'] },
  { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Kvalitetssikringsleder', bio: 'Sikrer polerede og fejlfri spiloplevelser ved at systematisere testprocesser og feedback.', categories: ['teamworkCommunity', 'innovationDevelopment'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Live Services Specialist', bio: 'Optimerer spillerengagement og fastholdelse gennem datadrevet indsigt og løbende opdateringer.', categories: ['innovationDevelopment', 'visionProgress'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Brugerflade Designer', bio: 'Udvikler intuitive og æstetiske brugerflader, der forbedrer spilbarheden og oplevelsen.', categories: ['creativityDesign', 'teamworkCommunity'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend Infrastruktur Ingeniør', bio: 'Bygger og vedligeholder den skalerbare serverinfrastruktur, der understøtter vores spil.', categories: ['innovationDevelopment', 'visionProgress'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ & World Builder', bio: 'Fletter fængslende historier og dybe verdener ind i vores spil, der fanger fantasien.', categories: ['creativityDesign', 'teamworkCommunity'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Forretningsudvikler', bio: 'Udvikler fair og engagerende monetiseringsmodeller samt strategiske partnerskaber.', categories: ['visionProgress', 'teamworkCommunity'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spilleroplevelseschef', bio: 'Yder enestående support og sikrer en positiv rejse for alle vores spillere.', categories: ['teamworkCommunity', 'visionProgress'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativityDesign',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design',
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser** gennem innovativt design og fængslende kunst. Vi elsker at udforske nye idéer og visuelle stilarter.',
    category: 'creativityDesign',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamworkCommunity',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen og opbygge relationer.',
    category: 'teamworkCommunity',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'innovationDevelopment',
    icon: <FaLightbulb size={40} />, // Brugt lightbulb for innovation/udvikling
    title: 'Innovation & Udvikling',
    info: 'Vi driver kontinuerlig innovation ved at udforske **nye teknologier og banebrydende idéer**. Vores robuste udvikling sikrer, at vi skaber unikke og fremtidssikre spiloplevelser.',
    category: 'innovationDevelopment',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
  {
    id: 'visionProgress',
    icon: <FaChartLine size={40} />,
    title: 'Vision & Fremdrift',
    info: 'Vi har et **klart formål og en tydelig retning** for vores spil og forretning. Vi omsætter strategiske indsigter til handlingsplaner, der sikrer Kløgtigs succes og vækst.',
    category: 'visionProgress',
    colors: {
      border: '#22d3ee', // cyan-400
      background: '#0e7490', // cyan-700
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          // Sikrer at en foto fremhæves hvis den matcher en af dens kategorier med den hovered category
          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
       
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

         
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

        
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

  
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaTrophy } from 'react-icons/fa'; // FaTrophy replaced with FaCode
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Skaber af spilverden og fællesskab', bio: 'Fokuserer på spilmekanikker og sociale oplevelser.', categories: ['creativity', 'teamwork'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Bygger det tekniske fundament', bio: 'Gør idéer til virkelighed gennem kode.', categories: ['code', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Holder kursen', bio: 'Sikrer at visionen og teamet hænger sammen.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Skaber relationer og sammenhold', bio: 'Fremmer fællesskab og dialog med spillere.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Visualiserer nye verdener', bio: 'Omsætter idéer til levende universer.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'Forfiner og forbedrer oplevelser', bio: 'Sikrer kvalitet og gnidningsfri gameplay.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Optimerer spilleroplevelser', bio: 'Finder måder at holde spillere engagerede.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'Designer flow og følelse', bio: 'Skaber intuitive og æstetiske brugerrejser.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Holder serverne kørende', bio: 'Sørger for robust infrastruktur og backend.', categories: ['teamwork', 'code'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Skriver spillets stemme', bio: 'Fletter historier ind i oplevelsen.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Skaber bæredygtige spilsystemer', bio: 'Udvikler motiverende modeller og økonomier.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Støtter spillerne hele vejen', bio: 'Lytter og hjælper, når noget går galt.', categories: ['teamwork', 'inspiration'] },
];


// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Udtryk',
    info: 'Vi skaber **spændende spilverden og visuelt udtryk**, hvor idéer vokser til oplevelser. Vores styrke ligger i at tænke frit og gøre det legende og levende.',
    category: 'creativity',
    colors: {
      border: '#7c3aed',
      background: '#4c1d95',
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab',
    info: '**Gode spil skabes sammen.** Vi arbejder i harmoni, deler ansvar og hjælper hinanden. Vores fællesskab skinner igennem i alt, vi bygger.',
    category: 'teamwork',
    colors: {
      border: '#9333ea',
      background: '#5b21b6',
    },
  },
  {
    id: 'code',
    icon: <FaTrophy size={40} />, // Optional: consider FaCode or FaTerminal instead
    title: 'Teknik & Struktur',
    info: 'Bag det legende ligger **solid kode og arkitektur**, som holder spillet kørende. Vi bygger med omtanke for både spilleroplevelsen og fremtiden.',
    category: 'code',
    colors: {
      border: '#db2777',
      background: '#831843',
    },
  },
  {
    id: 'innovation',
    icon: <FaLightbulb size={40} />,
    title: 'Nysgerrighed & Fornyelse',
    info: 'Vi er drevet af nysgerrighed og lysten til at prøve nyt. Fra teknologi til idéudvikling søger vi at **forny spiloplevelser og skabe noget unikt**.',
    category: 'innovation',
    colors: {
      border: '#facc15',
      background: '#713f12',
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

        
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, er vi dedikeret til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaLightbulb, FaCode } from 'react-icons/fa'; // FaTrophy replaced with FaCode
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Spildesigner', bio: 'Skaber fængslende gameplay og sociale mekanikker.', categories: ['creativity', 'teamwork'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Gameplay Programmør', bio: 'Gør spildesign til virkelighed med robust kode.', categories: ['code', 'innovation'] }, // Changed category to 'code'
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktejer', bio: 'Styrer spillets vision og køreplan.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsmanager', bio: 'Forbinder sig med spillere og fremmer fællesskab.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Konceptkunstner', bio: 'Visualiserer nye spilverdener og karakterer.', categories: ['creativity', 'inspiration'] },
  { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA-leder', bio: 'Sikrer polerede og fejlfri spiloplevelser.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LiveOps Specialist', bio: 'Optimerer spillerengagement og fastholdelse.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX/UI Designer', bio: 'Udvikler intuitive brugerflader og oplevelser.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend-ingeniør', bio: 'Bygger og vedligeholder serverinfrastrukturen.', categories: ['teamwork', 'code'] }, // Changed category to 'code'
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ Designer', bio: 'Fletter fængslende historier ind i vores spil.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Indtægtsstrateg', bio: 'Udvikler fair og engagerende monetiseringsmodeller.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spillerstøttechef', bio: 'Yder enestående support til vores spillere.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet & Design', // Soft value
    info: 'Vi brænder for at skabe **originale og engagerende spiloplevelser**, der inspirerer og fanger fantasien. Vi elsker at tænke ud af boksen og udforske nye idéer.', // Soft value description
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Samarbejde & Fællesskab', // Soft value
    info: 'Vores succes bygger på **stærkt samarbejde og et inkluderende fællesskab**, både internt og med vores spillere. Vi tror på at nå store ting sammen.', // Soft value description
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'code',
    icon: <FaCode size={40} />, // Changed icon from FaTrophy to FaCode
    title: 'Innovation & Udvikling', // Soft value
    info: 'Vi driver vores spil med **robust og nytænkende teknologi**, sikrer en stabil platform og skaber de bedste digitale oplevelser gennem dygtig ingeniørkunst.', // Soft value description
    category: 'code',
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'innovation',
    icon: <FaLightbulb size={40} />,
    title: 'Vision & Fremdrift', // Soft value
    info: 'Fra nye trends til spillerfeedback finder vi inspiration overalt til at innovere. Vi sigter mod at skabe spil, der ikke kun underholder, men også **inspirerer til forbindelse, kreativitet og varige minder** for spillere over hele verden.', // Soft value description
    category: 'innovation',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

        
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, er vi dedikeret til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Spildesigner', bio: 'Skaber fængslende gameplay og sociale mekanikker.', categories: ['creativity', 'teamwork'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Gameplay Programmør', bio: 'Gør spildesign til virkelighed med robust kode.', categories: ['code', 'innovation'] }, // Changed category to 'code'
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktejer', bio: 'Styrer spillets vision og køreplan.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsmanager', bio: 'Forbinder sig med spillere og fremmer fællesskab.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Konceptkunstner', bio: 'Visualiserer nye spilverdener og karakterer.', categories: ['creativity', 'inspiration'] },
  { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA-leder', bio: 'Sikrer polerede og fejlfri spiloplevelser.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LiveOps Specialist', bio: 'Optimerer spillerengagement og fastholdelse.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX/UI Designer', bio: 'Udvikler intuitive brugerflader og oplevelser.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend-ingeniør', bio: 'Bygger og vedligeholder serverinfrastrukturen.', categories: ['teamwork', 'code'] }, // Changed category to 'code'
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ Designer', bio: 'Fletter fængslende historier ind i vores spil.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Indtægtsstrateg', bio: 'Udvikler fair og engagerende monetiseringsmodeller.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spillerstøttechef', bio: 'Yder enestående support til vores spillere.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Spildesign & Kunst',
    info: 'Vi skaber **engagerende spilmekanikker og levende kunststile**, der fanger fantasien og får spillere til at vende tilbage efter mere social sjov. Originale idéer er vores legeplads!',
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Teamsynergi & Fællesskab',
    info: 'Vores studie trives med **samarbejde og fælles mål**, ligesom de bedste multiplayer-spil. Vi arbejder som ét team for at opbygge stærke fællesskaber i spillet og fantastiske sociale oplevelser.',
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'code', // Changed ID to 'code'
    icon: <FaTrophy size={40} />, // You might want a different icon for code, e.g., FaCode or FaTerminal
    title: 'Kode & Arkitektur', // Changed title
    info: 'Vi skriver **robust og skalerbar kode** for at drive vores spil, sikrer stabil infrastruktur og implementerer innovative løsninger for en gnidningsfri spiloplevelse.', // New info text
    category: 'code', // Changed category to 'code'
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'innovation',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Teknologi',
    info: 'Fra nye trends til spillerfeedback finder vi inspiration overalt til at innovere. Vi sigter mod at skabe spil, der ikke kun underholder, men også **inspirerer til forbindelse, kreativitet og varige minder** for spillere over hele verden.',
    category: 'innovation',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

       
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

   
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Spildesigner', bio: 'Skaber fængslende gameplay og sociale mekanikker.', categories: ['creativity', 'teamwork'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Gameplay Programmør', bio: 'Gør spildesign til virkelighed med robust kode.', categories: ['code', 'innovation'] }, // Changed category to 'code'
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Produktejer', bio: 'Styrer spillets vision og køreplan.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Fællesskabsmanager', bio: 'Forbinder sig med spillere og fremmer fællesskab.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Konceptkunstner', bio: 'Visualiserer nye spilverdener og karakterer.', categories: ['creativity', 'inspiration'] },
  { id: 6, 'name': 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA-leder', bio: 'Sikrer polerede og fejlfri spiloplevelser.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'LiveOps Specialist', bio: 'Optimerer spillerengagement og fastholdelse.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX/UI Designer', bio: 'Udvikler intuitive brugerflader og oplevelser.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'Backend-ingeniør', bio: 'Bygger og vedligeholder serverinfrastrukturen.', categories: ['teamwork', 'code'] }, // Changed category to 'code'
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Narrativ Designer', bio: 'Fletter fængslende historier ind i vores spil.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Indtægtsstrateg', bio: 'Udvikler fair og engagerende monetiseringsmodeller.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Spillerstøttechef', bio: 'Yder enestående support til vores spillere.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Spildesign & Kunst',
    info: 'Vi skaber **engagerende spilmekanikker og levende kunststile**, der fanger fantasien og får spillere til at vende tilbage efter mere social sjov. Originale idéer er vores legeplads!',
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Teamsynergi & Fællesskab',
    info: 'Vores studie trives med **samarbejde og fælles mål**, ligesom de bedste multiplayer-spil. Vi arbejder som ét team for at opbygge stærke fællesskaber i spillet og fantastiske sociale oplevelser.',
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'code', // Changed ID to 'code'
    icon: <FaTrophy size={40} />, // You might want a different icon for code, e.g., FaCode or FaTerminal
    title: 'Kode & Arkitektur', // Changed title
    info: 'Vi skriver **robust og skalerbar kode** for at drive vores spil, sikrer stabil infrastruktur og implementerer innovative løsninger for en gnidningsfri spiloplevelse.', // New info text
    category: 'code', // Changed category to 'code'
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'innovation',
    icon: <FaLightbulb size={40} />,
    title: 'Innovation & Teknologi',
    info: 'Fra nye trends til spillerfeedback finder vi inspiration overalt til at innovere. Vi sigter mod at skabe spil, der ikke kun underholder, men også **inspirerer til forbindelse, kreativitet og varige minder** for spillere over hele verden.',
    category: 'innovation',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

       
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

   
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['competition', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['teamwork', 'innovation'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'We craft **engaging game mechanics and vibrant art styles** that capture imaginations and keep players coming back for more social fun. Original ideas are our playground!',
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Our studio thrives on **collaboration and shared goals**, just like the best multiplayer games. We work as one team to build strong in-game communities and fantastic social experiences.',
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'We embrace **friendly rivalry and dynamic challenges** both in our games and our development process. This drives us to create competitive leaderboards, thrilling events, and continuously improve our craft.',
    category: 'competition',
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'From emerging trends to player feedback, we find inspiration everywhere to innovate. We aim to create games that not only entertain but also **inspire connection, creativity, and lasting memories** for players worldwide.',
    category: 'inspiration',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

       
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

         
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punktèr Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

        
          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

 
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['competition', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['teamwork', 'innovation'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements within our studio and **the multiplayer worlds we build**.',
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and **drives innovation**. We celebrate every victory, big or small, just like in our **engaging social games**.',
    category: 'competition',
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

        
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som social spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punkter Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

     
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png';

// --- Constants ---
const REQUIRED_CLICKS = 10; // You might want to increase this for a longer game, e.g., 20 or 30
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const PHOTO_BUFFER = 20; // Minimum space in pixels between photos
const RESIZE_DEBOUNCE_TIME = 200; // milliseconds for debouncing resize events
const BURST_DURATION = 600; // milliseconds for confetti burst animation and photo reset
const DECAY_INTERVAL = 500; // milliseconds: how often the clicks decay (increased from 300ms)
const DECAY_AMOUNT = 1; // how many clicks are lost per decay interval

// --- Team Member Data ---
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['competition', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['teamwork', 'innovation'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

// --- Info Box Data ---
const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity',
    colors: {
      border: '#7c3aed', // purple-700
      background: '#4c1d95', // purple-900
    },
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements within our studio and **the multiplayer worlds we build**.',
    category: 'teamwork',
    colors: {
      border: '#9333ea', // fuchsia-700
      background: '#5b21b6', // violet-900 - Adjusted for better contrast/theme
    },
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and **drives innovation**. We celebrate every victory, big or small, just like in our **engaging social games**.',
    category: 'competition',
    colors: {
      border: '#db2777', // pink-700
      background: '#831843', // pink-900
    },
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration',
    colors: {
      border: '#facc15', // yellow-400
      background: '#713f12', // amber-900
    },
  },
];

// --- Helper for generating photo positions ---
const generatePhotoPositions = (team, photoSize, buffer, exclusionZone) => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const effectivePhotoDim = photoSize + buffer;
  const MAX_PLACEMENT_TRIES = 500;

  for (const member of team) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;

    while (tries < MAX_PLACEMENT_TRIES && !foundPosition) {
      newX = Math.random() * (w - photoSize);
      newY = Math.random() * (h - photoSize);

      // Check for overlap with the central UI exclusion zone
      const overlapsExclusion =
        newX < exclusionZone.x + exclusionZone.width &&
        newX + photoSize > exclusionZone.x &&
        newY < exclusionZone.y + exclusionZone.height &&
        newY + photoSize > exclusionZone.y;

      if (overlapsExclusion) {
        tries++;
        continue;
      }

      // Check for overlap with existing photos
      let overlapsExistingPhotos = false;
      for (const p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (
          newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx
        ) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`,
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.name} after ${MAX_PLACEMENT_TRIES} tries. Placing randomly.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - photoSize) / h) * 100}%`,
        left: `${(Math.random() * (w - photoSize) / w) * 100}%`,
      });
    }
  }
  return positions;
};

// --- Main App Component ---
export default function App() {
  const [clicks, setClicks] = useState(0);
  const [isInflated, setIsInflated] = useState(false);
  const [isBursting, setIsBursting] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [currentNavInfo, setCurrentNavInfo] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [lastClickTimestamp, setLastClickTimestamp] = useState(Date.now());

  const centralUIExclusion = useMemo(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    return {
      x: w * 0.25,
      y: h * 0.15,
      width: w * 0.50,
      height: h * 0.70,
    };
  }, []);

  const memoizedGeneratePositions = useCallback(
    () => generatePhotoPositions(teamMembers, PHOTO_SIZE, PHOTO_BUFFER, centralUIExclusion),
    [centralUIExclusion]
  );

  const [positions, setPositions] = useState(memoizedGeneratePositions);

  const resizeTimerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        setPositions(memoizedGeneratePositions());
      }, RESIZE_DEBOUNCE_TIME);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimerRef.current);
    };
  }, [memoizedGeneratePositions]);

  // Effect for progress decay when idle
  useEffect(() => {
    let decayInterval;
    if (clicks > 0 && !isInflated) {
      decayInterval = setInterval(() => {
        const now = Date.now();
        // Decay only if enough time has passed since the last click
        if (now - lastClickTimestamp > DECAY_INTERVAL) {
          setClicks(prev => Math.max(0, prev - DECAY_AMOUNT));
        }
      }, DECAY_INTERVAL);
    }
    return () => clearInterval(decayInterval);
  }, [clicks, isInflated, lastClickTimestamp]);


  const handleMainButtonClick = useCallback(() => {
    // Trigger button animation
    setIsButtonClicked(true);
    setTimeout(() => setIsButtonClicked(false), 150); // Animation duration

    setLastClickTimestamp(Date.now()); // Update last click time to reset decay timer

    if (isInflated) {
      setIsBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 },
          colors: ['#a855f7', '#ec4899', '#facc15', '#06d6a0'], // Tailwind colors
        })
      );
      // Immediately hide photos for a smoother transition to burst
      setPositions([]);
      setTimeout(() => {
        setIsBursting(false);
        setIsInflated(false);
        setClicks(0); // Reset clicks only after burst
        setPositions(memoizedGeneratePositions()); // Regenerate positions after burst
      }, BURST_DURATION);
      return;
    }

    // Clicks simply increment from current value
    setClicks(prev => {
      const nextClicks = Math.min(REQUIRED_CLICKS, prev + 1);
      if (nextClicks >= REQUIRED_CLICKS) {
        setIsInflated(true);
      }
      return nextClicks;
    });
  }, [isInflated, positions, memoizedGeneratePositions]);

  const photoScaleFactor = 0.3 + 0.7 * (clicks / REQUIRED_CLICKS);
  const showPhotos = clicks > 0 || isInflated;
  const progressPercentage = Math.round((clicks / REQUIRED_CLICKS) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]">

      
      <AnimatePresence>
        {!isBursting && showPhotos && positions.map(pos => {
          const member = teamMembers.find(t => t.id === pos.id);
          if (!member) return null;

          const isHighlighted = hoveredCategory && member.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2;

          const currentPhotoScale = isHighlighted
            ? 1.1
            : (isInflated
              ? 1
              : photoScaleFactor);

          const photoVariants = {
            initial: { scale: 0.3, opacity: 0 },
            animate: {
              scale: currentPhotoScale,
              opacity: photoOpacity,
              transition: {
                type: 'spring',
                stiffness: 120,
                damping: 20,
                ...(isInflated && !isBursting && {
                  scale: { duration: 0.3, ease: 'easeOut' }
                })
              }
            },
            exit: { scale: 0.1, opacity: 0, transition: { duration: 0.3 } }
          };

          return (
            <motion.div
              key={member.id}
              variants={photoVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className={`absolute rounded-full overflow-hidden shadow-lg z-50 ${isInflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={member.photo} alt={member.name || 'Team member'} className="w-full h-full object-cover" draggable={false} />
                
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center p-2 text-center">
                  <p className="font-bold text-lg">{member.name}</p>
                  <p className="italic text-sm">{member.role}</p>
                  <p className="mt-2 text-xs text-gray-300">{member.bio}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      
      <div className="relative z-30 flex flex-col items-center min-h-screen">
        
        <nav className="flex justify-between items-center p-4 md:p-6 w-full bg-black/20 backdrop-blur-sm sticky top-0 z-40">
          <div className="flex items-center space-x-2 md:space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-16 h-16 md:w-24 md:h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1 text-xs md:text-base">- seriøs sjov!</span>
              <span className="text-2xl md:text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-sm lg:max-w-lg hidden lg:block">
            <AnimatePresence mode="wait">
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1 text-gray-200">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className="w-16 md:w-24" /> 
        </nav>

        
        <header className="flex flex-col items-center text-center pt-8 md:pt-16 pb-20 md:pb-28 px-4 max-w-4xl mx-auto">
          <motion.h1
            className="text-4xl md:text-6xl md:pb-14 font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400 drop-shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: 0.2 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <p className="mt-4 text-base md:text-xl md:pb-14 font-medium text-gray-300 max-w-2xl">
            Som sociale spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          
          <div className="mt-8 w-full max-w-sm md:max-w-md">
            <motion.button
              onClick={handleMainButtonClick}
              className="w-full px-8 py-3 md:px-10 md:py-4 text-lg md:text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden text-white"
              style={{
                background: isInflated ? 'linear-gradient(90deg,#831843,#db2777,#ec4899)' : 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: isInflated ? 'pulseGradient 1.5s ease-in-out infinite' : 'buttonGradient 2s linear infinite',
              }}
              whileTap={{ scale: 0.95 }}
              animate={isButtonClicked ? { scale: [1, 1.02, 1] } : {}}
              transition={{ duration: 0.1 }}
              aria-label={isInflated ? 'Punkter Vores Egoer' : 'Blæs Vores Egoer Op!'}
            >
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
              <span className="relative z-10">{isInflated ? 'Punkter Os!' : 'Blæs Vores Egoer Op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className={`h-full ${isInflated ? 'bg-yellow-400' : 'bg-green-400'}`}
                animate={{ width: `${progressPercentage}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
              />
            </div>
            <div className="mt-2 text-lg md:text-xl font-semibold text-gray-200">{clicks} / {REQUIRED_CLICKS} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-4 md:gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((item) => (
              <motion.div
                key={item.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 md:w-36 md:h-36 text-center cursor-pointer transform hover:scale-105 transition-transform duration-200"
                style={{
                  borderColor: item.colors.border,
                  backgroundColor: item.colors.background,
                  boxShadow: hoveredCategory === item.category ? `0 0 15px ${item.colors.border}` : 'none',
                }}
                onMouseEnter={() => {
                  setHoveredCategory(item.category);
                  setCurrentNavInfo({
                    id: item.id,
                    title: item.title,
                    info: item.info,
                    borderColor: item.colors.border,
                    bgColor: item.colors.background,
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null);
                  setCurrentNavInfo(null);
                }}
              >
                <span className="text-white mb-2">{item.icon}</span>
                <span className="font-bold text-base leading-tight">{item.title}</span>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

     
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        @keyframes pulseGradient {
          0%{background-position:0% 50%; transform: scale(1);}
          50%{background-position:100% 50%; transform: scale(1.01);}
          100%{background-position:0% 50%; transform: scale(1);}
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['competition', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', 'photo': 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['teamwork', 'innovation'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity'
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements within our studio and **the multiplayer worlds we build**.',
    category: 'teamwork'
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and **drives innovation**. We celebrate every victory, big or small, just like in our **engaging social games**.',
    category: 'competition'
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration'
  },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  const centralUIExclusion = {
    x: w * 0.25,
    y: h * 0.15,
    width: w * 0.50,
    height: h * 0.70
  };

  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000;

    while (tries < maxTries && !foundPosition) {
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue;
      }

      let overlapsExistingPhotos = false;
      for (let p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (newX < pLeftPx + effectivePhotoDim &&
            newX + effectivePhotoDim > pLeftPx &&
            newY < pTopPx + effectivePhotoDim &&
            newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // State for hovered info box category (for photo highlight)
  const [hoveredCategory, setHoveredCategory] = useState(null);
  // State for the currently displayed info in the nav
  const [currentNavInfo, setCurrentNavInfo] = useState(null);


  const resizeTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []);

  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1;
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null;

          // Determine if the member should be highlighted
          const isHighlighted = hoveredCategory && m.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2; // Dim if not highlighted and a category is hovered
          const photoScale = isHighlighted ? 1.1 : (inflated ? 1 : scale); // Slightly bigger if highlighted

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: photoScale, opacity: photoOpacity }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />

                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-lg hidden lg:block"> 
            <AnimatePresence mode="wait"> 
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id} // Key ensures re-animation on content change
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="bg-black/40 p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"vi skaber pixels og glade minder, ét episk socialt spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          

          <div className="w-24" /> 
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <p className="mt-2 text-xl font-medium text-gray-300 max-w-2xl">
            Som sociale spiludviklere, dedikerer vi os til at skabe uforglemmelige oplevelser, der forbinder spillere og fremmer sjov og fællesskab.
          </p>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>

              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'punkter os!' : 'blæs vores egoer op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


          <section className="flex flex-wrap justify-center mt-12 gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((it, i) => (
              <motion.div key={it.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 text-center cursor-pointer"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i],
                }}
                whileHover={{ scale: 1.05 }}
                onMouseEnter={() => {
                  setHoveredCategory(it.category); // For photo highlight
                  setCurrentNavInfo({ // Set info for central display
                    id: it.id,
                    title: it.title,
                    info: it.info,
                    borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                    bgColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null); // Clear photo highlight
                  setCurrentNavInfo(null); // Hide central display
                }}
              >
              
                <span className="text-white mb-2">
                  {it.icon}
                </span>
             
                <span className="font-bold text-base leading-tight">{it.title}</span>

              </motion.div>
            ))}
          </section>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['competition', 'innovation'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', 'photo': 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['competition', 'innovation'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['teamwork', 'innovation'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity'
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements.',
    category: 'teamwork'
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and **drives innovation**. We celebrate every victory, big or small.',
    category: 'competition'
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration'
  },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  const centralUIExclusion = {
    x: w * 0.25,
    y: h * 0.15,
    width: w * 0.50,
    height: h * 0.70
  };

  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000;

    while (tries < maxTries && !foundPosition) {
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue;
      }

      let overlapsExistingPhotos = false;
      for (let p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // State for hovered info box category (for photo highlight)
  const [hoveredCategory, setHoveredCategory] = useState(null);
  // State for the currently displayed info in the nav
  const [currentNavInfo, setCurrentNavInfo] = useState(null);


  const resizeTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []);

  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1;
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null;

          // Determine if the member should be highlighted
          const isHighlighted = hoveredCategory && m.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2; // Dim if not highlighted and a category is hovered
          const photoScale = isHighlighted ? 1.1 : (inflated ? 1 : scale); // Slightly bigger if highlighted

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: photoScale, opacity: photoOpacity }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />

                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-lg hidden lg:block"> 
            <AnimatePresence mode="wait"> 
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id} // Key ensures re-animation on content change
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="bg-black/40 p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-sm text-gray-400">"Vi skaber pixels og glade minder, ét episk spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        

          <div className="w-24" />
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>

              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


          <section className="flex flex-wrap justify-center mt-12 gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((it, i) => (
              <motion.div key={it.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 text-center cursor-pointer"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i],
                }}
                whileHover={{ scale: 1.05 }}
                onMouseEnter={() => {
                  setHoveredCategory(it.category); // For photo highlight
                  setCurrentNavInfo({ // Set info for central display
                    id: it.id,
                    title: it.title,
                    info: it.info,
                    borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                    bgColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null); // Clear photo highlight
                  setCurrentNavInfo(null); // Hide central display
                }}
              >
           
                <span className="text-white mb-2">
                  {it.icon}
                </span>
      
                <span className="font-bold text-base leading-tight">{it.title}</span>

              </motion.div>
            ))}
          </section>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}
 */




/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['innovation', 'competition'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', 'photo': 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['innovation', 'competition'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['innovation', 'teamwork'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

const infoBoxesData = [
  {
    id: 'creativity',
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity'
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements.',
    category: 'teamwork'
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and celebrates every victory, big or small.',
    category: 'competition'
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration'
  },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  const centralUIExclusion = {
    x: w * 0.25,
    y: h * 0.15,
    width: w * 0.50,
    height: h * 0.70
  };

  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000;

    while (tries < maxTries && !foundPosition) {
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue;
      }

      let overlapsExistingPhotos = false;
      for (let p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // State for hovered info box category (for photo highlight)
  const [hoveredCategory, setHoveredCategory] = useState(null);
  // State for the currently displayed info in the nav
  const [currentNavInfo, setCurrentNavInfo] = useState(null);


  const resizeTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []);

  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1;
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null;

          // Determine if the member should be highlighted
          const isHighlighted = hoveredCategory && m.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2; // Dim if not highlighted and a category is hovered
          const photoScale = isHighlighted ? 1.1 : (inflated ? 1 : scale); // Slightly bigger if highlighted

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: photoScale, opacity: photoOpacity }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />

                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>

          
          <div className="absolute left-1/2 -translate-x-1/2 p-2 px-4 rounded-xl text-center max-w-lg hidden lg:block">
            <AnimatePresence mode="wait"> 
              {currentNavInfo ? (
                <motion.div
                  key={currentNavInfo.id} // Key ensures re-animation on content change
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="bg-black/40 p-2 rounded-lg"
                  style={{
                    borderColor: currentNavInfo.borderColor,
                    backgroundColor: currentNavInfo.bgColor,
                    borderWidth: '1px'
                  }}
                >
                  <p className="text-base font-semibold">{currentNavInfo.title}</p>
                  <p className="text-sm mt-1">{currentNavInfo.info}</p>
                </motion.div>
              ) : (
                <motion.div
                  key="default-nav-info"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="p-2"
                >
                  <p className="text-md text-white-400">"Vi skaber pixels og glade minder, ét episk spil ad gangen!"</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          

          <div className="w-24" />
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>

              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


          <section className="flex flex-wrap justify-center mt-12 gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((it, i) => (
              <motion.div key={it.id}
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 text-center cursor-pointer"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i],
                }}
                whileHover={{ scale: 1.05 }}
                onMouseEnter={() => {
                  setHoveredCategory(it.category); // For photo highlight
                  setCurrentNavInfo({ // Set info for central display
                    id: it.id,
                    title: it.title,
                    info: it.info,
                    borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                    bgColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                  });
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null); // Clear photo highlight
                  setCurrentNavInfo(null); // Hide central display
                }}
              >
               
                <span className="text-white mb-2">
                  {it.icon}
                </span>
                
                <span className="font-bold text-base leading-tight">{it.title}</span>

             
              </motion.div>
            ))}
          </section>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['innovation', 'competition'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', 'photo': 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['innovation', 'competition'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['innovation', 'teamwork'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

const infoBoxesData = [
  {
    id: 'creativity', // Add an ID for tracking hovered tooltip
    icon: <FaPaintBrush size={40} />,
    title: 'Kreativitet',
    info: 'Unleash groundbreaking ideas and push boundaries. We cultivate an environment where innovative thinking leads to exceptional solutions and fresh perspectives.',
    category: 'creativity'
  },
  {
    id: 'teamwork',
    icon: <FaUsers size={40} />,
    title: 'Sammenhold',
    info: 'Experience the power of synergy. Our strong collaborative spirit ensures every team member contributes their best, driving collective success and shared achievements.',
    category: 'teamwork'
  },
  {
    id: 'competition',
    icon: <FaTrophy size={40} />,
    title: 'Konkurrence',
    info: 'Embrace challenge to achieve peak performance. Healthy competition fuels excellence, motivates growth, and celebrates every victory, big or small.',
    category: 'competition'
  },
  {
    id: 'inspiration',
    icon: <FaLightbulb size={40} />,
    title: 'Inspiration',
    info: 'Spark your passion and ignite new possibilities. We aim to inspire continuous learning, foster personal development, and illuminate the path for future innovations.',
    category: 'inspiration'
  },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  const centralUIExclusion = {
    x: w * 0.25,
    y: h * 0.15,
    width: w * 0.50,
    height: h * 0.70
  };

  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000;

    while (tries < maxTries && !foundPosition) {
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue;
      }

      let overlapsExistingPhotos = false;
      for (let p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // State for hovered info box category (for photo highlight)
  const [hoveredCategory, setHoveredCategory] = useState(null);
  // New state to manage which info box's tooltip is visible
  const [activeTooltipId, setActiveTooltipId] = useState(null);


  const resizeTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []);

  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1;
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null;

          // Determine if the member should be highlighted
          const isHighlighted = hoveredCategory && m.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2; // Dim if not highlighted and a category is hovered
          const photoScale = isHighlighted ? 1.1 : (inflated ? 1 : scale); // Slightly bigger if highlighted

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: photoScale, opacity: photoOpacity }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />

                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>

              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


          <section className="flex flex-wrap justify-center mt-12 gap-6 px-2 max-w-4xl mx-auto text-xl font-semibold"> 
            {infoBoxesData.map((it, i) => (
              <motion.div key={it.id} // Use it.id for key
                className="relative flex flex-col items-center justify-center rounded-xl border p-3 shadow-lg bg-opacity-40 w-32 h-32 text-center cursor-pointer" // Adjusted size, padding, and text-center
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i],
                }}
                whileHover={{ scale: 1.05 }} // Slight pop on hover
                onMouseEnter={() => {
                  setHoveredCategory(it.category); // For photo highlight
                  setActiveTooltipId(it.id); // For tooltip display
                }}
                onMouseLeave={() => {
                  setHoveredCategory(null); // Clear photo highlight
                  setActiveTooltipId(null); // Hide tooltip
                }}
              >
             
                <span className="text-white mb-2"> 
                  {it.icon}
                </span>
           
                <span className="font-bold text-base leading-tight">{it.title}</span> 

            
                <AnimatePresence>
                  {activeTooltipId === it.id && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.2 }}
                      className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-3 rounded-lg shadow-xl text-sm z-30"
                      style={{
                        backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i], // Match background color
                        borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i], // Match border color
                        borderWidth: '1px'
                      }}
                    >
                      {it.info}
                      <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px]"
                           style={{ borderLeftColor: 'transparent', borderRightColor: 'transparent', borderTopColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i] }}></div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </section>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti';
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.', categories: ['creativity'] },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.', categories: ['innovation', 'competition'] },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.', categories: ['teamwork', 'competition'] },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.', categories: ['teamwork', 'inspiration'] },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.', categories: ['creativity', 'inspiration'] },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.', categories: ['teamwork', 'competition'] },
  { id: 7, name: 'Grace', 'photo': 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.', categories: ['innovation', 'competition'] },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.', categories: ['creativity', 'teamwork'] },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.', categories: ['innovation', 'teamwork'] },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.', categories: ['creativity', 'inspiration'] },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.', categories: ['competition', 'teamwork'] },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.', categories: ['teamwork', 'inspiration'] },
];

const infoBoxesData = [
  { icon: <FaPaintBrush size={32} className="text-pink-400" />, title: 'Kreativitet', info: 'Unleash your imagination and explore new frontiers, fostering innovative ideas and unique perspectives.', category: 'creativity' },
  { icon: <FaUsers size={32} className="text-indigo-400" />, title: 'Sammenhold', info: 'Our collaborative spirit ensures everyone contributes their best to achieve shared goals efficiently.', category: 'teamwork' },
  { icon: <FaTrophy size={32} className="text-yellow-400" />, title: 'Konkurrence', info: 'Embrace healthy competition to push your limits, striving for excellence and celebrating achievements.', category: 'competition' },
  { icon: <FaLightbulb size={32} className="text-purple-400" />, title: 'Inspiration', info: 'Find motivation in every challenge, inspiring continuous learning and sparking new ideas that drive progress.', category: 'inspiration' },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  const centralUIExclusion = {
    x: w * 0.25,
    y: h * 0.15,
    width: w * 0.50,
    height: h * 0.70
  };

  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000;

    while (tries < maxTries && !foundPosition) {
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue;
      }

      let overlapsExistingPhotos = false;
      for (let p of positions) {
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break;
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // New state for hovered info box category
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const resizeTimer = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []);

  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos =>
        confetti({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1;
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null;

          // Determine if the member should be highlighted
          const isHighlighted = hoveredCategory && m.categories.includes(hoveredCategory);
          const photoOpacity = isHighlighted || !hoveredCategory ? 1 : 0.2; // Dim if not highlighted and a category is hovered
          const photoScale = isHighlighted ? 1.1 : (inflated ? 1 : scale); // Slightly bigger if highlighted

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: photoScale, opacity: photoOpacity }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'} ${isHighlighted ? 'ring-4 ring-offset-2 ring-offset-purple-900 ring-yellow-400' : ''}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />

                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>

              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>

            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {infoBoxesData.map((it, i) => (
              <motion.div key={i}
                className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                }}
                whileHover={{ scale: 1.03 }}
                onMouseEnter={() => setHoveredCategory(it.category)}
                onMouseLeave={() => setHoveredCategory(null)}
              >
                {it.icon}
                <span className="font-semibold">{it.title}</span>

                <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center text-sm">
                  {it.info}
                </div>
              </motion.div>
            ))}
          </section>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti'; // Import confetti library
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.' },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.' },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.' },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.' },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.' },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.' },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.' },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.' },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  // Define the central UI exclusion rectangle in pixels.
  // These values are approximations based on the layout of the main content.
  // Adjust these percentages if the central UI layout changes significantly.
  const centralUIExclusion = {
    x: w * 0.25, // Starts 25% from the left edge of the screen
    y: h * 0.15, // Starts 15% from the top edge of the screen (to clear nav/header)
    width: w * 0.50, // Occupies 50% of the screen width
    height: h * 0.70 // Occupies 70% of the screen height
  };

  // Effective dimension for overlap check, including the photo size and the buffer.
  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000; // Increased max tries to find a suitable spot

    while (tries < maxTries && !foundPosition) {
      // Generate random position for the top-left corner of the photo.
      // Ensure the photo stays within the viewport bounds.
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      // Check if the new photo's bounding box (actual PHOTO_SIZE) overlaps with the central UI exclusion zone.
      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue; // This position is in the central UI area, try again.
      }

      // Check for overlap with existing photos using the effectivePhotoDim (PHOTO_SIZE + BUFFER)
      // This ensures there's a minimum buffer space between photos.
      let overlapsExistingPhotos = false;
      for (let p of positions) {
        // Convert existing position percentages to pixels for accurate comparison.
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        // AABB (Axis-Aligned Bounding Box) overlap check:
        // Two rectangles (newX, newY, effectivePhotoDim, effectivePhotoDim) and
        // (pLeftPx, pTopPx, effectivePhotoDim, effectivePhotoDim) overlap if:
        // (newX < pLeftPx + effectivePhotoDim) AND (newX + effectivePhotoDim > pLeftPx) AND
        // (newY < pTopPx + effectivePhotoDim) AND (newY + effectivePhotoDim > pTopPx)
        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break; // Overlap detected, break and try a new position.
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        // If a non-overlapping position is found, store it.
        // Convert pixel coordinates back to percentages for responsive styling.
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      // Fallback: If a non-overlapping position cannot be found after maxTries,
      // place it at a random location. This might lead to overlaps in very constrained
      // scenarios (e.g., small screen, too many members), but ensures all members are displayed.
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // Use useRef for the timer to persist it across renders without causing re-renders
  const resizeTimer = useRef(null);

  // Effect to recalculate positions on window resize for responsiveness.
  useEffect(() => {
    const handleResize = () => {
      // Debounce the resize event to prevent excessive recalculations during resizing.
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200); // Recalculate after 200ms of no resizing
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      // Corrected: Access the .current property of the ref
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []); // Empty dependency array ensures this effect runs once on mount and cleans up on unmount

  // Idle decay for clicks: if no clicks for maxInterval, reduce clicks by 1.
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

 
  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // If already inflated, trigger the burst animation and reset.
      setBursting(true);
      // Trigger confetti effect for each photo's position.
      positions.forEach(pos =>
        confetti({ // Use imported confetti
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]); // Clear photos during burst
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions()); // Regenerate positions for next round
        setLastTime(Date.now());
      }, 600);
      return;
    }

    // Increment clicks if within maxInterval, otherwise increment from current value.
    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1; // Modified line
      // Trigger inflation when required clicks are met, only if not already inflated
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
    
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

 
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null; // Should not happen if generatePositions is correct

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: inflated ? 1 : scale, opacity: 1 }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />
           
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">
     
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>
            
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>
         
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>

   
          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {[
              { icon: <FaPaintBrush size={32} className="text-pink-400" />, title: 'Kreativitet', info: 'Unlock new ideas!' },
              { icon: <FaUsers size={32} className="text-indigo-400" />, title: 'Sammenhold', info: 'Teamwork makes dream work.' },
              { icon: <FaTrophy size={32} className="text-yellow-400" />, title: 'Konkurrence', info: 'Challenge yourself.' },
              { icon: <FaLightbulb size={32} className="text-purple-400" />, title: 'Inspiration', info: 'Spark your next project.' },
            ].map((it, i) => (
              <motion.div key={i}
                className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                }}
                whileHover={{ scale: 1.03 }}
              >
                {it.icon}
                <span className="font-semibold">{it.title}</span>
       
                <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                  {it.info}
                </div>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

   
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import confetti from 'canvas-confetti'; // Import confetti library
import logo from './assets/logo/fox.png'

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.' },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.' },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.' },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.' },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.' },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.' },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.' },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.' },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  // Define the central UI exclusion rectangle in pixels.
  // These values are approximations based on the layout of the main content.
  // Adjust these percentages if the central UI layout changes significantly.
  const centralUIExclusion = {
    x: w * 0.25, // Starts 25% from the left edge of the screen
    y: h * 0.15, // Starts 15% from the top edge of the screen (to clear nav/header)
    width: w * 0.50, // Occupies 50% of the screen width
    height: h * 0.70 // Occupies 70% of the screen height
  };

  // Effective dimension for overlap check, including the photo size and the buffer.
  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000; // Increased max tries to find a suitable spot

    while (tries < maxTries && !foundPosition) {
      // Generate random position for the top-left corner of the photo.
      // Ensure the photo stays within the viewport bounds.
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      // Check if the new photo's bounding box (actual PHOTO_SIZE) overlaps with the central UI exclusion zone.
      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue; // This position is in the central UI area, try again.
      }

      // Check for overlap with existing photos using the effectivePhotoDim (PHOTO_SIZE + BUFFER)
      // This ensures there's a minimum buffer space between photos.
      let overlapsExistingPhotos = false;
      for (let p of positions) {
        // Convert existing position percentages to pixels for accurate comparison.
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        // AABB (Axis-Aligned Bounding Box) overlap check:
        // Two rectangles (newX, newY, effectivePhotoDim, effectivePhotoDim) and
        // (pLeftPx, pTopPx, effectivePhotoDim, effectivePhotoDim) overlap if:
        // (newX < pLeftPx + effectivePhotoDim) AND (newX + effectivePhotoDim > pLeftPx) AND
        // (newY < pTopPx + effectivePhotoDim) AND (newY + effectivePhotoDim > pTopPx)
        if (newX < pLeftPx + effectivePhotoDim &&
          newX + effectivePhotoDim > pLeftPx &&
          newY < pTopPx + effectivePhotoDim &&
          newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break; // Overlap detected, break and try a new position.
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        // If a non-overlapping position is found, store it.
        // Convert pixel coordinates back to percentages for responsive styling.
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      // Fallback: If a non-overlapping position cannot be found after maxTries,
      // place it at a random location. This might lead to overlaps in very constrained
      // scenarios (e.g., small screen, too many members), but ensures all members are displayed.
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  // Use useRef for the timer to persist it across renders without causing re-renders
  const resizeTimer = useRef(null);

  // Effect to recalculate positions on window resize for responsiveness.
  useEffect(() => {
    const handleResize = () => {
      // Debounce the resize event to prevent excessive recalculations during resizing.
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
      resizeTimer.current = setTimeout(() => {
        setPositions(generatePositions());
      }, 200); // Recalculate after 200ms of no resizing
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      // Corrected: Access the .current property of the ref
      if (resizeTimer.current) clearTimeout(resizeTimer.current);
    };
  }, []); // Empty dependency array ensures this effect runs once on mount and cleans up on unmount

  // Idle decay for clicks: if no clicks for maxInterval, reduce clicks by 1.
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

 
  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // If already inflated, trigger the burst animation and reset.
      setBursting(true);
      // Trigger confetti effect for each photo's position.
      positions.forEach(pos =>
        confetti({ // Use imported confetti
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]); // Clear photos during burst
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        setPositions(generatePositions()); // Regenerate positions for next round
        setLastTime(Date.now());
      }, 600);
      return;
    }

    // Increment clicks if within maxInterval, otherwise increment from current value.
    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : prev + 1; // Modified line
      // Trigger inflation when required clicks are met, only if not already inflated
      if (next >= requiredClicks && !inflated) {
        setInflated(true);
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
    
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

 
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null; // Should not happen if generatePositions is correct

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: inflated ? 1 : scale, opacity: 1 }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />
           
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">
     
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>
            
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'blæs vores egoer op!'}</span>
            </motion.button>
         
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>

   
          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {[
              { icon: <FaPaintBrush size={32} className="text-pink-400" />, title: 'Kreativitet', info: 'Unlock new ideas!' },
              { icon: <FaUsers size={32} className="text-indigo-400" />, title: 'Sammenhold', info: 'Teamwork makes dream work.' },
              { icon: <FaTrophy size={32} className="text-yellow-400" />, title: 'Konkurrence', info: 'Challenge yourself.' },
              { icon: <FaLightbulb size={32} className="text-purple-400" />, title: 'Inspiration', info: 'Spark your next project.' },
            ].map((it, i) => (
              <motion.div key={i}
                className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                }}
                whileHover={{ scale: 1.03 }}
              >
                {it.icon}
                <span className="font-semibold">{it.title}</span>
       
                <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                  {it.info}
                </div>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

   
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';

// Placeholder for the logo to make the component self-contained.
// In a real application, you would import your logo image.
const logo = 'https://placehold.co/96x96/FF6B6B/FFFFFF?text=FOX';

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144; // Fixed size of the photo in pixels
const BUFFER = 20; // Minimum space in pixels between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
  { id: 5, name: 'Eve', photo: 'https://i.pravatar.cc/150?img=5', role: 'Artist', bio: 'Brings visions to life with stunning visuals.' },
  { id: 6, name: 'Frank', photo: 'https://i.pravatar.cc/150?img=6', role: 'QA Engineer', bio: 'Ensures everything runs smoothly and bug-free.' },
  { id: 7, name: 'Grace', photo: 'https://i.pravatar.cc/150?img=7', role: 'Data Scientist', bio: 'Uncovers insights from complex data.' },
  { id: 8, name: 'Heidi', photo: 'https://i.pravatar.cc/150?img=8', role: 'UX Researcher', bio: 'Focuses on user needs and experience.' },
  { id: 9, name: 'Ivan', photo: 'https://i.pravatar.cc/150?img=9', role: 'DevOps Engineer', bio: 'Manages infrastructure and deployments.' },
  { id: 10, name: 'Judy', photo: 'https://i.pravatar.cc/150?img=10', role: 'Content Creator', bio: 'Crafts compelling stories and messages.' },
  { id: 11, name: 'Kevin', photo: 'https://i.pravatar.cc/150?img=11', role: 'Sales Executive', bio: 'Connects with clients and drives growth.' },
  { id: 12, name: 'Liam', photo: 'https://i.pravatar.cc/150?img=12', role: 'Customer Support', bio: 'Helps users and ensures satisfaction.' },
];


const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;

  // Define the central UI exclusion rectangle in pixels.
  // These values are approximations based on the layout of the main content.
  // Adjust these percentages if the central UI layout changes significantly.
  const centralUIExclusion = {
    x: w * 0.25, // Starts 25% from the left edge of the screen
    y: h * 0.15, // Starts 15% from the top edge of the screen (to clear nav/header)
    width: w * 0.50, // Occupies 50% of the screen width
    height: h * 0.70 // Occupies 70% of the screen height
  };

  // Effective dimension for overlap check, including the photo size and the buffer.
  const effectivePhotoDim = PHOTO_SIZE + BUFFER;

  for (let member of teamMembers) {
    let newX, newY;
    let foundPosition = false;
    let tries = 0;
    const maxTries = 5000; // Increased max tries to find a suitable spot

    while (tries < maxTries && !foundPosition) {
      // Generate random position for the top-left corner of the photo.
      // Ensure the photo stays within the viewport bounds.
      newX = Math.random() * (w - PHOTO_SIZE);
      newY = Math.random() * (h - PHOTO_SIZE);

      // Check if the new photo's bounding box (actual PHOTO_SIZE) overlaps with the central UI exclusion zone.
      const overlapsCentralUI =
        newX < centralUIExclusion.x + centralUIExclusion.width &&
        newX + PHOTO_SIZE > centralUIExclusion.x &&
        newY < centralUIExclusion.y + centralUIExclusion.height &&
        newY + PHOTO_SIZE > centralUIExclusion.y;

      if (overlapsCentralUI) {
        tries++;
        continue; // This position is in the central UI area, try again.
      }

      // Check for overlap with existing photos using the effectivePhotoDim (PHOTO_SIZE + BUFFER)
      // This ensures there's a minimum buffer space between photos.
      let overlapsExistingPhotos = false;
      for (let p of positions) {
        // Convert existing position percentages to pixels for accurate comparison.
        const pLeftPx = parseFloat(p.left) / 100 * w;
        const pTopPx = parseFloat(p.top) / 100 * h;

        // AABB (Axis-Aligned Bounding Box) overlap check:
        // Two rectangles (newX, newY, effectivePhotoDim, effectivePhotoDim) and
        // (pLeftPx, pTopPx, effectivePhotoDim, effectivePhotoDim) overlap if:
        // (newX < pLeftPx + effectivePhotoDim) AND (newX + effectivePhotoDim > pLeftPx) AND
        // (newY < pTopPx + effectivePhotoDim) AND (newY + effectivePhotoDim > pTopPx)
        if (newX < pLeftPx + effectivePhotoDim &&
            newX + effectivePhotoDim > pLeftPx &&
            newY < pTopPx + effectivePhotoDim &&
            newY + effectivePhotoDim > pTopPx) {
          overlapsExistingPhotos = true;
          break; // Overlap detected, break and try a new position.
        }
      }

      if (!overlapsExistingPhotos) {
        foundPosition = true;
        // If a non-overlapping position is found, store it.
        // Convert pixel coordinates back to percentages for responsive styling.
        positions.push({
          id: member.id,
          top: `${(newY / h) * 100}%`,
          left: `${(newX / w) * 100}%`
        });
      }
      tries++;
    }

    if (!foundPosition) {
      // Fallback: If a non-overlapping position cannot be found after maxTries,
      // place it at a random location. This might lead to overlaps in very constrained
      // scenarios (e.g., small screen, too many members), but ensures all members are displayed.
      console.warn(`Could not find non-overlapping position for member ${member.id} after ${maxTries} tries. Placing at a default (potentially overlapping) random position.`);
      positions.push({
        id: member.id,
        top: `${(Math.random() * (h - PHOTO_SIZE) / h) * 100}%`,
        left: `${(Math.random() * (w - PHOTO_SIZE) / w) * 100}%`
      });
    }
  }

  return positions;
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  const burstRef = useRef(false);

  // Effect to recalculate positions on window resize for responsiveness.
  useEffect(() => {
    const handleResize = () => {
      // Debounce the resize event to prevent excessive recalculations during resizing.
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        setPositions(generatePositions());
      }, 200); // Recalculate after 200ms of no resizing
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    };
  }, []); // Empty dependency array ensures this effect runs once on mount and cleans up on unmount

  // Idle decay for clicks: if no clicks for maxInterval, reduce clicks by 1.
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // If already inflated, trigger the burst animation and reset.
      setBursting(true);
      // Trigger confetti effect for each photo's position.
      // Ensure 'canvas-confetti' script is loaded in your HTML (e.g., via CDN).
      positions.forEach(pos =>
        window.confetti?.({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left) / 100, y: parseFloat(pos.top) / 100 }
        })
      );
      setPositions([]); // Clear photos during burst
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        burstRef.current = false;
        setPositions(generatePositions()); // Regenerate positions for next round
        setLastTime(Date.now());
      }, 600);
      return;
    }

    // Increment clicks if within maxInterval, otherwise reset to 1.
    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : 1;
      if (next >= requiredClicks && !burstRef.current) {
        burstRef.current = true;
        setInflated(true); // Trigger inflation when required clicks are met
      }
      return next;
    });
  };

  // Calculate photo scale and progress percentage for UI feedback.
  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPct = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          if (!m) return null; // Should not happen if generatePositions is correct

          return (
            <motion.div key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: inflated ? 1 : scale, opacity: 1 }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated ? 'pointer-events-auto' : 'pointer-events-none'}`}
              style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />
       
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

   
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite'
              }} whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset' : 'Play'}>
            
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} style={{ width: '0%' }} />
              <span className="relative z-10">{inflated ? 'Reset' : 'pust vores egoer op!'}</span>
            </motion.button>
          
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPct}%` }} transition={{ type: 'tween', duration: 0.2 }} style={{ width: '0%' }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>

    
          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {[
              { icon: <FaPaintBrush size={32} className="text-pink-400" />, title: 'Kreativitet', info: 'Unlock new ideas!' },
              { icon: <FaUsers size={32} className="text-indigo-400" />, title: 'Sammenhold', info: 'Teamwork makes dream work.' },
              { icon: <FaTrophy size={32} className="text-yellow-400" />, title: 'Konkurrence', info: 'Challenge yourself.' },
              { icon: <FaLightbulb size={32} className="text-purple-400" />, title: 'Inspiration', info: 'Spark your next project.' },
            ].map((it, i) => (
              <motion.div key={i}
                className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
                style={{
                  borderColor: ['#7c3aed', '#9333ea', '#db2777', '#facc15'][i],
                  backgroundColor: ['#4c1d95', '#5b21b6', '#831843', '#713f12'][i]
                }}
                whileHover={{ scale: 1.03 }}
              >
                {it.icon}
                <span className="font-semibold">{it.title}</span>
          
                <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                  {it.info}
                </div>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

   
      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
    
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          25% { background-position: 50% 100%; }
          50% { background-position: 100% 50%; }
          75% { background-position: 50% 0%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144;
const BUFFER = 20; // minimum space between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
];

// Generate non-overlapping positions outside central UI (left/right) and fully within viewport
const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const widthPct = (PHOTO_SIZE / w) * 100;
  const heightPct = (PHOTO_SIZE / h) * 100;

  // side bands, clamped so photo doesn’t overflow
  const sideBands = [
    { min: 10, max: 25 - widthPct },
    { min: 75, max: 90 - widthPct }
  ];
  const topMin = 30 + heightPct/2;
  const topMax = 100 - heightPct;

  for (let member of teamMembers) {
    let pos, tries = 0;
    do {
      const band = sideBands[Math.floor(Math.random() * sideBands.length)];
      const left = Math.random() * (band.max - band.min) + band.min;
      const top  = Math.random() * (topMax - topMin) + topMin;
      pos = { id: member.id, left, top };
      tries++;
    } while (
      positions.some(p => {
        const dx = ((p.left - pos.left) * w) / 100;
        const dy = ((p.top  - pos.top ) * h) / 100;
        return Math.hypot(dx, dy) < PHOTO_SIZE + BUFFER;
      }) && tries < 100
    );
    positions.push(pos);
  }

  return positions.map(p => ({
    id: p.id,
    top:  `${p.top}%`,
    left: `${p.left}%`
  }));
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  const burstRef = useRef(false);

  // idle decay
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now(),
          delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // burst
      setBursting(true);
      positions.forEach(pos =>
        window.confetti?.({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left)/100, y: parseFloat(pos.top)/100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        burstRef.current = false;
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : 1;
      if (next >= requiredClicks && !burstRef.current) {
        burstRef.current = true;
        setInflated(true);
      }
      return next;
    });
  };

  const scale = 0.3 + 0.7 * (clicks / requiredClicks),
        showPhotos = clicks > 0 || inflated,
        progressPct  = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          return (
            <motion.div key={pos.id}
              initial={{ scale:0.3, opacity:0 }}
              animate={{ scale: inflated ? 1 : scale, opacity:1 }}
              exit   ={{ scale:0.1, opacity:0 }}
              transition={{ type:'spring', stiffness:120, damping:20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated?'pointer-events-auto':'pointer-events-none'}`}
              style={{ width:PHOTO_SIZE, height:PHOTO_SIZE, top:pos.top, left:pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false}/>
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain"/>
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{scale:0.8,opacity:0}} animate={{scale:1,opacity:1}}
            transition={{type:'spring',stiffness:120,damping:20}}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background:'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize:'200% 200%',
                animation:'buttonGradient 2s linear infinite'
              }} whileTap={{scale:0.95}} aria-label={inflated?'Reset':'Play'}>
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{width:`${progressPct}%`}} transition={{type:'tween',duration:0.2}} style={{width:'0%'}}/>
              <span className="relative z-10">{inflated ? 'Reset' : 'pust vores egoer op!'}</span>
            </motion.button>
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{width:`${progressPct}%`}} transition={{type:'tween',duration:0.2}} style={{width:'0%'}}/>
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>


        <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
          {[
            { icon:<FaPaintBrush size={32} className="text-pink-400"/>,   title:'Kreativitet', info:'Unlock new ideas!' },
            { icon:<FaUsers       size={32} className="text-indigo-400"/>, title:'Sammenhold', info:'Teamwork makes dream work.' },
            { icon:<FaTrophy      size={32} className="text-yellow-400"/>, title:'Konkurrence', info:'Challenge yourself.' },
            { icon:<FaLightbulb   size={32} className="text-purple-400"/>, title:'Inspiration', info:'Spark your next project.' },
          ].map((it,i) => (
            <motion.div key={i}
              className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
              style={{
                borderColor: ['#7c3aed','#9333ea','#db2777','#facc15'][i],
                backgroundColor:['#4c1d95','#5b21b6','#831843','#713f12'][i]
              }}
              whileHover={{ scale:1.03 }}
            >
              {it.icon}
              <span className="font-semibold">{it.title}</span>
              <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                {it.info}
              </div>
            </motion.div>
          ))}
        </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      `}</style>
    </div>
  );
} */





/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const requiredClicks = 10;
const maxInterval = 700;
const PHOTO_SIZE = 144;
const BUFFER = 20; // minimum space between photos

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
];

// Generate non-overlapping positions outside central UI (left/right) and fully within viewport
const generatePositions = () => {
  const positions = [];
  const w = window.innerWidth;
  const h = window.innerHeight;
  const widthPct = (PHOTO_SIZE / w) * 100;
  const heightPct = (PHOTO_SIZE / h) * 100;

  // side bands, clamped so photo doesn’t overflow
  const sideBands = [
    { min: 10, max: 25 - widthPct },
    { min: 75, max: 90 - widthPct }
  ];
  const topMin = 30 + heightPct/2;
  const topMax = 100 - heightPct;

  for (let member of teamMembers) {
    let pos, tries = 0;
    do {
      const band = sideBands[Math.floor(Math.random() * sideBands.length)];
      const left = Math.random() * (band.max - band.min) + band.min;
      const top  = Math.random() * (topMax - topMin) + topMin;
      pos = { id: member.id, left, top };
      tries++;
    } while (
      positions.some(p => {
        const dx = ((p.left - pos.left) * w) / 100;
        const dy = ((p.top  - pos.top ) * h) / 100;
        return Math.hypot(dx, dy) < PHOTO_SIZE + BUFFER;
      }) && tries < 100
    );
    positions.push(pos);
  }

  return positions.map(p => ({
    id: p.id,
    top:  `${p.top}%`,
    left: `${p.left}%`
  }));
};

export default function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  const burstRef = useRef(false);

  // idle decay
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const t = setTimeout(() => setClicks(c => Math.max(0, c - 1)), maxInterval);
      return () => clearTimeout(t);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now(),
          delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // burst
      setBursting(true);
      positions.forEach(pos =>
        window.confetti?.({
          particleCount: 60,
          spread: 120,
          origin: { x: parseFloat(pos.left)/100, y: parseFloat(pos.top)/100 }
        })
      );
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        burstRef.current = false;
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : 1;
      if (next >= requiredClicks && !burstRef.current) {
        burstRef.current = true;
        setInflated(true);
      }
      return next;
    });
  };

  const scale = 0.3 + 0.7 * (clicks / requiredClicks),
        showPhotos = clicks > 0 || inflated,
        progressPct  = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          return (
            <motion.div key={pos.id}
              initial={{ scale:0.3, opacity:0 }}
              animate={{ scale: inflated ? 1 : scale, opacity:1 }}
              exit   ={{ scale:0.1, opacity:0 }}
              transition={{ type:'spring', stiffness:120, damping:20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg z-20 ${inflated?'pointer-events-auto':'pointer-events-none'}`}
              style={{ width:PHOTO_SIZE, height:PHOTO_SIZE, top:pos.top, left:pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false}/>
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">
       
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="logo" className="w-24 h-24 object-contain"/>
            <div className="flex flex-col items-end">
              <span className="italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{scale:0.8,opacity:0}} animate={{scale:1,opacity:1}}
            transition={{type:'spring',stiffness:120,damping:20}}
          >Spil. Hyg. Fejr!</motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background:'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
                backgroundSize:'200% 200%',
                animation:'buttonGradient 2s linear infinite'
              }} whileTap={{scale:0.95}} aria-label={inflated?'Reset':'Play'}>
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{width:`${progressPct}%`}} transition={{type:'tween',duration:0.2}} style={{width:'0%'}}/>
              <span className="relative z-10">{inflated ? 'Reset' : 'pust vores egoer op!'}</span>
            </motion.button>
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{width:`${progressPct}%`}} transition={{type:'tween',duration:0.2}} style={{width:'0%'}}/>
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks} / {requiredClicks} klik</div>
          </div>

       
        <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
          {[
            { icon:<FaPaintBrush size={32} className="text-pink-400"/>,   title:'Kreativitet', info:'Unlock new ideas!' },
            { icon:<FaUsers       size={32} className="text-indigo-400"/>, title:'Sammenhold', info:'Teamwork makes dream work.' },
            { icon:<FaTrophy      size={32} className="text-yellow-400"/>, title:'Konkurrence', info:'Challenge yourself.' },
            { icon:<FaLightbulb   size={32} className="text-purple-400"/>, title:'Inspiration', info:'Spark your next project.' },
          ].map((it,i) => (
            <motion.div key={i}
              className="group relative flex items-center gap-3 rounded-xl border p-4 shadow-lg bg-opacity-40"
              style={{
                borderColor: ['#7c3aed','#9333ea','#db2777','#facc15'][i],
                backgroundColor:['#4c1d95','#5b21b6','#831843','#713f12'][i]
              }}
              whileHover={{ scale:1.03 }}
            >
              {it.icon}
              <span className="font-semibold">{it.title}</span>
              <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                {it.info}
              </div>
            </motion.div>
          ))}
        </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      `}</style>
    </div>
  );
} */






/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const requiredClicks = 10;
const maxInterval = 700;
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1', role: 'Designer', bio: 'Loves creativity and color palettes.' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2', role: 'Developer', bio: 'Writes clean code and automates tasks.' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3', role: 'Project Manager', bio: 'Keeps the team on track and goals clear.' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4', role: 'Marketer', bio: 'Spreads the word and builds community.' },
];

// Avoid central UI: left 10-25% or 75-90%, top 40-90%
const generatePositions = () =>
  teamMembers.map(m => {
    const left = Math.random() < 0.5
      ? Math.random() * 15 + 10 // 10-25%
      : Math.random() * 15 + 75; // 75-90%
    const top = Math.random() * 50 + 40; // 40-90%
    return { id: m.id, top: `${top}%`, left: `${left}%` };
  });

function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  const burstRef = useRef(false);

  // automatically shrink progress bar when idle
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const timer = setTimeout(() => setClicks(prev => Math.max(0, prev - 1)), maxInterval);
      return () => clearTimeout(timer);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      setBursting(true);
      positions.forEach(pos => {
        window.confetti?.({ particleCount: 60, spread: 120, origin: { x: parseFloat(pos.left)/100, y: parseFloat(pos.top)/100 } });
      });
      setPositions([]);
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        burstRef.current = false;
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : 1;
      if (next >= requiredClicks && !burstRef.current) {
        burstRef.current = true;
        setInflated(true);
      }
      return next;
    });
  };

  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPercent = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

  
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          return (
            <motion.div
              key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: inflated ? 1 : scale, opacity: 1 }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className={`absolute rounded-full overflow-hidden shadow-lg ${inflated ? 'pointer-events-auto' : 'pointer-events-none'}`}
              style={{ width: 144, height: 144, top: pos.top, left: pos.left }}
            >
              <div className="relative group w-full h-full">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover" draggable={false} />
              
                <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="flex flex-col items-center justify-center h-full p-2 text-center">
                    <p className="font-bold text-lg">{m.name}</p>
                    <p className="italic text-sm">{m.role}</p>
                    <p className="mt-2 text-xs">{m.bio}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 120, damping: 20 }}>
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{ background: 'linear-gradient(90deg, #FF6B6B,#FFD166,#06D6A0)', backgroundSize: '200% 200%', animation: 'buttonGradient 2s linear infinite', userSelect: 'none', cursor: 'pointer' }}
              whileTap={{ scale: 0.95 }} aria-label={inflated ? 'Reset game' : 'Play Kløgtig'}>
              <motion.div className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercent}%` }} transition={{ type: 'tween', duration: 0.2 }} style={{ width:'0%' }} />
              <span className="relative z-10">{inflated?'Reset':'Spil Kløgtig!'}</span>
            </motion.button>
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div className="h-full bg-green-400"
                animate={{ width: `${progressPercent}%` }} transition={{ type: 'tween', duration: 0.2 }} style={{ width:'0%' }} />
            </div>
            <div className="mt-2 text-xl font-semibold">{clicks}/{requiredClicks} klik</div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            {[
              { icon: <FaPaintBrush size={32} className="text-pink-400" />, title: 'Kreativitet', info: 'Unlock new ideas!' },
              { icon: <FaUsers size={32} className="text-indigo-400" />, title: 'Sammenhold', info: 'Teamwork makes dream work.' },
              { icon: <FaTrophy size={32} className="text-yellow-400" />, title: 'Konkurrence', info: 'Challenge yourself.' },
              { icon: <FaLightbulb size={32} className="text-purple-400" />, title: 'Inspiration', info: 'Spark your next project.' },
            ].map((item,i) => (
              <motion.div key={i} className="group relative flex items-center gap-3 rounded-xl border p-4 max-w-[240px] shadow-lg bg-opacity-40"
                style={{ borderColor: ['#7c3aed','#9333ea','#db2777','#facc15'][i], backgroundColor: ['#4c1d95','#5b21b6','#831843','#713f12'][i] }}>
                {item.icon}
                <div className="flex flex-col">
                  <span className="font-semibold">{item.title}</span>
                </div>
                <div className="absolute inset-0 bg-black bg-opacity-75 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4 text-center">
                  {item.info}
                </div>
              </motion.div>
            ))}
          </section>
        </header>
      </div>

      <style>{`@keyframes buttonGradient {0%{background-position:0%50%}50%{background-position:100%50%}100%{background-position:0%50%}}`}</style>
    </div>
  );
}

export default App; */






/* import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const requiredClicks = 10;
const maxInterval = 700;
const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
];

// Avoid central UI: left 10-25% or 75-90%, top 40-90%
const generatePositions = () =>
  teamMembers.map(m => {
    const left = Math.random() < 0.5
      ? Math.random() * 15 + 10 // 10-25%
      : Math.random() * 15 + 75; // 75-90%
    const top = Math.random() * 50 + 40; // 40-90%
    return { id: m.id, top: `${top}%`, left: `${left}%` };
  });

function App() {
  const [positions, setPositions] = useState(() => generatePositions());
  const [clicks, setClicks] = useState(0);
  const [lastTime, setLastTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [bursting, setBursting] = useState(false);
  const burstRef = useRef(false);

  // automatically shrink progress bar when idle
  useEffect(() => {
    if (clicks > 0 && !inflated) {
      const timer = setTimeout(() => {
        setClicks(prev => Math.max(0, prev - 1));
      }, maxInterval);
      return () => clearTimeout(timer);
    }
  }, [clicks, inflated]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastTime;
    setLastTime(now);

    if (inflated) {
      // Burst and confetti
      setBursting(true);
      positions.forEach(pos => {
        const y = parseFloat(pos.top) / 100;
        const x = parseFloat(pos.left) / 100;
        window.confetti?.({ particleCount: 60, spread: 120, origin: { x, y } });
      });
      setPositions([]);

      // Reset after exit animation
      setTimeout(() => {
        setBursting(false);
        setInflated(false);
        setClicks(0);
        burstRef.current = false;
        setPositions(generatePositions());
        setLastTime(Date.now());
      }, 600);
      return;
    }

    setClicks(prev => {
      const next = delta < maxInterval ? Math.min(requiredClicks, prev + 1) : 1;
      if (next >= requiredClicks && !burstRef.current) {
        burstRef.current = true;
        setInflated(true);
      }
      return next;
    });
  };

  const scale = 0.3 + 0.7 * (clicks / requiredClicks);
  const showPhotos = clicks > 0 || inflated;
  const progressPercent = Math.round((clicks / requiredClicks) * 100);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

   
      <AnimatePresence>
        {!bursting && showPhotos && positions.map(pos => {
          const m = teamMembers.find(t => t.id === pos.id);
          return (
            <motion.div
              key={pos.id}
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: inflated ? 1 : scale, opacity: 1 }}
              exit={{ scale: 0.1, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              className="absolute rounded-full overflow-hidden shadow-lg pointer-events-none"
              style={{ width: 144, height: 144, top: pos.top, left: pos.left }}
            >
              <img
                src={m.photo}
                alt={m.name}
                className="w-full h-full object-cover"
                draggable={false}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label={inflated ? 'Reset game' : 'Play Kløgtig'}
            >
         
              <motion.div
                className="absolute inset-0 bg-white bg-opacity-20"
                animate={{ width: `${progressPercent}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
                style={{ width: '0%' }}
              />
              <span className="relative z-10">{inflated ? 'Reset' : 'Spil Kløgtig!'}</span>
            </motion.button>
        
            <div className="mt-4 w-full bg-gray-700 h-2 rounded overflow-hidden">
              <motion.div
                className="h-full bg-green-400"
                animate={{ width: `${progressPercent}%` }}
                transition={{ type: 'tween', duration: 0.2 }}
                style={{ width: '0%' }}
              />
            </div>
            <div className="mt-2 text-xl font-semibold">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

                    <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" /> Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaUsers size={32} className="text-indigo-400" /> Sammenhold
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaTrophy size={32} className="text-yellow-400" /> Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-yellow-700 p-4 max-w-[240px] shadow-lg bg-yellow-900/40">
              <FaLightbulb size={32} className="text-purple-400" /> Inspiration
            </div>
          </section>
        </header>
      </div>

      <style>{`@keyframes buttonGradient {0%{background-position:0%50%}50%{background-position:100%50%}100%{background-position:0%50%}}`}</style>
    </div>
  );
}

export default App; */






/* import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72,
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  const [spheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [fullyInflated, setFullyInflated] = useState(false);
  const hasBurstRef = useRef(false);

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });
  };

  const updateScalesByClicks = (clickCount) => {
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (fullyInflated) {
      // Reset on button click when fully inflated
      setClicks(0);
      setFullyInflated(false);
      updateScalesByClicks(0);
      hasBurstRef.current = false;
      setLastClickTime(now);
      return;
    }

    setClicks((prevClicks) => {
      let newClicks;

      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }
      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;
        setFullyInflated(true);

        // Keep scale max and clicks at max
        setClicks(requiredClicks);
        updateScalesByClicks(requiredClicks);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size * 2,
              height: size * 2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            animate={{ scale: scales[i], opacity: clicks === 0 ? 0 : 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label={fullyInflated ? "Reset game" : "Play Kløgtig"}
            >
              {fullyInflated ? 'Reset' : 'Spil Kløgtig!'}
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Sammenhold
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaTrophy size={32} className="text-yellow-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-yellow-700 p-4 max-w-[240px] shadow-lg bg-yellow-900/40">
              <FaLightbulb size={32} className="text-purple-400" />
              Inspiration
            </div>
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Confetti from 'react-confetti';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import { useWindowSize } from 'react-use';
import logo from './assets/logo/fox.png';

const requiredClicks = 10;
const maxInterval = 700; // ms

const teamMembers = [
  { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
  { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
  { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
  { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
];

const App = () => {
  const { width, height } = useWindowSize();
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [inflated, setInflated] = useState(false);
  const [scales, setScales] = useState(Array(teamMembers.length).fill(0.3));
  const hasBurst = useRef(false);

  useEffect(() => {
    if (clicks > 0 && clicks < requiredClicks) {
      setScales(scales.map(() => 0.3 + (0.7 * clicks) / requiredClicks));
    }
  }, [clicks]);

  const handleClick = () => {
    const now = Date.now();
    const delta = now - lastClickTime;
    let newCount = delta < maxInterval ? clicks + 1 : 1;
    newCount = Math.min(requiredClicks, newCount);

    setClicks(newCount);
    setLastClickTime(now);

    if (newCount === requiredClicks && !hasBurst.current) {
      hasBurst.current = true;
      setInflated(true);
    }

    if (inflated && newCount === requiredClicks) {
      // reset
      setClicks(0);
      setInflated(false);
      hasBurst.current = false;
      setScales(Array(teamMembers.length).fill(0.3));
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden font-sans text-white">
      
      <div className="absolute inset-0 animate-gradient bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900" />

      {[...Array(8)].map((_, i) => {
        const size = Math.random() * 200 + 200;
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        return (
          <motion.div
            key={i}
            className="absolute rounded-full bg-white/10 filter blur-3xl"
            style={{ width: size, height: size, top: `${top}%`, left: `${left}%` }}
            animate={{ y: ['-20%', '20%', '-20%'] }}
            transition={{ repeat: Infinity, duration: 10 + Math.random() * 5, ease: 'easeInOut' }}
          />
        );
      })}

     
      <header className="relative z-10 bg-black/20 backdrop-blur-md sticky top-0">
        <nav className="max-w-6xl mx-auto flex items-center justify-between p-4">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-20 h-20" />
            <div className="text-right">
              <p className="italic text-pink-300">- seriøs sjov!</p>
              <h1 className="text-3xl font-bold uppercase">kløgtig</h1>
            </div>
          </div>
        </nav>
      </header>

 
      <main className="relative z-10 flex flex-col items-center text-center pt-28 pb-16 px-4">
        <motion.h2
          className="text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        >
          Spil. Hyg. Fejr!
        </motion.h2>

        <motion.button
          onClick={handleClick}
          className="mt-8 px-12 py-4 text-xl font-bold uppercase rounded-full shadow-2xl"
          style={{
            background: 'linear-gradient(90deg,#FF6B6B,#FFD166,#06D6A0)',
            backgroundSize: '200% 200%',
          }}
          animate={inflated ? { scale: [1, 1.1, 1] } : { scale: 1 }}
          transition={{ repeat: inflated ? Infinity : 0, duration: 0.8 }}
          whileTap={{ scale: 0.9 }}
        >
          {inflated ? 'Reset' : 'Spil Kløgtig!'}
        </motion.button>

        <motion.div
          className="mt-4 p-3 bg-black/50 rounded-xl shadow-lg border border-purple-800"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          {clicks} / {requiredClicks} klik
        </motion.div>

     
        <div className="mt-12 flex flex-wrap justify-center gap-6">
          {[
            { icon: FaPaintBrush, text: 'Kreativitet' },
            { icon: FaUsers, text: 'Sammenhold' },
            { icon: FaTrophy, text: 'Konkurrence' },
            { icon: FaLightbulb, text: 'Inspiration' },
          ].map(({ icon: Icon, text }) => (
            <motion.div
              key={text}
              className="flex items-center gap-2 px-4 py-3 border rounded-2xl shadow-lg bg-black/30"
              whileHover={{ scale: 1.05 }}
              transition={{ type: 'spring', stiffness: 200 }}
            >
              <Icon size={28} className="text-gradient from-pink-300 to-indigo-300" />
              <span className="text-lg font-medium">{text}</span>
            </motion.div>
          ))}
        </div>
      </main>

    
      <AnimatePresence>
        {teamMembers.map((member, i) => (
          <motion.div
            key={member.id}
            className="absolute rounded-full overflow-hidden shadow-2xl"
            style={{ width: 144, height: 144 }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: clicks > 0 ? 1 : 0,
              scale: scales[i],
              x: [0, -10, 10, 0],
              y: [0, -10, 10, 0],
            }}
            transition={{ type: 'spring', stiffness: 120, damping: 20, delay: i * 0.1 }}
            whileHover={{ scale: scales[i] + 0.1 }}
            drag={false}
            style={{ top: `${15 + i * 20}%`, left: `${20 + i * 15}%` }}
          >
            <img
              src={member.photo}
              alt={member.name}
              className="w-full h-full object-cover"
            />
            <motion.div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-black/70 rounded-full text-xs"
              initial={{ opacity: 0 }}
              whileHover={{ opacity: 1 }}
            >
              {member.name}
            </motion.div>
          </motion.div>
        ))}
      </AnimatePresence>

    
      {inflated && <Confetti width={width} height={height} recycle={false} numberOfPieces={300} />}

     
      <style>{`
        @keyframes gradient {
          0% { background-position: 0 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 15s ease infinite;
        }
        .text-gradient {
          background: linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>
    </div>
  );
};

export default App; */






/* import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72,
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  const [spheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [fullyInflated, setFullyInflated] = useState(false);
  const hasBurstRef = useRef(false);

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });
  };

  const updateScalesByClicks = (clickCount) => {
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (fullyInflated) {
      // Reset on button click when fully inflated
      setClicks(0);
      setFullyInflated(false);
      updateScalesByClicks(0);
      hasBurstRef.current = false;
      setLastClickTime(now);
      return;
    }

    setClicks((prevClicks) => {
      let newClicks;

      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }
      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;
        setFullyInflated(true);

        // Keep scale max and clicks at max
        setClicks(requiredClicks);
        updateScalesByClicks(requiredClicks);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size * 2,
              height: size * 2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            animate={{ scale: scales[i], opacity: clicks === 0 ? 0 : 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label={fullyInflated ? "Reset game" : "Play Kløgtig"}
            >
              {fullyInflated ? 'Reset' : 'Spil Kløgtig!'}
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Sammenhold
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaTrophy size={32} className="text-yellow-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-yellow-700 p-4 max-w-[240px] shadow-lg bg-yellow-900/40">
              <FaLightbulb size={32} className="text-purple-400" />
              Inspiration
            </div>
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  // Team members array
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // Initialize spheres based on team members with random positions and sizes
  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72, // base size for all spheres
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  // State to hold spheres data (positions, size)
  const [spheres, setSpheres] = useState(initialSpheres);
  // Scales of each sphere (starts small)
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));

  // Clicks count (progress)
  const [clicks, setClicks] = useState(0);
  // Last click time for interval control
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  // Track if fully inflated
  const [fullyInflated, setFullyInflated] = useState(false);

  const hasBurstRef = useRef(false);

  // Get random position helper for bursts
  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti at spheres' positions
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });
  };

  // Update scales of all spheres/photos based on clicks progress
  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 to 1 based on clicks
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  // Handle clicking on the main button to inflate spheres/photos
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;

      if (fullyInflated) {
        // If fully inflated and user clicks again, restart inflation cycle
        newClicks = 1;
        setFullyInflated(false);
        updateScalesByClicks(1);
      } else {
        if (interval < maxInterval) {
          newClicks = Math.min(requiredClicks, prevClicks + 1);
        } else {
          newClicks = 1;
        }
        updateScalesByClicks(newClicks);
      }

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;
        setFullyInflated(true);

        // Reset clicks & burst flag after 500ms for next cycle
        setTimeout(() => {
          setClicks(requiredClicks); // Keep at max to stay inflated
          updateScalesByClicks(requiredClicks);
          hasBurstRef.current = false;
          setLastClickTime(Date.now());
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Remove continuous deflate effect so photos stay inflated after full inflation
  // Remove progress shrinking on idle for same reason

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      
      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size * 2,
              height: size * 2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            // Hide spheres if clicks is 0 by setting opacity to 0
            animate={{ scale: scales[i], opacity: clicks === 0 ? 0 : 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label="Spil kløgtig"
            >
              Spil Kløgtig!
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Sammenhold
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaTrophy size={32} className="text-yellow-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-yellow-700 p-4 max-w-[240px] shadow-lg bg-yellow-900/40">
              <FaLightbulb size={32} className="text-purple-400" />
              Inspiration
            </div>
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  // Team members array
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // Initialize spheres based on team members with random positions and sizes
  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72, // base size for all spheres, can randomize if you want
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  // State to hold spheres data (positions, size)
  const [spheres, setSpheres] = useState(initialSpheres);
  // Scales of each sphere (starts small)
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));

  // Clicks count (progress)
  const [clicks, setClicks] = useState(0);
  // Last click time for interval control
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);

  // Get random position helper for bursts
  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti at spheres' positions
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    // Animate spheres scale down and disappear (opacity 0)
    setScales(spheres.map(() => 0));

    // After short delay, reposition spheres randomly, reset scale
    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  // Update scales of all spheres/photos based on clicks progress
  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 to 1 based on clicks
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  // Handle clicking on the main button to inflate spheres/photos
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        // Reset clicks & burst flag after 500ms for next cycle
        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now());
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously independent of clicks
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // prevent rapid multiple shrinks
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      
      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size * 2,
              height: size * 2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            // Hide spheres if clicks is 0 by setting opacity to 0
            animate={{ scale: scales[i], opacity: clicks === 0 ? 0 : 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label="Spil kløgtig"
            >
              Spil Kløgtig!
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Sammenhold
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaTrophy size={32} className="text-yellow-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-yellow-700 p-4 max-w-[240px] shadow-lg bg-yellow-900/40">
              <FaLightbulb size={32} className="text-purple-400" />
              Inspiration
            </div>
          </section>
        </header>
      </div>

      
      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  // Team members array
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // Initialize spheres based on team members with random positions and sizes
  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72, // base size for all spheres, can randomize if you want
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  // State to hold spheres data (positions, size)
  const [spheres, setSpheres] = useState(initialSpheres);
  // Scales of each sphere (starts small)
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  // Visibility of spheres (opacity toggle)
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Clicks count (progress)
  const [clicks, setClicks] = useState(0);
  // Last click time for interval control
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);

  // Get random position helper for bursts
  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti at spheres' positions
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    // Animate spheres scale down and disappear (opacity 0)
    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    // After short delay, reposition spheres randomly, reset scale & visibility
    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  // Update scales of all spheres/photos based on clicks progress
  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 to 1 based on clicks
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  // Handle clicking on the main button to inflate spheres/photos
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        // Reset clicks & burst flag after 500ms for next cycle
        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now());
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously independent of clicks
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // prevent rapid multiple shrinks
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      
      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size*2,
              height: size*2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',
              
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            animate={{ scale: scales[i], opacity: visible[i] ? 1 : 0 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label="Spil kløgtig"
            >
              Spil Kløgtig!
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Samarbejde
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-blue-700 p-4 max-w-[240px] shadow-lg bg-blue-900/40">
              <FaTrophy size={32} className="text-purple-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaLightbulb size={32} className="text-blue-400" />
              Innovation
            </div>
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 200% 50%;
          }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  // Team members array
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // Initialize spheres based on team members with random positions and sizes
  const initialSpheres = teamMembers.map((member, i) => ({
    id: member.id,
    size: 72, // base size for all spheres, can randomize if you want
    top: `${10 + i * 20 + Math.random() * 10}%`,
    left: `${20 + i * 15 + Math.random() * 15}%`,
  }));

  // State to hold spheres data (positions, size)
  const [spheres, setSpheres] = useState(initialSpheres);
  // Scales of each sphere (starts small)
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  // Visibility of spheres (opacity toggle)
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Clicks count (progress)
  const [clicks, setClicks] = useState(0);
  // Last click time for interval control
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);

  // Get random position helper for bursts
  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti at spheres' positions
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    // Animate spheres scale down and disappear (opacity 0)
    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    // After short delay, reposition spheres randomly, reset scale & visibility
    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  // Update scales of all spheres/photos based on clicks progress
  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 to 1 based on clicks
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  // Handle clicking on the main button to inflate spheres/photos
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        // Reset clicks & burst flag after 500ms for next cycle
        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now());
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously independent of clicks
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // prevent rapid multiple shrinks
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      
      {spheres.map(({ id, size, top, left }, i) => {
        const member = teamMembers.find((m) => m.id === id);
        return (
          <motion.div
            key={id}
            className="absolute rounded-full overflow-hidden shadow-lg"
            style={{
              width: size*2,
              height: size*2,
              top,
              left,
              cursor: 'default',
              userSelect: 'none',
              
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            animate={{ scale: scales[i], opacity: visible[i] ? 1 : 0 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            draggable={false}
          >
            <motion.img
              src={member?.photo}
              alt={member?.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              draggable={false}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </motion.div>
        );
      })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s linear infinite',
                userSelect: 'none',
                cursor: 'pointer',
              }}
              whileTap={{ scale: 0.95 }}
              aria-label="Spil kløgtig"
            >
              Spil Kløgtig!
            </motion.button>

            <div className="mt-6 rounded-xl bg-black/40 p-4 border border-purple-800 text-xl font-semibold shadow-lg">
              {clicks} / {requiredClicks} klik
            </div>
          </div>

          <section className="flex flex-wrap justify-center mt-12 gap-10 px-2 max-w-4xl mx-auto text-xl font-semibold">
            <div className="flex items-center gap-3 rounded-xl border border-indigo-700 p-4 max-w-[240px] shadow-lg bg-indigo-900/40">
              <FaPaintBrush size={32} className="text-pink-400" />
              Kreativitet
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-pink-700 p-4 max-w-[240px] shadow-lg bg-pink-900/40">
              <FaUsers size={32} className="text-indigo-400" />
              Samarbejde
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-blue-700 p-4 max-w-[240px] shadow-lg bg-blue-900/40">
              <FaTrophy size={32} className="text-purple-400" />
              Konkurrence
            </div>
            <div className="flex items-center gap-3 rounded-xl border border-purple-700 p-4 max-w-[240px] shadow-lg bg-purple-900/40">
              <FaLightbulb size={32} className="text-blue-400" />
              Innovation
            </div>
          </section>
        </header>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 200% 50%;
          }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  // === TEAM MEMBER PHOTOS & CONFETTI LOGIC ===

  // Replace these with your actual team member photo URLs
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // State to control if team photos are visible
  const [teamPhotosVisible, setTeamPhotosVisible] = useState(false);

  // The array of team members already shown (in random order)
  const [revealedMembers, setRevealedMembers] = useState([]);

  // Ref for timer
  const revealTimeoutRef = useRef(null);

  // Position for each revealed photo (random)
  const [photoPositions, setPhotoPositions] = useState({}); // id => {top, left}

  // Helper to generate random positions inside screen
  const getRandomPositionForPhoto = () => {
    // Avoid edges for nice look
    const top = Math.random() * 70 + 10; // 10% to 80%
    const left = Math.random() * 70 + 10; // 10% to 80%
    return { top: `${top}%`, left: `${left}%` };
  };

  // Confetti burst at a given position
  const burstConfettiAt = ({ top, left }) => {
    const y = parseFloat(top) / 100;
    const x = parseFloat(left) / 100;
    window.confetti?.({
      particleCount: 60,
      spread: 100,
      origin: { x, y },
    });
  };

  // Show team members one by one with confetti on each
  const revealTeamMembersSequentially = () => {
    // Create a shuffled array of members
    const shuffled = [...teamMembers].sort(() => Math.random() - 0.5);

    setRevealedMembers([]);
    setPhotoPositions({});

    let index = 0;

    const revealNext = () => {
      if (index >= shuffled.length) {
        return;
      }
      const member = shuffled[index];
      const pos = getRandomPositionForPhoto();

      setPhotoPositions((prev) => ({ ...prev, [member.id]: pos }));

      // Add member to revealedMembers (to render photo)
      setRevealedMembers((prev) => [...prev, member]);

      // Burst confetti at photo position
      burstConfettiAt(pos);

      index++;
      revealTimeoutRef.current = setTimeout(revealNext, 1500);
    };

    revealNext();
  };

  // On team box click
  const handleTeamBoxClick = () => {
    if (teamPhotosVisible) {
      // Hide all photos & clear timeout
      setTeamPhotosVisible(false);
      setRevealedMembers([]);
      setPhotoPositions({});
      if (revealTimeoutRef.current) {
        clearTimeout(revealTimeoutRef.current);
      }
    } else {
      // Show confetti once on center (or anywhere)
      window.confetti?.({
        particleCount: 150,
        spread: 150,
        origin: { x: 0.5, y: 0.5 },
      });

      // Start showing photos sequentially
      setTeamPhotosVisible(true);
      revealTeamMembersSequentially();
    }
  };

  // === EXISTING GAME CLICK LOGIC ===

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        // Reset clicks and burst flag after 500ms so confetti only triggers once per full cycle
        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // reset lastClickTime so next clicks work normally
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      {teamPhotosVisible &&
        revealedMembers.map((member) => {
          const pos = photoPositions[member.id];
          if (!pos) return null;
          return (
            <motion.img
              key={member.id}
              src={member.photo}
              alt={member.name}
              className="absolute rounded-full border-4 border-pink-400 shadow-lg"
              style={{
                width: 120,
                height: 120,
                top: pos.top,
                left: pos.left,
                cursor: 'default',
                userSelect: 'none',
              }}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              draggable={false}
            />
          );
        })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-xs mt-2">Klik {requiredClicks} gange hurtigt for at fyre konfetti!</p>
          </div>

          <div
            onClick={handleTeamBoxClick}
            className="mt-20 mx-auto w-48 h-48 rounded-full bg-gradient-to-tr from-pink-600 to-purple-700 shadow-lg cursor-pointer select-none flex flex-col items-center justify-center text-white text-center"
            style={{ userSelect: 'none' }}
            title="Klik her for team overraskelse"
          >
            <FaUsers size={48} />
            <span className="mt-3 text-xl font-semibold">Team</span>
            <small className="opacity-70 mt-1">Klik for overraskelse</small>
          </div>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50% }
          50% { background-position: 100% 50% }
          100% { background-position: 0% 50% }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  // === TEAM MEMBER PHOTOS & CONFETTI LOGIC ===

  // Replace these with your actual team member photo URLs
  const teamMembers = [
    { id: 1, name: 'Alice', photo: 'https://i.pravatar.cc/150?img=1' },
    { id: 2, name: 'Bob', photo: 'https://i.pravatar.cc/150?img=2' },
    { id: 3, name: 'Charlie', photo: 'https://i.pravatar.cc/150?img=3' },
    { id: 4, name: 'Diana', photo: 'https://i.pravatar.cc/150?img=4' },
  ];

  // State to control if team photos are visible
  const [teamPhotosVisible, setTeamPhotosVisible] = useState(false);

  // The array of team members already shown (in random order)
  const [revealedMembers, setRevealedMembers] = useState([]);

  // Ref for timer
  const revealTimeoutRef = useRef(null);

  // Position for each revealed photo (random)
  const [photoPositions, setPhotoPositions] = useState({}); // id => {top, left}

  // Helper to generate random positions inside screen
  const getRandomPositionForPhoto = () => {
    // Avoid edges for nice look
    const top = Math.random() * 70 + 10; // 10% to 80%
    const left = Math.random() * 70 + 10; // 10% to 80%
    return { top: `${top}%`, left: `${left}%` };
  };

  // Confetti burst at a given position
  const burstConfettiAt = ({ top, left }) => {
    const y = parseFloat(top) / 100;
    const x = parseFloat(left) / 100;
    window.confetti?.({
      particleCount: 60,
      spread: 100,
      origin: { x, y },
    });
  };

  // Show team members one by one with confetti on each
  const revealTeamMembersSequentially = () => {
    // Create a shuffled array of members
    const shuffled = [...teamMembers].sort(() => Math.random() - 0.5);

    setRevealedMembers([]);
    setPhotoPositions({});

    let index = 0;

    const revealNext = () => {
      if (index >= shuffled.length) {
        return;
      }
      const member = shuffled[index];
      const pos = getRandomPositionForPhoto();

      setPhotoPositions((prev) => ({ ...prev, [member.id]: pos }));

      // Add member to revealedMembers (to render photo)
      setRevealedMembers((prev) => [...prev, member]);

      // Burst confetti at photo position
      burstConfettiAt(pos);

      index++;
      revealTimeoutRef.current = setTimeout(revealNext, 1500);
    };

    revealNext();
  };

  // On team box click
  const handleTeamBoxClick = () => {
    if (teamPhotosVisible) {
      // Hide all photos & clear timeout
      setTeamPhotosVisible(false);
      setRevealedMembers([]);
      setPhotoPositions({});
      if (revealTimeoutRef.current) {
        clearTimeout(revealTimeoutRef.current);
      }
    } else {
      // Show confetti once on center (or anywhere)
      window.confetti?.({
        particleCount: 150,
        spread: 150,
        origin: { x: 0.5, y: 0.5 },
      });

      // Start showing photos sequentially
      setTeamPhotosVisible(true);
      revealTeamMembersSequentially();
    }
  };

  // === EXISTING GAME CLICK LOGIC ===

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        // Reset clicks and burst flag after 500ms so confetti only triggers once per full cycle
        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // reset lastClickTime so next clicks work normally
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      {teamPhotosVisible &&
        revealedMembers.map((member) => {
          const pos = photoPositions[member.id];
          if (!pos) return null;
          return (
            <motion.img
              key={member.id}
              src={member.photo}
              alt={member.name}
              className="absolute rounded-full border-4 border-pink-400 shadow-lg"
              style={{
                width: 120,
                height: 120,
                top: pos.top,
                left: pos.left,
                cursor: 'default',
                userSelect: 'none',
              }}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              draggable={false}
            />
          );
        })}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
            <div className="flex flex-col items-end leading-tight">
              <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
              <span className="text-4xl font-bold">kløgtig</span>
            </div>
          </div>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-xs mt-2">Klik {requiredClicks} gange hurtigt for at fyre konfetti!</p>
          </div>

          <div
            onClick={handleTeamBoxClick}
            className="mt-20 mx-auto w-48 h-48 rounded-full bg-gradient-to-tr from-pink-600 to-purple-700 shadow-lg cursor-pointer select-none flex flex-col items-center justify-center text-white text-center"
            style={{ userSelect: 'none' }}
            title="Klik her for team overraskelse"
          >
            <FaUsers size={48} />
            <span className="mt-3 text-xl font-semibold">Team</span>
            <small className="opacity-70 mt-1">Klik for overraskelse</small>
          </div>
        </header>
      </div>


      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50% }
          50% { background-position: 100% 50% }
          100% { background-position: 0% 50% }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
  const now = Date.now();
  const interval = now - lastClickTime;

  setClicks((prevClicks) => {
    let newClicks;
    if (interval < maxInterval) {
      newClicks = Math.min(requiredClicks, prevClicks + 1);
    } else {
      newClicks = 1;
    }

    updateScalesByClicks(newClicks);

    if (newClicks >= requiredClicks && !hasBurstRef.current) {
      burstConfetti();
      hasBurstRef.current = true;

      // Reset clicks and burst flag after 500ms so confetti only triggers once per full cycle
      setTimeout(() => {
        setClicks(0);
        updateScalesByClicks(0);
        hasBurstRef.current = false;
        setLastClickTime(Date.now()); // reset lastClickTime so next clicks work normally
      }, 500);
    }

    return newClicks;
  });

  setLastClickTime(now);
};


  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

    
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
  <div className="flex items-center space-x-4">
    <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
    <div className="flex flex-col items-end leading-tight">
      <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
      <span className="text-4xl font-bold">
        kløgtig
      </span>
    </div>
  </div>
</nav>


        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>
         

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
  {
    icon: <FaLightbulb />,
    title: 'Innovative pixelfortællere',
    desc: 'Vi skaber pixels og glade minder, ét episk spil ad gangen!',
  },
  {
  icon: <FaUsers />,
  title: 'Teamet bag',
  desc: 'Et passioneret hold af spilentusiaster og kreative sjæle, der elsker at bringe mennesker sammen.',
},
].map(({ icon, title, desc }, i) => (
  <motion.div
    key={i}
    className="bg-black/30 p-8 rounded-xl backdrop-blur-md"
    initial={{ y: 40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 0.2 * i, type: 'spring', stiffness: 80 }}
  >
    <div className="text-5xl mb-4 text-purple-400">{icon}</div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-300">{desc}</p>
  </motion.div>
))}

        </section>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {background-position: 0% 50%;}
          50% {background-position: 100% 50%;}
          100% {background-position: 0% 50%;}
        }
      `}</style>
    </div>
  );
}

export default App; */




/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        // Reset progress if too slow click
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // Reset lastClickTime after burst reset
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

    
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
  <div className="flex items-center space-x-4">
    <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
    <div className="flex flex-col items-end leading-tight">
      <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
      <span className="text-4xl font-bold">
        kløgtig
      </span>
    </div>
  </div>
</nav>


        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>
       

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
  {
    icon: <FaLightbulb />,
    title: 'Innovative pixelfortællere',
    desc: 'Vi skaber pixels og glade minder, ét episk spil ad gangen!',
  },
  {
  icon: <FaUsers />,
  title: 'Teamet bag',
  desc: 'Et passioneret hold af spilentusiaster og kreative sjæle, der elsker at bringe mennesker sammen.',
},
].map(({ icon, title, desc }, i) => (
  <motion.div
    key={i}
    className="bg-black/30 p-8 rounded-xl backdrop-blur-md"
    initial={{ y: 40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 0.2 * i, type: 'spring', stiffness: 80 }}
  >
    <div className="text-5xl mb-4 text-purple-400">{icon}</div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-300">{desc}</p>
  </motion.div>
))}

        </section>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {background-position: 0% 50%;}
          50% {background-position: 100% 50%;}
          100% {background-position: 0% 50%;}
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        // Reset progress if too slow click
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // Reset lastClickTime after burst reset
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

    
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
  <div className="flex items-center space-x-4">
    <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
    <div className="flex flex-col items-end leading-tight">
      <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
      <span className="text-4xl font-bold">
        kløgtig
      </span>
    </div>
  </div>
</nav>


        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>
         

          <div className="mt-4 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
  {
    icon: <FaPaintBrush />,
    title: 'Pixelfortællere',
    desc: 'Skaber pixels og glade minder, ét episk spil ad gangen!',
  },
  {
    icon: <FaLightbulb />,
    title: 'Innovation',
    desc: 'Spildesign der overrasker og glæder',
  },
].map(({ icon, title, desc }, i) => (
  <motion.div
    key={i}
    className="bg-black/30 p-8 rounded-xl backdrop-blur-md"
    initial={{ y: 40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 0.2 * i, type: 'spring', stiffness: 80 }}
  >
    <div className="text-5xl mb-4 text-pink-400">{icon}</div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-300">{desc}</p>
  </motion.div>
))}

        </section>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {background-position: 0% 50%;}
          50% {background-position: 100% 50%;}
          100% {background-position: 0% 50%;}
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        // Reset progress if too slow click
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // Reset lastClickTime after burst reset
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

    
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
  <div className="flex items-center space-x-4">
    <img src={logo} alt="Kløgtig logo" className="w-24 h-24 object-contain" />
    <div className="flex flex-col items-end leading-tight">
      <span className="text-md italic text-pink-300 -mb-1">- seriøs sjov!</span>
      <span className="text-4xl font-bold">
        kløgtig
      </span>
    </div>
  </div>
</nav>


        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold leading-snug mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Spil. Hyg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map(({ icon, title, desc }, i) => (
            <motion.div
              key={i}
              className="bg-black/30 p-8 rounded-xl backdrop-blur-md"
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 * i, type: 'spring', stiffness: 80 }}
            >
              <div className="text-5xl mb-4 text-pink-400">{icon}</div>
              <h3 className="text-xl font-bold mb-2">{title}</h3>
              <p className="text-gray-300">{desc}</p>
            </motion.div>
          ))}
        </section>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {background-position: 0% 50%;}
          50% {background-position: 100% 50%;}
          100% {background-position: 0% 50%;}
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // ms between clicks allowed

  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Store clicks count which corresponds to progress chunks (0 to requiredClicks)
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);
  const progressChunk = 100 / requiredClicks; // 10

  const randomPosition = () => {
    const top = Math.random() * 80 + 10;
    const left = Math.random() * 80 + 10;
    return { top: `${top}%`, left: `${left}%` };
  };

  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  const updateScalesByClicks = (clickCount) => {
    // scale from 0.3 (0 clicks) to 1 (full clicks)
    const scale = 0.3 + 0.7 * (clickCount / requiredClicks);
    setScales(scales.map(() => scale));
  };

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    setClicks((prevClicks) => {
      let newClicks;
      if (interval < maxInterval) {
        newClicks = Math.min(requiredClicks, prevClicks + 1);
      } else {
        // Reset progress if too slow click
        newClicks = 1;
      }

      updateScalesByClicks(newClicks);

      if (newClicks >= requiredClicks && !hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;

        setTimeout(() => {
          setClicks(0);
          updateScalesByClicks(0);
          hasBurstRef.current = false;
          setLastClickTime(Date.now()); // Reset lastClickTime after burst reset
        }, 500);
      }

      return newClicks;
    });

    setLastClickTime(now);
  };

  // Slowly deflate spheres continuously (independent of clicks)
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? Math.max(0.3, s - 0.02) : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Shrink progress bar by 1 chunk if idle > 500ms
  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 500 && clicks > 0) {
        const newClicks = Math.max(0, clicks - 1);
        setClicks(newClicks);
        updateScalesByClicks(newClicks);
        setLastClickTime(Date.now()); // Prevent rapid multiple shrinks
      }
    }, 1000); // every 1 second shrink by 1 chunk

    return () => clearInterval(interval);
  }, [lastClickTime, clicks]);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

     
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${(clicks / requiredClicks) * 100}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Skab Spil', desc: 'Lav dine egne quizzer og små spil' },
          ].map(({ icon, title, desc }, i) => (
            <motion.div
              key={i}
              className="bg-black/30 p-8 rounded-xl backdrop-blur-md"
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 * i, type: 'spring', stiffness: 80 }}
            >
              <div className="text-5xl mb-4 text-pink-400">{icon}</div>
              <h3 className="text-xl font-bold mb-2">{title}</h3>
              <p className="text-gray-300">{desc}</p>
            </motion.div>
          ))}
        </section>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% {background-position: 0% 50%;}
          50% {background-position: 100% 50%;}
          100% {background-position: 0% 50%;}
        }
      `}</style>
    </div>
  );
}

export default App; */








/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // max ms between clicks

  // Initial spheres with fixed size and starting position
  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  // States for spheres position, scale, and visibility
  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Click tracking states
  const [clicks, setClicks] = useState(0);
  const [progress, setProgress] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);

  // Utility: generate random position within viewport (10%-90%)
  const randomPosition = () => {
    const top = Math.random() * 80 + 10; // 10% to 90%
    const left = Math.random() * 80 + 10; // 10% to 90%
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti and burst spheres, then reposition and fade in spheres
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    // Step 1: Scale spheres to 0 and hide (opacity 0)
    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    // Step 2: After 300ms, reposition spheres randomly and fade them back in scaled to 0.3
    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  // Handle click logic with progress tracking and burst triggering
  const handleGameClick = () => {
  const now = Date.now();
  const interval = now - lastClickTime;

  if (interval < maxInterval) {
    const newClicks = clicks + 1;
    const newProgress = (newClicks / requiredClicks) * 100;
    setClicks(newClicks);
    setProgress(newProgress);

    // Scale spheres bigger with progress
    setScales(scales.map(() => 0.3 + 0.7 * (newProgress / 100)));

    // Trigger burst when reached required clicks
    if (newClicks >= requiredClicks) {
      if (!hasBurstRef.current) {
        burstConfetti();
        hasBurstRef.current = true;
      }
      setClicks(0);
      setProgress(0);

      // Reset burst lock after a short delay so you can burst again
      setTimeout(() => {
        hasBurstRef.current = false;
      }, 500);
    }
  } else {
    // Too slow click: reset clicks and shrink spheres slightly
    setClicks(1);

    // Shrink progress bar a bit
    setProgress((prevProgress) => Math.max(0, prevProgress - 10));

    // Shrink spheres slightly
    setScales(scales.map((s) => Math.max(0.3, s - 0.15)));
  }
  setLastClickTime(now);
};


  // Slowly deflate spheres over time when idle
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) => prev.map((s) => (s > 0.3 ? s - 0.02 : 0.3)));
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Skab Spil', desc: 'Lav dine egne quizzer og små spil' },
          ].map(({ icon, title, desc }, i) => (
            <motion.div
              key={i}
              className="bg-black/20 rounded-3xl p-8 shadow-lg flex flex-col items-center text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
            >
              <div className="text-pink-400 mb-4 text-5xl">{icon}</div>
              <h3 className="text-xl font-bold mb-2">{title}</h3>
              <p className="text-gray-300">{desc}</p>
            </motion.div>
          ))}
        </section>

        <footer className="bg-black/20 py-8 px-4 text-center text-gray-400">
          &copy; 2025 Kløgtig ApS — Alle rettigheder forbeholdes
        </footer>
      </div>
    </div>
  );
}

export default App; */







/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700; // max ms between clicks

  // Initial spheres with fixed size and starting position
  const initialSpheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  // States for spheres position, scale, and visibility
  const [spheres, setSpheres] = useState(initialSpheres);
  const [scales, setScales] = useState(initialSpheres.map(() => 0.3));
  const [visible, setVisible] = useState(initialSpheres.map(() => true));

  // Click tracking states
  const [clicks, setClicks] = useState(0);
  const [progress, setProgress] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());

  const hasBurstRef = useRef(false);

  // Utility: generate random position within viewport (10%-90%)
  const randomPosition = () => {
    const top = Math.random() * 80 + 10; // 10% to 90%
    const left = Math.random() * 80 + 10; // 10% to 90%
    return { top: `${top}%`, left: `${left}%` };
  };

  // Burst confetti and burst spheres, then reposition and fade in spheres
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });

    // Step 1: Scale spheres to 0 and hide (opacity 0)
    setScales(spheres.map(() => 0));
    setVisible(spheres.map(() => false));

    // Step 2: After 300ms, reposition spheres randomly and fade them back in scaled to 0.3
    setTimeout(() => {
      const newPositions = spheres.map(() => randomPosition());
      setSpheres((prev) =>
        prev.map((s, i) => ({
          ...s,
          top: newPositions[i].top,
          left: newPositions[i].left,
        }))
      );
      setVisible(spheres.map(() => true));
      setScales(spheres.map(() => 0.3));
    }, 300);
  };

  // Handle click logic with progress tracking and burst triggering
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (interval < maxInterval) {
      const newClicks = clicks + 1;
      const newProgress = (newClicks / requiredClicks) * 100;
      setClicks(newClicks);
      setProgress(newProgress);

      // Scale spheres bigger with progress
      setScales(scales.map(() => 0.3 + 0.7 * (newProgress / 100)));

      // Trigger burst when reached required clicks
      if (newClicks >= requiredClicks) {
        if (!hasBurstRef.current) {
          burstConfetti();
          hasBurstRef.current = true;
        }
        setClicks(0);
        setProgress(0);

        // Reset burst lock after a short delay so you can burst again
        setTimeout(() => {
          hasBurstRef.current = false;
        }, 500);
      }
    } else {
      // Too slow click: reset clicks and shrink spheres slightly
      setClicks(1);
      setProgress(10);
      setScales(scales.map((s) => Math.max(0.3, s - 0.15)));
    }
    setLastClickTime(now);
  };

  // Slowly deflate spheres over time when idle
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) => prev.map((s) => (s > 0.3 ? s - 0.02 : 0.3)));
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen bg-gradient-to-tr from-indigo-800 via-purple-900 to-black font-sans text-white overflow-hidden">
   
      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white"
          style={{
            width: size,
            height: size,
            top,
            left,
            pointerEvents: 'none',
            opacity: 0.1,
          }}
          animate={{ scale: scales[i], opacity: visible[i] ? 0.1 : 0 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

     
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-6">
        <h1 className="mb-12 text-5xl font-extrabold tracking-tight text-white select-none">
          Click Quickly for 🎉
        </h1>

        <button
          onClick={handleGameClick}
          className="w-full max-w-sm px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg bg-gradient-to-r from-pink-500 via-yellow-400 to-green-400 animate-gradient-x"
          style={{
            backgroundSize: '200% 200%',
          }}
        >
          Click Me Fast!
        </button>

        <p className="mt-8 text-lg select-none">
          Progress: {progress.toFixed(0)}% ({clicks} / {requiredClicks})
        </p>
      </div>

      <style>{`
        @keyframes gradient-x {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-x {
          animation: gradient-x 3s ease infinite;
        }
      `}</style>
    </div>
  );
}

export default App;
 */





/* import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const requiredClicks = 10;
  const maxInterval = 700;

  const spheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  // State for clicks & progress
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [progress, setProgress] = useState(0);

  // For scaling spheres dynamically (normal scale)
  const [scales, setScales] = useState(spheres.map(() => 0.3));

  // For bursting animation control: stores burst status per sphere
  const [burstingSpheres, setBurstingSpheres] = useState(spheres.map(() => false));

  // Ref to prevent multiple bursts simultaneously
  const hasBurstRef = useRef(false);

  // Handles clicks & progress
  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (interval < maxInterval) {
      const newClicks = clicks + 1;
      const newProgress = (newClicks / requiredClicks) * 100;
      setClicks(newClicks);
      setProgress(newProgress);
      setScales(scales.map(() => 0.3 + 0.7 * (newProgress / 100)));

      if (newClicks >= requiredClicks) {
        if (!hasBurstRef.current) {
          hasBurstRef.current = true;
          triggerBurstSequence();
        }
      }
    } else {
      // too slow — deflate spheres and reset clicks
      setClicks(1);
      setProgress(10);
      setScales(scales.map((s) => Math.max(0.3, s - 0.15)));
    }
    setLastClickTime(now);
  };

  // Slowly deflate spheres if no clicks for a while
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) =>
        prev.map((s) => (s > 0.3 ? s - 0.02 : 0.3))
      );
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Burst each sphere one by one with confetti from their position
  const triggerBurstSequence = async () => {
    for (let i = 0; i < spheres.length; i++) {
      // Trigger bursting animation for sphere i
      setBurstingSpheres((prev) =>
        prev.map((b, idx) => (idx === i ? true : b))
      );

      // Trigger confetti burst from sphere i's position
      const { top, left } = spheres[i];
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 120,
        origin: { x, y },
      });

      // Wait for burst animation duration before next burst
      await new Promise((res) => setTimeout(res, 400));

      // Reset this sphere bursting state so it reappears for next cycle
      setBurstingSpheres((prev) =>
        prev.map((b, idx) => (idx === i ? false : b))
      );
    }

    // Reset clicks, progress and scales after bursts
    setClicks(0);
    setProgress(0);
    setScales(spheres.map(() => 0.3));
    hasBurstRef.current = false;
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />

      {spheres.map(({ id, size, top, left }, i) => (
        <AnimatePresence key={id}>
          {!burstingSpheres[i] && (
            <motion.span
              className="absolute rounded-full bg-white opacity-10"
              style={{ width: size, height: size, top, left }}
              animate={{ scale: scales[i] }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
              initial={{ scale: 0.3 }}
              exit={{ scale: 1.5, opacity: 0, transition: { duration: 0.4 } }}
            />
          )}
          {burstingSpheres[i] && (
            <motion.span
              className="absolute rounded-full bg-pink-400 opacity-80"
              style={{ width: size, height: size, top, left }}
              initial={{ scale: scales[i], opacity: 1 }}
              animate={{ scale: 2, opacity: 0 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
              exit={{ opacity: 0 }}
            />
          )}
        </AnimatePresence>
      ))}

      <div className="relative z-10">
   
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [progress, setProgress] = useState(0);
  const requiredClicks = 10;
  const maxInterval = 700; // milliseconds

  // Sphere data with positions and initial sizes
  const spheres = [
    { id: 0, size: 72, top: '10%', left: '20%' },
    { id: 1, size: 48, top: '60%', left: '75%' },
    { id: 2, size: 56, top: '35%', left: '45%' },
  ];

  // Track each sphere's scale dynamically
  const [scales, setScales] = useState(spheres.map(() => 0.3)); // start small (0.3 scale)

  // Ref to prevent multiple confetti bursts on the same completion
  const hasBurstRef = useRef(false);

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (interval < maxInterval) {
      const newClicks = clicks + 1;
      const newProgress = (newClicks / requiredClicks) * 100;
      setClicks(newClicks);
      setProgress(newProgress);

      // Inflate spheres proportional to progress
      setScales(scales.map(() => 0.3 + 0.7 * (newProgress / 100)));

      if (newClicks >= requiredClicks) {
        if (!hasBurstRef.current) {
          burstConfetti();
          hasBurstRef.current = true;
        }
        setClicks(0);
        setProgress(0);
        // Reset scales after a short delay
        setTimeout(() => {
          setScales(spheres.map(() => 0.3));
          hasBurstRef.current = false;
        }, 500);
      }
    } else {
      // too slow — deflate spheres a bit and reset clicks to 1
      setClicks(1);
      setProgress(10);
      setScales(scales.map((s) => Math.max(0.3, s - 0.15))); // deflate but not below 0.3
    }
    setLastClickTime(now);
  };

  // Also slowly deflate spheres if no clicks for a while
  useEffect(() => {
    const interval = setInterval(() => {
      setScales((prev) => {
        const newScales = prev.map((s) => {
          if (s > 0.3) return s - 0.02;
          return 0.3;
        });
        return newScales;
      });
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  // Confetti burst function for each sphere's position
  const burstConfetti = () => {
    spheres.forEach(({ top, left }) => {
      const y = parseFloat(top) / 100;
      const x = parseFloat(left) / 100;
      window.confetti?.({
        particleCount: 60,
        spread: 100,
        origin: { x, y },
      });
    });
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />


      {spheres.map(({ id, size, top, left }, i) => (
        <motion.span
          key={id}
          className="absolute rounded-full bg-white opacity-10"
          style={{ width: size, height: size, top, left }}
          animate={{ scale: scales[i] }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
        />
      ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */





// WORKS
/* import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [progress, setProgress] = useState(0);

  const requiredClicks = 10;
  const maxInterval = 700; // milliseconds

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (interval < maxInterval) {
      const newClicks = clicks + 1;
      setClicks(newClicks);
      setProgress((newClicks / requiredClicks) * 100);
      if (newClicks >= requiredClicks) {
        window.confetti?.({ particleCount: 200, spread: 120, origin: { y: 0.2 } });
        setClicks(0);
        setProgress(0);
      }
    } else {
      // too slow — reset
      setClicks(1);
      setProgress((1 / requiredClicks) * 100);
    }

    setLastClickTime(now);
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      
   
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">
   
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

     
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

    
          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>


        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

       
        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const BONUSES = [
  { id: 1, text: "Bonus 1: Mascot appears! 🦊" },
  { id: 2, text: "Bonus 2: Background brightens! 🌟" },
  { id: 3, text: "Bonus 3: Final confetti & celebration! 🎉" },
];

function App() {
  const [progress, setProgress] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(null);
  const [message, setMessage] = useState("");
  const timeoutRef = useRef(null);

  // On mount, initial confetti
  useEffect(() => {
    const timer = setTimeout(() => window.confetti?.({ particleCount: 150, spread: 100 }), 800);
    return () => clearTimeout(timer);
  }, []);

  // Handle clicks with timing checks
  const handleClick = () => {
    const now = Date.now();
    if (lastClickTime === null) {
      // First click: start progress
      setProgress(1);
      setMessage(BONUSES[0].text);
      setLastClickTime(now);
      startTimeout();
      return;
    }

    const diff = now - lastClickTime;

    // Must be between 300ms and 1500ms to count as good click
    if (diff >= 300 && diff <= 1500) {
      const nextProgress = progress + 1;
      if (nextProgress <= BONUSES.length) {
        setProgress(nextProgress);
        setMessage(BONUSES[nextProgress - 1].text);
        setLastClickTime(now);

        if (nextProgress === BONUSES.length) {
          // Fire confetti on final step
          window.confetti?.({
            particleCount: 300,
            spread: 150,
            origin: { y: 0.3 },
          });
          clearTimeout(timeoutRef.current);
          // Reset progress after celebration delay
          timeoutRef.current = setTimeout(() => {
            setProgress(0);
            setMessage("");
            setLastClickTime(null);
          }, 4000);
        } else {
          // Reset timeout for next click window
          startTimeout();
        }
      }
    } else {
      // Too slow or too fast, reset progress
      resetProgress("Oops! Click slower or faster to keep the rhythm.");
    }
  };

  // Timeout: user took too long, reset
  const startTimeout = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      resetProgress("Too slow! Try to keep the rhythm.");
    }, 1500);
  };

  const resetProgress = (msg) => {
    setProgress(0);
    setMessage(msg || "");
    setLastClickTime(null);
    clearTimeout(timeoutRef.current);
  };

  return (
    <div
      className={`relative min-h-screen font-sans text-white overflow-auto
        ${progress >= 2 ? "bg-gradient-to-br from-purple-700 via-blue-700 to-indigo-700" : ""}
      `}
    >
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home','Features','Contact'].map((t,i)=>(
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

      
          <div className="w-72 h-6 bg-gray-700 rounded-full overflow-hidden mt-10">
            <motion.div
              className="h-full bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400"
              initial={{ width: 0 }}
              animate={{ width: `${(progress / BONUSES.length) * 100}%` }}
              transition={{ type: 'spring', stiffness: 120, damping: 20 }}
            />
          </div>

 
          <p className="mt-4 min-h-[24px] text-lg text-yellow-300 font-semibold">{message}</p>

          <motion.button
            onClick={handleClick}
            className="mt-12 px-12 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 2s ease infinite',
              userSelect: 'none',
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Tryk rytmisk 🎮
          </motion.button>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f,i)=>(
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i*0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb, FaGift } from 'react-icons/fa';
import logo from './assets/logo/fox.png';
import mascot from './assets/logo/fox.png'; // reuse or use new image

function App() {
  const [confettiCount, setConfettiCount] = useState(0);

  const handleCelebrate = () => {
    if (confettiCount < 3) {
      setConfettiCount(confettiCount + 1);
      window.confetti?.({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.3 },
      });
    }
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto transition-all duration-700"
      style={{
        background: confettiCount >= 2
          ? 'linear-gradient(to right, #ff6ec4, #7873f5)'
          : 'linear-gradient(to bottom right, #2e026d, #15162c)',
      }}
    >

      {[{ size: 72, top: '10%', left: '20%' },
        { size: 48, top: '60%', left: '75%' },
        { size: 56, top: '35%', left: '45%' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left }}
          />
        ))}

      <div className="relative z-10">
  
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

     
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>

          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <motion.button
            onClick={handleCelebrate}
            className="mt-12 px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 2s ease infinite',
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Tryk for 🎉
          </motion.button>

          <p className="mt-4 text-pink-200">🎯 Fremgang: {confettiCount}/3</p>

          {confettiCount >= 1 && (
            <motion.img
              src={mascot}
              alt="Fox mascot"
              initial={{ x: -200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 100 }}
              className="w-32 mt-10"
            />
          )}

    
          {confettiCount >= 3 && (
            <motion.div
              className="mt-10 text-center"
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <div className="text-4xl mb-2 text-yellow-300">
                <FaGift />
              </div>
              <h2 className="text-2xl font-bold mb-2">🎉 Du har låst op for en overraskelse!</h2>
              <button className="bg-pink-500 hover:bg-pink-600 px-6 py-3 rounded-full text-white text-lg font-semibold shadow-lg mt-4">
                Tilmeld dig Betaen
              </button>
            </motion.div>
          )}
        </header>

      
        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [clicks, setClicks] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(Date.now());
  const [progress, setProgress] = useState(0);

  const requiredClicks = 10;
  const maxInterval = 700; // milliseconds

  const handleGameClick = () => {
    const now = Date.now();
    const interval = now - lastClickTime;

    if (interval < maxInterval) {
      const newClicks = clicks + 1;
      setClicks(newClicks);
      setProgress((newClicks / requiredClicks) * 100);
      if (newClicks >= requiredClicks) {
        window.confetti?.({ particleCount: 200, spread: 120, origin: { y: 0.2 } });
        setClicks(0);
        setProgress(0);
      }
    } else {
      // too slow — reset
      setClicks(1);
      setProgress((1 / requiredClicks) * 100);
    }

    setLastClickTime(now);
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      
   
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">
   
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

     
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

    
          <div className="mt-12 w-full max-w-md">
            <motion.button
              onClick={handleGameClick}
              className="w-full px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Klik hurtigt for 🎉
            </motion.button>
            <div className="mt-4 bg-gray-700 h-4 w-full rounded-full overflow-hidden shadow-inner">
              <motion.div
                className="h-full bg-pink-400 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.2 }}
              />
            </div>
            <p className="text-sm mt-2 text-gray-300">
              {clicks}/{requiredClicks} klik — hold tempoet!
            </p>
          </div>
        </header>


        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

       
        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App;
 */





/* import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import confetti from 'canvas-confetti';
import { FaBolt } from 'react-icons/fa';

function App() {
  const [progress, setProgress] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [showVictory, setShowVictory] = useState(false);
  const progressRef = useRef(0);

  useEffect(() => {
    const decay = setInterval(() => {
      setProgress((prev) => Math.max(0, prev - 1));
      progressRef.current = Math.max(0, progressRef.current - 1);
    }, 100);
    return () => clearInterval(decay);
  }, []);

  const handleClick = () => {
    const now = Date.now();
    const timeDiff = now - lastClickTime;
    const gain = timeDiff < 300 ? 6 : 3;

    let newProgress = Math.min(100, progressRef.current + gain);
    progressRef.current = newProgress;
    setProgress(newProgress);
    setLastClickTime(now);

    if (newProgress >= 100) {
      confetti({
        particleCount: 200,
        spread: 160,
        origin: { y: 0.6 },
      });
      setShowVictory(true);
      setTimeout(() => setShowVictory(false), 2000);
      setProgress(0);
      progressRef.current = 0;
    }
  };

  const getMessage = () => {
    if (progress >= 100) return 'CONFETTI TIME!';
    if (progress >= 70) return 'Almost there!';
    if (progress >= 40) return 'Keep clicking!';
    return 'Warm it up...';
  };

  const getBarColor = () => {
    if (progress >= 100) return 'bg-green-500';
    if (progress >= 70) return 'bg-yellow-400';
    if (progress >= 40) return 'bg-orange-400';
    return 'bg-pink-400';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-800 via-purple-900 to-fuchsia-900 text-white flex flex-col items-center justify-center p-8 font-sans">
      <motion.h1
        className="text-5xl font-bold mb-10 text-center"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        🎉 Hype Meter Challenge
      </motion.h1>

      <motion.button
        className="relative w-40 h-40 bg-gradient-to-br from-pink-500 to-purple-600 text-white rounded-full shadow-xl flex items-center justify-center text-5xl hover:scale-110 transition-all duration-200"
        onClick={handleClick}
        whileTap={{ scale: 0.9 }}
        animate={{ boxShadow: ['0 0 0px', '0 0 25px #fff'] }}
        transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
      >
        <FaBolt />
      </motion.button>

      <div className="w-full max-w-md mt-10">
        <div className="h-4 rounded-full bg-white/20 overflow-hidden">
          <div
            className={`h-full transition-all duration-200 ${getBarColor()}`}
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-center mt-2 text-sm text-white/80">{getMessage()}</p>
      </div>

      <AnimatePresence>
        {showVictory && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: -40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: -40 }}
            className="fixed top-10 bg-green-500 text-black font-bold px-6 py-3 rounded-full shadow-lg"
          >
            🎊 Confetti Unlocked!
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        body {
          margin: 0;
          font-family: 'Inter', sans-serif;
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';
import confetti from 'canvas-confetti';

function App() {
  const [progress, setProgress] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);
  const progressRef = useRef(0);
  const intervalRef = useRef(null);

  // Gradually reduce progress over time if idle
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setProgress((prev) => Math.max(0, prev - 1));
    }, 100);
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleClick = () => {
    const now = Date.now();
    const timeDiff = now - lastClickTime;

    // If clicking fast enough (under 500ms), build up
    const gain = timeDiff < 500 ? 5 : 2;
    const newProgress = Math.min(100, progressRef.current + gain);
    setProgress(newProgress);
    progressRef.current = newProgress;
    setLastClickTime(now);

    // Trigger confetti when full
    if (newProgress >= 100) {
      confetti({
        particleCount: 300,
        spread: 120,
        origin: { y: 0.6 },
      });
      setProgress(0);
      progressRef.current = 0;
    }
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Klik hurtigt for at fylde hype-meteret og udløse konfetti!
          </motion.p>

          <motion.button
            onClick={handleClick}
            className="mt-12 px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg relative overflow-hidden"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 2s ease infinite',
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Klik for 🎉
            <div className="absolute bottom-0 left-0 h-1 bg-white/80" style={{ width: `${progress}%` }} />
          </motion.button>
        </header>

        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  // Initial confetti on mount
  useEffect(() => {
    const timer = setTimeout(() => window.confetti?.({ particleCount: 150, spread: 100 }), 800);
    return () => clearTimeout(timer);
  }, []);

  // Game state
  const [gameState, setGameState] = useState('idle'); // idle | waiting | now | success | tooSoon
  const timeoutRef = useRef(null);
  const nowTimeRef = useRef(null);
  const [reactionTime, setReactionTime] = useState(null);

  const startGame = () => {
    if (gameState !== 'idle') return;

    setGameState('waiting');
    const randomDelay = Math.floor(Math.random() * 3000) + 2000; // 2–5s

    timeoutRef.current = setTimeout(() => {
      nowTimeRef.current = Date.now();
      setGameState('now');
    }, randomDelay);
  };

  const handleClick = () => {
    if (gameState === 'waiting') {
      clearTimeout(timeoutRef.current);
      setGameState('tooSoon');
    } else if (gameState === 'now') {
      const reaction = Date.now() - nowTimeRef.current;
      setReactionTime(reaction);
      setGameState('success');
      window.confetti?.({ particleCount: 200, spread: 120, origin: { y: 0.2 } });
    } else if (gameState === 'tooSoon' || gameState === 'success') {
      setGameState('idle');
      setReactionTime(null);
    }
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">

   
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">

      
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

   
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

        
          <div className="mt-12 text-center space-y-4">
            <motion.button
              onClick={gameState === 'idle' ? startGame : handleClick}
              className="px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
                backgroundSize: '200% 200%',
                animation: 'buttonGradient 2s ease infinite',
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              {gameState === 'idle' && 'Tryk for 🎉'}
              {gameState === 'waiting' && 'Vent...'}
              {gameState === 'now' && 'KLIK NU!'}
              {gameState === 'tooSoon' && 'For tidligt! Prøv igen'}
              {gameState === 'success' && `🎉 ${reactionTime}ms! Klik for at prøve igen`}
            </motion.button>
          </div>
        </header>

       
        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

     
        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>


      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGamepad, FaUsers, FaTrophy, FaLightbulb } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  // Trigger initial confetti on mount
  useEffect(() => {
    const timer = setTimeout(() => window.confetti?.({ particleCount: 150, spread: 100 }), 800);
    return () => clearTimeout(timer);
  }, []);

  const handleCelebrate = () => {
    // burst confetti on click
    window.confetti?.({ particleCount: 200, spread: 120, origin: { y: 0.2 } });
  };

  return (
    <div className="relative min-h-screen font-sans text-white overflow-auto">
    
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[{ size: 72, top: '10%', left: '20%', delay: '0s' },
        { size: 48, top: '60%', left: '75%', delay: '3s' },
        { size: 56, top: '35%', left: '45%', delay: '1.5s' }]
        .map((o, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-5 animate-pulse"
            style={{ width: o.size, height: o.size, top: o.top, left: o.left, animationDelay: o.delay }}
          />
        ))}

      <div className="relative z-10">
      
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home','Features','Contact'].map((t,i)=>(
              <li key={i} className="hover:underline cursor-pointer">{t}</li>
            ))}
          </ul>
        </nav>

    
        <header className="flex flex-col items-center text-center pt-32 pb-20 px-4">
          <motion.h1
            className="text-6xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-purple-400"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            Skab. Leg. Fejr!
          </motion.h1>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>

          <motion.button
            onClick={handleCelebrate}
            className="mt-12 px-10 py-4 text-xl font-bold uppercase rounded-full shadow-lg"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 2s ease infinite',
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Tryk for 🎉
          </motion.button>
        </header>

    
        <section id="features" className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {[
            { icon: <FaGamepad />, title: 'Real‑World Multiplayer', desc: 'Sociale spil til at spille sammen IRL' },
            { icon: <FaUsers />, title: 'Fællesskaber', desc: 'Skab minder med venner og nye bekendtskaber' },
            { icon: <FaTrophy />, title: 'Turneringer', desc: 'Deltag i øjeblikkelige turneringer og konkurrencer' },
            { icon: <FaLightbulb />, title: 'Innovation', desc: 'Spildesign der overrasker og glæder' },
          ].map((f,i)=>(
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i*0.3 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

    
        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

   
      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import {
  FaGamepad,
  FaUsers,
  FaTrophy,
  FaLightbulb,
  FaEnvelope,
  FaPhone,
  FaLinkedin,
} from 'react-icons/fa';
import logo from './assets/logo/fox.png';


function App() {
  const [flipped, setFlipped] = useState(false);
  const flipAudioRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(
      () => window.confetti?.({ particleCount: 100, spread: 70 }),
      600
    );
    return () => clearTimeout(timer);
  }, []);

  const handleFlip = (e) => {
    if (['A', 'I', 'IMG', 'svg', 'path'].includes(e.target.tagName)) return;
    flipAudioRef.current?.play();
    setFlipped((f) => !f);
    window.confetti?.({ particleCount: 100, spread: 70 });
  };

  return (
    <div className="relative h-screen font-sans text-white">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[ 
        { size: 72, top: '5%', left: '15%', delay: '0s' },
        { size: 48, top: '60%', left: '80%', delay: '2s' },
        { size: 56, top: '35%', left: '40%', delay: '4s' },
      ].map((o, i) => (
        <span
          key={i}
          className="absolute rounded-full bg-white opacity-5 animate-pulse"
          style={{
            width: o.size,
            height: o.size,
            top: o.top,
            left: o.left,
            animationDelay: o.delay,
          }}
        />
      ))}


      <div className="relative z-10 h-screen overflow-auto">

        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Kløgtig logo" className="w-12 h-12 object-contain" />
            <div className="flex flex-col leading-tight">
              <span className="text-2xl font-bold">Kløgtig</span>
              <span className="text-sm italic text-pink-300">Seriøs sjov!</span>
            </div>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">
                {t}
              </li>
            ))}
          </ul>
        </nav>

        <header className="text-center pt-32 pb-20 px-4 max-w-3xl mx-auto">
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed mx-auto"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>
        </header>

        <section
          id="features"
          className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12"
        >
          {[
            {
              icon: <FaGamepad />,
              title: 'Real‑World Multiplayer',
              desc: 'Sociale spil til at spille sammen IRL',
            },
            {
              icon: <FaUsers />,
              title: 'Fællesskaber',
              desc: 'Skab minder med venner og nye bekendtskaber',
            },
            {
              icon: <FaTrophy />,
              title: 'Turneringer',
              desc: 'Deltag i øjeblikkelige turneringer og konkurrencer',
            },
            {
              icon: <FaLightbulb />,
              title: 'Innovation',
              desc: 'Spildesign der overrasker og glæder',
            },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>

        <section className="py-20 px-4 flex flex-col items-center">
        
          <motion.div
            className="cursor-pointer"
            onClick={handleFlip}
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            <motion.div
              className="relative w-72 h-80 rounded-2xl shadow-2xl"
              style={{ perspective: 1000 }}
              animate={{ rotateY: flipped ? 180 : 0 }}
              transition={{ duration: 0.8, ease: [0.68, -0.55, 0.27, 1.55] }}
            >

              <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 overflow-visible">
                <img src={logo} alt="" className="w-24 h-24 object-contain -mt-12 shadow-lg" />
                <h4 className="mt-4 text-2xl font-bold">Se vores magi!</h4>
              </div>
  
              <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 transform rotateY-180">
                <h4 className="text-2xl font-bold mb-2">Kontakt os</h4>
                <div className="flex space-x-4 text-2xl">
                  <a href="mailto:hello@kloegtig.com"><FaEnvelope /></a>
                  <a href="tel:+4512345678"><FaPhone /></a>
                  <a href="#"><FaLinkedin /></a>
                </div>
              </div>
            </motion.div>
          </motion.div>
          <button
            onClick={handleFlip}
            className="mt-6 px-8 py-3 font-bold uppercase tracking-wider rounded-full text-white shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 3s ease infinite',
            }}
          >
            tryk på mig :-)
          </button>
        </section>

        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>


      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */





/* // src/App.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FaGamepad,
  FaUsers,
  FaTrophy,
  FaLightbulb,
  FaEnvelope,
  FaPhone,
  FaLinkedin,
} from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const timer = setTimeout(
      () => window.confetti?.({ particleCount: 100, spread: 70 }),
      600
    );
    return () => clearTimeout(timer);
  }, []);

  const handleFlip = (e) => {
    if (['A', 'I', 'IMG', 'svg', 'path'].includes(e.target.tagName)) return;
    setFlipped((f) => !f);
    window.confetti?.({ particleCount: 100, spread: 70 });
  };

  return (
    <div className="relative h-screen font-sans text-white overflow-hidden">
   
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[ 
        { size: 72, top: '5%', left: '15%', delay: '0s' },
        { size: 48, top: '60%', left: '80%', delay: '2s' },
        { size: 56, top: '35%', left: '40%', delay: '4s' },
      ].map((o, i) => (
        <span
          key={i}
          className="absolute rounded-full bg-white opacity-5 animate-pulse"
          style={{
            width: o.size,
            height: o.size,
            top: o.top,
            left: o.left,
            animationDelay: o.delay,
          }}
        />
      ))}


      <div className="relative z-10 h-screen overflow-auto">
    
        <nav className="flex justify-between items-center p-6 bg-black/20 backdrop-blur-sm sticky top-0">
          <div className="flex items-center space-x-3">
            <img
              src={logo}
              alt="Kløgtig logo"
              className="w-12 h-12 object-contain"
            />
            <span className="text-2xl font-bold">Kløgtig</span>
          </div>
          <ul className="flex space-x-6 text-lg">
            {['Home', 'Features', 'Contact'].map((t, i) => (
              <li key={i} className="hover:underline cursor-pointer">
                {t}
              </li>
            ))}
          </ul>
        </nav>


        <header className="text-center pt-32 pb-20 px-4 max-w-3xl mx-auto">
          <motion.p
            className="text-2xl italic mb-2 text-pink-300"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Seriøs sjov!
          </motion.p>
          <motion.p
            className="text-lg text-gray-200 max-w-lg leading-relaxed mx-auto"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Skaber pixels og glade minder, ét episk spil ad gangen!
          </motion.p>
        </header>

 
        <section
          id="features"
          className="py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12"
        >
          {[
            {
              icon: <FaGamepad />,
              title: 'Real‑World Multiplayer',
              desc: 'Sociale spil til at spille sammen IRL',
            },
            {
              icon: <FaUsers />,
              title: 'Fællesskaber',
              desc: 'Skab minder med venner og nye bekendtskaber',
            },
            {
              icon: <FaTrophy />,
              title: 'Turneringer',
              desc: 'Deltag i øjeblikkelige turneringer og konkurrencer',
            },
            {
              icon: <FaLightbulb />,
              title: 'Innovation',
              desc: 'Spildesign der overrasker og glæder',
            },
          ].map((f, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2 }}
            >
              <div className="text-4xl text-pink-400">{f.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
                <p className="text-gray-300">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </section>


        <section className="py-20 px-4 flex flex-col items-center">
          <motion.div
            className="cursor-pointer"
            onClick={handleFlip}
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          >
            <motion.div
              className="relative w-72 h-80 rounded-2xl shadow-2xl"
              style={{ perspective: 1000 }}
              animate={{ rotateY: flipped ? 180 : 0 }}
              transition={{ duration: 0.8, ease: [0.68, -0.55, 0.27, 1.55] }}
            >
         
              <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 overflow-visible">
                <img
                  src={logo}
                  alt=""
                  className="w-24 h-24 object-contain -mt-12 shadow-lg"
                />
                <h4 className="mt-4 text-2xl font-bold">Se vores magi!</h4>
              </div>
   
              <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 transform rotateY-180">
                <h4 className="text-2xl font-bold mb-2">Kontakt os</h4>
                <div className="flex space-x-4 text-2xl">
                  <a href="mailto:hello@kloegtig.com">
                    <FaEnvelope />
                  </a>
                  <a href="tel:+4512345678">
                    <FaPhone />
                  </a>
                  <a href="#">
                    <FaLinkedin />
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
          <button
            onClick={handleFlip}
            className="mt-6 px-8 py-3 font-bold uppercase tracking-wider rounded-full text-white shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
            style={{
              background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
              backgroundSize: '200% 200%',
              animation: 'buttonGradient 3s ease infinite',
            }}
          >
            tryk på mig :-)
          </button>
        </section>

 
        <footer className="py-8 text-center text-gray-400">
          © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
        </footer>
      </div>

    
      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        @keyframes buttonGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FaGamepad,
  FaUsers,
  FaTrophy,
  FaLightbulb,
  FaEnvelope,
  FaPhone,
  FaLinkedin,
} from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => window.confetti?.({ particleCount: 100, spread: 70 }), 600);
    return () => clearTimeout(t);
  }, []);

  const handleFlip = e => {
    if (['A','I','IMG','svg','path'].includes(e.target.tagName)) return;
    setFlipped(f => !f);
    window.confetti?.({ particleCount: 100, spread: 70 });
  };

  return (
    <div className="relative min-h-screen overflow-hidden font-sans text-white">
 
      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[ 
        {size:72, top:'5%', left:'15%', delay:'0s'},
        {size:48, top:'60%', left:'80%', delay:'2s'},
        {size:56, top:'35%', left:'40%', delay:'4s'},
      ].map((o,i)=>(
        <span key={i}
          className="absolute rounded-full bg-white opacity-5 animate-pulse"
          style={{
            width:o.size, height:o.size,
            top:o.top, left:o.left,
            animationDelay:o.delay
          }}/>
      ))}


      <nav className="relative z-10 flex justify-between items-center p-6 max-w-5xl mx-auto">
        <img src={logo} alt="Kløgtig" className="w-24 h-24 object-contain" />
        <ul className="flex space-x-6 text-lg">
          {['Home','Features','Contact'].map((t,i)=><li key={i} className="hover:underline cursor-pointer">{t}</li>)}
        </ul>
      </nav>

    
      <header className="relative z-10 flex flex-col items-center text-center pt-32 pb-20 px-4 max-w-3xl mx-auto">
        <motion.h1
          className="text-6xl font-extrabold mb-4"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type:'spring', stiffness:120, damping:20 }}
        >
          Kløgtig
        </motion.h1>
        <motion.p
          className="text-2xl italic mb-2 text-pink-300"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Seriøs sjov!
        </motion.p>
        <motion.p
          className="text-lg text-gray-200 max-w-lg leading-relaxed"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Skaber pixels og glade minder, ét episk spil ad gangen!
        </motion.p>
      </header>

    
      <section id="features" className="relative z-10 py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
        {[
          {
            icon: <FaGamepad />,
            title: 'Real‑World Multiplayer',
            desc: 'Sociale spil til at spille sammen IRL',
          },
          {
            icon: <FaUsers />,
            title: 'Fællesskaber',
            desc: 'Skab minder med venner og nye bekendtskaber',
          },
          {
            icon: <FaTrophy />,
            title: 'Turneringer',
            desc: 'Deltag i øjeblikkelige turneringer og konkurrencer',
          },
          {
            icon: <FaLightbulb />,
            title: 'Innovation',
            desc: 'Spildesign der overrasker og glæder',
          },
        ].map((f, i) => (
          <motion.div
            key={i}
            className="flex items-start space-x-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.2 }}
          >
            <div className="text-4xl text-pink-400">{f.icon}</div>
            <div>
              <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
              <p className="text-gray-300">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </section>

     
      <section className="relative z-10 py-20 px-4 flex justify-center">
        <motion.div
          className="cursor-pointer"
          onClick={handleFlip}
          initial={{ scale:0.9, opacity:0 }}
          whileInView={{ scale:1, opacity:1 }}
          transition={{ type:'spring', stiffness:120, damping:20 }}
        >
          <motion.div
            className="relative w-72 h-80 rounded-2xl shadow-2xl"
            style={{ perspective: 1000 }}
            animate={{ rotateY: flipped ? 180 : 0 }}
            transition={{ duration:0.8, ease:[0.68,-0.55,0.27,1.55] }}
          >
   
            <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 overflow-visible">
              <img src={logo} alt="" className="w-24 h-24 object-contain -mt-12 shadow-lg" />
              <h4 className="mt-4 text-2xl font-bold">Se vores magi!</h4>
            </div>
        
            <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 transform rotateY-180">
              <h4 className="text-2xl font-bold mb-2">Kontakt os</h4>
              <div className="flex space-x-4 text-2xl">
                <a href="mailto:hello@kloegtig.com"><FaEnvelope /></a>
                <a href="tel:+4512345678"><FaPhone /></a>
                <a href="#"><FaLinkedin /></a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>

      <footer className="relative z-10 py-8 text-center text-gray-400">
        © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
      </footer>

   
      <style>{`
        @keyframes gradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
      `}</style>
    </div>
  );
}

export default App; */






/* // src/App.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FaGamepad,
  FaUsers,
  FaCode,
  FaLightbulb,
  FaEnvelope,
  FaPhone,
  FaLinkedin,
} from 'react-icons/fa';
import logo from './assets/logo/fox.png';

function App() {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    // initial confetti
    const t = setTimeout(() => window.confetti?.({ particleCount: 100, spread: 70 }), 600);
    return () => clearTimeout(t);
  }, []);

  const handleFlip = e => {
    if (['A','I','IMG','svg','path'].includes(e.target.tagName)) return;
    setFlipped(f => !f);
    window.confetti?.({ particleCount: 100, spread: 70 });
  };

  return (
    <div className="relative min-h-screen overflow-hidden font-sans text-white">

      <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 animate-[gradient_15s_ease_infinite]" />
      {[ // orbs
        {size:72, top:'5%', left:'15%', delay:'0s'},
        {size:48, top:'60%', left:'80%', delay:'2s'},
        {size:56, top:'35%', left:'40%', delay:'4s'},
      ].map((o,i)=>(
        <span key={i}
          className="absolute rounded-full bg-white opacity-5 animate-pulse"
          style={{
            width:o.size, height:o.size,
            top:o.top, left:o.left,
            animationDelay:o.delay
          }}/>
      ))}


      <nav className="relative z-10 flex justify-between items-center p-6 max-w-5xl mx-auto">
        <img src={logo} alt="Kløgtig" className="w-12 h-12 object-contain" />
        <ul className="flex space-x-6 text-lg">
          {['Home','Features','Contact'].map((t,i)=><li key={i} className="hover:underline cursor-pointer">{t}</li>)}
        </ul>
      </nav>

      <header className="relative z-10 flex flex-col items-center text-center pt-32 pb-20 px-4 max-w-3xl mx-auto">
        <motion.h1
          className="text-6xl font-extrabold mb-4"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type:'spring', stiffness:120, damping:20 }}
        >
          Kløgtig
        </motion.h1>
        <motion.p
          className="text-2xl italic mb-2 text-pink-300"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Seriøs sjov!
        </motion.p>
        <motion.p
          className="text-lg text-gray-200 max-w-lg leading-relaxed"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Skaber pixels og glade minder, ét episk spil ad gangen!
        </motion.p>
      </header>

      <section id="features" className="relative z-10 py-20 px-4 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
        {[
          { icon:<FaGamepad/>, title:'Real‑World Multiplayer', desc:'Sociale spil til at spille sammen IRL' },
          { icon:<FaUsers/>, title:'Fællesskaber',             desc:'Skab minder med venner og nye bekendtskaber' },
          { icon:<FaCode/>,  title:'Solid Kode',               desc:'Ren, skalerbar og vedligeholdelses‑venlig' },
          { icon:<FaLightbulb/>,title:'Innovation',            desc:'Spildesign der overrasker og glæder' },
        ].map((f,i)=>(
          <motion.div key={i}
            className="flex items-start space-x-4"
            initial={{ opacity:0, y:20 }}
            whileInView={{ opacity:1, y:0 }}
            transition={{ delay: i*0.2 }}
          >
            <div className="text-4xl text-pink-400">{f.icon}</div>
            <div>
              <h3 className="text-2xl font-semibold mb-1">{f.title}</h3>
              <p className="text-gray-300">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </section>

    
      <section className="relative z-10 py-20 px-4 flex justify-center">
        <motion.div
          className="cursor-pointer"
          onClick={handleFlip}
          initial={{ scale:0.9, opacity:0 }}
          whileInView={{ scale:1, opacity:1 }}
          transition={{ type:'spring', stiffness:120, damping:20 }}
        >
          <motion.div
            className="relative w-72 h-80 rounded-2xl shadow-2xl"
            style={{ perspective: 1000 }}
            animate={{ rotateY: flipped ? 180 : 0 }}
            transition={{ duration:0.8, ease:[0.68,-0.55,0.27,1.55] }}
          >
          
            <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 overflow-visible">
              <img src={logo} alt="" className="w-24 h-24 object-contain -mt-12 shadow-lg" />
              <h4 className="mt-4 text-2xl font-bold">Se vores magi!</h4>
            </div>
        
            <div className="absolute inset-0 bg-white/10 backdrop-blur-md rounded-2xl flex flex-col items-center justify-center p-6 transform rotateY-180">
              <h4 className="text-2xl font-bold mb-2">Kontakt os</h4>
              <div className="flex space-x-4 text-2xl">
                <a href="mailto:hello@kloegtig.com"><FaEnvelope /></a>
                <a href="tel:+4512345678"><FaPhone /></a>
                <a href="#"><FaLinkedin /></a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>

      <footer className="relative z-10 py-8 text-center text-gray-400">
        © {new Date().getFullYear()} Kløgtig — Skabt med ❤️ og pixels.
      </footer>

   
      <style>{`
        @keyframes gradient {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
        .animate-[gradient_15s_ease_infinite] {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
      `}</style>
    </div>
  );
}

export default App; */






/* import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FaGamepad,
  FaUsers,
  FaCode,
  FaLightbulb,
  FaEnvelope,
  FaPhone,
  FaLinkedin,
} from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const App = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const launchConfetti = () => {
    if (window.confetti) {
      window.confetti({
        particleCount: 150,
        spread: 90,
        origin: { y: 0.6, x: 0.5 },
        colors: ['#8A2BE2', '#FF1493', '#00FFFF', '#39FF14', '#4B0082'],
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(launchConfetti, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleFlip = (e) => {
    const tag = e.target.tagName;
    if (['A', 'I', 'IMG', 'svg', 'path'].includes(tag)) return;
    setIsFlipped((f) => !f);
    launchConfetti();
  };

  return (
    <div className="relative overflow-hidden">
  
      <div className="fixed inset-0 bg-gradient-to-br from-purple-800 via-blue-800 to-indigo-900 animate-[gradient_15s_ease_infinite]"></div>
    
      <div className="absolute inset-0 pointer-events-none">
        {[
          { size: 72, top: '10%', left: '20%', delay: '0s' },
          { size: 48, top: '70%', left: '80%', delay: '3s' },
          { size: 56, top: '40%', left: '10%', delay: '1.5s' },
        ].map((orb, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-white opacity-10 animate-pulse"
            style={{
              width: `${orb.size}px`,
              height: `${orb.size}px`,
              top: orb.top,
              left: orb.left,
              animationDelay: orb.delay,
            }}
          />
        ))}
      </div>

      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <motion.div
          className="card-container relative cursor-pointer"
          onClick={handleFlip}
          initial={{ opacity: 0, y: 50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          style={{ perspective: 1000, width: '100%', maxWidth: '450px', height: '300px' }}
        >
          <motion.div
            className={`card absolute w-full h-full rounded-2xl shadow-2xl`}
            animate={{ rotateY: isFlipped ? 180 : 0 }}
            transition={{ duration: 0.8, ease: [0.68, -0.55, 0.27, 1.55] }}
            style={{ transformStyle: 'preserve-3d' }}
          >
       
            <div
              className="card-face absolute inset-0 rounded-2xl flex flex-col items-center justify-center p-8"
              style={{
                backfaceVisibility: 'hidden',
                background: 'rgba(255,255,255,0.12)',
                boxShadow: '0 0 40px rgba(255,255,255,0.05)',
                overflow: 'visible',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(20px)',
              }}
            >
              <img
                src={logo}
                alt="kløgtig logo"
                className="w-32 h-32 object-contain -mt-16"
              />

              <h1 className="mt-4 text-5xl font-extrabold text-white mb-2 bounce-text">
                {['G', 'a', 'm', 'e', ' ', 'O', 'n', '!'].map((char, i) => (
                  <span
                    key={i}
                    style={{ '--i': `${i + 1}` }}
                    className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400"
                  >
                    {char}
                  </span>
                ))}
              </h1>
              <p className="text-lg text-pink-200 font-medium mb-1">by Kløgtig</p>
              <p className="text-xl text-blue-200 mb-4">Social Gaming Developer</p>
              <p className="text-center text-gray-200 italic max-w-xs">
                "Crafting pixels and building happy memories, one epic game at a time!"
              </p>
            </div>

      
            <div
              className="card-face absolute inset-0 rounded-2xl flex flex-col items-center justify-center p-8"
              style={{
                backfaceVisibility: 'hidden',
                transform: 'rotateY(180deg)',
                background: 'rgba(255,255,255,0.12)',
                boxShadow: '0 0 40px rgba(255,255,255,0.05)',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(20px)',
              }}
            >
              <h2 className="text-3xl font-bold text-purple-300 mb-4">My Superpowers!</h2>
              <ul className="text-white space-y-2 mb-6">
                <li className="flex items-center">
                  <FaGamepad className="mr-2 text-pink-400" /> Engaging Multiplayer
                </li>
                <li className="flex items-center">
                  <FaUsers className="mr-2 text-blue-400" /> Vibrant Communities
                </li>
                <li className="flex items-center">
                  <FaCode className="mr-2 text-green-400" /> Clean, Scalable Code
                </li>
                <li className="flex items-center">
                  <FaLightbulb className="mr-2 text-yellow-300" /> Innovative Design
                </li>
              </ul>
              <div className="flex items-center space-x-4 mb-6 text-white text-2xl">
                <a href="mailto:you@example.com"><FaEnvelope /></a>
                <a href="tel:+1234567890"><FaPhone /></a>
                <a href="https://linkedin.com/in/you" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
              </div>
              <p className="text-gray-300">Let's level up your next project!</p>
            </div>
          </motion.div>
        </motion.div>

        <button
          className="mt-8 px-8 py-3 font-bold uppercase tracking-wider rounded-full text-white shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
          style={{
            background: 'linear-gradient(90deg, #FF6B6B, #FFD166, #06D6A0)',
            backgroundSize: '200% 200%',
            animation: 'buttonGradient 3s ease infinite',
          }}
          onClick={handleFlip}
        >
          Flip Card
        </button>
      </div>

      <style>
        {`
          @keyframes gradient {
            0%{background-position:0% 50%}
            50%{background-position:100% 50%}
            100%{background-position:0% 50%}
          }
          .animate-[gradient_15s_ease_infinite] {
            background-size: 400% 400%;
            animation: gradient 15s ease infinite;
          }
          @keyframes buttonGradient {
            0%{background-position:0% 50%}
            50%{background-position:100% 50%}
            100%{background-position:0% 50%}
          }
          .bounce-text span {
            animation: bounce 1.8s infinite ease-in-out;
            animation-delay: calc(0.1s * var(--i));
          }
          @keyframes bounce {
            0%,20%,50%,80%,100%{transform:translateY(0)}
            40%{transform:translateY(-20px)}
            60%{transform:translateY(-10px)}
          }
        `}
      </style>
    </div>
  );
};

export default App; */






/* import React, { useState, useEffect } from 'react';
import { FaGamepad, FaUsers, FaCode, FaLightbulb, FaEnvelope, FaPhone } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import logo from './assets/logo/fox.png';

const App = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const launchConfetti = () => {
    if (window.confetti) {
      window.confetti({
        particleCount: 150,
        spread: 90,
        origin: { y: 0.6, x: 0.5 },
        colors: ['#8A2BE2', '#FF1493', '#00FFFF', '#39FF14', '#4B0082'],
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(launchConfetti, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleFlip = (e) => {
    const tag = e.target.tagName;
    if (['A', 'I', 'IMG', 'svg', 'path'].includes(tag)) return;
    setIsFlipped((f) => !f);
    launchConfetti();
  };

  return (
    <div
      className="flex flex-col items-center min-h-screen justify-center p-4 overflow-hidden"
      style={{ fontFamily: 'Inter, sans-serif', boxSizing: 'border-box' }}
    >
      <style>
        {`
          .card-container {
            width: 100%;
            max-width: 450px;
            height: 300px;
            perspective: 1000px;
            position: relative;
            cursor: pointer;
            min-height: 280px;
          }
          .card {
            width: 100%;
            height: 100%;
            position: absolute;
            transform-style: preserve-3d;
            transition: transform 0.8s cubic-bezier(0.68,-0.55,0.27,1.55);
            border-radius: 2.5rem;
            box-shadow: 0 15px 40px rgba(0,0,0,0.35);
          }
          .card.flipped { transform: rotateY(180deg); }
          .card-face {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            border-radius: 2.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 2rem;
            box-sizing: border-box;
         
            overflow: visible; 
          }
          .card-front, .card-back {
            background-color: rgba(255,255,255,0.98);
            backdrop-filter: blur(12px);
            color: #333;
          }
          .card-back { transform: rotateY(180deg); }
          .icon-link:hover { transform: scale(1.25); }
          @keyframes bounce {
            0%,20%,50%,80%,100%{transform: translateY(0)}
            40%{transform: translateY(-18px)}
            60%{transform: translateY(-9px)}
          }
          .bounce-text span {
            display: inline-block;
            animation: bounce 2s infinite ease-in-out;
            animation-delay: calc(0.08s * var(--i));
          }
          .flip-button {
            background: linear-gradient(45deg,#FFD166,#FF6B6B);
            color:white;
            padding:.75rem 1.5rem;
            border-radius:9999px;
            font-weight:bold;
            text-transform:uppercase;
            letter-spacing:.05em;
            box-shadow:0 8px 20px rgba(0,0,0,0.2);
            border:none;
            margin-top:1.5rem;
            transition: all .3s ease-in-out;
          }
          .flip-button:hover {
            transform: translateY(-3px) scale(1.05);
            box-shadow:0 12px 25px rgba(0,0,0,0.3);
            background: linear-gradient(45deg,#FF6B6B,#FFD166);
          }
          @media (max-width:640px) { 
            .card-container { height:280px; min-height:260px }
            .card-face { padding:1.5rem }
            .text-5xl{font-size:2.5rem}
            .text-2xl{font-size:1.5rem}
            .text-lg{font-size:1rem}
            .text-md{font-size:.875rem}
            .space-x-6 > * + *{ margin-left:1rem }
            .flip-button { padding:.6rem 1.2rem; font-size:.875rem }
          }
        `}
      </style>

      <div className="card-container" onClick={handleFlip}>
        <div className={`card ${isFlipped ? 'flipped' : ''}`}>
          <div className="card-face card-front">
            <img
              src={logo}
              alt="kløgtig logo"
              className="w-32 h-32 object-cover sm:w-36 sm:h-36 -mt-16"
            />

            <h1 className="text-5xl font-extrabold text-gray-900 mb-1 bounce-text">
              {['G','a','m','e',' ','O','n','!'].map((c, i) => (
                <span key={i} style={{ '--i': `${i+1}` }}>{c}</span>
              ))}
            </h1>
            <p className="text-xl font-bold text-indigo-700 mb-1">by Kløgtig</p>
            <p className="text-2xl font-semibold text-blue-600 mb-3">
              Social Gaming Developer
            </p>
            <p className="text-lg text-gray-700 italic max-w-xs mx-auto text-center">
              "Crafting pixels and building happy memories, one epic game at a time!"
            </p>
          </div>

          <div className="card-face card-back text-center">
            <h2 className="text-3xl font-bold text-purple-700 mb-4">My Superpowers!</h2>
            <ul className="text-lg text-gray-800 list-disc list-inside mb-6">
              <li><FaGamepad className="inline mr-2 text-red-500"/>Engaging Multiplayer</li>
              <li><FaUsers className="inline mr-2 text-blue-500"/>Vibrant Communities</li>
              <li><FaCode className="inline mr-2 text-green-500"/>Clean, Scalable Code</li>
              <li><FaLightbulb className="inline mr-2 text-yellow-500"/>Innovative Game Design</li>
            </ul>
            <p className="text-md text-gray-700 font-medium">
              Let's level up your next project!
            </p>
            <div className="flex justify-center space-x-4 text-gray-600 text-2xl mt-4">
              <a href="mailto:your.email@example.com" className="icon-link" aria-label="Email">
                <FaEnvelope/>
              </a>
              <a href="tel:+1234567890" className="icon-link" aria-label="Phone">
                <FaPhone/>
              </a>
              <a
                href="https://linkedin.com/in/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin/>
              </a>
            </div>
          </div>
        </div>
      </div>

      <button className="flip-button" onClick={handleFlip}>
        Flip Card!
      </button>
    </div>
  );
};

export default App; */






/* import React, { useState, useEffect } from 'react';
import { FaGamepad, FaUsers, FaCode, FaLightbulb, FaEnvelope, FaPhone } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import logo from './assets/logo/fox.png';  // ← import the image

const App = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const launchConfetti = () => {
    if (window.confetti) {
      window.confetti({
        particleCount: 150,
        spread: 90,
        origin: { y: 0.6, x: 0.5 },
        colors: ['#8A2BE2', '#FF1493', '#00FFFF', '#39FF14', '#4B0082'],
      });
    } else {
      console.warn('Confetti library not available.');
    }
  };

  useEffect(() => {
    const timer = setTimeout(launchConfetti, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleFlip = (e) => {
    const tag = e.target.tagName;
    if (['A', 'I', 'IMG', 'svg', 'path'].includes(tag)) return;
    setIsFlipped((f) => !f);
    launchConfetti();
  };

  return (
    <div
      className="flex flex-col items-center min-h-screen justify-center p-4 overflow-hidden"
      style={{ fontFamily: 'Inter, sans-serif', boxSizing: 'border-box' }}
    >
      <style>
        {`
          .card-container {
            width: 100%;
            max-width: 450px;
            height: 300px;
            perspective: 1000px;
            position: relative;
            cursor: pointer;
            min-height: 280px;
          }
          .card {
            width: 100%;
            height: 100%;
            position: absolute;
            transform-style: preserve-3d;
            transition: transform 0.8s cubic-bezier(0.68,-0.55,0.27,1.55);
            border-radius: 2.5rem;
            box-shadow: 0 15px 40px rgba(0,0,0,0.35);
          }
          .card.flipped { transform: rotateY(180deg); }
          .card-face {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            border-radius: 2.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 2rem;
            box-sizing: border-box;
            border: 4px solid rgba(255,255,255,0.4);
          }
          .card-front, .card-back {
            background-color: rgba(255,255,255,0.98);
            backdrop-filter: blur(12px);
            color: #333;
          }
          .card-back { transform: rotateY(180deg); }
          .icon-link:hover { transform: scale(1.25); }
          @keyframes bounce {
            0%,20%,50%,80%,100%{transform: translateY(0)}
            40%{transform: translateY(-18px)}
            60%{transform: translateY(-9px)}
          }
          .bounce-text span {
            display: inline-block;
            animation: bounce 2s infinite ease-in-out;
            animation-delay: calc(0.08s * var(--i));
          }
          .flip-button {
            background: linear-gradient(45deg,#FFD166,#FF6B6B);
            color:white;
            padding:.75rem 1.5rem;
            border-radius:9999px;
            font-weight:bold;
            text-transform:uppercase;
            letter-spacing:.05em;
            box-shadow:0 8px 20px rgba(0,0,0,0.2);
            border:none;
            margin-top:1.5rem;
            transition: all .3s ease-in-out;
          }
          .flip-button:hover {
            transform: translateY(-3px) scale(1.05);
            box-shadow:0 12px 25px rgba(0,0,0,0.3);
            background: linear-gradient(45deg,#FF6B6B,#FFD166);
          }
          @media (max-width:640px) { 
            .card-container { height:280px; min-height:260px }
            .card-face { padding:1.5rem }
            .text-5xl{font-size:2.5rem}
            .text-2xl{font-size:1.5rem}
            .text-lg{font-size:1rem}
            .text-md{font-size:.875rem}
            .space-x-6 > * + *{ margin-left:1rem }
            .flip-button { padding:.6rem 1.2rem; font-size:.875rem }
          }
        `}
      </style>

      <div className="card-container" onClick={handleFlip}>
        <div className={`card ${isFlipped ? 'flipped' : ''}`}>
          <div className="card-face card-front">
            <img
              src={logo}
              alt="kløgtig logo"
              className="w-28 h-28 rounded-full mb-4 border-4 border-[#06D6A0] shadow-lg object-cover sm:w-32 sm:h-32"
            />

            <h1 className="text-5xl font-extrabold text-gray-900 mb-1 bounce-text">
              {['G','a','m','e',' ','O','n','!'].map((c, i) => (
                <span key={i} style={{ '--i': `${i+1}` }}>{c}</span>
              ))}
            </h1>
            <p className="text-xl font-bold text-indigo-700 mb-1">by Kløgtig</p>
            <p className="text-2xl font-semibold text-blue-600 mb-3">
              Social Gaming Developer
            </p>
            <p className="text-lg text-gray-700 italic max-w-xs mx-auto text-center">
              "Crafting pixels and building happy memories, one epic game at a time!"
            </p>
          </div>

          <div className="card-face card-back text-center">
            <h2 className="text-3xl font-bold text-purple-700 mb-4">My Superpowers!</h2>
            <ul className="text-lg text-gray-800 list-disc list-inside mb-6">
              <li><FaGamepad className="inline mr-2 text-red-500"/>Engaging Multiplayer</li>
              <li><FaUsers className="inline mr-2 text-blue-500"/>Vibrant Communities</li>
              <li><FaCode className="inline mr-2 text-green-500"/>Clean, Scalable Code</li>
              <li><FaLightbulb className="inline mr-2 text-yellow-500"/>Innovative Game Design</li>
            </ul>
            <p className="text-md text-gray-700 font-medium">
              Let's level up your next project!
            </p>
            <div className="flex justify-center space-x-4 text-gray-600 text-2xl mt-4">
              <a href="mailto:your.email@example.com" className="icon-link" aria-label="Email">
                <FaEnvelope/>
              </a>
              <a href="tel:+1234567890" className="icon-link" aria-label="Phone">
                <FaPhone/>
              </a>
              <a
                href="https://linkedin.com/in/yourprofile"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin/>
              </a>
            </div>
          </div>
        </div>
      </div>

      <button className="flip-button" onClick={handleFlip}>
        Flip Card!
      </button>
    </div>
  );
};

export default App; */






// import React, { useState, useEffect } from 'react';

// const App = () => {
//     const [isFlipped, setIsFlipped] = useState(false);

//     // Function to trigger confetti
//     const launchConfetti = () => {
//         // Confetti is now loaded globally via index.html, so it should always be available
//         if (window.confetti) {
//             window.confetti({
//                 particleCount: 150,
//                 spread: 90,
//                 origin: { y: 0.6, x: 0.5 },
//                 colors: ['#8A2BE2', '#FF1493', '#00FFFF', '#39FF14', '#4B0082'] // Match background colors
//             });
//         } else {
//             console.warn("Confetti library not available. Check public/index.html script tag.");
//         }
//     };

//     // Initial confetti burst on component mount
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             launchConfetti();
//         }, 500); // A small delay for better effect
//         return () => clearTimeout(timer); // Cleanup timeout
//     }, []); // Empty dependency array means this runs once on mount

//     // Handle card flip
//     const handleFlip = (event) => {
//         // Prevent flipping if clicking on a link or image inside the card
//         if (event.target.tagName === 'A' || event.target.tagName === 'I' || event.target.tagName === 'IMG') {
//             return;
//         }
//         setIsFlipped(!isFlipped);
//         launchConfetti(); // Launch confetti on each flip
//     };

//     return (
//         // The main container for the entire application, applying global styles
//         // This div now handles the full height, flex centering, and padding
//         <div className="flex flex-col items-center min-h-screen justify-center p-4" style={{
//             fontFamily: 'Inter, sans-serif',
//             overflow: 'hidden', // Prevent scrollbars from confetti
//             boxSizing: 'border-box'
//         }}>
//             {/*
//                 Custom styles specific to the card and its animations.
//                 Global styles like body background are now in public/index.html.
//             */}
//             <style>
//                 {`
//                 /* Card container for 3D flip */
//                 .card-container {
//                     width: 100%;
//                     max-width: 450px; /* Max width for desktop */
//                     height: 300px; /* Fixed height for consistent flip animation */
//                     perspective: 1000px; /* For 3D perspective */
//                     position: relative;
//                     cursor: pointer; /* Indicate it's interactive */
//                     min-height: 280px; /* A minimum height to prevent squishing */
//                 }

//                 .card {
//                     width: 100%;
//                     height: 100%;
//                     position: absolute;
//                     transform-style: preserve-3d; /* Crucial for 3D flip */
//                     transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55); /* Bouncy transition */
//                     border-radius: 2.5rem; /* More rounded corners */
//                     box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35); /* Deeper shadow */
//                 }

//                 .card.flipped {
//                     transform: rotateY(180deg);
//                 }

//                 .card-face {
//                     position: absolute;
//                     width: 100%;
//                     height: 100%;
//                     -webkit-backface-visibility: hidden; /* Hide the back of the face when flipped */
//                     backface-visibility: hidden;
//                     border-radius: 2.5rem; /* Match container border-radius */
//                     display: flex;
//                     flex-direction: column;
//                     justify-content: center;
//                     align-items: center;
//                     padding: 2rem; /* Default padding */
//                     box-sizing: border-box;
//                     border: 4px solid rgba(255, 255, 255, 0.4); /* Frosted border */
//                 }

//                 .card-front {
//                     background-color: rgba(255, 255, 255, 0.98); /* Near opaque white */
//                     backdrop-filter: blur(12px); /* Stronger frosted glass effect */
//                     color: #333;
//                 }

//                 .card-back {
//                     background-color: rgba(255, 255, 255, 0.98); /* Near opaque white */
//                     backdrop-filter: blur(12px);
//                     color: #333;
//                     transform: rotateY(180deg); /* Initially rotated to be the back */
//                 }

//                 /* Icon styling */
//                 .icon-link {
//                     transition: transform 0.2s ease-in-out, color 0.2s ease-in-out;
//                 }

//                 .icon-link:hover {
//                     transform: scale(1.25); /* More pronounced scale */
//                     color: #FF6B6B; /* Match a vibrant background color */
//                 }

//                 /* Custom animation for the "Game On!" text */
//                 @keyframes bounce {
//                     0%, 20%, 50%, 80%, 100% {
//                         transform: translateY(0);
//                     }
//                     40% {
//                         transform: translateY(-18px); /* Higher bounce */
//                     }
//                     60% {
//                         transform: translateY(-9px);
//                     }
//                 }

//                 .bounce-text span {
//                     display: inline-block;
//                     animation: bounce 2s infinite ease-in-out;
//                     animation-delay: calc(0.08s * var(--i)); /* Staggered delay, slightly faster */
//                 }

//                 /* Flip button styling */
//                 .flip-button {
//                     background: linear-gradient(45deg, #FFD166, #FF6B6B); /* Fun button gradient */
//                     color: white;
//                     padding: 0.75rem 1.5rem;
//                     border-radius: 9999px; /* Pill shape */
//                     font-weight: bold;
//                     text-transform: uppercase;
//                     letter-spacing: 0.05em;
//                     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
//                     transition: all 0.3s ease-in-out;
//                     border: none;
//                     margin-top: 1.5rem; /* Space below card */
//                 }

//                 .flip-button:hover {
//                     transform: translateY(-3px) scale(1.05);
//                     box-shadow: 0 12px 25px rgba(0, 0, 0, 0.3);
//                     background: linear-gradient(45deg, #FF6B6B, #FFD166); /* Reverse gradient on hover */
//                 }

//                 /* Responsive adjustments for smaller screens */
//                 @media (max-width: 640px) {
//                     .card-container {
//                         height: 280px; /* Slightly adjust height for smaller screens */
//                         min-height: 260px; /* Ensure it doesn't get too small */
//                     }
//                     .card-face {
//                         padding: 1.5rem; /* Reduce padding inside card */
//                     }
//                     .text-5xl { /* Adjust main title size */
//                         font-size: 2.5rem; /* ~40px */
//                     }
//                     .text-2xl { /* Adjust subtitle size */
//                         font-size: 1.5rem; /* ~24px */
//                     }
//                     .text-lg { /* Adjust general text size */
//                         font-size: 1rem; /* ~16px */
//                     }
//                     .text-md { /* Adjust smaller text size */
//                         font-size: 0.875rem; /* ~14px */
//                     }
//                     .space-x-6 > *:not([hidden]) ~ *:not([hidden]) {
//                         margin-left: 1rem; /* Reduce spacing for social icons */
//                     }
//                     .flip-button {
//                         padding: 0.6rem 1.2rem;
//                         font-size: 0.875rem;
//                     }
//                 }
//                 `}
//             </style>

//             <div className="card-container" onClick={handleFlip}>
//                 <div className={`card ${isFlipped ? 'flipped' : ''}`}>
//                     {/* Front of the card */}
//                     <div className="card-face card-front">
//                         {/* Profile Picture Placeholder */}
//                         <img src="./assets/logo/fox.png" alt="kløgtig logo"
//                              className="w-28 h-28 rounded-full mb-4 border-4 border-06D6A0 shadow-lg object-cover sm:w-32 sm:h-32"/>

//                         {/* Name and Title */}
//                         <h1 className="text-5xl font-extrabold text-gray-900 mb-1 bounce-text">
//                             {/* Apply bounce animation to each letter */}
//                             <span style={{ '--i': 1 }}>G</span>
//                             <span style={{ '--i': 2 }}>a</span>
//                             <span style={{ '--i': 3 }}>m</span>
//                             <span style={{ '--i': 4 }}>e</span>
//                             <span style={{ '--i': 5 }} className="ml-2">O</span>
//                             <span style={{ '--i': 6 }}>n</span>
//                             <span style={{ '--i': 7 }}>!</span>
//                         </h1>
//                         {/* Kløgtig Company Name */}
//                         <p className="text-xl font-bold text-indigo-700 mb-1">by Kløgtig</p>
//                         <p className="text-2xl font-semibold text-blue-600 mb-3">Social Gaming Developer</p>

//                         {/* Whimsical Tagline */}
//                         <p className="text-lg text-gray-700 italic max-w-xs mx-auto text-center">
//                             "Crafting pixels and building happy memories, one epic game at a time!"
//                         </p>
//                     </div>

//                     {/* Back of the card */}
//                     <div className="card-face card-back text-center">
//                         <h2 className="text-3xl font-bold text-purple-700 mb-4">My Superpowers!</h2>
//                         <ul className="text-lg text-gray-800 list-disc list-inside mb-6">
//                             <li><i className="fas fa-gamepad mr-2 text-red-500"></i> Engaging Multiplayer</li>
//                             <li><i className="fas fa-users mr-2 text-blue-500"></i> Vibrant Communities</li>
//                             <li><i className="fas fa-code mr-2 text-green-500"></i> Clean, Scalable Code</li>
//                             <li><i className="fas fa-lightbulb mr-2 text-yellow-500"></i> Innovative Game Design</li>
//                         </ul>
//                         <p className="text-md text-gray-700 font-medium">
//                             Let's level up your next project!
//                         </p>
//                         {/* Contact Info on back too, for easy access */}
//                         <div className="flex justify-center space-x-4 text-gray-600 text-2xl mt-4">
//                             <a href="mailto:your.email@example.com" className="icon-link hover:text-red-500" aria-label="Email">
//                                 <i className="fas fa-envelope"></i>
//                             </a>
//                             <a href="tel:+1234567890" className="icon-link hover:text-green-500" aria-label="Phone">
//                                 <i className="fas fa-phone"></i>
//                             </a>
//                             <a href="https://linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer" className="icon-link hover:text-blue-600" aria-label="LinkedIn">
//                                 <i className="fab fa-linkedin"></i>
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Flip Button */}
//             <button id="flipButton" className="flip-button" onClick={handleFlip}>
//                 Flip Card!
//             </button>
//         </div>
//     );
// };

// export default App;